webpackJsonp([1],{

/***/ "+288":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AuthInterceptor.$inject = ["$httpProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AuthInterceptor;
var UNAUTHENTICATED_ERR_CODE = 16;

/** @ngInject */
function AuthInterceptor($httpProvider) {
    /** @ngInject */
    $httpProvider.interceptors.push(["AuthService", "$q", function (AuthService, $q) {
        function request(config) {
            var accessToken = AuthService.getAccessToken();

            if (accessToken) {
                config.headers.Authorization = "Bearer " + accessToken;
            }

            return config;
        }

        function responseError(rejection) {
            var Code = rejection.data.Code;

            if (Code === UNAUTHENTICATED_ERR_CODE) {
                return AuthService.login();
            }
            return $q.reject(rejection);
        }

        return {
            request: request,
            responseError: responseError
        };
    }]);
}

/***/ }),

/***/ "+DP6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingSignal = __webpack_require__("FgbM");

var _thingSignal2 = _interopRequireDefault(_thingSignal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingSignal',
    options: _thingSignal2.default
};

/***/ }),

/***/ "+FUi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("W13y"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * DeveloperApi class.
 */

var AlertsActionsApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    AlertsActionsApi.$inject = ["$http"];
    function AlertsActionsApi($http) {
        _classCallCheck(this, AlertsActionsApi);

        this.$http = $http;
        this.config = _local2.default.api.alertsActions;
    }

    /**
     * Get developer application config
     * @returns {promise}
     */


    _createClass(AlertsActionsApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }

        /**
         * Create application
         * @returns {promise}
         */

    }, {
        key: 'create',
        value: function create(rule) {
            // eslint-disable-line
            // TODO: should be refactoring with real API
            var returnedRule = {
                title: rule.title,
                id: Math.floor(Math.random() * 1000000000000000000),
                type: rule.type
            };

            var promise = new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve(returnedRule);
                    reject('Error');
                }, 1000);
            });

            return promise;
        }

        /**
         * Update application
         * @returns {promise}
         */

    }, {
        key: 'remove',
        value: function remove(rule) {
            // eslint-disable-line
            var promise = new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve(rule);
                    reject('Error');
                }, 1000);
            });

            return promise;
        }
    }]);

    return AlertsActionsApi;
}();

exports.default = AlertsActionsApi;

/***/ }),

/***/ "+Vwy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/star-o.svg";

/***/ }),

/***/ "+jTT":
/***/ (function(module, exports) {

module.exports = "<div class=dt-thing-details__subheader>Advanced</div> <ul class=\"custom-list custom-list--simple custom-list--striped\"> <li layout=row layout-align=\"start start\"> <div layout=column layout-align=\"start start\" flex> <div class=md-body-1><b>Firmware</b></div> </div> <div layout=column layout-align=\"start start\" flex> <div class=md-body-1>{{ $ctrl.advancedInformation.firmware.version }}</div> </div> </li> </ul>";

/***/ }),

/***/ "+o/V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FoldersController = function () {
    /** @ngInject */
    FoldersController.$inject = ["Loader", "FolderService", "DialogService", "ToastService", "$state", "$scope"];
    function FoldersController(Loader, FolderService, DialogService, ToastService, $state, $scope) {
        _classCallCheck(this, FoldersController);

        this.Loader = Loader;
        this.FolderService = FolderService;
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.$state = $state;
        this.$scope = $scope;
    }

    _createClass(FoldersController, [{
        key: '$onInit',
        value: function $onInit() {
            this.foldersLoading = false;
            this.folders = this.FolderService.getTree();
            this.searchIndex = this.prepareSearchIndex();
        }
    }, {
        key: 'prepareSearchIndex',
        value: function prepareSearchIndex() {
            var _this = this;

            var data = [];
            Object.keys(this.FolderService.folderMap).forEach(function (folderId) {
                var folderPath = _this.FolderService.buildFolderPath(folderId);
                var name = folderPath.map(function (folder) {
                    return folder.name;
                }).join(' > ');
                data.push({
                    id: folderId,
                    name: name
                });
            });
            return _utils2.default.buildSearchIndex(data);
        }
    }, {
        key: 'onSearch',
        value: function onSearch(_ref) {
            var query = _ref.query;

            return _utils2.default.searchInIndex(this.searchIndex, query);
        }
    }, {
        key: 'onFolderFound',
        value: function onFolderFound(_ref2) {
            var item = _ref2.item;

            if (item) {
                if (!this.currentFolderId || this.currentFolderId !== item.id) {
                    this.$scope.$broadcast('angular-ui-tree:collapse-all');
                }
                var folder = this.FolderService.getFolder(item.id);
                this.editFolder({
                    folder: folder
                });
            }
        }
    }, {
        key: 'moveFolder',
        value: function moveFolder(_ref3) {
            var _this2 = this;

            var folder = _ref3.folder,
                parent = _ref3.parent,
                index = _ref3.index;

            this.Loader.show();
            this.foldersLoading = true;
            this.FolderService.moveFolder(folder, parent, index).then(function () {
                _this2.searchIndex = _this2.prepareSearchIndex();
                _this2.showToast('folder_was_moved');
            }).catch(function () {
                _this2.showToast('folder_wasnt_moved');
            }).finally(function () {
                _this2.foldersLoading = false;
                _this2.Loader.hide();
            });
        }
    }, {
        key: 'showToast',
        value: function showToast(textKey) {
            this.ToastService.showSimpleTranslated(textKey);
        }
    }, {
        key: 'createFolder',
        value: function createFolder(_ref4) {
            var _this3 = this;

            var data = _ref4.folder;

            this.Loader.show();
            return this.FolderService.addFolder(data).then(function (folder) {
                _this3.showToast('folder_was_created');
                _this3.searchIndex = _this3.prepareSearchIndex();
                _this3.$state.go('main.folders-and-labels.folders.folder', {
                    folderId: folder.id
                });
            }, function () {
                _this3.showToast('folder_wasnt_created');
            }).finally(function () {
                _this3.Loader.hide();
            });
        }
    }, {
        key: 'showSensors',
        value: function showSensors() {
            this.$state.go('main.sensors.list', {
                folderId: this.currentFolderId
            });
        }
    }, {
        key: 'editFolder',
        value: function editFolder(_ref5) {
            var folder = _ref5.folder;

            this.$state.go('main.folders-and-labels.folders.folder', {
                folderId: folder.id
            });
        }
    }, {
        key: 'cancelEdit',
        value: function cancelEdit() {
            this.$state.go('main.folders-and-labels.folders');
        }
    }, {
        key: 'saveFolder',
        value: function saveFolder(_ref6) {
            var _this4 = this;

            var folder = _ref6.folder;

            this.Loader.show();
            this.FolderService.saveFolder(folder).then(function () {
                _this4.searchIndex = _this4.prepareSearchIndex();
                _this4.showToast('folder_was_updated');
            }, function () {
                _this4.showToast('folder_wasnt_updated');
            }).finally(function () {
                _this4.Loader.hide();
            });
        }
    }, {
        key: 'deleteFolder',
        value: function deleteFolder(_ref7) {
            var _this5 = this;

            var folder = _ref7.folder;

            this.Loader.show();
            this.FolderService.deleteFolder(folder).then(function () {
                _this5.searchIndex = _this5.prepareSearchIndex();
                _this5.showToast('folder_was_removed');
            }, function () {
                _this5.showToast('folder_wasnt_removed');
            }).finally(function () {
                _this5.Loader.hide();
            });
            this.cancelEdit();
        }
    }, {
        key: 'currentFolderId',
        get: function get() {
            return this.$state.params.folderId;
        }
    }]);

    return FoldersController;
}();

exports.default = FoldersController;

/***/ }),

/***/ "/8cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _access = __webpack_require__("gw8L");

var _access2 = _interopRequireDefault(_access);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("dWeu");

exports.default = {
    controller: _access2.default,
    template: template
};

/***/ }),

/***/ "/GEJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FolderBrowserDialogController = function () {
    /** @ngInject */
    FolderBrowserDialogController.$inject = ["DialogService", "folderChangedCallback"];
    function FolderBrowserDialogController(DialogService, folderChangedCallback) {
        _classCallCheck(this, FolderBrowserDialogController);

        this.DialogService = DialogService;
        this.folderChangedCallback = folderChangedCallback;
    }

    _createClass(FolderBrowserDialogController, [{
        key: "onFolderChange",
        value: function onFolderChange(_ref) {
            var folderId = _ref.folderId,
                dblClicked = _ref.dblClicked;

            this.folderId = folderId;
            if (dblClicked) {
                this.submit();
            }
        }
    }, {
        key: "submit",
        value: function submit() {
            if (this.folderId) {
                this.folderChangedCallback(this.folderId);
            }
            this.DialogService.hide();
        }
    }, {
        key: "close",
        value: function close() {
            this.DialogService.cancel();
        }
    }]);

    return FolderBrowserDialogController;
}();

exports.default = FolderBrowserDialogController;

/***/ }),

/***/ "/MXH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

var _charting = __webpack_require__("6EsV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var warnChartIcon = '/assets/images/warn-chart-icon-16.png'; // eslint-disable-line
var alertChartIcon = '/assets/images/alert-chart-icon-16.png';

var ThingChartController = function () {
    /** @ngInject */
    ThingChartController.$inject = ["ThingsApi", "NotificationsApi", "$q"];
    function ThingChartController(ThingsApi, NotificationsApi, $q) {
        _classCallCheck(this, ThingChartController);

        this.ThingsApi = ThingsApi;
        this.NotificationsApi = NotificationsApi;
        this.$q = $q;

        this.extractChartData = this.extractChartData.bind(this);
        this.updateData = this.updateData.bind(this);
    }

    _createClass(ThingChartController, [{
        key: 'loadNavigatorData',
        value: function loadNavigatorData(start, end) {
            var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1d';

            return this.ThingsApi.historicalQueryAggregated(this.thing.id, {
                fields: this.thing.getHistoryFieldsNavigatorConfig(),
                time_period: {
                    start: start,
                    end: end
                },
                interval: interval,
                fill: 'null'
            });
        }
    }, {
        key: 'loadData',
        value: function loadData(start, end) {
            var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1d';

            if (this.thing.isHistoryAggregated()) {
                return this.ThingsApi.historicalQueryAggregated(this.thing.id, {
                    fields: this.thing.getHistoryFieldsConfig(),
                    time_period: {
                        start: start,
                        end: end
                    },
                    interval: interval,
                    fill: 'null'
                });
            }

            return this.ThingsApi.historicalQuery(this.thing.id, {
                fields: this.thing.getHistoryFieldsConfig(),
                time_period: {
                    start: start,
                    end: end
                }
            });
        }
    }, {
        key: 'updateData',
        value: function updateData(_ref) {
            var _this = this;

            var min = _ref.min,
                max = _ref.max,
                trigger = _ref.trigger;

            if (!trigger) {
                return;
            }

            var interval = _charting.DataConverter.calculateInterval(min, max);

            var start = (0, _moment2.default)(min).format();
            var end = (0, _moment2.default)(max).format();

            this.chart.showLoading('Loading data from server...');
            this.loadData(start, end, interval).then(this.extractChartData).then(function (data) {
                _this.chart.hideLoading();
                if (_this.chartType === 'temperature') {
                    var ranges = data.ranges,
                        average = data.average;

                    _this.chart.series[0].setData(average);
                    _this.chart.series[1].setData(ranges);
                } else {
                    _this.chart.series[0].setData(data);
                }
            });
        }
    }, {
        key: 'extractChartData',
        value: function extractChartData(response) {
            var data = response && response.values ? response.values : [];
            var chartData = this.convertChartData(data);
            this.chartStats = this.calculateChartStats(chartData);
            return chartData;
        }
    }, {
        key: 'calculateChartStats',
        value: function calculateChartStats(data) {
            if (this.chartType === 'temperature') {
                return _charting.DataConverter.temperatureStats(data);
            } else if (this.chartType === 'touch') {
                return _charting.DataConverter.touchStats(data);
            }
            return _charting.DataConverter.proximityStats(data);
        }
    }, {
        key: 'convertNavigatorData',
        value: function convertNavigatorData(data) {
            if (this.chartType === 'proximity') {
                return _charting.DataConverter.proximityNavigator(data);
            } else if (this.chartType === 'temperature') {
                return _charting.DataConverter.temperature(data).average;
            }
            return this.convertChartData(data);
        }
    }, {
        key: 'convertChartData',
        value: function convertChartData(data) {
            if (this.chartType === 'temperature') {
                return _charting.DataConverter.temperature(data);
            } else if (this.chartType === 'touch') {
                return _charting.DataConverter.touch(data);
            }
            return _charting.DataConverter.proximity(data);
        }
    }, {
        key: 'prepareTemperatureConfig',
        value: function prepareTemperatureConfig(data) {
            this.chartConfig = _charting.ConfigHelper.temperatureFull(data, _charting.ConfigHelper.asyncDataLoading(this.navigatorSeriesData, this.updateData));
        }
    }, {
        key: 'prepareTouchConfig',
        value: function prepareTouchConfig(data) {
            this.chartConfig = _charting.ConfigHelper.touchFull(data, _charting.ConfigHelper.asyncDataLoading(this.navigatorSeriesData, this.updateData));
        }
    }, {
        key: 'prepareProximityConfig',
        value: function prepareProximityConfig(data) {
            this.chartConfig = _charting.ConfigHelper.proximityFull(data, _charting.ConfigHelper.asyncDataLoading(this.navigatorSeriesData, this.updateData));
        }
    }, {
        key: 'onChartLoaded',
        value: function onChartLoaded(_ref2) {
            var chart = _ref2.chart;

            this.chart = chart;
            this.chart.xAxis[0].setExtremes(this.defaultStart.valueOf(), this.periodEnd.valueOf());
        }
    }, {
        key: 'mergeNotifications',
        value: function mergeNotifications() {
            if (this.notifications) {
                var notifications = this.notifications;
                var series = {
                    type: 'scatter',
                    name: 'Notifications',
                    tooltip: {
                        split: true,
                        pointFormatter: function pointFormatter() {
                            // eslint-disable-line
                            return '<h1>' + notifications[this.index].subject + '</h1><br />\n                            <p>' + notifications[this.index].message + '</p>';
                        }
                    },
                    zIndex: 50,
                    data: []
                };
                var notification = this.notifications.shift();
                series.data.push({
                    x: (0, _moment2.default)(notification.created).valueOf(),
                    y: 24.5,
                    marker: {
                        symbol: notification.level === 'ALERT' ? 'url(' + alertChartIcon + ')' : 'url(' + alertChartIcon + ')'
                    }
                });
                this.chartConfig.series.push(series);
            }
        }
    }, {
        key: 'prepareChartConfig',
        value: function prepareChartConfig(data) {
            if (this.chartType === 'temperature') {
                this.prepareTemperatureConfig(data);
            } else if (this.chartType === 'touch') {
                this.prepareTouchConfig(data);
            } else {
                this.prepareProximityConfig(data);
            }
            this.mergeNotifications();
            this.dataLoaded = true;
        }
    }, {
        key: 'loadHistoricalData',
        value: function loadHistoricalData() {
            var _this2 = this;

            var end = this.periodEnd.format();
            var start = this.periodStart.format();

            return this.loadNavigatorData(start, end).then(function (response) {
                var data = response && response.values ? response.values : [];
                _this2.navigatorSeriesData = _this2.convertNavigatorData(data);
                return _this2.loadData(_this2.defaultStart.format(), end, _charting.DataConverter.calculateInterval(_this2.defaultStart.valueOf(), _this2.periodEnd.valueOf())).then(_this2.extractChartData);
            });
        }
    }, {
        key: 'loadNotifications',
        value: function loadNotifications() {
            var _this3 = this;

            return this.NotificationsApi.getByObjectId(this.selectedThingId).then(function (data) {
                _this3.notifications = data.notifications || [];
            });
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.eventReceived && !changes.eventReceived.isFirstChange()) {
                var extremes = this.chart.xAxis[0].getExtremes();
                this.updateData({
                    min: extremes.min,
                    max: extremes.max,
                    trigger: true
                });
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this4 = this;

            this.chartData = null;
            this.chartType = null;
            this.dataLoaded = false;

            var _ConfigHelper$getDefa = _charting.ConfigHelper.getDefaultTimespan(),
                start = _ConfigHelper$getDefa.start,
                end = _ConfigHelper$getDefa.end;

            this.periodEnd = end.endOf('day');
            this.periodStart = (0, _moment2.default)(this.thing.registered);

            this.defaultStart = start;

            this.chartType = this.thing.getHistoryChartType();
            this.$q.all([this.loadHistoricalData()]
            // this.loadNotifications()
            ).then(function (resolved) {
                _this4.prepareChartConfig(resolved[0]);
            });
        }
    }]);

    return ThingChartController;
}();

exports.default = ThingChartController;

/***/ }),

/***/ "/Mo1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/dashboards.png";

/***/ }),

/***/ "/Wte":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UACAddUser = exports.Component = exports.Config = undefined;

var _users = __webpack_require__("EGhv");

var _users2 = _interopRequireDefault(_users);

var _users3 = __webpack_require__("47vn");

var _users4 = _interopRequireDefault(_users3);

var _addUser = __webpack_require__("btPW");

var _addUser2 = _interopRequireDefault(_addUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtUsersView',
    options: _users4.default
};

exports.Config = _users2.default;
exports.Component = Component;
exports.UACAddUser = _addUser2.default;

/***/ }),

/***/ "/dA1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * HttpInterceptor class.
 * Use it to extend request or response made by $http service.
 */
var HttpInterceptor = function () {
    function HttpInterceptor() {
        _classCallCheck(this, HttpInterceptor);
    }

    _createClass(HttpInterceptor, [{
        key: 'request',

        /**
         * Request modifier
         * @param {Object} requestConfig - Request configuration
         * @returns {Object}
         */
        value: function request(requestConfig) {
            // eslint-disable-line class-methods-use-this
            // if (Config.api.apiKey) {
            //     requestConfig.headers['Authorization'] = Config.api.apiKey;
            // }

            if (requestConfig && requestConfig.url && requestConfig.url.startsWith('/v1/')) {
                requestConfig.url = _local2.default.api.baseUrl + requestConfig.url; // eslint-disable-line no-param-reassign
            }

            return requestConfig;
        }
    }]);

    return HttpInterceptor;
}();

exports.default = HttpInterceptor;

/***/ }),

/***/ "/jyb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contentHeader = __webpack_require__("XK6R");

var _contentHeader2 = _interopRequireDefault(_contentHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("uPUl");

exports.default = {
    bindings: {
        stateTitle: '<'
    },
    template: template,
    controller: _contentHeader2.default
};

/***/ }),

/***/ "/t3i":
/***/ (function(module, exports) {

module.exports = "<dt-entities-autocomplete entities=$ctrl.labels on-change=$ctrl.changed($event) on-add=$ctrl.added($event) on-remove=$ctrl.removed($event) on-search=$ctrl.search($event) require-match=::$ctrl.requireMatch editable=$ctrl.editable placeholder=\"{{ $ctrl.placeholder }}\" secondary-placeholder=\"{{ $ctrl.secondaryPlaceholder }}\" text-key=name></dt-entities-autocomplete>";

/***/ }),

/***/ "0+U/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rule = __webpack_require__("Werf");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtRule',
    options: _rule2.default
};

/***/ }),

/***/ "0//z":
/***/ (function(module, exports) {

module.exports = "<section class=\"box box--{{ $ctrl.severity.cls }} layout-padding\" ng-if=$ctrl.notification> <div layout=row layout-align=\"start center\"> <div layout=row layout-align=\"start center\"> <i class=\"fa fa-3 {{ $ctrl.severity.icon }}\" aria-hidden=true></i> <div class=space-m-l-m> <div class=md-body-2>{{ $ctrl.notification.subject }}</div> <div class=md-caption>{{ $ctrl.notification.message }}</div> </div> </div> </div> </section>";

/***/ }),

/***/ "07mR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autocomplete = __webpack_require__("fdDM");

var _autocomplete2 = _interopRequireDefault(_autocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtLabelsAutocomplete',
    options: _autocomplete2.default
};

/***/ }),

/***/ "0ATH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


uiTreeModuleConfig.$inject = ["treeConfig"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uiTreeModuleConfig;
/** @ngInject */
function uiTreeModuleConfig(treeConfig) {
    treeConfig.defaultCollapsed = true;
}

/***/ }),

/***/ "0F4W":
/***/ (function(module, exports) {

module.exports = "<md-dialog class=md-dialog--location flex=60> <h2 class=\"md-dialog-title space-p-h-l\">{{($ctrl.isEditing ? \"Click on the map to select location\" : \"Location\")}}</h2> <md-dialog-content class=\"md-dialog-content space-p-t-n\" flex> <dt-map ng-if=::!$ctrl.isEditing marker=$ctrl.marker center-coordinates=$ctrl.centerCoordinates></dt-map> <dt-map ng-if=::$ctrl.isEditing marker=$ctrl.marker center-coordinates=$ctrl.centerCoordinates on-marker-coordinates-changed=$ctrl.update($event)></dt-map> </md-dialog-content> <md-dialog-actions class=space-p-r-m ng-if=$ctrl.isEditing> <a href=\"\" class=md-secondary ng-click=\"$ctrl.remove(); $event.preventDefault();\"> <md-icon class=\"material-icons material-icons--s\">delete</md-icon> Remove sensor from map </a> <span flex></span> <md-button class=md-primary ng-click=$ctrl.cancel($event);>Cancel</md-button> <md-button class=md-primary ng-click=$ctrl.done($event);>Ok</md-button> </md-dialog-actions> <md-dialog-actions class=space-p-r-m ng-if=!$ctrl.isEditing> <span flex></span> <md-button class=md-primary ng-click=$ctrl.cancel($event);>Ok</md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "0H2f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createAlertsActions = __webpack_require__("BopK");

var _createAlertsActions2 = _interopRequireDefault(_createAlertsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var createRuleTemplate = __webpack_require__("aabv");

var AlertsActionsNavController = function () {
    /** @ngInject */
    AlertsActionsNavController.$inject = ["EventEmitter", "DialogService"];
    function AlertsActionsNavController(EventEmitter, DialogService) {
        _classCallCheck(this, AlertsActionsNavController);

        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
    }

    _createClass(AlertsActionsNavController, [{
        key: '$onInit',
        value: function $onInit() {
            this.filterRule = '';
            this.currentRule = null;
            this.addFocus = false;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.alertsActions.currentValue) {
                this.alertsActions = changes.alertsActions.currentValue;
            }
        }
    }, {
        key: 'onSelect',
        value: function onSelect(rule) {
            this.currentRule = rule;

            this.onPushCurrent(this.eventEmitter({
                rule: this.currentRule
            }));
        }
    }, {
        key: 'create',
        value: function create(ev, typeOfRule) {
            var config = {
                type: typeOfRule
            };

            // TODO: should be implement after update real API
            this.DialogService.show({
                controller: _createAlertsActions2.default,
                controllerAs: '$ctrl',
                template: createRuleTemplate,
                parent: document.body,
                targetEvent: ev,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    rules: this.alertsActions,
                    config: config
                }
            });
        }
    }, {
        key: 'getFilterRules',
        value: function getFilterRules(_ref) {
            var query = _ref.query;

            this.filterRule = query;
        }
    }]);

    return AlertsActionsNavController;
}();

exports.default = AlertsActionsNavController;

/***/ }),

/***/ "0K23":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GraphsDialogController = function () {
    /** @ngInject */
    GraphsDialogController.$inject = ["DialogService"];
    function GraphsDialogController(DialogService) {
        _classCallCheck(this, GraphsDialogController);

        this.DialogService = DialogService;
    }

    _createClass(GraphsDialogController, [{
        key: "close",
        value: function close() {
            this.DialogService.cancel();
        }
    }]);

    return GraphsDialogController;
}();

exports.default = GraphsDialogController;

/***/ }),

/***/ "0PIR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/table-sorted-asc.svg";

/***/ }),

/***/ "0k6n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__("SItB");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("3nmL");

/**
 * Application Component
 */
exports.default = {
  template: template,
  controller: _app2.default
};

/***/ }),

/***/ "18Me":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _detailsChart = __webpack_require__("9V1s");

var _detailsChart2 = _interopRequireDefault(_detailsChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingDetailsChart',
    options: _detailsChart2.default
};

/***/ }),

/***/ "1EOf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'geo_distance';

var ThingLocationController = function () {
    /** @ngInject */
    ThingLocationController.$inject = ["GeoService", "EventEmitter"];
    function ThingLocationController(GeoService, EventEmitter) {
        _classCallCheck(this, ThingLocationController);

        this.GeoService = GeoService;
        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingLocationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.mapOptions = {
                scrollwheel: false
            };

            this.locationEnabled = false;
            this.distance = null;
            this.location = null;
            this.marker = {};
            this.centerCoordinates = {};
            this.geo = navigator.geolocation;
            this.defaultCoordinates = this.GeoService.getCoordsByKey('default') || {};

            this.defineCoordinates();
        }
    }, {
        key: 'changed',
        value: function changed() {
            if (this.locationEnabled && this.distance && this.location) {
                this.addItemToBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME,
                        value: {
                            distance: this.distance,
                            location: this.location
                        }
                    }
                }));
            } else {
                this.removeItemFromBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                }));
            }
        }
    }, {
        key: 'boundsChanged',
        value: function boundsChanged(_ref) {
            var bounds = _ref.bounds;

            var distance = Math.round(this.GeoService.getDistanceBetweenCoords(bounds.southWest.lat, bounds.southWest.lng, bounds.northEast.lat, bounds.northEast.lng) * 0.2);
            this.distance = distance + 'm';
            this.changed();
        }
    }, {
        key: 'centerChanged',
        value: function centerChanged(_ref2) {
            var _ref2$center = _ref2.center,
                lat = _ref2$center.lat,
                lng = _ref2$center.lng;

            this.location = {
                lat: lat,
                lon: lng
            };
            this.changed();
        }
    }, {
        key: 'defineCoordinates',
        value: function defineCoordinates() {
            var _this = this;

            this.geo.getCurrentPosition(function (position) {
                _this.centerCoordinates.lat = position.coords.latitude;
                _this.centerCoordinates.lng = position.coords.longitude;
            }, function () {
                // TODO: by default Oslo coordinates
                _this.centerCoordinates.lat = _this.defaultCoordinates.lat;
                _this.centerCoordinates.lng = _this.defaultCoordinates.lng;
            });
        }
    }]);

    return ThingLocationController;
}();

exports.default = ThingLocationController;

/***/ }),

/***/ "1ES/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    chart: {
        animation: false,
        panning: false
    },
    title: {
        text: null
    },
    xAxis: {
        ordinal: false,
        type: 'datetime'
    },
    yAxis: {
        title: {
            text: null
        },
        labels: {
            x: -10
        }
    },
    tooltip: {
        crosshairs: true,
        shared: true,
        zIndex: 50
    },
    credits: {
        enabled: false
    }
};

/***/ }),

/***/ "1hZ4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * ThingsService class.
 * Used to work with Things configs
 */
var ThingsService = function () {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @param {$filter} $filter - Angular $filter service
     * @constructor
     * @ngInject
     */
    ThingsService.$inject = ["RemoteConfigService", "$filter"];
    function ThingsService(RemoteConfigService, $filter) {
        _classCallCheck(this, ThingsService);

        this.RemoteConfigService = RemoteConfigService;
        this.$filter = $filter;

        this.config = (0, _cloneDeep3.default)(this.RemoteConfigService.getThingsConfig());

        this.items = this.config.items || [];
        this.itemsMapByType = {};

        this.createThingsMapByType();
    }

    /**
     * Parse config items and create map for thing by thing.type
     * @returns {Object} Return object with things linked to thing.type inside that object
     */


    _createClass(ThingsService, [{
        key: 'createThingsMapByType',
        value: function createThingsMapByType() {
            var _this = this;

            if (!this.items || !Array.isArray(this.items) || !this.items.length) return {};

            this.items.forEach(function (thing) {
                thing.titlePlural = _this.$filter('pluralFilter')(thing.description);

                _this.itemsMapByType[thing.type] = thing;
            });

            this.sortThingsMap();

            return this.getThingsMapByType();
        }

        /**
         * Sort things map by thing.type
         * @returns {Object} Map of things
         */

    }, {
        key: 'sortThingsMap',
        value: function sortThingsMap() {
            var _this2 = this;

            this.itemsMapByType = Object.keys(this.itemsMapByType).sort().reduce(function (result, item) {
                result[item] = _this2.itemsMapByType[item];

                return result;
            }, {});

            return this.itemsMapByType;
        }

        /**
         * Get thing by type
         * @param {string} type - Thing type
         * @returns {Object|null} Return Thing config object or Null on absent thing type
         */

    }, {
        key: 'getThingByType',
        value: function getThingByType(type) {
            return this.itemsMapByType[type] || null;
        }

        /**
         * Get all things (NOTICE: this is not a map of thing, this is original items from API/Server)
         * @returns {Array} Return array of thing configs
         */

    }, {
        key: 'getAllThings',
        value: function getAllThings() {
            return this.items;
        }

        /**
         * Get all things from map
         * @returns {Object} Return map of things by type
         */

    }, {
        key: 'getThingsMapByType',
        value: function getThingsMapByType() {
            return this.itemsMapByType;
        }
    }]);

    return ThingsService;
}();

exports.default = ThingsService;

/***/ }),

/***/ "1hlv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

var _user = __webpack_require__("sVqQ");

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("8kps"); // eslint-disable-line global-require
    __webpack_require__("og9u"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    var data = response.data;

    if ('users' in data) {
        data.users = data.users.map(function (user) {
            return new _user2.default(user);
        });
    }

    return data;
}

/**
 * UsersApi class.
 */

var UsersApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    UsersApi.$inject = ["$http"];
    function UsersApi($http) {
        _classCallCheck(this, UsersApi);

        this.$http = $http;
        this.config = _local2.default.api.users;
    }

    /**
     * Get Users
     * @returns {promise}
     */


    _createClass(UsersApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }

        /**
         * Search Users by given query
         * @param {string} query - Pattern for user search
         * @param {Object} [metadata={}] - optional, set limit and ofset
         * @returns {promise}
         */

    }, {
        key: 'search',
        value: function search(query) {
            var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.$http.get(this.config.searchUrl, {
                params: _extends({
                    query: query + '*'
                }, metadata)
            }).then(responseDataExtractor);
        }

        /**
         * Get User by given id
         * @param {number} userId - User id
         * @returns {promise}
         */

    }, {
        key: 'getUser',
        value: function getUser(userId) {
            var url = _utils2.default.formatString({ userId: userId }, this.config.getUrl);

            return this.$http.get(url).then(responseDataExtractor);
        }

        /**
         * Delete user by given id
         * @param {number} userId - User id
         * @returns {promise}
         */

    }, {
        key: 'deleteUser',
        value: function deleteUser(userId) {
            var url = _utils2.default.formatString({ userId: userId }, this.config.deleteUrl);

            return this.$http.delete(url).then(responseDataExtractor);
        }

        /**
         * Update User
         * @param {Object} user - User object
         * @returns {promise}
         */

    }, {
        key: 'updateUser',
        value: function updateUser(user) {
            return this.$http.put(this.config.updateUrl, _extends({}, user)).then(responseDataExtractor);
        }

        /**
         * Create User
         * @param {Object} user - User object
         * @returns {promise}
         */

    }, {
        key: 'createUser',
        value: function createUser(user) {
            return this.$http.post(this.config.createUrl, _extends({}, user)).then(responseDataExtractor);
        }

        /**
         * Reset User password by given id
         * @param {number} userId - User id
         * @returns {promise}
         */

    }, {
        key: 'resetPassword',
        value: function resetPassword(userId) {
            var url = _utils2.default.formatString({ userId: userId }, this.config.resetPasswordUrl);

            return this.$http.post(url).then(responseDataExtractor);
        }

        /**
         * Upload User image
         * @param {number} userId - User id
         * @param {string} image - Image content
         * @returns {promise}
         */

    }, {
        key: 'uploadProfileImage',
        value: function uploadProfileImage(userId, image) {
            var url = _utils2.default.formatString({ userId: userId }, this.config.uploadProfileImageUrl);

            return this.$http.post(url, { 'user_id': userId, image: image }).then(responseDataExtractor);
        }
    }]);

    return UsersApi;
}();

exports.default = UsersApi;

/***/ }),

/***/ "1itO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lucene = __webpack_require__("2luL");

var _lucene2 = _interopRequireDefault(_lucene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LabelDetailsController = function () {
    /** @ngInject */
    LabelDetailsController.$inject = ["EventEmitter", "DialogService"];
    function LabelDetailsController(EventEmitter, DialogService) {
        _classCallCheck(this, LabelDetailsController);

        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
    }

    _createClass(LabelDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.labelName = this.label.name;
            this.searchQuery = _lucene2.default.convertLabelsToLuceneCompatible([{ id: this.label.id }]);
        }
    }, {
        key: 'save',
        value: function save() {
            this.onSaved(this.eventEmitter({
                label: this.label
            }));
            this.labelName = this.label.name;
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.onEditCancelled();
        }
    }, {
        key: 'validateLabel',
        value: function validateLabel() {
            var _this = this;

            var validationErrors = this.onNameChange(this.eventEmitter({
                label: this.label
            }));

            if (validationErrors) {
                Object.keys(validationErrors).forEach(function (ruleName) {
                    _this.labelForm.name.$setValidity(ruleName, validationErrors[ruleName]);
                });
            }
        }
    }, {
        key: 'showDeleteConfirmation',
        value: function showDeleteConfirmation() {
            var _this2 = this;

            this.DialogService.confirm({
                title: 'Delete Label?',
                textContent: 'Do you really want to delete label "' + this.labelName + '"?',
                ariaLabel: 'delete-label',
                ok: 'Delete',
                cancel: 'Cancel'
            }).then(function () {
                _this2.onDeleted(_this2.eventEmitter({
                    label: _this2.label
                }));
            });
        }
    }]);

    return LabelDetailsController;
}();

exports.default = LabelDetailsController;

/***/ }),

/***/ "1j4k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = onEnterDirectiveConfig;
/** @ngInject */
function onEnterDirectiveConfig() {
    function link($scope, $element, $attrs) {
        $element.on('keydown', function ($ev) {
            if ($ev.keyCode === 13) {
                if ($scope.$eval($attrs.considerSpecialKeys)) {
                    if (!$ev.shiftKey) {
                        $scope.$eval($attrs.onEnter);
                    }
                } else {
                    $scope.$eval($attrs.onEnter);
                }
            }
        });
    }

    return {
        restrict: 'A',
        link: link
    };
}

/***/ }),

/***/ "1wn3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FolderDetails = exports.FolderTree = exports.Component = exports.Config = undefined;

var _folders = __webpack_require__("G9fG");

var _folders2 = _interopRequireDefault(_folders);

var _folderTree = __webpack_require__("GmSh");

var FolderTree = _interopRequireWildcard(_folderTree);

var _folderDetails = __webpack_require__("DAwG");

var _folderDetails2 = _interopRequireDefault(_folderDetails);

var _folders3 = __webpack_require__("byU/");

var _folders4 = _interopRequireDefault(_folders3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtFoldersView',
    options: _folders4.default
};

exports.Config = _folders2.default;
exports.Component = Component;
exports.FolderTree = FolderTree;
exports.FolderDetails = _folderDetails2.default;

/***/ }),

/***/ "2ZN7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/app.developer.json";

/***/ }),

/***/ "2efs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigation = __webpack_require__("Wavz");

var _navigation2 = _interopRequireDefault(_navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NavigationService settings
 * @type {{name: string, definition: NavigationService}}
 */
exports.default = {
  name: 'NavigationService',
  definition: _navigation2.default
};

/***/ }),

/***/ "2gIx":
/***/ (function(module, exports) {

module.exports = "<md-checkbox class=md-primary ng-model=$ctrl.thingPicture ng-change=$ctrl.onChange() aria-label=checkbox> <span class=md-body-1>Has picture</span> </md-checkbox> <md-icon class=\"material-icons material-icons--help\">help</md-icon>";

/***/ }),

/***/ "2hpa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingDescription = __webpack_require__("l95T");

var _thingDescription2 = _interopRequireDefault(_thingDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("gtHx");

exports.default = {
    bindings: {
        description: '<',
        onUpdate: '&'
    },
    template: template,
    controller: _thingDescription2.default
};

/***/ }),

/***/ "2ii8":
/***/ (function(module, exports) {

module.exports = "<div class=\"box box--grey space-m-v-m\" layout-padding> <md-button class=\"md-primary md-icon-button box__btn-close\" ng-click=$ctrl.close();> <i class=material-icons>add_circle_outline</i> </md-button> <div class=content-title layout=row layout-align=\"start center\"> <span>Send email</span> <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </div> <div> <md-input-container class=\"md-block space-m-t-s\"> <label>Users, roles and email adresses that will receive email</label> <input type=text> </md-input-container> <md-input-container class=md-block> <label>Email subject</label> <input type=text> </md-input-container> <md-input-container class=\"md-block space-m-b-n\"> <label>Email message content</label> <input type=text> </md-input-container> </div> </div> ";

/***/ }),

/***/ "2luL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _isString2 = __webpack_require__("5CkJ");

var _isString3 = _interopRequireDefault(_isString2);

var _luceneQueryGenerator = __webpack_require__("X3A5");

var _luceneQueryGenerator2 = _interopRequireDefault(_luceneQueryGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Lucene class with helper methods to operate with lucene compatible API services.
 */
var Lucene = function () {
    function Lucene() {
        _classCallCheck(this, Lucene);
    }

    _createClass(Lucene, null, [{
        key: 'convertToString',

        /**
         * Convert data to lucene compatible string
         * @param {{metadata: Object, state: Object, alerts: Object, users: Array<number>, devices: Object}} data - Object
         * for conversion
         * @returns {string} Return lucene compatible string
         * @static
         * @example
         * Lucene.convertToString({
         *       metadata: {
         *           name: 'Test',
         *           photo_url: 'url',
         *       },
         *       state: {
         *           battery: {
         *               above: 10,
         *               below: 50
         *           },
         *           rssi: {
         *               above: 5,
         *               below: 20
         *           },
         *           starred: true
         *       },
         *       alerts: {
         *           status: [0, 1]
         *       },
         *       users: [0, 1, 2],
         *       devices: [
         *           {
         *               type: 'temperature',
         *               state: {
         *                   above: 5,
         *                   below: 10
         *               },
         *           },
         *           {
         *               type: 'door',
         *               state: {
         *                   open: false,
         *                   closed: true
         *               },
         *           },
         *           {
         *               type: 'window',
         *               state: {
         *                   open: false,
         *                   closed: true
         *               },
         *           },
         *           {
         *               type: 'theft',
         *               state: {
         *                   present: true,
         *                   absent: false
         *               },
         *           },
         *           {
         *               type: 'cloud-connector',
         *               state: {
         *                   withSensors: true,
         *                   withoutSensors: false
         *               },
         *           }
         *       ]
         *   });
         */
        value: function convertToString(data) {
            var schema = {};
            var operands = [];

            function recursiveLocalOperandsJoinAnd(parsed, parsedItems, items, recursiveOperands) {
                if (parsed && parsedItems < items && recursiveOperands.length === parsedItems) {
                    return ' (' + recursiveOperands.join(' AND ') + ') ';
                }

                return recursiveOperands;
            }

            function recursiveLocalOperandsFlatArrayOrReturn(recursiveOperands) {
                if (Array.isArray(recursiveOperands) && recursiveOperands.length === 1) {
                    return recursiveOperands[0].trim();
                }

                return recursiveOperands;
            }

            function recursiveLocalOperandsParseOperandsResult(result, draftOperands, recursiveOperands) {
                var localResult = result;

                if (localResult === false) {
                    localResult = ' (' + _luceneQueryGenerator2.default.convert(draftOperands, { schema: schema }) + ') ';
                    recursiveOperands.push(localResult);
                } else if (Array.isArray(localResult)) {
                    if ('$operator' in draftOperands) {
                        var operator = ' ' + draftOperands.$operator.toUpperCase() + ' ';

                        localResult = ' (' + localResult.join(operator) + ') ';
                    }
                    recursiveOperands.push(localResult);
                } else {
                    recursiveOperands.push(localResult);
                }
            }

            function recursiveLocalOperandsIsParsed(parsed, recursiveOperands) {
                if (!parsed) {
                    return false;
                }

                return recursiveLocalOperandsFlatArrayOrReturn(recursiveOperands);
            }

            function recursiveLocalOperands(draftOperands) {
                var recursiveOperands = [];
                if (Array.isArray(draftOperands)) {
                    var parsed = false;
                    var parsedItems = 0;
                    var items = draftOperands.length;
                    for (var i = 0; i < items; ++i) {
                        var draftOperand = draftOperands[i];
                        if ('$operands' in draftOperand) {
                            var result = recursiveLocalOperands(draftOperand);
                            if (Array.isArray(result) && result.length === 1) {
                                recursiveOperands.push(result[0].trim());
                            } else {
                                recursiveOperands.push(result);
                            }
                            parsed = true;
                            ++parsedItems;
                        } else {
                            recursiveOperands.push(_luceneQueryGenerator2.default.convert({ $operands: draftOperand }, { schema: schema }));
                        }
                    }

                    recursiveOperands = recursiveLocalOperandsJoinAnd(parsed, parsedItems, items, recursiveOperands);

                    return recursiveLocalOperandsIsParsed(parsed, recursiveOperands);
                } else if ('$operands' in draftOperands) {
                    recursiveLocalOperandsParseOperandsResult(recursiveLocalOperands(draftOperands.$operands), draftOperands, recursiveOperands);
                } else {
                    return false;
                }

                return recursiveLocalOperandsFlatArrayOrReturn(recursiveOperands);
            }

            var localData = JSON.parse(JSON.stringify((0, _cloneDeep3.default)(data)));
            /* {
                metadata: {
                    name: 'Test',
                    photo_url: 'url'
                },
                state: {
                    battery: {
                        above: 10,
                            below: 50
                    },
                    rssi: {
                        from: 5,
                            to: 20
                    },
                    starred: true
                },
                 alerts: {
                    status: [0, 1]
                 },
                users: [0, 1, 2],
                devices: [
                    {
                        type: 'temperature',
                         state: {
                             above: 5,
                             below: 10
                         },
                    },
                    {
                        type: 'door',
                         state: {
                             open: false,
                             closed: true
                         },
                    },
                    {
                        type: 'window',
                         state: {
                             open: false,
                             closed: true
                         },
                    },
                    {
                        type: 'theft',
                         state: {
                             present: true,
                             absent: false
                         },
                    },
                    {
                        type: 'cloud-connector',
                         state: {
                             withSensors: true,
                             withoutSensors: false
                         },
                    }
                ]
            } */

            var attributeTypes = {
                'metadata': function metadata(config) {
                    var result = Lucene.convertMetadataToLuceneCompatible(config);

                    Object.assign(schema, result.schema);
                    operands = operands.concat(result.operands);
                },
                'state': function state(config) {
                    var result = Lucene.convertStateToLuceneCompatible(config);

                    Object.assign(schema, result.schema);
                    operands = operands.concat(result.operands);
                },
                'alerts': function alerts(config) {
                    var result = Lucene.convertAlertsToLuceneCompatible(config);

                    Object.assign(schema, result.schema);
                    operands = operands.concat(result.operands);
                },
                'users': function users(config) {
                    var result = Lucene.convertUsersToLuceneCompatible(config);

                    Object.assign(schema, result.schema);
                    operands = operands.concat(result.operands);
                },
                'folders': function folders(config) {
                    var result = Lucene.convertFoldersToLuceneCompatible(config);

                    operands.push(result);
                },
                'labels': function labels(config) {
                    var result = Lucene.convertLabelsToLuceneCompatible(config);

                    operands.push(result);
                },
                'geo_distance': function geo_distance(config) {
                    var result = Lucene.convertGeoDistanceToLuceneCompatible(config);

                    operands.push(result);
                },
                'devices': function devices(config) {
                    var result = Lucene.convertThingsToLuceneCompatible(config);

                    Object.assign(schema, result.schema);
                    operands = operands.concat(result.operands);
                },
                registered: function registered(config) {
                    var result = Lucene.convertDateRangeToLuceneCompatible(config);

                    operands.push({
                        registered: result
                    });
                },
                last_updated: function last_updated(config) {
                    var result = Lucene.convertDateRangeToLuceneCompatible(config);

                    operands.push({
                        last_updated: result
                    });
                },
                'default': function _default(config, unspecifiedKey) {
                    var tempObject = {};
                    tempObject[unspecifiedKey] = 'Unspecified key';

                    operands.push(tempObject);
                }
            };

            Object.keys(localData).forEach(function (key) {
                return (attributeTypes[key] || attributeTypes.default)(localData[key], key);
            });

            if (operands.length) {
                var localOperands = [];

                operands.forEach(function (operand) {
                    if ((0, _isString3.default)(operand)) {
                        localOperands.push(operand);
                    } else if ('$operands' in operand) {
                        localOperands.push(recursiveLocalOperands(operand));
                    } else {
                        localOperands.push(_luceneQueryGenerator2.default.convert({ $operands: operand }, { schema: schema }));
                    }
                });

                return localOperands.join(' AND ');
            }

            return _luceneQueryGenerator2.default.convert({ $operator: 'and', $operands: operands }, { schema: schema });
        }

        /**
         * Convert state object to lucene builder compatible object
         * @param {{battery: Object, rssi: Object, starred: boolean}} data - State config
         * @returns {{schema: {}, operands: Array}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertStateToLuceneCompatible',
        value: function convertStateToLuceneCompatible(data) {
            /*
            {
                battery: {
                    above: 10,
                    below: 50
                },
                rssi: {
                    above: 5,
                    bellow: 20
                },
                starred: true
            }
            */
            var schema = {};
            var operands = [];

            var types = {
                'battery': function battery(config) {
                    var key = 'state.properties.battery_percentage';
                    var value = Lucene.convertBatteryToLucene(config);

                    if (value) {
                        var tempObject = {};
                        tempObject[key] = value;

                        operands.push(tempObject);
                    }
                },
                'rssi': function rssi(config) {
                    var key = 'state.properties.rssi_strength';
                    var value = Lucene.convertRssiToLucene(config);

                    if (value) {
                        var tempObject = {};
                        tempObject[key] = value;

                        operands.push(tempObject);
                    }
                },
                'starred': function starred(config) {
                    var key = 'starred';
                    var value = config;

                    if (value) {
                        var tempObject = {};
                        tempObject[key] = value.toString();

                        operands.push(tempObject);
                    }
                },
                'default': function _default(config, unspecifiedKey) {
                    var tempObject = {};
                    tempObject['state.' + unspecifiedKey] = 'Unspecified key';

                    operands.push(tempObject);
                }
            };

            Object.keys(data).forEach(function (key) {
                return (types[key] || types.default)(data[key], key);
            });

            return { schema: schema, operands: operands };
        }

        /**
         * Convert metadata object to lucene builder compatible object
         * @param {{name: string, photo_url: string}} data - Metadata config
         * @returns {{schema: {}, operands: Array}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertMetadataToLuceneCompatible',
        value: function convertMetadataToLuceneCompatible(data) {
            /*
             {
                name: 'Test',
                photo_url: 'url'
             }
             */
            var schema = {};
            var operands = [];

            var types = {
                'name': function name(value) {
                    var key = 'name';
                    var tempObject = {};

                    tempObject[key] = value;

                    operands.push(tempObject);
                },
                'photo_url': function photo_url(value) {
                    var key = 'metadata.photo_url';
                    if (value) {
                        var tempObject = {};
                        // TODO: refactor this! with that way it will punch elastic performance right into balls!
                        tempObject[key] = {
                            '$from': '*',
                            '$to': '*'
                        };

                        operands.push(tempObject);
                    }
                },
                'default': function _default(config, unspecifiedKey) {
                    var tempObject = {};
                    tempObject['metadata.' + unspecifiedKey] = 'Unspecified key';

                    operands.push(tempObject);
                }
            };

            Object.keys(data).forEach(function (key) {
                return (types[key] || types.default)(data[key], key);
            });

            if (operands.length > 1) {
                operands = {
                    $operator: 'and',
                    $operands: operands
                };
            } else if (operands.length === 1) {
                operands = operands[0];
            }

            return { schema: schema, operands: operands };
        }

        /**
         * Convert alerts object to lucene builder compatible object
         * @param {{status: Array<number>}} data - Alerts config
         * @returns {{schema: {}, operands: Array}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertAlertsToLuceneCompatible',
        value: function convertAlertsToLuceneCompatible(data) {
            /*
            {
                status: [0, 1]
             }
             */
            var schema = {};
            var operands = [];

            var types = {
                'status': function status(states) {
                    var key = 'alerts.status';

                    states.forEach(function (state) {
                        var tempObject = {};

                        tempObject[key] = state.toString();

                        operands.push(tempObject);
                    });
                },
                'default': function _default(config, unspecifiedKey) {
                    var tempObject = {};
                    tempObject['alerts.' + unspecifiedKey] = 'Unspecified key';

                    operands.push(tempObject);
                }
            };

            Object.keys(data).forEach(function (key) {
                return (types[key] || types.default)(data[key], key);
            });

            if (operands.length > 1) {
                operands = {
                    $operator: 'or',
                    $operands: operands
                };
            } else if (operands.length === 1) {
                operands = operands[0];
            }

            return { schema: schema, operands: operands };
        }

        /**
         * Convert users object to lucene builder compatible object
         * @param {Array<number>} data - Users config
         * @returns {{schema: {}, operands: Array}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertUsersToLuceneCompatible',
        value: function convertUsersToLuceneCompatible(data) {
            /*
             [0, 1, 2],
             */
            var schema = {};
            var operands = [];
            var key = 'users';

            data.forEach(function (userId) {
                var tempObject = {};

                tempObject[key] = userId.toString();

                operands.push(tempObject);
            });

            if (operands.length > 1) {
                operands = {
                    $operator: 'or',
                    $operands: operands
                };
            } else if (operands.length === 1) {
                operands = operands[0];
            }

            return { schema: schema, operands: operands };
        }
    }, {
        key: 'convertFoldersToLuceneCompatible',
        value: function convertFoldersToLuceneCompatible(data) {
            /*
             [0, 1, 2],
             */
            var key = 'folder';

            var operands = data.map(function (folderId) {
                return folderId.toString();
            });

            if (operands.length > 1) {
                return key + ':(' + operands.join(' ') + ')';
            } else if (operands.length === 1) {
                return key + ':' + operands[0];
            }

            return '';
        }
    }, {
        key: 'convertLabelsToLuceneCompatible',
        value: function convertLabelsToLuceneCompatible(data) {
            var operands = [];
            var key = 'labels';
            var query = '';

            data.forEach(function (label) {
                operands.push(label.id.toString());
            });

            if (operands.length > 1) {
                query = key + ':(' + operands.join(' ') + ')';
            } else if (operands.length === 1) {
                query = key + ':' + operands[0];
            }

            return query;
        }
    }, {
        key: 'convertGeoDistanceToLuceneCompatible',
        value: function convertGeoDistanceToLuceneCompatible(data) {
            // geo_distance:{distance:500km, location:{lat:10,lon:102}}
            return 'geo_distance:' + JSON.stringify(data).replace(/"/g, '');
        }

        /**
         * Convert things object to lucene builder compatible object
         * @param {Array<Object>} data - Things config
         * @returns {{schema: {}, operands: Array}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertThingsToLuceneCompatible',
        value: function convertThingsToLuceneCompatible(data) {
            /*
            [
                {
                    type: 'temperature',
                    state: {
                        above: 5,
                        below: 10
                    },
                },
                {
                    type: 'door',
                    state: {
                        open: false,
                        closed: true
                    },
                },
                {
                    type: 'window',
                    state: {
                        open: false,
                        closed: true
                    },
                },
                {
                    type: 'theft',
                    state: {
                        present: true,
                        absent: false
                    },
                },
                {
                    type: 'cloud-connector',
                    state: {
                        withSensors: true,
                        withoutSensors: false
                    },
                }
            ]
            */
            var schema = {};
            var operands = [];

            var constructOperands = function constructOperands(key, value, localOperands) {
                var tempOperands = localOperands.concat([value]);
                tempOperands = {
                    $operator: 'and',
                    $operands: tempOperands
                };

                operands.push(tempOperands);
            };

            var types = {
                'temperature': function temperature(config) {
                    var localOperands = [{ 'type': 'temperature' }];

                    if ('state' in config && config.state) {
                        var stateKey = 'state.properties.temperature';
                        var stateValue = Lucene.convertTemperatureToLucene(config.state, stateKey);

                        if (stateValue) {
                            constructOperands(stateKey, stateValue, localOperands);
                        } else {
                            operands.push(localOperands[0]);
                        }
                    } else {
                        operands.push(localOperands[0]);
                    }
                },
                'door': function door(config) {
                    var localOperands = [{ 'type': 'door' }];

                    if ('state' in config && config.state) {
                        var stateKey = 'state.properties.object_present';
                        var stateValue = Lucene.convertDoorToLucene(config.state, stateKey);

                        if (stateValue) {
                            constructOperands(stateKey, stateValue, localOperands);
                        } else {
                            operands.push(localOperands[0]);
                        }
                    } else {
                        operands.push(localOperands[0]);
                    }
                },
                'window': function window(config) {
                    var localOperands = [{ 'type': 'window' }];

                    if ('state' in config && config.state) {
                        var stateKey = 'state.properties.object_present';
                        var stateValue = Lucene.convertWindowToLucene(config.state, stateKey);

                        if (stateValue) {
                            constructOperands(stateKey, stateValue, localOperands);
                        } else {
                            operands.push(localOperands[0]);
                        }
                    } else {
                        operands.push(localOperands[0]);
                    }
                },
                'proximity': function proximity(config) {
                    var localOperands = [{ 'type': 'proximity' }];

                    if ('state' in config && config.state) {
                        var stateKey = 'state.properties.object_present';
                        var stateValue = Lucene.convertProximityToLucene(config.state, stateKey);

                        if (stateValue) {
                            constructOperands(stateKey, stateValue, localOperands);
                        } else {
                            operands.push(localOperands[0]);
                        }
                    } else {
                        operands.push(localOperands[0]);
                    }
                },
                'touch': function touch() {
                    operands.push({
                        'type': 'touch'
                    });
                },
                'theft': function theft(config) {
                    var localOperands = [{ 'type': 'theft' }];

                    if ('state' in config && config.state) {
                        var stateKey = 'state.properties.object_present';
                        var stateValue = Lucene.convertTheftToLucene(config.state, stateKey);

                        if (stateValue) {
                            constructOperands(stateKey, stateValue, localOperands);
                        } else {
                            operands.push(localOperands[0]);
                        }
                    } else {
                        operands.push(localOperands[0]);
                    }
                },
                'cloud-connector': function cloudConnector() {
                    operands.push({
                        'type': 'cloud-connector'
                    });
                    // TODO: need specification for that case
                    // if ('state' in config && config.state) {
                    //     const stateKey = 'state.object_present';
                    //     const stateValue = Lucene.convertCloudConnectorToLucene(config.state, stateKey);
                    //
                    //     if (stateValue) {
                    //         constructOperands(stateKey, stateValue, localOperands);
                    //     } else {
                    //         operands.push(localOperands);
                    //     }
                    // }
                },
                'default': function _default(config, unspecifiedType) {
                    var tempObject = {};
                    tempObject['config.type'] = 'Unspecified thing type: ' + unspecifiedType;

                    operands.push(tempObject);
                }
            };

            data.forEach(function (thing) {
                return (types[thing.type] || types.default)(thing, thing.type);
            });

            if (operands.length > 1) {
                operands = {
                    $operator: 'or',
                    $operands: operands
                };
            } else if (operands.length === 1) {
                operands = operands[0];
            }

            return { schema: schema, operands: operands };
        }

        /**
         * Convert battery value to lucene builder compatible object
         * @param {{above: number, below: number}} config - Battery config
         * @returns {null|{$from: number, $to: number}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertBatteryToLucene',
        value: function convertBatteryToLucene(config) {
            var value = null;

            if ('above' in config && 'below' in config) {
                value = {
                    $from: config.above.toString(),
                    $to: config.below.toString()
                };
            } else if ('above' in config && !('below' in config)) {
                value = {
                    $from: config.above.toString(),
                    $to: '*'
                };
            } else if (!('above' in config) && 'below' in config) {
                value = {
                    $from: '*',
                    $to: config.below.toString()
                };
            }

            return value;
        }

        /**
         * Convert rssi value to lucene builder compatible object
         * @param {{above: number, below: number}} config - Rssi config
         * @returns {null|{$from: number, $to: number}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertRssiToLucene',
        value: function convertRssiToLucene(config) {
            var value = null;

            if ('above' in config && 'below' in config) {
                value = {
                    $from: config.above.toString(),
                    $to: config.below.toString()
                };
            } else if ('above' in config && !('below' in config)) {
                value = {
                    $from: config.above.toString(),
                    $to: '*'
                };
            } else if (!('above' in config) && 'below' in config) {
                value = {
                    $from: '*',
                    $to: config.below.toString()
                };
            }

            return value;
        }

        /**
         * Convert temperature value to lucene builder compatible object
         * @param {{above: number, below: number}} config - Temperature config
         * @param {string} key - Name of lucene field
         * @returns {null|{$from: number, $to: number}|{$operands: Array<Object>}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertTemperatureToLucene',
        value: function convertTemperatureToLucene(config, key) {
            var value = null;

            if ('above' in config && 'below' in config) {
                value = {
                    $from: config.above.toString(),
                    $to: config.below.toString()
                };
            } else if ('above' in config && !('below' in config)) {
                value = {
                    $from: config.above.toString(),
                    $to: '*'
                };
            } else if (!('above' in config) && 'below' in config) {
                value = {
                    $from: '*',
                    $to: config.below.toString()
                };
            }

            if (value) {
                var tempObj = {};
                tempObj[key] = value;

                return {
                    $operands: [tempObj]
                };
            }

            return value;
        }

        /**
         * Convert door value to lucene builder compatible object
         * @param {{open: boolean, closed: boolean}} config - Door config
         * @param {string} key - Name of lucene field
         * @returns {null|{$operator: string, $operands: Array<Object>}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertDoorToLucene',
        value: function convertDoorToLucene(config, key) {
            return Lucene.convertProximityToLucene(config, key);
        }

        /**
         * Convert window value to lucene builder compatible object
         * @param {{open: boolean, closed: boolean}} config - Window config
         * @param {string} key - Name of lucene field
         * @returns {null|{$operator: string, $operands: Array<Object>}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertWindowToLucene',
        value: function convertWindowToLucene(config, key) {
            return Lucene.convertProximityToLucene(config, key);
        }

        /**
         * Convert proximity value to lucene builder compatible object
         * @param {{open: boolean, closed: boolean}} config - Window config
         * @param {string} key - Name of lucene field
         * @returns {null|{$operator: string, $operands: Array<Object>}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertProximityToLucene',
        value: function convertProximityToLucene(config, key) {
            var value = null;
            var open = {};
            var closed = {};

            if ('open' in config && 'closed' in config) {
                open[key] = 'false';
                closed[key] = 'true';
                value = {
                    $operator: 'OR',
                    $operands: [open, closed]
                };
            } else if ('open' in config && !('closed' in config)) {
                value = _defineProperty({}, key, 'false');
            } else if (!('open' in config) && 'closed' in config) {
                value = _defineProperty({}, key, 'true');
            }

            return value;
        }

        /**
         * Convert theft value to lucene builder compatible object
         * @param {{present: boolean, absent: boolean}} config - Theft config
         * @param {string} key - Name of lucene field
         * @returns {null|{$operator: string, $operands: Array<Object>}} Return lucene builder object
         * @static
         */

    }, {
        key: 'convertTheftToLucene',
        value: function convertTheftToLucene(config, key) {
            var value = null;
            var present = {};
            var absent = {};

            if ('present' in config && 'absent' in config) {
                present[key] = 'true';
                absent[key] = 'false';
                value = {
                    $operator: 'OR',
                    $operands: [present, absent]
                };
            } else if ('present' in config && !('absent' in config)) {
                value = _defineProperty({}, key, 'true');
            } else if (!('present' in config) && 'absent' in config) {
                value = _defineProperty({}, key, 'false');
            }

            return value;
        }
    }, {
        key: 'convertDateRangeToLuceneCompatible',
        value: function convertDateRangeToLuceneCompatible(config) {
            var value = null;

            if (config.after && config.before) {
                value = {
                    $from: config.after,
                    $to: config.before
                };
            } else if (config.after && !config.before) {
                value = {
                    $from: config.after,
                    $to: '*'
                };
            }

            return value;
        }
    }]);

    return Lucene;
}();

exports.default = Lucene;

/***/ }),

/***/ "2ncJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo.png";

/***/ }),

/***/ "2twT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__("aeQg");

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__("63Uv");

var _angularjs2 = _interopRequireDefault(_angularjs);

var _angularMaterial = __webpack_require__("IdJG");

var _angularMaterial2 = _interopRequireDefault(_angularMaterial);

var _common = __webpack_require__("hETz");

var Common = _interopRequireWildcard(_common);

var _components = __webpack_require__("TR+I");

var Components = _interopRequireWildcard(_components);

var _services = __webpack_require__("QQMY");

var Services = _interopRequireWildcard(_services);

var _filters = __webpack_require__("F/iv");

var Filters = _interopRequireWildcard(_filters);

var _app = __webpack_require__("ykX9");

var _app2 = _interopRequireDefault(_app);

var _app3 = __webpack_require__("6kKc");

var _app4 = __webpack_require__("cih7");

var _app5 = _interopRequireDefault(_app4);

var _app6 = __webpack_require__("5GsZ");

var _app7 = _interopRequireDefault(_app6);

__webpack_require__("bThm");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mdDataTable = __webpack_require__("/wei");
var uiTree = __webpack_require__("R0WY");
var angularMoment = __webpack_require__("U54W");
var ngMap = __webpack_require__("Cr9Q");
var ngMessages = __webpack_require__("z4KH");
var ngSanitize = __webpack_require__("bsgf");

/**
 * Common module name
 */
var dtCommon = _angular2.default.module('dt.common', [ngMap]).config(Common.Tree.Config).component(Common.ContentComponent.selector, Common.ContentComponent.options).component(Common.ContentHeaderComponent.selector, Common.ContentHeaderComponent.options).component(Common.Tree.FolderSelectorComponent.selector, Common.Tree.FolderSelectorComponent.options).component(Common.EmptyState.selector, Common.EmptyState.options).component(Common.HeaderComponent.selector, Common.HeaderComponent.options).component(Common.HelpIconComponent.selector, Common.HelpIconComponent.options).component(Common.HelpMenuComponent.Component.selector, Common.HelpMenuComponent.Component.options).component(Common.HelpMenuComponent.ApplicationHelp.selector, Common.HelpMenuComponent.ApplicationHelp.options).component(Common.HelpMenuComponent.FeedbackForm.selector, Common.HelpMenuComponent.FeedbackForm.options).directive(Common.ScreenshotDirective.selector, Common.ScreenshotDirective.options).directive(Common.DragDrop.selector, Common.DragDrop.options).component(Common.IconComponent.selector, Common.IconComponent.options).directive(Common.IconDirective.selector, Common.IconDirective.options).directive(Common.ShyDirective.selector, Common.ShyDirective.options).directive(Common.StickyDirective.selector, Common.StickyDirective.options).directive(Common.GetFocusDirective.selector, Common.GetFocusDirective.options).directive(Common.GetWidthDirective.selector, Common.GetWidthDirective.options).directive(Common.BackropDirective.selector, Common.BackropDirective.options).directive(Common.BlockLoaderDirective.selector, Common.BlockLoaderDirective.options).directive(Common.ChartDirective.selector, Common.ChartDirective.options).directive(Common.EditNavBarDirective.selector, Common.EditNavBarDirective.options).directive(Common.OnEnterDirective.selector, Common.OnEnterDirective.options).component(Common.MapComponent.selector, Common.MapComponent.options).component(Common.LayoutComponent.selector, Common.LayoutComponent.options).component(Common.LoaderComponent.selector, Common.LoaderComponent.options).service(Common.LoaderService.name, Common.LoaderService.definition).component(Common.Navigation.LeftNavigationComponent.selector, Common.Navigation.LeftNavigationComponent.options).component(Common.Navigation.TabsComponent.selector, Common.Navigation.TabsComponent.options).component(Common.AccessManagementComponent.selector, Common.AccessManagementComponent.options).component(Common.RulesListComponent.selector, Common.RulesListComponent.options).component(Common.RuleComponent.selector, Common.RuleComponent.options).component(Common.BatteryStatusComponent.selector, Common.BatteryStatusComponent.options).component(Common.FolderPathComponent.selector, Common.FolderPathComponent.options).directive(Common.FolderPathEditDirective.selector, Common.FolderPathEditDirective.options).component(Common.RadioStatusComponent.selector, Common.RadioStatusComponent.options).component(Common.ThingStarComponent.selector, Common.ThingStarComponent.options).component(Common.SearchBox.selector, Common.SearchBox.options).component(Common.UserPopover.selector, Common.UserPopover.options).directive(Common.SaveView.Directive.selector, Common.SaveView.Directive.options).directive(Common.mdCustomColumnDirective.selector, Common.mdCustomColumnDirective.options).component(Common.EntitiesListComponent.selector, Common.EntitiesListComponent.options).component(Common.SearchAutocompleteComponent.selector, Common.SearchAutocompleteComponent.options).component(Common.EntitiesAutocompleteComponent.selector, Common.EntitiesAutocompleteComponent.options).component(Common.LabelsAutocompleteComponent.selector, Common.LabelsAutocompleteComponent.options).component(Common.SplashScreen.selector, Common.SplashScreen.options).name;

var dashboard = Components.Dashboard;
var sensorsAndConnectors = Components.SensorsAndConnectors;
var foldersAndLabels = Components.FoldersAndLabels;
var usersAndAccess = Components.UsersAndAccess;
var developerSettings = Components.DeveloperSettings;
var alertsActions = Components.AlertsActions;
var accountSettings = Components.AccountSettings;
var companySettings = Components.CompanySettings;
var notifications = Components.Notifications;

var sacsComponents = sensorsAndConnectors.Components;
var details = sacsComponents.ThingDetails;
var search = sacsComponents.Search;

/**
 * Components module name
 */
var dtComponents = _angular2.default.module('dt.components', [mdDataTable]).config(dashboard.Config).component(dashboard.Component.selector, dashboard.Component.options).config(sensorsAndConnectors.Routes).config(sensorsAndConnectors.Graphs.Routes).component(sensorsAndConnectors.Component.selector, sensorsAndConnectors.Component.options).component(sensorsAndConnectors.Tabs.selector, sensorsAndConnectors.Tabs.options).component(sensorsAndConnectors.ListContainer.selector, sensorsAndConnectors.ListContainer.options).component(sensorsAndConnectors.Graphs.Component.selector, sensorsAndConnectors.Graphs.Component.options).component(sensorsAndConnectors.Components.ThingChartComponent.selector, sensorsAndConnectors.Components.ThingChartComponent.options)

// THING DETAILS: START
.component(details.Component.selector, details.Component.options).component(details.AdvancedInformationComponent.selector, details.AdvancedInformationComponent.options).component(details.AlertBoxComponent.selector, details.AlertBoxComponent.options).component(details.DetailsChartComponent.selector, details.DetailsChartComponent.options).component(details.GeneralInformationComponent.selector, details.GeneralInformationComponent.options).component(details.ThingLocation.selector, details.ThingLocation.options).component(details.ThingName.selector, details.ThingName.options).component(details.ThingDetailsLabels.selector, details.ThingDetailsLabels.options).component(details.ThingDetailsFolder.selector, details.ThingDetailsFolder.options).component(details.ThingDescription.selector, details.ThingDescription.options).component(details.NotesComponent.selector, details.NotesComponent.options).component(details.PermissionsComponent.selector, details.PermissionsComponent.options).component(details.RecentEventsComponent.selector, details.RecentEventsComponent.options)
// THING DETAILS: END

.component(sacsComponents.ThingsToolboxComponent.selector, sacsComponents.ThingsToolboxComponent.options).component(sacsComponents.ThingsListComponent.selector, sacsComponents.ThingsListComponent.options)

// SIMPLE SEARCH: START
.component(search.SimpleSearchComponent.selector, search.SimpleSearchComponent.options)
// SIMPLE SEARCH: END

// ADVANCED SEARCH: START
.component(search.AdvancedSearch.Component.selector, search.AdvancedSearch.Component.options).component(search.AdvancedSearch.ThingNameComponent.selector, search.AdvancedSearch.ThingNameComponent.options).component(search.AdvancedSearch.ThingOwnerComponent.selector, search.AdvancedSearch.ThingOwnerComponent.options).component(search.AdvancedSearch.ThingStatusComponent.selector, search.AdvancedSearch.ThingStatusComponent.options).component(search.AdvancedSearch.ThingStarComponent.selector, search.AdvancedSearch.ThingStarComponent.options).component(search.AdvancedSearch.ThingPictureComponent.selector, search.AdvancedSearch.ThingPictureComponent.options).component(search.AdvancedSearch.ThingTypeComponent.selector, search.AdvancedSearch.ThingTypeComponent.options).component(search.AdvancedSearch.ThingBatteryComponent.selector, search.AdvancedSearch.ThingBatteryComponent.options).component(search.AdvancedSearch.ThingSignalComponent.selector, search.AdvancedSearch.ThingSignalComponent.options).component(search.AdvancedSearch.ThingRegisteredComponent.selector, search.AdvancedSearch.ThingRegisteredComponent.options).component(search.AdvancedSearch.ThingUpdatedComponent.selector, search.AdvancedSearch.ThingUpdatedComponent.options).component(search.AdvancedSearch.ThingLocationComponent.selector, search.AdvancedSearch.ThingLocationComponent.options).component(search.AdvancedSearch.ThingLabelsComponent.selector, search.AdvancedSearch.ThingLabelsComponent.options).component(search.AdvancedSearch.ThingNotesComponent.selector, search.AdvancedSearch.ThingNotesComponent.options).component(search.AdvancedSearch.ThingFoldersComponent.selector, search.AdvancedSearch.ThingFoldersComponent.options)
// ADVANCED SEARCH: END


// FOLDERS AND LABELS: START
.config(foldersAndLabels.Config).config(foldersAndLabels.Folders.Config).config(foldersAndLabels.Labels.Config).component(foldersAndLabels.Component.selector, foldersAndLabels.Component.options).component(foldersAndLabels.Folders.Component.selector, foldersAndLabels.Folders.Component.options).component(foldersAndLabels.Folders.FolderDetails.selector, foldersAndLabels.Folders.FolderDetails.options).component(foldersAndLabels.Folders.FolderTree.Component.selector, foldersAndLabels.Folders.FolderTree.Component.options).component(foldersAndLabels.Folders.FolderTree.AddFolderComponent.selector, foldersAndLabels.Folders.FolderTree.AddFolderComponent.options).component(foldersAndLabels.Labels.Component.selector, foldersAndLabels.Labels.Component.options).component(foldersAndLabels.Labels.LabelDetails.selector, foldersAndLabels.Labels.LabelDetails.options)
// FOLDERS AND LABELS: END


// USERS AND ACCESS: START
.config(usersAndAccess.Config).config(usersAndAccess.Users.Config).config(usersAndAccess.Roles.Config).config(usersAndAccess.Customers.Config).component(usersAndAccess.Component.selector, usersAndAccess.Component.options).component(usersAndAccess.Users.Component.selector, usersAndAccess.Users.Component.options).component(usersAndAccess.Users.UACAddUser.selector, usersAndAccess.Users.UACAddUser.options).component(usersAndAccess.Roles.Component.selector, usersAndAccess.Roles.Component.options).component(usersAndAccess.Roles.UACRoleUsers.selector, usersAndAccess.Roles.UACRoleUsers.options).component(usersAndAccess.Customers.Component.selector, usersAndAccess.Customers.Component.options)
// USERS AND ACCESS: END

// Developer Settings: START
.config(developerSettings.Config)
// .config(developerSettings.apiAccess.Config)
.component(developerSettings.Component.selector, developerSettings.Component.options).component(developerSettings.apiAccess.Component.selector, developerSettings.apiAccess.Component.options)
// Developer Settings: END

// Alerts & Actions: START
.config(alertsActions.Config).component(alertsActions.Component.selector, alertsActions.Component.options).component(alertsActions.AlertsActionsNav.selector, alertsActions.AlertsActionsNav.options).component(alertsActions.AlertsActionsContent.Component.selector, alertsActions.AlertsActionsContent.Component.options).component(alertsActions.AlertsActionsContent.Actions.Component.selector, alertsActions.AlertsActionsContent.Actions.Component.options).component(alertsActions.AlertsActionsContent.Actions.CreateNotifications.selector, alertsActions.AlertsActionsContent.Actions.CreateNotifications.options).component(alertsActions.AlertsActionsContent.Actions.SendMail.selector, alertsActions.AlertsActionsContent.Actions.SendMail.options).component(alertsActions.AlertsActionsContent.Actions.TriggerWebhook.selector, alertsActions.AlertsActionsContent.Actions.TriggerWebhook.options).component(alertsActions.AlertsActionsContent.TimePeriod.Component.selector, alertsActions.AlertsActionsContent.TimePeriod.Component.options).component(alertsActions.AlertsActionsContent.TimePeriod.SpecificTime.selector, alertsActions.AlertsActionsContent.TimePeriod.SpecificTime.options)
// Alerts & Actions: END

// Accounts Settings: START
.config(accountSettings.Config).component(accountSettings.Component.selector, accountSettings.Component.options)
// Accounts Settings: END

// Company Settings: START
.config(companySettings.Config).component(companySettings.Component.selector, companySettings.Component.options)
// Company Settings: END

// Company Notifications: START
.config(notifications.Config).component(notifications.Component.selector, notifications.Component.options)
// Company Notifications: END
.name;

_angular2.default.module('app', [ngMessages, _angularjs2.default, _angularMaterial2.default, ngSanitize, uiTree, dtCommon, dtComponents, angularMoment]).component(_app7.default.selector, _app7.default.options).config(_app2.default).config(_app3.AppConfig).config(Services.Auth.InterceptorConfig).service(Services.Interceptors.HttpInterceptor.name, Services.Interceptors.HttpInterceptor.definition).value(_app3.EventEmitter.name, _app3.EventEmitter.definition).service(Services.Config.RemoteConfigService.name, Services.Config.RemoteConfigService.definition).service(Services.Things.Service.name, Services.Things.Service.definition).service(Services.Notifications.Service.name, Services.Notifications.Service.definition).service(Services.Errors.Service.name, Services.Errors.Service.definition).service(Services.Help.Service.name, Services.Help.Service.definition).service(Services.Geo.Service.name, Services.Geo.Service.definition).service(Services.CharsService.name, Services.CharsService.definition).service(Services.DialogService.name, Services.DialogService.definition).service(Services.FolderService.name, Services.FolderService.definition).service(Services.HealthCheckerService.name, Services.HealthCheckerService.definition).service(Services.Auth.AuthService.name, Services.Auth.AuthService.definition).service(Services.ToastService.name, Services.ToastService.definition).service(Services.TranslationService.name, Services.TranslationService.definition).service(Services.NavigationService.name, Services.NavigationService.definition).service(Services.Api.MenuApiService.name, Services.Api.MenuApiService.definition).service(Services.Api.DeveloperApiService.name, Services.Api.DeveloperApiService.definition).service(Services.Api.AlertsActionsApiService.name, Services.Api.AlertsActionsApiService.definition).service(Services.Api.ConfigApiService.name, Services.Api.ConfigApiService.definition).service(Services.Api.AlertsApiService.name, Services.Api.AlertsApiService.definition).service(Services.Api.NotificationsApiService.name, Services.Api.NotificationsApiService.definition).constant(Services.Api.ThingsApi.Constant.name, Services.Api.ThingsApi.Constant.value).service(Services.Api.ThingsApi.Service.name, Services.Api.ThingsApi.Service.definition).service(Services.Api.EventsApiService.name, Services.Api.EventsApiService.definition).service(Services.Api.HistoryApiService.name, Services.Api.HistoryApiService.definition).service(Services.Api.NotesApiService.name, Services.Api.NotesApiService.definition).service(Services.Api.LabelsApiService.name, Services.Api.LabelsApiService.definition).service(Services.Api.AuthUsersApiService.name, Services.Api.AuthUsersApiService.definition).service(Services.Api.FoldersApiService.name, Services.Api.FoldersApiService.definition).service(Services.Api.ViewsApiService.name, Services.Api.ViewsApiService.definition).service(Services.Api.CategoriesApiService.name, Services.Api.CategoriesApiService.definition).service(Services.Api.NavigationApiService.name, Services.Api.NavigationApiService.definition).service(Services.Api.CustomersApiService.name, Services.Api.CustomersApiService.definition).service(Services.Api.RolesApiService.name, Services.Api.RolesApiService.definition).service(Services.Api.UsersApiService.name, Services.Api.UsersApiService.definition).service(Services.Api.PrivilegesApiService.name, Services.Api.PrivilegesApiService.definition).service(Services.Api.FeedbackApiService.name, Services.Api.FeedbackApiService.definition).filter(Filters.Plural.name, Filters.Plural.definition).run(_app5.default);

/***/ }),

/***/ "3/H6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _chart = __webpack_require__("lfBu");

var _chart2 = _interopRequireDefault(_chart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtChart',
    options: _chart2.default
};

/***/ }),

/***/ "303b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _folders = __webpack_require__("uNYU");

var _folders2 = _interopRequireDefault(_folders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * FoldersApi settings
 * @type {{name: string, definition: FoldersApi}}
 */
exports.default = {
  name: 'FoldersApi',
  definition: _folders2.default
};

/***/ }),

/***/ "32Ub":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search = __webpack_require__("MV+4");

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("rpcn");

exports.default = {
    bindings: {
        query: '<',
        onFocusChange: '&',
        onSearchResult: '&',
        onBeforeSearch: '&',
        onEmptySearch: '&'
    },
    template: template,
    controller: _search2.default
};

/***/ }),

/***/ "32b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _labels = __webpack_require__("UDfw");

var _labels2 = _interopRequireDefault(_labels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * LabelsApi settings
 * @type {{name: string, definition: LabelsApi}}
 */
exports.default = {
  name: 'LabelsApi',
  definition: _labels2.default
};

/***/ }),

/***/ "3FGJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/warn-chart-icon-16.png";

/***/ }),

/***/ "3Oj2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autocomplete = __webpack_require__("ZV/g");

var _autocomplete2 = _interopRequireDefault(_autocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("m/NR");

exports.default = {
    bindings: {
        entities: '<',
        editable: '<',
        requireMatch: '<',
        onSearch: '&',
        onChange: '&',
        onAdd: '&',
        onRemove: '&',
        textKey: '@',
        placeholder: '@',
        secondaryPlaceholder: '@'

    },
    controller: _autocomplete2.default,
    template: template
};

/***/ }),

/***/ "3dRZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _icon = __webpack_require__("RLG5");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("isvF");

exports.default = {
    bindings: {
        iconClass: '<',
        colorClass: '<',
        hasExclamation: '<',
        iconSize: '@',
        showAriaLabel: '<'
    },
    template: template,
    controller: _icon2.default
};

/***/ }),

/***/ "3nmL":
/***/ (function(module, exports) {

module.exports = "<dt-layout class=dt-layout layout=column flex=100></dt-layout>";

/***/ }),

/***/ "3ulZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _folderPathEdit = __webpack_require__("vmFd");

var _folderPathEdit2 = _interopRequireDefault(_folderPathEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtFolderPathEdit',
    options: _folderPathEdit2.default
};

/***/ }),

/***/ "3zRx":
/***/ (function(module, exports) {

module.exports = "<md-content layout=column data-ng-class=\"{\n                'dt-layout--expanded': !$ctrl.navCollapsed,\n                'dt-layout--collapsed': $ctrl.navCollapsed,\n                'mobile-nav-open': $ctrl.isMobileNav\n            }\" flex> <dt-layout-header class=dt-layout-header on-show-mobile-nav=$ctrl.showMobileNav($event)></dt-layout-header> <dt-navbar-left data-ng-class=\"{'dt-navbar--expanded': !$ctrl.navCollapsed, 'dt-navbar--collapsed': $ctrl.navCollapsed}\" class=dt-navbar nav=::$ctrl.appMenu on-toggle=$ctrl.onNavToggle(isCollapsed)> </dt-navbar-left> <div class=mobile-nav-scrim ng-click=$ctrl.hideMobileNav()></div> <dt-layout-content class=dt-layout-content layout=row flex></dt-layout-content> </md-content> ";

/***/ }),

/***/ "4+qO":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"start start\" layout-margin flex> <div class=\"content-box developer-settings\" flex-xs-auto layout-padding> <div> <h3 class=\"box-title space-m-t-n\">API Key</h3> <div class=\"alert-box alert-box--info\"> <div layout=row layout-align=\"start center\"> <md-icon class=alert-box__icon>info_outline</md-icon> <div class=space-m-l-m> API Usage is subject to the terms and conditions set out in the signed Pilot Kit Agreement.<br> Using the API without a signed Pilot Kit Agreement is illegal. </div> </div> </div> <div class=developer-settings__key-box layout=row layout-align=\"start center\"> <span class=\"developer-settings__key text-emphasis\" flex>zx89jiaojd9--as988d8as7d8hjak</span> <a href=# class=md-secondary> <md-icon class=material-icons--s>content_copy</md-icon> Copy </a> </div> <div class=developer-settings__regenerate-box layout=row layout-align=\"start center\"> <div> <md-button class=developer-settings__regenerate-btn>Regenerate Key</md-button> </div> <div class=\"developer-settings__regenerate-desc space-m-l-xl\"> <p>Your old API Key and any app using it will stop working if you regenerate your key.</p> <p>It will take a few minutes for this change to be reflected everywhere across the solution.</p> </div> </div> </div> </div> <section layout=column flex=30 ng-if=$ctrl.developer.access> <div class=\"box space-m-b-m\" layout-padding> <header class=\"block-header block-header--accent\"> <h4 class=\"box-title space-m-t-n\">api key</h4> <div class=text-emphasis data-ng-bind=$ctrl.developer.key></div> </header> <div layout=row layout-align=\"start center\"> <div> <md-button class=\"md-primary md-raised space-p-h-m space-m-l-n space-m-r-m\" ng-click=$ctrl.regenerateKey()>Regenerate key</md-button> </div> <div class=text-grey>Your old API Key and any app using it will stop working if you regenerate your key.</div> </div> </div> <div class=box layout-padding> <div class=\"box-title space-m-v-n\">Applications</div> <md-list flex style=\"margin:0 -16px\"> <md-list-item class=\"md-2-line dt-theme\" ng-class=\"{'md-2-line--active': item.id == $ctrl.currentAppId}\" ng-repeat=\"item in $ctrl.developer.apps\" ng-click=$ctrl.select(item)> <img ng-if=item.image ng-src={{item.image}}?20 class=md-avatar alt={{item.description}} /> <div ng-if=!item.image class=\"md-avatar-icon fa fa-th-large\"></div> <div class=md-list-item-text> <h3 ng-bind=item.name></h3> <p>App ID: {{item.id}}</p> </div> </md-list-item> </md-list> <footer> <a href=# class=md-caption ng-click=\"$ctrl.create($event); $event.preventDefault();\">+ Create new application</a> </footer> </div> </section> <div class=\"box flex-30\" layout-padding ng-if=$ctrl.currentApp> <header class=\"block-header block-header--accent\" layout=column> <md-input-container class=\"input-container--large space-m-v-n md-block\"> <input type=text ng-model=$ctrl.currentApp.name> <div class=\"md-input-hint text-accent\">ID: {{ $ctrl.currentApp.id }}</div> </md-input-container> </header> <form action=# name=applicationForm> <div layout=column> <md-input-container class=space-m-v-n> <label>App description</label> <textarea ng-keydown=null rows=3 ng-model=$ctrl.currentApp.description md-no-autogrow=true md-no-resize=true aria-label=\"Descripbe application\"></textarea> </md-input-container> </div> <div layout=column> <div layout=row layout-align=\"start center\"> <md-input-container flex> <label>App Secret</label> <input class=md-input--secret disabled=disabled type=\"{{ $ctrl.showAppSecret ? 'text': 'password' }}\" ng-value=\"$ctrl.showAppSecret ? $ctrl.currentApp.secret : '••••••••'\"> <div class=md-input-hint> <a href=# ng-click=\"$ctrl.regenerateSecretKey($event); $event.preventDefault();\">Regenerate secret</a> </div> </md-input-container> <md-button class=md-primary ng-click=$ctrl.toggleAppSecret()>show</md-button> </div> </div> <div class=block-title>application icon</div> <dt-upload-icon class=upload-icon layout=row layout-align=\"start center\"> <div class=upload-icon__default> <i class=\"fa fa-th-large\"></i> </div> <div> <md-button class=md-primary ng-click=$ctrl.showUpload()>Upload new icon</md-button> <div class=\"md-caption text-greyBlue\"> <i>Recommended: min 256×256px, png/jpg/gif</i> </div> </div> <input class=is-hidden type=file name=applicationIcon id={{::$ctrl.inputFileId}}> </dt-upload-icon> </form> <footer class=block-footer> <div class=block-footer__actions-bar> <a href=# class=md-secondary ng-click=\"$ctrl.remove(); $event.preventDefault();\"> <i class=\"material-icons material-icons--s\">delete</i> Delete application </a> <span flex></span> <md-button class=md-primary ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=md-primary ng-click=$ctrl.save()>Save changes</md-button> </div> </footer> </div> </div> ";

/***/ }),

/***/ "4/CJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _users = __webpack_require__("1hlv");

var _users2 = _interopRequireDefault(_users);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * UsersApi settings
 * @type {{name: string, definition: UsersApi}}
 */
exports.default = {
  name: 'UsersApi',
  definition: _users2.default
};

/***/ }),

/***/ "42OU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _labelDetails = __webpack_require__("1itO");

var _labelDetails2 = _interopRequireDefault(_labelDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("VhMM");

exports.default = {
    bindings: {
        label: '<',
        onSaved: '&',
        onEditCancelled: '&',
        onDeleted: '&',
        onNameChange: '&'
    },
    controller: _labelDetails2.default,
    template: template
};

/***/ }),

/***/ "47vn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _users = __webpack_require__("xGfM");

var _users2 = _interopRequireDefault(_users);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("aU5s");

exports.default = {
    controller: _users2.default,
    template: template
};

/***/ }),

/***/ "4JbS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * DialogService class.
 * Use this service to create dialogs.
 */
var DialogService = function () {
    /**
     * @param {$mdDialog} $mdDialog - Angular-Material dialog service
     * @constructor
     * @ngInject
     */
    DialogService.$inject = ["$mdDialog"];
    function DialogService($mdDialog) {
        _classCallCheck(this, DialogService);

        this.dialog = $mdDialog;
    }

    /**
     * Create confirm dialog by given config
     * @param {Object} config - Config for dialog
     * @returns {promise}
     */


    _createClass(DialogService, [{
        key: 'confirm',
        value: function confirm(config) {
            return this.show(this.dialog.confirm(config));
        }

        /**
         * Create prompt dialog by given config
         * @param {Object} config - Config for dialog
         * @returns {promise}
         */

    }, {
        key: 'prompt',
        value: function prompt(config) {
            return this.show(this.dialog.prompt(config));
        }

        /**
         * Create modal dialog by given config
         * @param {Object} config - Config for dialog
         * @returns {promise}
         */

    }, {
        key: 'show',
        value: function show(config) {
            return this.dialog.show(config);
        }

        /**
         * Close dialog
         * @param {Object} dialog - Dialog object. If not passed then internal this.dialog will be used
         */

    }, {
        key: 'cancel',
        value: function cancel(dialog) {
            if (dialog && typeof dialog.cancel === 'function') {
                dialog.cancel();
            } else {
                this.dialog.cancel();
            }
        }

        /**
         * Close dialog
         * @param {Object} dialog - Dialog data.
         */

    }, {
        key: 'hide',
        value: function hide(data) {
            this.dialog.hide(data);
        }
    }]);

    return DialogService;
}();

exports.default = DialogService;

/***/ }),

/***/ "4OjK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingNotes = __webpack_require__("xowN");

var _thingNotes2 = _interopRequireDefault(_thingNotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("sL6j");

exports.default = {
    bindings: {
        reset: '<',
        notes: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingNotes2.default
};

/***/ }),

/***/ "4R3X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _folderPath = __webpack_require__("FznX");

var _folderPath2 = _interopRequireDefault(_folderPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("8xGQ");

exports.default = {
    bindings: {
        folderId: '<',
        emptyTrail: '<',
        maxWidth: '<',
        fontSize: '@'
    },
    template: template,
    controller: _folderPath2.default
};

/***/ }),

/***/ "4atV":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"start start\" flex layout-margin> <div class=\"box flex-20\" layout-padding> <form action=#> <div class=\"form-group form-group--large\"> <md-input-container class=\"form-element form-element--simple\"> <input type=text ng-model=$ctrl.queryForSearchRoles ng-change=$ctrl.filterRoles()> </md-input-container> <md-button class=\"md-primary md-raised md-button--icon space-m-b-n\"> <md-icon class=material-icons>search</md-icon> </md-button> </div> <dt-entities-list entities=$ctrl.rolesFiltered on-entity-selected=$ctrl.onRolesSelected($event) entity-type=role on-entity-created=$ctrl.onRoleCreate($event)></dt-entities-list> </form> </div> <div class=box flex=30 data-ng-if=$ctrl.currentRole> <div layout=column layout-padding> <header class=\"block-header block-header--accent\"> <md-input-container class=\"md-block input-container--large\"> <label for=name>Name</label> <input id=name ng-model=$ctrl.currentRole.name type=text> </md-input-container> <md-input-container class=md-block> <label for=description>Description</label> <input id=description ng-model=$ctrl.currentRole.description type=text> <div class=md-input-hint> What is this role, and who should have it? </div> </md-input-container> </header> <section> <div class=md-block-header>privileges</div> <ul class=\"custom-list custom-list--simple\"> <li> <md-checkbox ng-model=checkbox1>Add, edit, and delete labels</md-checkbox> </li> <li> <md-checkbox ng-model=checkbox2>Add, edit, and delete folders</md-checkbox> </li> <li> <md-checkbox ng-model=checkbox3>Edit nav bar</md-checkbox> </li> </ul> </section> <footer class=block-footer> <div class=block-footer__actions-bar> <md-button class=\"md-default md-button--with-icon md-button--s\" ng-click=$ctrl.onDeleteCurrentRole()> <md-icon class=material-icons>delete</md-icon> Delete this role </md-button> <span flex></span> <md-button class=md-primary ng-click=$ctrl.onResetCurrentRole()>Reset</md-button> <md-button class=md-primary ng-click=$ctrl.onUpdateCurrentRole()>Save changes</md-button> </div> </footer> </div> </div> <div class=\"box flex-30\" data-ng-if=$ctrl.currentRole> <section layout=column layout-padding> <div class=container> <h4 class=block-heading>Users with this role</h4> <dt-role-users users=$ctrl.currentRole.users on-remove-user=$ctrl.onRemoveUser($event) on-add-user=$ctrl.onAddUser($event)></dt-role-users> </div> </section> </div> </div>";

/***/ }),

/***/ "4jHz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Rule = function Rule() {
  _classCallCheck(this, Rule);
};

exports.default = Rule;

/***/ }),

/***/ "4lQk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/customer.json";

/***/ }),

/***/ "53v/":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("IVes"),
    noop = __webpack_require__("uTXi"),
    setToArray = __webpack_require__("ZEJm");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "59za":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _menu = __webpack_require__("vkwR");

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * MenuApi settings
 * @type {{name: string, definition: MenuApi}}
 */
exports.default = {
  name: 'MenuApi',
  definition: _menu2.default
};

/***/ }),

/***/ "5GET":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autocomplete = __webpack_require__("3Oj2");

var _autocomplete2 = _interopRequireDefault(_autocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtEntitiesAutocomplete',
    options: _autocomplete2.default
};

/***/ }),

/***/ "5GsZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__("0k6n");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * App component settings for further initialization
 */
exports.default = {
  selector: 'dtApp',
  options: _app2.default
};

/***/ }),

/***/ "5WPP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _shy = __webpack_require__("QeIE");

var _shy2 = _interopRequireDefault(_shy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'imSoShy',
    options: _shy2.default
};

/***/ }),

/***/ "5XMH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lucene = __webpack_require__("2luL");

var _lucene2 = _interopRequireDefault(_lucene);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdvancedSearchController = function () {
    /** @ngInject */
    AdvancedSearchController.$inject = ["Loader", "ThingsApi", "EventEmitter", "$timeout"];
    function AdvancedSearchController(Loader, ThingsApi, EventEmitter, $timeout) {
        _classCallCheck(this, AdvancedSearchController);

        this.Loader = Loader;
        this.ThingsApi = ThingsApi;
        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
    }

    _createClass(AdvancedSearchController, [{
        key: '$onInit',
        value: function $onInit() {
            this.advancedSearchBuckets = {};
            this.isProcessing = false;
            this.hasBuckets = false;

            this.query = '';

            this.labels = [];
            this.notes = [];
            this.folders = [];

            this.resetSearchSettings();
        }
    }, {
        key: 'resetSearchSettings',
        value: function resetSearchSettings() {
            this.thingName = true;
            this.thingOwner = true;
            this.thingStatus = true;
            this.thingStarred = true;
            this.thingHasPicture = true;
            this.thingType = true;
            this.thingBattery = true;
            this.thingSignal = true;
            this.thingRegistered = true;
            this.thingUpdated = true;
            this.thingLocation = true;
            this.thingLabels = true;
            this.thingNotes = true;
            this.thingFolders = true;
        }
    }, {
        key: 'onThingNameUpdate',
        value: function onThingNameUpdate(_ref) {
            var value = _ref.value;

            this.thingName = value;
        }
    }, {
        key: 'onThingOwnerUpdate',
        value: function onThingOwnerUpdate(_ref2) {
            var value = _ref2.value;

            this.thingOwner = value;
        }
    }, {
        key: 'onThingStatusUpdate',
        value: function onThingStatusUpdate(_ref3) {
            var value = _ref3.value;

            this.thingStatus = value;
        }
    }, {
        key: 'onThingStarredUpdate',
        value: function onThingStarredUpdate(_ref4) {
            var value = _ref4.value;

            this.thingStarred = !value;
        }
    }, {
        key: 'onThingHasPictureUpdate',
        value: function onThingHasPictureUpdate(_ref5) {
            var value = _ref5.value;

            this.thingHasPicture = !value;
        }
    }, {
        key: 'onThingTypeUpdate',
        value: function onThingTypeUpdate(_ref6) {
            var value = _ref6.value;

            this.thingType = value;
        }
    }, {
        key: 'onThingBatteryUpdate',
        value: function onThingBatteryUpdate(_ref7) {
            var value = _ref7.value;

            this.thingBattery = value;
        }
    }, {
        key: 'onThingSignalUpdate',
        value: function onThingSignalUpdate(_ref8) {
            var value = _ref8.value;

            this.thingSignal = value;
        }
    }, {
        key: 'onThingRegisteredUpdate',
        value: function onThingRegisteredUpdate(_ref9) {
            var value = _ref9.value;

            this.thingRegistered = value;
        }
    }, {
        key: 'onThingUpdatedUpdate',
        value: function onThingUpdatedUpdate(_ref10) {
            var value = _ref10.value;

            this.thingUpdated = value;
        }
    }, {
        key: 'onThingLocationUpdate',
        value: function onThingLocationUpdate(_ref11) {
            var value = _ref11.value;

            this.thingLocation = value;
        }
    }, {
        key: 'onThingLabelsUpdate',
        value: function onThingLabelsUpdate(_ref12) {
            var value = _ref12.value;

            this.thingLabels = value;
        }
    }, {
        key: 'onThingNotesUpdate',
        value: function onThingNotesUpdate(_ref13) {
            var value = _ref13.value;

            this.thingNotes = value;
        }
    }, {
        key: 'onThingFoldersUpdate',
        value: function onThingFoldersUpdate(_ref14) {
            var value = _ref14.value;

            this.thingFolders = value;
        }
    }, {
        key: 'setItemInAdvancedSearchBucket',
        value: function setItemInAdvancedSearchBucket(_ref15) {
            var item = _ref15.item;

            _utils2.default.createPath(this.advancedSearchBuckets, item.name, item.value);
            this.hasBuckets = true;

            this.query = _lucene2.default.convertToString(this.advancedSearchBuckets);

            return this.advancedSearchBuckets;
        }
    }, {
        key: 'removeItemFromAdvancedSearchBucket',
        value: function removeItemFromAdvancedSearchBucket(_ref16) {
            var item = _ref16.item;

            if (!Object.keys(this.advancedSearchBuckets).length) return this.advancedSearchBuckets;

            _utils2.default.crawlObjectByPath(this.advancedSearchBuckets, item.name, true);

            this.hasBuckets = Object.keys(this.advancedSearchBuckets).length > 0;

            this.query = _lucene2.default.convertToString(this.advancedSearchBuckets);

            return this.advancedSearchBuckets;
        }
    }, {
        key: 'onSearch',
        value: function onSearch() {
            if (!Object.keys(this.advancedSearchBuckets).length || this.isProcessing || !this.query.length) {
                return;
            }

            // this.startProcessing();
            //
            // this.ThingsApi
            //     .search(this.query)
            //     .then(
            //         (data) => {
            this.triggerSearchResult();
            //         this.stopProcessing();
            //     },
            //     this.stopProcessing.bind(this)
            // );
        }
    }, {
        key: 'triggerSearchResult',
        value: function triggerSearchResult() {
            this.onSearchResult(this.eventEmitter({
                query: this.query
            }));
        }
    }, {
        key: 'startProcessing',
        value: function startProcessing() {
            this.isProcessing = true;
            this.Loader.show();
        }
    }, {
        key: 'stopProcessing',
        value: function stopProcessing() {
            var _this = this;

            // TODO: We use timeout here to visualize progress, if progress is fast no visual component will be visible
            // (it will actually blink), but we don't won't blink :)
            this.$timeout(function () {
                _this.isProcessing = false;
                _this.Loader.hide();
            }, 500);
        }
    }, {
        key: 'onReset',
        value: function onReset() {
            this.resetSearchSettings();

            this.advancedSearchBuckets = {};
            this.hasBuckets = false;
            this.query = '';

            this.triggerSearchResult();
        }
    }, {
        key: 'close',
        value: function close() {
            this.onCloseSideNav();
        }
    }, {
        key: 'triggerSaveView',
        value: function triggerSaveView(_ref17) {
            var view = _ref17.view;

            this.onSaveView(this.eventEmitter({ view: view }));
        }
    }]);

    return AdvancedSearchController;
}();

exports.default = AdvancedSearchController;

/***/ }),

/***/ "5XkD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _foldersAndLabels = __webpack_require__("Impk");

var _foldersAndLabels2 = _interopRequireDefault(_foldersAndLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("joEl");

exports.default = {
    controller: _foldersAndLabels2.default,
    template: template
};

/***/ }),

/***/ "5apT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/star.svg";

/***/ }),

/***/ "5kx/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getWidth = __webpack_require__("YXbO");

var _getWidth2 = _interopRequireDefault(_getWidth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'getWidth',
    options: _getWidth2.default
};

/***/ }),

/***/ "5kxK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _companySettings = __webpack_require__("bKZY");

var _companySettings2 = _interopRequireDefault(_companySettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("lPUQ");

exports.default = {
    controller: _companySettings2.default,
    template: template
};

/***/ }),

/***/ "5m0o":
/***/ (function(module, exports) {

module.exports = "<md-autocomplete md-delay=50 md-no-cache md-autoselect md-select-on-match md-search-text=$ctrl.query md-search-text-change=$ctrl.queryChanged() md-selected-item=$ctrl.selectedItem md-selected-item-change=$ctrl.itemSelected(item) md-items=\"item in $ctrl.search()\" md-item-text=$ctrl.getText(item) md-min-length=1 placeholder=\"{{ $ctrl.placeholder }}\"> <md-item-template> <span md-highlight-text=$ctrl.query md-highlight-flags=^i>{{$ctrl.getText(item)}}</span> </md-item-template> </md-autocomplete>";

/***/ }),

/***/ "5qCE":
/***/ (function(module, exports) {

module.exports = "<md-icon class=\"material-icons material-icons--help\" aria-label=help> help <md-tooltip class=dt-theme>{{::$ctrl.message}}</md-tooltip> </md-icon> ";

/***/ }),

/***/ "5qVy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _applicationHelp = __webpack_require__("bIf/");

var _applicationHelp2 = _interopRequireDefault(_applicationHelp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("DmSA");

exports.default = {
    bindings: {
        onShowFeedbackForm: '&'
    },
    controller: _applicationHelp2.default,
    template: template
};

/***/ }),

/***/ "5t+A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _selector = __webpack_require__("VLtw");

var _selector2 = _interopRequireDefault(_selector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Fqfp");

exports.default = {
    bindings: {
        preSelected: '<',
        selected: '=?fsModel',
        multiSelect: '<',
        expandSelected: '=',
        onChange: '&'
    },
    controller: _selector2.default,
    template: template
};

/***/ }),

/***/ "5vET":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _feedback = __webpack_require__("CVh+");

var _feedback2 = _interopRequireDefault(_feedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'FeedbackApi',
    definition: _feedback2.default
};

/***/ }),

/***/ "67p2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = __webpack_require__("amTI");

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtMap',
    options: _map2.default
};

/***/ }),

/***/ "6Cbs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThingChartComponent = exports.Search = exports.ThingsListComponent = exports.ThingsToolboxComponent = exports.ThingDetails = undefined;

var _thingDetails = __webpack_require__("i2/F");

var ThingDetails = _interopRequireWildcard(_thingDetails);

var _thingsToolbox = __webpack_require__("hr0G");

var _thingsToolbox2 = _interopRequireDefault(_thingsToolbox);

var _thingsList = __webpack_require__("Nr0z");

var _thingsList2 = _interopRequireDefault(_thingsList);

var _search = __webpack_require__("WCDB");

var Search = _interopRequireWildcard(_search);

var _thingChart = __webpack_require__("slQK");

var _thingChart2 = _interopRequireDefault(_thingChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.ThingDetails = ThingDetails;
exports.ThingsToolboxComponent = _thingsToolbox2.default;
exports.ThingsListComponent = _thingsList2.default;
exports.Search = Search;
exports.ThingChartComponent = _thingChart2.default;

/***/ }),

/***/ "6EsV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataConverter = exports.ConfigHelper = undefined;

var _configHelper = __webpack_require__("mnij");

var _configHelper2 = _interopRequireDefault(_configHelper);

var _dataConverter = __webpack_require__("SI0v");

var _dataConverter2 = _interopRequireDefault(_dataConverter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConfigHelper = _configHelper2.default;
exports.DataConverter = _dataConverter2.default;

/***/ }),

/***/ "6WEP":
/***/ (function(module, exports) {

module.exports = "<script type=text/ng-template id=generic-messages.html> <div ng-repeat=\"item in $ctrl.genericErrors track by $index\" ng-message-exp=\"item.type\">\n        {{ item.message }}\n    </div> </script> <md-dialog flex=30> <md-dialog-content class=md-dialog-content> <h2 class=md-dialog-title>Edit Comment</h2> <form name=editNoteForm novalidate> <md-input-container class=md-block> <label>Edit comment</label> <textarea name=note id=note ng-model=$ctrl.content md-autofocus required></textarea> <div ng-if=editNoteForm.note.$touched ng-messages=editNoteForm.note.$error> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> </form> </md-dialog-content> <md-dialog-actions class=\"space-p-r-m space-p-b-s\"> <md-button class=md-primary ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=md-primary ng-disabled=editNoteForm.$invalid ng-click=$ctrl.updateNote()>Save</md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "6cRu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var template = __webpack_require__("dZ/z");

exports.default = {
    template: template
};

/***/ }),

/***/ "6kKc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppConfig.$inject = ["$mdThemingProvider", "$mdIconProvider", "$mdDateLocaleProvider", "$compileProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventEmitter = exports.AppConfig = undefined;

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sensorBlankIcon = __webpack_require__("CAZ4");
var temperatureIcon = __webpack_require__("RXTU");
var cloudConnectorIcon = __webpack_require__("xpeM");
var windowIcon = __webpack_require__("rDim");
var windowOpenIcon = __webpack_require__("Ihtr");
var doorIcon = __webpack_require__("o1sJ");
var doorClosedIcon = __webpack_require__("lRq9");
var theftIcon = __webpack_require__("nmcK");
var touchIcon = __webpack_require__("dUbX");
var starIcon = __webpack_require__("5apT");
var starOutlineIcon = __webpack_require__("+Vwy");
var iconSignalIcon0 = __webpack_require__("QDzy");
var iconSignalIcon1 = __webpack_require__("mJYQ");
var iconSignalIcon2 = __webpack_require__("Nl++");
var iconSignalIcon3 = __webpack_require__("Iy3b");
var iconSignalIcon4 = __webpack_require__("NAwI");
var iconSignalIcon5 = __webpack_require__("yZX0");
var tableSortable = __webpack_require__("NboS");
var tableSortedAsc = __webpack_require__("0PIR");

/**
 * Application configuration class
 * @constructor
 * @ngInject
 */
function AppConfig($mdThemingProvider, $mdIconProvider, $mdDateLocaleProvider, $compileProvider) {
    if (true) {
        $compileProvider.debugInfoEnabled(false);
        $compileProvider.commentDirectivesEnabled(false);
        $compileProvider.cssClassDirectivesEnabled(false);
    }

    $mdDateLocaleProvider.formatDate = function (date) {
        return (0, _moment2.default)(date).format('DD/MM/YY');
    };

    var customLightBlue = $mdThemingProvider.extendPalette('blue-grey', {
        '50': '#ECEFF1',
        '100': '#CFD8DC',
        '200': '#89bad6', // custom
        '300': '#90A4AE',
        '400': '#78909C',
        '500': '#42a0d6', // custom
        '600': '#2d79a5', // custom
        '700': '#455A64',
        '800': '#37474F',
        '900': '#263238',
        'contrastDefaultColor': 'light',
        'contrastLightColors': '400 500 600 700 800 900',
        'contrastStrongLightColors': '400 600 700 800 900'
    });

    var customRed = $mdThemingProvider.extendPalette('red', {
        '50': '#ffebee',
        '100': '#ffcdd2',
        '200': '#ef9a9a',
        '300': '#e57373',
        '400': '#E11F30', // custom
        '500': '#f44336',
        '600': '#e53935',
        '700': '#d32f2f',
        '800': '#c62828',
        '900': '#b71c1c',
        'A100': '#ff8a80',
        'A200': '#ff5252',
        'A400': '#ff1744',
        'A700': '#ff0008', // custom
        'contrastDefaultColor': 'light',
        'contrastDarkColors': '50 100 200 300 A100',
        'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
    });
    $mdThemingProvider.definePalette('customLightBlue', customLightBlue);

    $mdThemingProvider.definePalette('customRed', customRed);

    $mdThemingProvider.theme('default').primaryPalette('customLightBlue').accentPalette('customLightBlue').warnPalette('customRed');

    $mdThemingProvider.theme('dark').primaryPalette('yellow').dark().foregroundPalette['4'] = 'rgba(221, 221, 221, 1)';

    // Configure icons
    $mdIconProvider.icon('sensor-blank', sensorBlankIcon).icon('cloud-connector', cloudConnectorIcon).icon('door', doorIcon).icon('door-closed', doorClosedIcon).icon('temperature', temperatureIcon).icon('window', windowIcon).icon('window-open', windowOpenIcon).icon('theft', theftIcon).icon('touch', touchIcon).icon('star', starIcon).icon('star-o', starOutlineIcon).icon('icon_signal0', iconSignalIcon0).icon('icon_signal1', iconSignalIcon1).icon('icon_signal2', iconSignalIcon2).icon('icon_signal3', iconSignalIcon3).icon('icon_signal4', iconSignalIcon4).icon('icon_signal5', iconSignalIcon5).icon('table-sortable', tableSortable).icon('table-sorted', tableSortedAsc);

    // $animateProvider.classNameFilter(/dt-animated/);
}

/**
 * EventEmitter is wrapper and used to ease migration in future to angular 2
 * @type {Object}
 */
var EventEmitter = {
    name: 'EventEmitter',
    definition: function definition(payload) {
        return { $event: payload };
    }
};

exports.AppConfig = AppConfig;
exports.EventEmitter = EventEmitter;

/***/ }),

/***/ "6u/X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = __webpack_require__("1ES/");

var _base2 = _interopRequireDefault(_base);

var _full = __webpack_require__("OZ2k");

var _full2 = _interopRequireDefault(_full);

var _preview = __webpack_require__("MgRh");

var _preview2 = _interopRequireDefault(_preview);

var _proximity = __webpack_require__("J6d+");

var _proximity2 = _interopRequireDefault(_proximity);

var _proximityFull = __webpack_require__("7QAI");

var _proximityFull2 = _interopRequireDefault(_proximityFull);

var _proximityPreview = __webpack_require__("tfDx");

var _proximityPreview2 = _interopRequireDefault(_proximityPreview);

var _temperature = __webpack_require__("w+pj");

var _temperature2 = _interopRequireDefault(_temperature);

var _temperatureFull = __webpack_require__("AiBs");

var _temperatureFull2 = _interopRequireDefault(_temperatureFull);

var _temperaturePreview = __webpack_require__("SKXG");

var _temperaturePreview2 = _interopRequireDefault(_temperaturePreview);

var _touch = __webpack_require__("j9t6");

var _touch2 = _interopRequireDefault(_touch);

var _touchFull = __webpack_require__("hTSO");

var _touchFull2 = _interopRequireDefault(_touchFull);

var _touchPreview = __webpack_require__("PCux");

var _touchPreview2 = _interopRequireDefault(_touchPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    Base: _base2.default,
    Full: _full2.default,
    Preview: _preview2.default,
    Proximity: _proximity2.default,
    ProximityFull: _proximityFull2.default,
    ProximityPreview: _proximityPreview2.default,
    Temperature: _temperature2.default,
    TemperatureFull: _temperatureFull2.default,
    TemperaturePreview: _temperaturePreview2.default,
    Touch: _touch2.default,
    TouchFull: _touchFull2.default,
    TouchPreview: _touchPreview2.default
};

/***/ }),

/***/ "6wga":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabs = __webpack_require__("DOWT");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSensorTabs',
    options: _tabs2.default
};

/***/ }),

/***/ "6yYo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createNotification = __webpack_require__("teei");

var _createNotification2 = _interopRequireDefault(_createNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAlertsActionsCreateNotification',
    options: _createNotification2.default
};

/***/ }),

/***/ "70dX":
/***/ (function(module, exports) {

module.exports = "<div class=form-grid__row> <div class=\"form-grid__col form-grid__col8\"> <label class=md-body-1>Labels</label> </div> <dt-labels-autocomplete flex labels=$ctrl.labels require-match=true editable=true on-change=$ctrl.changed($event)></dt-labels-autocomplete> <div class=\"form-grid__col form-grid__col12\"> <dt-help-icon message-key=help_icon_advanced_search_labels></dt-help-icon> </div> </div>";

/***/ }),

/***/ "78T7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<form ng-submit=$event.preventDefault() layout=row> <md-autocomplete flex md-selected-item=ctrl.selectedItem md-search-text-change=$ctrl.searchUsers($ctrl.searchText) md-search-text=$ctrl.searchText md-selected-item-change=$ctrl.selectedUserChange(item) md-items=\"item in $ctrl.searchUsers($ctrl.searchText)\" md-item-text=item.fullName md-min-length=0 md-delay=500 md-no-cache=true placeholder=\"Assign this role to more users\"> <md-item-template> <span md-highlight-text=$ctrl.searchText md-highlight-flags=^i>{{item.first_name}} {{item.last_name}}</span> </md-item-template> <md-not-found> No users matching \"{{$ctrl.searchText}}\" were found. </md-not-found> </md-autocomplete> <md-button class=\"md-icon-button md-primary space-m-r-n\" aria-label=Assign ng-click=$ctrl.onAdd($ctrl.selectedUser);> <md-icon class=material-icons aria-hidden=true>add_circle_outline</md-icon> <md-tooltip>Assign user</md-tooltip> </md-button> </form> <md-list class=md-list--style3> <md-list-item class=md-2-line ng-repeat=\"user in $ctrl.users\"> <img src=" + __webpack_require__("ctaC") + " class=md-avatar alt=\"Ron Burgundy\"/> <div class=md-list-item-text> <h3>{{ user.first_name }} {{ user.last_name }}</h3> <p> <a class=# ng-href=\"mailto:{{ user.email }}\" data-ng-bind=user.email></a> </p> </div> <div class=md-secondary> <md-button class=\"md-icon-button md-accent\" aria-label=Close ng-click=$ctrl.onRemove(user)> <md-icon class=material-icons aria-hidden=true>remove_circle_outline</md-icon> </md-button> </div> </md-list-item> </md-list>";

/***/ }),

/***/ "7Dj5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sticky = __webpack_require__("jJjP");

var _sticky2 = _interopRequireDefault(_sticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSticky',
    options: _sticky2.default
};

/***/ }),

/***/ "7Gr3":
/***/ (function(module, exports) {

module.exports = "<md-dialog class=md-dialog--m> <md-dialog-content class=md-dialog-content> <div class=md-dialog-title>Folders</div> <dt-folder-selector on-change=$ctrl.onFolderChange($event)></dt-folder-selector> </md-dialog-content> <md-dialog-actions class=\"spacae-p-h-l space-p-b-m\"> <md-button class=md-primary ng-click=$ctrl.close()> Close </md-button> <md-button class=md-primary ng-click=$ctrl.submit() ng-disabled=!$ctrl.folderId> View sensors in this folder </md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "7HZj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RulesListController = function RulesListController() {
  _classCallCheck(this, RulesListController);
};

exports.default = RulesListController;

/***/ }),

/***/ "7QAI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    yAxis: {
        plotBands: [{
            label: {
                align: 'right',
                x: -10
            }
        }, {
            label: {
                align: 'right',
                x: -10
            }
        }]
    }
};

/***/ }),

/***/ "7iMI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _list = __webpack_require__("FI/j");

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSensorListContainer',
    options: _list2.default
};

/***/ }),

/***/ "7mjG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingDetailsLabels = __webpack_require__("qU0y");

var _thingDetailsLabels2 = _interopRequireDefault(_thingDetailsLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingDetailsLabels',
    options: _thingDetailsLabels2.default
};

/***/ }),

/***/ "7tBR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sendMail = __webpack_require__("uMxi");

var _sendMail2 = _interopRequireDefault(_sendMail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("2ii8");

exports.default = {
    bindings: {
        action: '<',
        onClose: '&'
    },
    template: template,
    controller: _sendMail2.default
};

/***/ }),

/***/ "8+ZO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingName = __webpack_require__("f5k9");

var _thingName2 = _interopRequireDefault(_thingName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("pON3");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingName2.default
};

/***/ }),

/***/ "80IO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autocomplete = __webpack_require__("AGcD");

var _autocomplete2 = _interopRequireDefault(_autocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("5m0o");

exports.default = {
    bindings: {
        onSearch: '&',
        onChange: '&',
        onSelected: '&',
        textKey: '@',
        placeholder: '@'
    },
    controller: _autocomplete2.default,
    template: template
};

/***/ }),

/***/ "8B5C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sortBy2 = __webpack_require__("JXMh");

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UI_READINESS_TIMEOUT_DELAY = 20;

var TOAST_CONFIG = {
    hideDelay: 1500
};

var EditNavBarPopupController = function () {
    /** @ngInject */
    EditNavBarPopupController.$inject = ["DialogService", "onDone", "treeConfig", "EventEmitter", "NavigationService", "Loader", "ViewsApi", "CategoriesApi", "ToastService", "$q", "$scope"];
    function EditNavBarPopupController(DialogService, onDone, treeConfig, EventEmitter, NavigationService, Loader, ViewsApi, CategoriesApi, ToastService, $q, $scope) {
        _classCallCheck(this, EditNavBarPopupController);

        this.NavigationService = NavigationService;
        this.DialogService = DialogService;
        this.Loader = Loader;
        this.eventEmitter = EventEmitter;
        this.onDone = onDone;
        this.ViewsApi = ViewsApi;
        this.CategoriesApi = CategoriesApi;
        this.ToastService = ToastService;
        this.$q = $q;
        this.$scope = $scope;

        treeConfig.dragClass = 'angular-ui-tree-drag ui-tree--views ui-tree';

        this.isLoading = true;

        this.treeOptions = {
            beforeDrop: EditNavBarPopupController.beforeNodeDrop,
            accept: function accept(_ref, _ref2) {
                var draggedItem = _ref.$modelValue;
                var dropScope = _ref2.$nodeScope;

                if (!dropScope) {
                    return true;
                }

                return draggedItem.type !== 'CATEGORY';
            },
            dropped: this.onItemDropped.bind(this)
        };

        this.addCategoryVisible = false;
        this.savingItemPromise = null;

        this.loadCategories();
    }

    _createClass(EditNavBarPopupController, [{
        key: 'onItemDropped',
        value: function onItemDropped(ev) {
            var _this = this;

            var item = ev.source.nodeScope.$modelValue;
            if (item.type === 'VIEW') {
                var newParent = ev.dest.nodesScope.$nodeScope ? ev.dest.nodesScope.$nodeScope.$modelValue : null;

                this.ViewsApi.saveView(item.id, {
                    name: item.title,
                    search_query: item.search_query,
                    category_id: newParent ? newParent.id : '',
                    position: ev.dest.index + 1
                }).then(function () {
                    _this.ToastService.showSimpleTranslated('navbar_view_was_moved', TOAST_CONFIG);
                }).catch(function () {
                    _this.ToastService.showSimpleTranslated('navbar_view_wasnt_moved', TOAST_CONFIG);
                });
            }

            if (item.type === 'CATEGORY') {
                this.CategoriesApi.saveCategory(item.id, {
                    parent_id: item.parent_id,
                    name: item.title,
                    position: ev.dest.index + 1
                }).then(function () {
                    _this.ToastService.showSimpleTranslated('navbar_category_was_moved', TOAST_CONFIG);
                }).catch(function () {
                    _this.ToastService.showSimpleTranslated('navbar_category_wasnt_moved', TOAST_CONFIG);
                });
            }
        }
    }, {
        key: 'expandAll',
        value: function expandAll() {
            this.$scope.$broadcast('angular-ui-tree:expand-all');
        }
    }, {
        key: 'collapseAll',
        value: function collapseAll() {
            this.$scope.$broadcast('angular-ui-tree:collapse-all');
        }
    }, {
        key: 'showAddCategoryForm',
        value: function showAddCategoryForm() {
            this.addCategoryVisible = true;
        }
    }, {
        key: 'hideAddCategoryForm',
        value: function hideAddCategoryForm() {
            this.addCategoryVisible = false;
            this.resetAddCategoryForm();
        }
    }, {
        key: 'resetAddCategoryForm',
        value: function resetAddCategoryForm() {
            this.categoryName = '';
            this.addCategoryForm.$setPristine();
        }
    }, {
        key: 'deleteItem',
        value: function deleteItem(item) {
            var _this2 = this;

            var promise = void 0;
            var itemType = void 0;

            if (item.type === 'CATEGORY') {
                itemType = 'category';
                promise = this.CategoriesApi.deleteCategory(item.id);
            } else {
                itemType = 'view';
                promise = this.ViewsApi.deleteView(item.id);
            }

            promise.then(function () {
                _this2.loadCategories();
                _this2.ToastService.showSimpleTranslated('navbar_' + itemType + '_was_removed', TOAST_CONFIG);
            }).catch(function () {
                _this2.ToastService.showSimpleTranslated('navbar_' + itemType + '_wasnt_removed', TOAST_CONFIG);
            });
        }
    }, {
        key: 'editItem',
        value: function editItem(item, inputId) {
            var _this3 = this;

            if (this.editingItemInputId === inputId) {
                return;
            }

            this.$q.when(this.savingItemPromise).then(function () {
                _this3.editingItem = item;
                _this3.originalTitle = _this3.editingItem.title;
                _this3.editingItemInputId = inputId;

                var input = document.getElementById(inputId);
                setTimeout(function () {
                    input.select();input.focus();
                }, UI_READINESS_TIMEOUT_DELAY);
            });
        }
    }, {
        key: 'saveItem',
        value: function saveItem() {
            var _this4 = this;

            if (!this.editingItem || this.editingItem.title === this.originalTitle) {
                return;
            }

            this.showProgress();
            var item = this.editingItem;

            var promise = void 0;
            var itemType = void 0;

            if (item.type === 'CATEGORY') {
                itemType = 'category';
                promise = this.CategoriesApi.saveCategory(item.id, {
                    name: item.title,
                    position: item.position
                });
            } else {
                itemType = 'view';
                promise = this.ViewsApi.saveView(item.id, {
                    name: item.title,
                    search_query: item.search_query,
                    category_id: item.category_id,
                    position: item.position
                });
            }

            this.savingItemPromise = promise.then(function () {
                _this4.ToastService.showSimpleTranslated('navbar_' + itemType + '_was_updated', TOAST_CONFIG);
            }).catch(function () {
                item.title = _this4.originalTitle;
                _this4.ToastService.showSimpleTranslated('navbar_' + itemType + '_wasnt_updated', TOAST_CONFIG);
            }).finally(function () {
                _this4.hideProgress();
                _this4.originalTitle = null;
                _this4.editingItem = null;
                _this4.editingItemInputId = null;
            });
        }
    }, {
        key: 'addCategory',
        value: function addCategory() {
            var _this5 = this;

            this.CategoriesApi.createCategory({
                name: this.categoryName
            }).then(function () {
                _this5.loadCategories();
                _this5.hideAddCategoryForm();
                _this5.ToastService.showSimpleTranslated('navbar_category_was_created', TOAST_CONFIG);
            }).catch(function () {
                _this5.ToastService.showSimpleTranslated('navbar_category_wasnt_created', TOAST_CONFIG);
            });
        }
    }, {
        key: 'showProgress',
        value: function showProgress() {
            this.isLoading = true;
            this.Loader.show();
        }
    }, {
        key: 'hideProgress',
        value: function hideProgress() {
            this.isLoading = false;
            this.Loader.hide();
        }
    }, {
        key: 'loadCategories',
        value: function loadCategories() {
            var _this6 = this;

            this.showProgress();

            this.NavigationService.getSensorsAndConnectors().then(function (data) {
                _this6.categories = (0, _sortBy3.default)(_utils2.default.parseNavigationData({
                    data: data,
                    removeKeys: ['name', 'order', 'created', 'updated'],
                    addEmptyItemsArrayOnGroup: true
                }), 'position');

                _this6.categories.forEach(function (item) {
                    if ('items' in item) {
                        item.items = (0, _sortBy3.default)(item.items, 'position');
                    }
                });

                _this6.hideProgress();

                _this6.addNoDropPropertyToView();
            }, this.hideProgress.bind(this));
        }
    }, {
        key: 'addNoDropPropertyToView',
        value: function addNoDropPropertyToView() {
            var addNoDrop = function addNoDrop(item) {
                if (item.type === 'VIEW') {
                    item.nodrop = true;
                }

                if (item.items && item.items.length) {
                    item.items.forEach(addNoDrop);
                }
            };

            this.categories.forEach(addNoDrop);
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.hideProgress();
            this.DialogService.cancel();
        }
    }, {
        key: 'done',
        value: function done() {
            this.showProgress();
            this.onDone();
            this.cancel();
        }
    }, {
        key: 'blurFocusedItems',
        value: function blurFocusedItems(_ref3) {
            var target = _ref3.target;

            if (this.editingItem && this.editingItemInputId && !target.closest('.entity-label')) {
                this.editingItem = null;
                this.editingItemInputId = null;
            }
        }
    }], [{
        key: 'beforeNodeDrop',
        value: function beforeNodeDrop(event) {
            var source = event.source.nodeScope.$modelValue;
            var destination = event.dest.nodesScope.$nodeScope ? event.dest.nodesScope.$nodeScope.$modelValue : undefined;

            return destination ? source.type !== destination.type : true;
        }
    }]);

    return EditNavBarPopupController;
}();

exports.default = EditNavBarPopupController;

/***/ }),

/***/ "8HS2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/history.json";

/***/ }),

/***/ "8Kqj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LabelsController = function () {
    /** @ngInject */
    LabelsController.$inject = ["LabelsApi", "Loader", "DialogService", "ToastService", "$q", "$state"];
    function LabelsController(LabelsApi, Loader, DialogService, ToastService, $q, $state) {
        _classCallCheck(this, LabelsController);

        this.LabelsApi = LabelsApi;
        this.Loader = Loader;
        this.DialogService = DialogService;
        this.toastService = ToastService;
        this.$q = $q;
        this.$state = $state;
    }

    _createClass(LabelsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.query = '';
            this.labelsLoaded = false;
            this.isCreateBtn = true;

            this.fetch();
        }
    }, {
        key: 'showCreateForm',
        value: function showCreateForm() {
            this.isCreateBtn = false;
            this.isCreateForm = true;
        }
    }, {
        key: 'showCreateBtn',
        value: function showCreateBtn() {
            this.isCreateBtn = true;
            this.isCreateForm = false;
            this.name = null;
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            this.processing = true;

            this.LabelsApi.create(this.name).then(function (label) {
                _this.labels.unshift(label);

                _this.searchIndex = _utils2.default.buildSearchIndex(_this.labels);

                _this.name = null;
                _this.addLabelForm.$setPristine();
                _this.addLabelForm.$setUntouched();

                _this.$state.go('main.folders-and-labels.labels.label', {
                    labelId: label.id
                });

                _this.toastService.showSimpleTranslated('label_was_created');
            }, function () {
                _this.toastService.showSimpleTranslated('label_wasnt_created');
            }).finally(function () {
                _this.processing = false;
            });
        }
    }, {
        key: 'onSearch',
        value: function onSearch(_ref) {
            var query = _ref.query;

            return _utils2.default.searchInIndex(this.searchIndex, query);
        }
    }, {
        key: 'onLabelFound',
        value: function onLabelFound(_ref2) {
            var item = _ref2.item;

            if (item) {
                this.$state.go('main.folders-and-labels.labels.label', {
                    labelId: item.id
                });
            }
        }
    }, {
        key: 'fetch',
        value: function fetch() {
            var _this2 = this;

            this.Loader.show();

            this.LabelsApi.fetch().then(function (data) {
                _this2.labels = data.labels || [];
                _this2.searchIndex = _utils2.default.buildSearchIndex(_this2.labels);
                _this2.Loader.hide();
            }).finally(function () {
                _this2.labelsLoaded = true;
            });
        }
    }, {
        key: 'cancelEdit',
        value: function cancelEdit() {
            this.$state.go('main.folders-and-labels.labels');
        }
    }, {
        key: 'deleteLabel',
        value: function deleteLabel(_ref3) {
            var _this3 = this;

            var label = _ref3.label;

            this.LabelsApi.remove(label.id).then(function () {
                _this3.labels.every(function (item, index) {
                    if (item.id === label.id) {
                        _this3.labels.splice(index, 1);
                        return false;
                    }
                    return true;
                });

                _this3.searchIndex = _utils2.default.buildSearchIndex(_this3.labels);

                _this3.toastService.showSimpleTranslated('label_was_removed');
            }, function () {
                _this3.toastService.showSimpleTranslated('label_wasnt_removed');
            });
            this.cancelEdit();
        }
    }, {
        key: 'saveLabel',
        value: function saveLabel(_ref4) {
            var _this4 = this;

            var label = _ref4.label;

            this.LabelsApi.update(label.id, label.name).then(function () {
                var labelRef = _this4.labels.find(function (item) {
                    return item.id === label.id;
                });
                Object.assign(labelRef, label);

                _this4.searchIndex = _utils2.default.buildSearchIndex(_this4.labels);

                _this4.toastService.showSimpleTranslated('label_was_updated');
            }, function () {
                _this4.toastService.showSimpleTranslated('label_wasnt_updated');
            });
        }
    }, {
        key: 'validateLabel',
        value: function validateLabel(_ref5) {
            var label = _ref5.label;

            return {
                unique: this.isLabelUnique(label)
            };
        }
    }, {
        key: 'isLabelUnique',
        value: function isLabelUnique(label) {
            for (var i = 0; i < this.labels.length; ++i) {
                if (this.labels[i].name === label.name && this.labels[i].id !== label.id) {
                    return false;
                }
            }

            return true;
        }
    }, {
        key: 'validateName',
        value: function validateName(name) {
            var isUnique = true;

            for (var i = 0; i < this.labels.length; i++) {
                if (this.labels[i].name === name) {
                    isUnique = false;
                    break;
                }
            }

            this.addLabelForm.name.$setValidity('unique', isUnique);
        }
    }, {
        key: 'currentLabelId',
        get: function get() {
            return this.$state.params.labelId;
        }
    }]);

    return LabelsController;
}();

exports.default = LabelsController;

/***/ }),

/***/ "8RgO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/customers.json";

/***/ }),

/***/ "8UR1":
/***/ (function(module, exports) {

module.exports = "<input class=dt-map__autocomplete id=ngMapAutocomplete places-auto-complete size=30 on-place-changed=$ctrl.onSearch($ctrl)> <ng-map on-click=$ctrl.mapClickedBound(event) zoom={{$ctrl.options.zoom}} street-view-control-options=\"{position:'LEFT_TOP'}\" zoom-control-options=\"{position:'LEFT_TOP'}\" on-center-changed=$ctrl.centerChangedBound() on-bounds-changed=$ctrl.boundsChangedBound() map-initialized=$ctrl.onMapInitialized(map) scrollwheel={{$ctrl.options.scrollwheel}}> <marker id=googleMapMarker ng-if=$ctrl.marker on-click=\"$ctrl.map.showInfoWindow('googleMapInfoWindow', 'googleMapMarker')\" position=\"{{$ctrl.marker.lat}}, {{$ctrl.marker.lng}}\"></marker> <info-window id=googleMapInfoWindow> <div ng-non-bindable=\"\"> <span>{{$ctrl.marker.address}}</span> </div> </info-window> </ng-map> ";

/***/ }),

/***/ "8WM+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingType = __webpack_require__("Evvn");

var _thingType2 = _interopRequireDefault(_thingType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingType',
    options: _thingType2.default
};

/***/ }),

/***/ "8kps":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/user.json";

/***/ }),

/***/ "8tMW":
/***/ (function(module, exports) {

module.exports = "<dt-chart class=chart ng-class=\"{\n            'chart-proximity-preview': $ctrl.chartType === 'proximity',\n            'chart-touch-preview': $ctrl.chartType === 'touch',\n            'chart-temperature-preview': $ctrl.chartType === 'temperature'\n        }\" config=$ctrl.chartConfig></dt-chart> <div layout=row layout-align=\"end center\"> <a ui-sref=main.sensors.list.thing.graph class=\"md-primary md-caption\">See more detailed graph</a> </div> ";

/***/ }),

/***/ "8xGQ":
/***/ (function(module, exports) {

module.exports = "<div class=dtFolder-path__item> {{ $ctrl.folderPathPlaceholder }} <md-tooltip ng-if=$ctrl.folderPathFull class=\"dt-theme u-width-auto\"> {{ $ctrl.folderPathFull }} </md-tooltip> </div> ";

/***/ }),

/***/ "94vt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThingFoldersComponent = exports.ThingNotesComponent = exports.ThingLabelsComponent = exports.ThingLocationComponent = exports.ThingUpdatedComponent = exports.ThingRegisteredComponent = exports.ThingSignalComponent = exports.ThingBatteryComponent = exports.ThingTypeComponent = exports.ThingPictureComponent = exports.ThingStarComponent = exports.ThingStatusComponent = exports.ThingOwnerComponent = exports.ThingNameComponent = exports.Component = undefined;

var _search = __webpack_require__("eoya");

var _search2 = _interopRequireDefault(_search);

var _thingName = __webpack_require__("Oaxr");

var _thingName2 = _interopRequireDefault(_thingName);

var _thingOwner = __webpack_require__("ZUS+");

var _thingOwner2 = _interopRequireDefault(_thingOwner);

var _thingStatus = __webpack_require__("B0UP");

var _thingStatus2 = _interopRequireDefault(_thingStatus);

var _thingStar = __webpack_require__("SNdJ");

var _thingStar2 = _interopRequireDefault(_thingStar);

var _thingPicture = __webpack_require__("Cb8j");

var _thingPicture2 = _interopRequireDefault(_thingPicture);

var _thingType = __webpack_require__("8WM+");

var _thingType2 = _interopRequireDefault(_thingType);

var _thingBattery = __webpack_require__("Zaj5");

var _thingBattery2 = _interopRequireDefault(_thingBattery);

var _thingSignal = __webpack_require__("+DP6");

var _thingSignal2 = _interopRequireDefault(_thingSignal);

var _thingRegistered = __webpack_require__("l+66");

var _thingRegistered2 = _interopRequireDefault(_thingRegistered);

var _thingUpdated = __webpack_require__("eoha");

var _thingUpdated2 = _interopRequireDefault(_thingUpdated);

var _thingLocation = __webpack_require__("coYr");

var _thingLocation2 = _interopRequireDefault(_thingLocation);

var _thingLabels = __webpack_require__("WaeA");

var _thingLabels2 = _interopRequireDefault(_thingLabels);

var _thingNotes = __webpack_require__("Xmc5");

var _thingNotes2 = _interopRequireDefault(_thingNotes);

var _thingFolders = __webpack_require__("U0SW");

var _thingFolders2 = _interopRequireDefault(_thingFolders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtThingsSearchAdvanced',
    options: _search2.default
};

exports.Component = Component;
exports.ThingNameComponent = _thingName2.default;
exports.ThingOwnerComponent = _thingOwner2.default;
exports.ThingStatusComponent = _thingStatus2.default;
exports.ThingStarComponent = _thingStar2.default;
exports.ThingPictureComponent = _thingPicture2.default;
exports.ThingTypeComponent = _thingType2.default;
exports.ThingBatteryComponent = _thingBattery2.default;
exports.ThingSignalComponent = _thingSignal2.default;
exports.ThingRegisteredComponent = _thingRegistered2.default;
exports.ThingUpdatedComponent = _thingUpdated2.default;
exports.ThingLocationComponent = _thingLocation2.default;
exports.ThingLabelsComponent = _thingLabels2.default;
exports.ThingNotesComponent = _thingNotes2.default;
exports.ThingFoldersComponent = _thingFolders2.default;

/***/ }),

/***/ "9D2k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


dashboardRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = dashboardRouter;

var _dashboard = __webpack_require__("tJDh");

/** @ngInject */
function dashboardRouter($stateProvider) {
    var baseState = {
        url: '/dashboard',
        views: {
            content: {
                component: _dashboard.Component.selector
            }
        }
    };

    $stateProvider.state('main.dashboard', baseState);
}

/***/ }),

/***/ "9V1s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _detailsChart = __webpack_require__("n0UU");

var _detailsChart2 = _interopRequireDefault(_detailsChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("8tMW");

exports.default = {
    bindings: {
        chartData: '<',
        chartType: '<'
    },
    template: template,
    controller: _detailsChart2.default
};

/***/ }),

/***/ "A+ND":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _categories = __webpack_require__("y9gm");

var _categories2 = _interopRequireDefault(_categories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * CategoriesApi settings
 * @type {{name: string, definition: CategoriesApi}}
 */
exports.default = {
  name: 'CategoriesApi',
  definition: _categories2.default
};

/***/ }),

/***/ "AGcD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchAutocompleteController = function () {
    /** @ngInject */
    SearchAutocompleteController.$inject = ["EventEmitter"];
    function SearchAutocompleteController(EventEmitter) {
        _classCallCheck(this, SearchAutocompleteController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(SearchAutocompleteController, [{
        key: "getText",
        value: function getText(item) {
            if (this.textKey) {
                return item[this.textKey];
            }
            return item;
        }
    }, {
        key: "itemSelected",
        value: function itemSelected() {
            this.onSelected(this.eventEmitter({
                item: this.selectedItem
            }));
        }
    }, {
        key: "queryChanged",
        value: function queryChanged() {
            this.onChange(this.eventEmitter({
                query: this.query
            }));
        }
    }, {
        key: "search",
        value: function search() {
            return this.onSearch(this.eventEmitter({
                query: this.query
            }));
        }
    }]);

    return SearchAutocompleteController;
}();

exports.default = SearchAutocompleteController;

/***/ }),

/***/ "AMnj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlertsActionsController = function () {
    /** @ngInject */
    AlertsActionsController.$inject = ["Loader", "AlertsActionsApi", "ToastService", "$rootScope", "$timeout"];
    function AlertsActionsController(Loader, AlertsActionsApi, ToastService, $rootScope, $timeout) {
        _classCallCheck(this, AlertsActionsController);

        this.Loader = Loader;
        this.ToastService = ToastService;
        this.AlertsActionsApi = AlertsActionsApi;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
    }

    _createClass(AlertsActionsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isSupported = false;
            this.currentAlertsActions = null;
            this.alertsActions = [];

            this.getAlertsActionsList();
        }
    }, {
        key: 'getAlertsActionsList',
        value: function getAlertsActionsList() {
            var _this = this;

            this.Loader.show();

            this.AlertsActionsApi.getList().then(function (data) {
                _this.alertsActions = data['alerts-actions'] || [];
                _this.Loader.hide();
            });
        }
    }, {
        key: 'getCurrentRule',
        value: function getCurrentRule(_ref) {
            var _this2 = this;

            var rule = _ref.rule;

            this.Loader.show();

            this.currentAlertsActions = false;
            this.$timeout(function () {
                _this2.currentAlertsActions = rule;
                _this2.Loader.hide();
            }, 500);
        }
    }, {
        key: 'resetAlertsActionsCurrent',
        value: function resetAlertsActionsCurrent(_ref2) {
            var rule = _ref2.rule;

            if (rule) {
                this.currentAlertsActions = null;
            }
        }
    }, {
        key: 'removeAlertsActions',
        value: function removeAlertsActions(id) {
            var _this3 = this;

            var removeId = id;

            this.Loader.show();

            this.AlertsActionsApi.remove(removeId).then(function (response) {
                _this3.alertsActions = _this3.alertsActions.filter(function (item) {
                    return item.id !== response.id;
                });

                _this3.currentAlertsActions = null;

                _this3.Loader.hide();

                _this3.ToastService.show(_this3.ToastService.createSimple({
                    text: 'Rule deleted',
                    position: 'bottom right'
                }));

                _this3.$rootScope.$applyAsync();
            });
        }
    }]);

    return AlertsActionsController;
}();

exports.default = AlertsActionsController;

/***/ }),

/***/ "ASwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TriggerWebhookController = function () {
    /** @ngInject */
    TriggerWebhookController.$inject = ["EventEmitter"];
    function TriggerWebhookController(EventEmitter) {
        _classCallCheck(this, TriggerWebhookController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(TriggerWebhookController, [{
        key: "$onInit",
        value: function $onInit() {
            if (!this.action) {
                this.action = false;
            }
        }
    }, {
        key: "close",
        value: function close() {
            this.onClose(this.eventEmitter({
                action: this.action
            }));
        }
    }]);

    return TriggerWebhookController;
}();

exports.default = TriggerWebhookController;

/***/ }),

/***/ "Acgv":
/***/ (function(module, exports) {

module.exports = "<div ng-switch=$ctrl.helpMenuType> <dt-application-help ng-switch-when=APPLICATION_HELP on-show-feedback-form=$ctrl.showFeedbackForm()> </dt-application-help> <dt-feedback-form ng-switch-when=FEEDBACK_FORM on-cancel=$ctrl.cancel()> </dt-feedback-form> </div> ";

/***/ }),

/***/ "AiBs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    plotOptions: {
        line: {
            marker: {
                enabled: true,
                radius: 5
            }
        }
    },
    tooltip: {
        formatter: function formatter() {
            return '\n                ' + (0, _moment2.default)(this.x).format('dddd, MMM D, HH:mm') + '<br>\n                Lowest <b>' + this.points[1].point.low + '\xB0C</b>,\n                Average <b>' + this.points[0].y + '\xB0C</b>,\n                Highest <b>' + this.points[1].point.high + '\xB0C</b>\n            ';
        }
    }
};

/***/ }),

/***/ "B+33":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HttpInterceptor = exports.Config = undefined;

var _interceptors = __webpack_require__("P3ud");

var _interceptors2 = _interopRequireDefault(_interceptors);

var _http = __webpack_require__("/dA1");

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * httpInterceptor settings
 * @type {{name: string, definition: HttpInterceptor}}
 */
var HttpInterceptor = {
    name: 'httpInterceptor',
    definition: _http2.default
};

exports.Config = _interceptors2.default;
exports.HttpInterceptor = HttpInterceptor;

/***/ }),

/***/ "B+BY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * NotesApi class.
 */

var NotesApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    NotesApi.$inject = ["$http"];
    function NotesApi($http) {
        _classCallCheck(this, NotesApi);

        this.$http = $http;
        this.listUrl = _utils2.default.buildApiUrl('notes.list');
    }

    /**
     * Get Notes
     * @returns {promise}
     */


    _createClass(NotesApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.listUrl).then(responseDataExtractor);
        }

        /**
         * Get Notes by Object id
         * @param {Object} params - consist from 'object_id', 'page_size', 'page_token'
         * @returns {promise}
         */

    }, {
        key: 'getListByObject',
        value: function getListByObject(params) {
            return this.$http.get(this.listUrl, {
                params: params
            }).then(responseDataExtractor);
        }

        /**
         * Create note
         * @param {Object} note - Note object
         * @returns {promise}
         */

    }, {
        key: 'createNote',
        value: function createNote(note) {
            return this.$http.post(this.listUrl, _extends({}, note)).then(responseDataExtractor);
        }

        /**
         * Edit Note
         * @param {Number} noteId - Note id
         * @param {String} content - Note content
         * @returns {promise}
         */

    }, {
        key: 'editNote',
        value: function editNote(noteId, content) {
            var url = _utils2.default.buildApiUrl('notes.entity', { noteId: noteId });
            return this.$http.put(url, { content: content }).then(responseDataExtractor);
        }

        /**
         * Delete note by given id
         * @param {number} noteId - Note id
         * @returns {promise}
         */

    }, {
        key: 'deleteNote',
        value: function deleteNote(noteId) {
            var url = _utils2.default.buildApiUrl('notes.entity', { noteId: noteId });

            return this.$http.delete(url).then(responseDataExtractor);
        }
    }]);

    return NotesApi;
}();

exports.default = NotesApi;

/***/ }),

/***/ "B0UP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingStatus = __webpack_require__("nlR8");

var _thingStatus2 = _interopRequireDefault(_thingStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingStatus',
    options: _thingStatus2.default
};

/***/ }),

/***/ "B2oC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpIcon = __webpack_require__("YqLS");

var _helpIcon2 = _interopRequireDefault(_helpIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtHelpIcon',
    options: _helpIcon2.default
};

/***/ }),

/***/ "BEV6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("pB1T"); // eslint-disable-line global-require
    __webpack_require__("CnML"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * RolesApi class.
 */

var RolesApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    RolesApi.$inject = ["$http"];
    function RolesApi($http) {
        _classCallCheck(this, RolesApi);

        this.$http = $http;
        this.config = _local2.default.api.roles;
    }

    /**
     * Get Roles
     * @returns {promise}
     */


    _createClass(RolesApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }

        /**
         * Search Role by given query
         * @param {string} query - Search pattern
         * @param {Object} metadata - Request settings, like: limit, ofset etc.
         * @returns {promise}
         */

    }, {
        key: 'search',
        value: function search(query) {
            var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.$http.get(this.config.searchUrl, {
                params: _extends({
                    query: query + '*'
                }, metadata)
            }).then(responseDataExtractor);
        }

        /**
         * Get Role by given id
         * @param {number} roleId - Role id
         * @returns {promise}
         */

    }, {
        key: 'getRole',
        value: function getRole(roleId) {
            var url = _utils2.default.formatString({ roleId: roleId }, this.config.getUrl);

            return this.$http.get(url).then(responseDataExtractor);
        }

        /**
         * Delete Role by given id
         * @param {number} roleId - Role id
         * @returns {promise}
         */

    }, {
        key: 'deleteRole',
        value: function deleteRole(roleId) {
            var url = _utils2.default.formatString({ roleId: roleId }, this.config.deleteUrl);

            return this.$http.delete(url).then(responseDataExtractor);
        }

        /**
         * Update Role
         * @param {number} roleId - Role id
         * @param {Object} role - Role object
         * @returns {promise}
         */

    }, {
        key: 'updateRole',
        value: function updateRole(roleId, role) {
            var url = _utils2.default.formatString({ roleId: roleId }, this.config.updateUrl);

            return this.$http.put(url, role).then(responseDataExtractor);
        }

        /**
         * Create Role
         * @param {Object} role - Role object
         * @returns {promise}
         */

    }, {
        key: 'createRole',
        value: function createRole(role) {
            return this.$http.post(this.config.createUrl, _extends({}, role)).then(responseDataExtractor);
        }

        /**
         * Add users to role
         * @param {number} roleId - Role id
         * @param {Array<number>} users - User ids
         * @returns {promise}
         */

    }, {
        key: 'addUsersToRole',
        value: function addUsersToRole(roleId, users) {
            var url = _utils2.default.formatString({ roleId: roleId }, this.config.addUsersUrl);

            return this.$http.post(url, { 'user_ids': users }).then(responseDataExtractor);
        }

        /**
         * Delete users from role
         * @param {number} roleId - Role id
         * @param {Array<number>} users - User ids
         * @returns {promise}
         */

    }, {
        key: 'deleteUsersFromRole',
        value: function deleteUsersFromRole(roleId, users) {
            var url = _utils2.default.formatString({ roleId: roleId }, this.config.deleteUsersUrl);

            return this.$http.post(url, { 'user_ids': users }).then(responseDataExtractor);
        }
    }]);

    return RolesApi;
}();

exports.default = RolesApi;

/***/ }),

/***/ "BFDt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notes = __webpack_require__("B+BY");

var _notes2 = _interopRequireDefault(_notes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NotesApi settings
 * @type {{name: string, definition: NotesApi}}
 */
exports.default = {
  name: 'NotesApi',
  definition: _notes2.default
};

/***/ }),

/***/ "BM+i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BM2Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _access = __webpack_require__("/8cb");

var _access2 = _interopRequireDefault(_access);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAccessManagement',
    options: _access2.default
};

/***/ }),

/***/ "BopK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateAppDialogController = function () {
    /** @ngInject */
    CreateAppDialogController.$inject = ["DialogService", "rules", "AlertsActionsApi", "ToastService", "Loader", "ErrorsService", "config"];
    function CreateAppDialogController(DialogService, rules, AlertsActionsApi, ToastService, Loader, ErrorsService, config) {
        _classCallCheck(this, CreateAppDialogController);

        this.DialogService = DialogService;
        this.rules = rules;
        this.config = config;
        this.AlertsActionsApi = AlertsActionsApi;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    _createClass(CreateAppDialogController, [{
        key: 'onInit',
        value: function onInit() {
            this.genericErrors = this.ErrorsService.getGenericErrors();
            this.rule = {
                title: null,
                type: this.config.type
            };
        }
    }, {
        key: 'create',
        value: function create() {
            var _this = this;

            if (!this.rule.title.length) return;

            this.Loader.show();

            this.AlertsActionsApi.create(this.rule).then(function (data) {
                _this.rules.push(data);

                _this.rule.title = '';
                _this.Loader.hide();

                _this.ToastService.show(_this.ToastService.createSimple({
                    text: 'Rule was created',
                    position: 'bottom right'
                }));

                _this.cancel();
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.DialogService.cancel();
        }
    }]);

    return CreateAppDialogController;
}();

exports.default = CreateAppDialogController;

/***/ }),

/***/ "C1bX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SpecificTime = exports.Component = undefined;

var _specificTime = __webpack_require__("f9ym");

var _specificTime2 = _interopRequireDefault(_specificTime);

var _timePeriod = __webpack_require__("Swwy");

var _timePeriod2 = _interopRequireDefault(_timePeriod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtTimePeriod',
    options: _timePeriod2.default
};

exports.Component = Component;
exports.SpecificTime = _specificTime2.default;

/***/ }),

/***/ "CAZ4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/blank-sensor.svg";

/***/ }),

/***/ "CIJ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LabelsListController = function LabelsListController() {
  _classCallCheck(this, LabelsListController);
};

exports.default = LabelsListController;

/***/ }),

/***/ "CIyU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimePeriod = exports.Actions = exports.Component = undefined;

var _timePeriod = __webpack_require__("C1bX");

var TimePeriod = _interopRequireWildcard(_timePeriod);

var _actions = __webpack_require__("sLdy");

var Actions = _interopRequireWildcard(_actions);

var _alertsActionsContent = __webpack_require__("Ls7g");

var _alertsActionsContent2 = _interopRequireDefault(_alertsActionsContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Component = {
    selector: 'dtAlertsActionsContent',
    options: _alertsActionsContent2.default
};

exports.Component = Component;
exports.Actions = Actions;
exports.TimePeriod = TimePeriod;

/***/ }),

/***/ "CO3H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navigation = __webpack_require__("iJjq");

var _navigation2 = _interopRequireDefault(_navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NavigationApi settings
 * @type {{name: string, definition: NavigationApi}}
 */
exports.default = {
  name: 'NavigationApi',
  definition: _navigation2.default
};

/***/ }),

/***/ "CUUb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingName = __webpack_require__("Unb/");

var _thingName2 = _interopRequireDefault(_thingName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingDetailsName',
    options: _thingName2.default
};

/***/ }),

/***/ "CVh+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * FeedbackApi class.
 */

var FeedbackApi = function () {
    /** @ngInject */
    FeedbackApi.$inject = ["$http"];
    function FeedbackApi($http) {
        _classCallCheck(this, FeedbackApi);

        this.$http = $http;
        this.feedbackUrl = _utils2.default.buildApiUrl('feedback.url');
    }

    _createClass(FeedbackApi, [{
        key: 'create',
        value: function create(feedback) {
            return this.$http.post(this.feedbackUrl, _extends({}, feedback)).then(responseDataExtractor);
        }
    }]);

    return FeedbackApi;
}();

exports.default = FeedbackApi;

/***/ }),

/***/ "CX8Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _folderPath = __webpack_require__("4R3X");

var _folderPath2 = _interopRequireDefault(_folderPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtFolderPath',
    options: _folderPath2.default
};

/***/ }),

/***/ "Cb8j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingPicture = __webpack_require__("eWur");

var _thingPicture2 = _interopRequireDefault(_thingPicture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingPicture',
    options: _thingPicture2.default
};

/***/ }),

/***/ "ChJs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _views = __webpack_require__("GSZi");

var _views2 = _interopRequireDefault(_views);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ViewsApi settings
 * @type {{name: string, definition: ViewsApi}}
 */
exports.default = {
  name: 'ViewsApi',
  definition: _views2.default
};

/***/ }),

/***/ "CnML":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/roles.json";

/***/ }),

/***/ "D0uB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlertsActionsContentController = function () {
    /** @ngInject */
    AlertsActionsContentController.$inject = ["EventEmitter", "DialogService"];
    function AlertsActionsContentController(EventEmitter, DialogService) {
        _classCallCheck(this, AlertsActionsContentController);

        this.eventEmmiter = EventEmitter;
        this.dialogService = DialogService;
    }

    _createClass(AlertsActionsContentController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.rule) {
                this.rule = {};
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.rule.currentValue) {
                this.rule = changes.rule.currentValue;
            }
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.onCancel(this.eventEmmiter({
                rule: this.rule
            }));
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            this.dialogService.confirm({
                title: 'Delete Rule?',
                textContent: 'Do you really want to delete rule "' + this.rule.name + '"?',
                ariaLabel: 'delete-rule',
                ok: 'Delete',
                cancel: 'Cancel'
            }).then(function () {
                _this.onRemove(_this.eventEmmiter({
                    id: _this.rule.id
                }));
            });
        }
    }]);

    return AlertsActionsContentController;
}();

exports.default = AlertsActionsContentController;

/***/ }),

/***/ "D6f4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    function link($scope, $element) {
        var dragHandler = $element[0].querySelector('[dt-drag-handle]');

        function getCoords(elem) {
            var box = elem.getBoundingClientRect();

            return {
                top: box.top + window.pageYOffset,
                left: box.left + window.pageXOffset,
                width: box.width,
                height: box.height
            };
        }

        dragHandler.onmousedown = function (e) {
            e.stopPropagation();

            $element.addClass('opacity-60');
            var coords = getCoords($element[0]);
            var shiftX = e.pageX - coords.left;
            var shiftY = e.pageY - coords.top;
            var maxPosY = document.documentElement.clientHeight - getCoords($element[0]).height;
            var maxPosX = document.documentElement.clientWidth - getCoords($element[0]).width;

            function moveAt(ev) {
                var posX = void 0;
                var posY = void 0;

                if (ev.pageX - shiftX > 10) {
                    if (ev.pageX - shiftX > maxPosX - 10) {
                        posX = maxPosX;
                    } else {
                        posX = ev.pageX - shiftX;
                    }
                } else {
                    posX = 0;
                }

                if (ev.pageY - shiftY > 10) {
                    if (ev.pageY - shiftY > maxPosY - 10) {
                        posY = maxPosY;
                    } else {
                        posY = ev.pageY - shiftY;
                    }
                } else {
                    posY = 0;
                }

                $element[0].style.left = posX + 'px';
                $element[0].style.top = posY + 'px';
            }

            moveAt(e);

            document.onmousemove = function (ev) {
                ev.stopPropagation();
                moveAt(ev);
            };

            document.onmouseup = function () {
                $element.removeClass('opacity-60');
                document.onmousemove = null;
                document.onmouseup = null;
            };
        };

        dragHandler.ondragstart = function () {
            return false;
        };
    }

    return {
        restrict: 'A',
        link: link
    };
};

/***/ }),

/***/ "D7iB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _developer = __webpack_require__("n2/Z");

var _developer2 = _interopRequireDefault(_developer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DeveloperApi settings
 * @type {{name: string, definition: DeveloperApi}}
 */
exports.default = {
  name: 'DeveloperApi',
  definition: _developer2.default
};

/***/ }),

/***/ "DAwG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _folderDetails = __webpack_require__("Hlvk");

var _folderDetails2 = _interopRequireDefault(_folderDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtFolderDetailsView',
    options: _folderDetails2.default
};

/***/ }),

/***/ "DI2n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _customers = __webpack_require__("feVk");

var _customers2 = _interopRequireDefault(_customers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * CustomersApi settings
 * @type {{name: string, definition: CustomersApi}}
 */
exports.default = {
  name: 'CustomersApi',
  definition: _customers2.default
};

/***/ }),

/***/ "DIb8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'users';

var ThingOwnerController = function () {
    /** @ngInject */
    ThingOwnerController.$inject = ["EventEmitter", "AuthUsersApi"];
    function ThingOwnerController(EventEmitter, AuthUsersApi) {
        _classCallCheck(this, ThingOwnerController);

        this.eventEmitter = EventEmitter;
        this.AuthUsersApi = AuthUsersApi;
    }

    _createClass(ThingOwnerController, [{
        key: '$onInit',
        value: function $onInit() {
            this.users = [];
            this.query = '';
            this.filterSelected = true;
            this.pendingSearch = null;
            this.lastSearch = 0;
            this.defaulImageUrl = '/assets/images/avatar.png';
            this.autocompleteRequireMatch = true;
            this.blurTime = 300;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'transformChip',
        value: function transformChip(chip) {
            // eslint-disable-line class-methods-use-this
            // If it is an object, it's already a known chip
            if ((typeof chip === 'undefined' ? 'undefined' : _typeof(chip)) === 'object') {
                return chip;
            }

            // Otherwise, create a new one
            return { name: chip, type: 'new' };
        }
    }, {
        key: 'searchUsers',
        value: function searchUsers(criteria) {
            var _this = this;

            if (!this.pendingSearch || !this.debounceSearch()) {
                this.cancelSearch();

                this.pendingSearch = this.AuthUsersApi.search(criteria).then(function (response) {
                    var data = [];

                    if (response && response.objects && response.objects.length) {
                        data = response.objects;
                    }

                    data = data.map(function (user) {
                        if (!('first_name' in user) || !('last_name' in user)) {
                            user.fullName = 'NoNaMe';
                        } else {
                            user.fullName = user.first_name + ' ' + user.last_name;
                        }
                        if (!user.image) {
                            user.image = _this.defaulImageUrl;
                        }

                        return user;
                    });

                    data = data.filter(function (user) {
                        var result = true;
                        var length = _this.users.length;

                        if (!length) return result;

                        for (var i = 0; i < length; i++) {
                            if (_this.users[i].id === user.id) {
                                result = false;
                                break;
                            }
                        }

                        return result;
                    });

                    _this.refreshDebounce();

                    return data;
                }, this.refreshDebounce);
            }

            return this.pendingSearch;
        }
    }, {
        key: 'refreshDebounce',
        value: function refreshDebounce() {
            this.lastSearch = 0;
            this.pendingSearch = null;
        }
    }, {
        key: 'cancelSearch',
        value: function cancelSearch() {
            if (this.pendingSearch) this.pendingSearch.reject();
        }

        /**
         * Debounce if querying faster than 300ms
         */

    }, {
        key: 'debounceSearch',
        value: function debounceSearch() {
            var now = new Date().getMilliseconds();

            this.lastSearch = this.lastSearch || now;

            return now - this.lastSearch < 300;
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var thingOwners = this.getThingOwners();

            if (thingOwners.length) {
                this.fillBucket(thingOwners);

                this.pushUpdate(this.eventEmitter({
                    value: thingOwners
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'getThingOwners',
        value: function getThingOwners() {
            var thingOwners = [];

            this.users.forEach(function (user) {
                thingOwners.push(user.id);
            });

            return thingOwners;
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket(value) {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: value || this.getThingOwners()
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            this.users = [];

            this.clearBucket();
        }
    }]);

    return ThingOwnerController;
}();

exports.default = ThingOwnerController;

/***/ }),

/***/ "DOWT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabs = __webpack_require__("uF0j");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Ft/N");

exports.default = {
    bindings: {
        searchQuery: '<',
        tabId: '<'
    },
    controller: _tabs2.default,
    template: template
};

/***/ }),

/***/ "DmSA":
/***/ (function(module, exports) {

module.exports = "<div class=content-box layout-column layout-padding> <div layout=row layout=\"start center\"> <div class=dtApplicationHelp__info> <div class=box-title>Application help</div> <div ng-bind-html=$ctrl.helpMessage></div> </div> <div class=\"box-rounded box-rounded--grey\"> <div class=\"space-p-t-l space-p-h-m\"> <div> Visit our Help Center to read detailed instructions, tips and tricks, and known issues </div> <md-button class=md-primary href=https://support.disruptive-technologies.com/hc/ target=_blank md-theme=dark>Visit Help Center</md-button> </div> <img ng-if=vm.helpImage ng-src=vm.helpImage alt=\"help illustration\"> </div> </div> <div class=content-box__footer> <md-button class=md-primary href=https://support.disruptive-technologies.com/hc/en-us/articles/360001692834-Where-can-I-find-API-documentation- target=_blank>Developer Documentation</md-button> <span flex></span> <md-button class=md-primary ng-click=$ctrl.onShowFeedbackForm()>Send feedback or submit support ticket</md-button> </div> </div> ";

/***/ }),

/***/ "DqNX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsersAndAccessController = function () {
    /** @ngInject */
    UsersAndAccessController.$inject = ["$state"];
    function UsersAndAccessController($state) {
        _classCallCheck(this, UsersAndAccessController);

        this.$state = $state;
    }

    _createClass(UsersAndAccessController, [{
        key: '$onInit',
        value: function $onInit() {
            this.tabs = [{
                title: 'Users',
                state: 'main.users-and-access.users',
                disabled: true
            }, {
                title: 'Roles',
                state: 'main.users-and-access.roles',
                disabled: true
            }, {
                title: 'Customers',
                state: 'main.users-and-access.customers',
                disabled: true
            }];
        }
    }, {
        key: 'onTabClick',
        value: function onTabClick(_ref) {
            var tab = _ref.tab;

            this.$state.go(tab.state);
        }
    }]);

    return UsersAndAccessController;
}();

exports.default = UsersAndAccessController;

/***/ }),

/***/ "E+Tu":
/***/ (function(module, exports) {

module.exports = "<script type=text/ng-template id=generic-messages.html> <div ng-repeat=\"item in $ctrl.genericErrors track by $index\" ng-message-exp=\"item.type\">\n        {{ item.message }}\n    </div> </script> <md-dialog flex=30> <md-toolbar class=md-hue-2> <div class=md-toolbar-tools> <span class=md-title>Create App</span> <span flex></span> <md-button ng-click=$ctrl.cancel() class=md-icon-button> <md-icon class=material-icons>clear</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=md-dialog-content> <form name=newAppForm novalidate> <md-input-container class=md-block> <label>Name</label> <input type=text name=new_app id=new_app ng-model=$ctrl.app.name md-autofocus required> <div ng-if=newAppForm.new_app.$touched ng-messages=newAppForm.new_app.$error> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> <md-button class=\"md-raised md-primary\" ng-disabled=newAppForm.$invalid ng-click=$ctrl.createApp()>Ok</md-button> </form> </md-dialog-content> </md-dialog> ";

/***/ }),

/***/ "EAMX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _applicationHelp = __webpack_require__("5qVy");

var _applicationHelp2 = _interopRequireDefault(_applicationHelp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtApplicationHelp',
    options: _applicationHelp2.default
};

/***/ }),

/***/ "EGhv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


usersRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = usersRouter;

var _usersAndAccess = __webpack_require__("flzX");

/** @ngInject */
function usersRouter($stateProvider) {
    var usersState = {
        url: '/users',
        views: {
            contentBody: {
                component: _usersAndAccess.Users.Component.selector
            }
        }
    };

    $stateProvider.state('main.users-and-access.users', usersState);
}

/***/ }),

/***/ "EScj":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"center start\" flex layout-margin> <div class=box flex=70> <dt-search-box placeholder=\"Search customers\" on-search=$ctrl.onSearch($event) on-empty-search=$ctrl.resetSearch() class=dt-things-toolbox> </dt-search-box> <md-table-container class=table-container> <table md-table md-row-select multiple=multiple ng-model=$ctrl.selectedCustomers> <thead md-head> <tr md-row> <th md-column md-order-by=customer.fullName> <span>Name</span> </th> <th md-column md-order-by=customer.email> <span>Email</span> </th> <th md-column md-order-by=customer.total_things> <span>Sensors owned</span> </th> <th md-column> <span class=space-p-l-m>Actions</span> </th> </tr> </thead> <tbody md-body> <tr md-row md-select=customer md-select-id=id ng-repeat=\"customer in $ctrl.customers track by customer.id\"> <td md-cell> <div class=md-body-1>{{ ::customer.fullName }}</div>  </td><td md-cell> <a href=\"mailto:{{ ::customer.email }}\">{{ ::customer.email }}</a> </td> <td md-cell> <div class=\"row middle-xs\"> <div class=\"col-xs-3 text-right\"> <b>{{ ::customer.total_things }}</b> </div> </div> </td> <td md-cell> <div layout=row> <md-button class=\"md-primary md-hue-1 md-button--s\" ng-click=$ctrl.onCustomerResetPassword(customer)> Reset password </md-button> <md-button ng-if=customer.hasAccess class=\"md-primary md-hue-1 md-button--s\" ng-click=$ctrl.onViewInfo(customer)> View customer info </md-button> <md-button ng-if=!customer.hasAccess class=\"md-primary md-hue-1 md-button--s\" ng-click=\"$ctrl.onRequestAccess($event, customer)\"> Request access </md-button> <md-button class=\"md-warn md-button--s\" ng-click=$ctrl.onCustomerDelete(customer)> Delete </md-button> </div> </td> </tr> </tbody> </table> </md-table-container> <div layout=row layout-align=\"start center\" layout-padding ng-if=$ctrl.hasRoles> <div class=md-body-1> Bulk edit </div> <div> <md-input-container class=space-m-v-n> <label>Choose role</label> <md-select ng-model=$ctrl.selectedRole> <md-option ng-repeat=\"role in $ctrl.roles track by $index\" ng-value=role>{{ ::role.name }}</md-option> </md-select> </md-input-container> </div> <div> <md-button class=\"md-primary md-hue-2 md-button--s\" ng-click=$ctrl.onAssignRole($event) ng-disabled=\"!$ctrl.selectedRole || !$ctrl.selectedUsers || !$ctrl.selectedUsers.length\"> Assign roles </md-button> </div> </div> </div> </div>";

/***/ }),

/***/ "EZyF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mapPopup = __webpack_require__("t5Zq");

var _mapPopup2 = _interopRequireDefault(_mapPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapPopupTemplate = __webpack_require__("0F4W");

var ThingEditLocationController = function () {
    /** @ngInject */
    ThingEditLocationController.$inject = ["DialogService", "GeoService", "EventEmitter"];
    function ThingEditLocationController(DialogService, GeoService, EventEmitter) {
        _classCallCheck(this, ThingEditLocationController);

        this.DialogService = DialogService;
        this.GeoService = GeoService;
        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingEditLocationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.defaultCoordinates = this.GeoService.getCoordsByKey('default') || {};
        }
    }, {
        key: 'showLocation',
        value: function showLocation(ev) {
            var marker = void 0;
            var centerCoordinates = void 0;

            if (this.location) {
                centerCoordinates = {
                    lat: this.location.latitude,
                    lng: this.location.longitude,
                    address: this.location.address
                };

                marker = centerCoordinates;
            } else {
                centerCoordinates = {
                    lat: this.defaultCoordinates.lat,
                    lng: this.defaultCoordinates.lng
                };
            }

            this.DialogService.show({
                controller: _mapPopup2.default,
                template: MapPopupTemplate,
                controllerAs: '$ctrl',
                parent: document.body,
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    marker: marker,
                    centerCoordinates: centerCoordinates,
                    updateMarker: this.updateMarker.bind(this),
                    isEditing: true
                }
            });
        }
    }, {
        key: 'updateMarker',
        value: function updateMarker(marker) {
            var location = null;

            if (marker) {
                location = {
                    address: marker.address,
                    latitude: marker.lat,
                    longitude: marker.lng
                };
            }

            this.onUpdate(this.eventEmitter({
                patch: {
                    location: location
                }
            }));
        }
    }]);

    return ThingEditLocationController;
}();

exports.default = ThingEditLocationController;

/***/ }),

/***/ "Evvn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingType = __webpack_require__("WUsz");

var _thingType2 = _interopRequireDefault(_thingType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("mYg8");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingType2.default
};

/***/ }),

/***/ "F+hJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notifications = __webpack_require__("cLBf");

var _notifications2 = _interopRequireDefault(_notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("JfqN");

exports.default = {
    controller: _notifications2.default,
    template: template
};

/***/ }),

/***/ "F/iv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Plural = undefined;

var _plural = __webpack_require__("pZmp");

var _plural2 = _interopRequireDefault(_plural);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Plural = _plural2.default;

/***/ }),

/***/ "F7qz":
/***/ (function(module, exports) {

module.exports = "<div class=box layout-padding dt-sticky dt-sticky-from=67 dt-sticky-to=16 sticky-class=sticky container=.dt-layout-content__container> <form class=form-grid ng-submit=\"$ctrl.onSearch(); $event.preventDefault();\"> <div class=\"form-grid__group push-out-box\"> <div layout=row layout-align=\"space-between center\"> <md-button type=submit class=\"md-primary md-raised space-m-r-n\">Search</md-button> <md-button class=md-default ng-click=$ctrl.onReset() ng-disabled=\"$ctrl.isProcessing || !$ctrl.hasBuckets\">Reset</md-button> <span flex></span> <md-button class=md-icon-button ui-sref=main.sensors.list style=margin-right:-12px> <md-icon class=\"material-icons material-icons--s\">close</md-icon> </md-button> </div> </div> <div class=form-grid__group> <dt-as-thing-name class=form-grid__row reset=$ctrl.thingName push-update=$ctrl.onThingNameUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-name> <dt-as-thing-status class=form-grid__row reset=$ctrl.thingStatus push-update=$ctrl.onThingStatusUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-status> <div class=\"form-grid__row gap24\"> <dt-as-thing-star class=form-grid__col reset=$ctrl.thingStarred push-update=$ctrl.onThingStarredUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-star> </div> </div> <dt-as-thing-type class=form-grid__group reset=$ctrl.thingType push-update=$ctrl.onThingTypeUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-type> <div class=form-grid__group> <dt-as-thing-battery class=\"form-grid__row gap24\" reset=$ctrl.thingBattery push-update=$ctrl.onThingBatteryUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-battery> <dt-as-thing-signal reset=$ctrl.thingSignal push-update=$ctrl.onThingSignalUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-signal> </div> <div class=form-grid__group> <div class=\"form-grid__row form-grid__row--static\"> <div class=form-grid__col> <dt-as-thing-registered reset=$ctrl.thingRegistered push-update=$ctrl.onThingRegisteredUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-registered> </div> <div class=form-grid__col> <dt-as-thing-updated reset=$ctrl.thingUpdated push-update=$ctrl.onThingUpdatedUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-updated> </div> </div> </div> <dt-as-thing-location class=form-grid__group reset=$ctrl.thingLocation push-update=$ctrl.onThingLocationUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-location> <dt-as-thing-labels reset=$ctrl.thingLabels class=form-grid__group labels=$ctrl.labels push-update=$ctrl.onThingLabelsUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-labels> <dt-as-thing-folders class=form-grid__group reset=$ctrl.thingFolders folders=$ctrl.folders push-update=$ctrl.onThingFoldersUpdate($event) add-item-to-bucket=$ctrl.setItemInAdvancedSearchBucket($event) remove-item-from-bucket=$ctrl.removeItemFromAdvancedSearchBucket($event)></dt-as-thing-folders> <md-divider class=space-m-v-m></md-divider> <div class=form-grid__group> <div layout=row layout-align=\"space-between center\"> <md-button ng-disabled=\"$ctrl.isProcessing || !$ctrl.hasBuckets || !$ctrl.query.length\" class=md-primary dt-save-view search-query=$ctrl.query on-save-view=$ctrl.triggerSaveView($event)> Save as View </md-button> <div> <md-button class=md-default ng-click=$ctrl.onReset() ng-disabled=\"$ctrl.isProcessing || !$ctrl.hasBuckets\">Reset</md-button> <md-button class=\"md-primary md-raised\" type=submit>Search</md-button> </div> </div> </div> </form> </div> ";

/***/ }),

/***/ "FI/j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _list = __webpack_require__("kaWl");

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("ilcP");

exports.default = {
    bindings: {
        searchQuery: '<'
    },
    template: template,
    controller: _list2.default
};

/***/ }),

/***/ "FIke":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lucene = __webpack_require__("2luL");

var _lucene2 = _interopRequireDefault(_lucene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FolderDetailsController = function () {
    /** @ngInject */
    FolderDetailsController.$inject = ["EventEmitter", "DialogService"];
    function FolderDetailsController(EventEmitter, DialogService) {
        _classCallCheck(this, FolderDetailsController);

        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
    }

    _createClass(FolderDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.folderName = this.folder.name;
            this.searchQuery = _lucene2.default.convertFoldersToLuceneCompatible([this.folder.id]);
        }
    }, {
        key: 'save',
        value: function save() {
            this.onSaved(this.eventEmitter({
                folder: this.folder
            }));
            this.folderName = this.folder.name;
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.onEditCancelled();
        }
    }, {
        key: 'showDeleteConfirmation',
        value: function showDeleteConfirmation() {
            var _this = this;

            this.DialogService.confirm({
                title: 'Delete Folder?',
                textContent: 'Do you really want to delete folder "' + this.folderName + '"?',
                ariaLabel: 'delete-folder',
                ok: 'Delete',
                cancel: 'Cancel'
            }).then(function () {
                _this.onDeleted(_this.eventEmitter({
                    folder: _this.folder
                }));
            });
        }
    }]);

    return FolderDetailsController;
}();

exports.default = FolderDetailsController;

/***/ }),

/***/ "FLNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function responseDataExtractor(response) {
    return response.data;
}

var NavigationApi = function () {
    /** @ngInject */
    NavigationApi.$inject = ["$http"];
    function NavigationApi($http) {
        _classCallCheck(this, NavigationApi);

        this.$http = $http;
        this.listUrl = _utils2.default.buildApiUrl('notifications.list');
    }

    _createClass(NavigationApi, [{
        key: 'getByObjectId',
        value: function getByObjectId(objectId) {
            var params = {
                object_id: objectId
            };
            return this.$http.get(this.listUrl, { params: params }).then(responseDataExtractor);
        }
    }]);

    return NavigationApi;
}();

exports.default = NavigationApi;

/***/ }),

/***/ "FSQp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

var _alert = __webpack_require__("prw6");

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("NNTt"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    var data = response.data;

    data.objects = data.objects.map(function (thing) {
        return new _alert2.default(thing);
    });

    return data;
}

/**
 * AlertsApi class.
 */

var AlertsApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    AlertsApi.$inject = ["$http"];
    function AlertsApi($http) {
        _classCallCheck(this, AlertsApi);

        /** @type {$http} */
        this.$http = $http;
        /** @type {Object} */
        this.config = _local2.default.api.alerts;
    }

    /**
     * Get Alerts
     * @returns {promise}
     */


    _createClass(AlertsApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }
    }]);

    return AlertsApi;
}();

exports.default = AlertsApi;

/***/ }),

/***/ "FUR/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _screenshot = __webpack_require__("SKhp");

var _screenshot2 = _interopRequireDefault(_screenshot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtScreenshot',
    options: _screenshot2.default
};

/***/ }),

/***/ "FbvC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlertBoxController = function () {
    /** @ngInject */
    AlertBoxController.$inject = ["NotificationsApi"];
    function AlertBoxController(NotificationsApi) {
        _classCallCheck(this, AlertBoxController);

        this.NotificationsApi = NotificationsApi;
    }

    _createClass(AlertBoxController, [{
        key: '$onInit',
        value: function $onInit() {
            this.notification = null;
            this.severity = null;
            this.severities = {
                INFO: {
                    cls: 'info',
                    icon: 'fa-info'
                },
                WARNING: {
                    cls: 'warn',
                    icon: 'fa-warning'
                },
                ALERT: {
                    cls: 'alert',
                    icon: 'fa-exclamation-circle'
                }
            };
        }
    }, {
        key: 'getSeverity',
        value: function getSeverity(notification) {
            return this.severities[notification.level];
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.selectedThingId && changes.selectedThingId.currentValue) {
                this.selectedThingId = changes.selectedThingId.currentValue;
                this.loadNotifications();
            }
        }
    }, {
        key: 'loadNotifications',
        value: function loadNotifications() {
            var _this = this;

            this.NotificationsApi.getByObjectId(this.selectedThingId).then(function (data) {
                var notifications = data.notifications || [];
                _this.notification = notifications.pop();
                if (_this.notification) {
                    _this.severity = _this.getSeverity(_this.notification);
                } else {
                    _this.severity = null;
                }
            });
        }
    }]);

    return AlertBoxController;
}();

exports.default = AlertBoxController;

/***/ }),

/***/ "Ffr7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _generalInformation = __webpack_require__("Yyya");

var _generalInformation2 = _interopRequireDefault(_generalInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtGeneralInformation',
    options: _generalInformation2.default
};

/***/ }),

/***/ "FgbM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingSignal = __webpack_require__("rZwI");

var _thingSignal2 = _interopRequireDefault(_thingSignal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("w3xc");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingSignal2.default
};

/***/ }),

/***/ "Ficg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _controller = __webpack_require__("0K23");

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SaveGraphsTemplate = __webpack_require__("ylAY");

var NotificationsController = function () {
    /** @ngInject */
    NotificationsController.$inject = ["EventEmitter", "DialogService"];
    function NotificationsController(EventEmitter, DialogService) {
        _classCallCheck(this, NotificationsController);

        this.eventEmiter = EventEmitter;
        this.DialogService = DialogService;
    }

    _createClass(NotificationsController, [{
        key: 'save',
        value: function save() {
            this.DialogService.show({
                controller: _controller2.default,
                controllerAs: '$ctrl',
                template: SaveGraphsTemplate,
                parent: document.body,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true
            });
        }
    }]);

    return NotificationsController;
}();

exports.default = NotificationsController;

/***/ }),

/***/ "Fqfp":
/***/ (function(module, exports) {

module.exports = "<dt-search-autocomplete ng-if=::!$ctrl.multiSelect class=\"md-block space-m-b-m\" placeholder=\"Search folders\" text-key=name on-selected=$ctrl.onFolderFound($event) on-search=$ctrl.onSearch($event)></dt-search-autocomplete> <script type=text/ng-template id=level.template.html> <li ng-repeat=\"folder in folder.children\" data-nodrag ui-tree-node data-collapsed=\"::!$ctrl.expandedByDefault[folder.id]\">\n        <div class=\"entity-label entity-label--active-no-arrow space-p-h-n\" ng-class=\"{'is-active': $ctrl.selected[folder.id]}\" ng-dblclick=\"$ctrl.selectFolder(folder, true)\" ng-click=\"$ctrl.selectFolder(folder)\">\n            <md-button ng-disabled=\"!folder.children\" class=\"md-button--icon space-m-r-s\" ng-click=\"toggle(); $event.stopPropagation();\" aria-label=\"Toggle\">\n                <i class=\"fa\" ng-class=\"collapsed ? 'fa-caret-right' : 'fa-caret-down'\" aria-hidden=\"true\"></i>\n            </md-button>\n\n            <div class=\"entity-label__content flex\">\n                <div class=\"entity-label__name\" title=\"{{folder.name}}\">{{ folder.name }}</div>\n            </div>\n\n            <!--<div class=\"entity-label__info\">-->\n            <!--<div class=\"entity-label__amount\">{{ folder.count }}</div>-->\n            <!--</div>-->\n        </div>\n\n        <ol class=\"custom-list custom-list--entities\"\n            ng-include=\"'level.template.html'\"\n            ui-tree-nodes\n            ng-model=\"folder.children\"\n            ng-class=\"{'is-hidden': collapsed}\">\n        </ol>\n    </li> </script> <div class=text-right> <a href=# ng-click=\"$event.preventDefault(); $ctrl.expandAll();\">Expand all</a> / <a href=# ng-click=\"$event.preventDefault(); $ctrl.collapseAll();\">Collapse all</a> </div> <div class=folder-tree ng-init=$ctrl.initTreeScope(this); ui-tree=$ctrl.treeOptions> <ol ui-tree-nodes class=\"custom-list custom-list--entities\" ng-model=$ctrl.data ng-if=$ctrl.data.length> <li ng-repeat=\"folder in $ctrl.data\" data-nodrag ui-tree-node data-expand-on-hover=true data-collapsed=false> <div class=\"entity-label entity-label--active-no-arrow space-p-h-n\" ng-class=\"{'is-active': $ctrl.selected[folder.id]}\" ng-dblclick=\"$ctrl.selectFolder(folder, true)\" ng-click=$ctrl.selectFolder(folder)> <md-button ng-disabled=!folder.children class=\"md-button--icon space-m-r-s\" ng-click=\"toggle(); $event.stopPropagation();\" aria-label=Toggle> <i class=fa ng-class=\"collapsed ? 'fa-caret-right' : 'fa-caret-down'\" aria-hidden=true></i> </md-button> <div class=\"entity-label__content flex\"> <div class=entity-label__name title={{folder.name}}>{{ folder.name }}</div> </div> </div> <ol class=\"custom-list custom-list--entities\" ng-include=\"'level.template.html'\" ui-tree-nodes ng-model=folder.children ng-class=\"{'is-hidden': collapsed}\"> </ol> </li> </ol> </div>";

/***/ }),

/***/ "Ft/N":
/***/ (function(module, exports) {

module.exports = "<div class=top-navbar layout=row layout-align=\"start center\"> <dt-tabs class=\"dt-tabs dt-theme\" layout=row layout-align=\"start center\" flex selected-tab-id=$ctrl.currentTabIndex tabs=$ctrl.tabs on-tab-click=$ctrl.onTabClick($event) on-tab-menu-item-click=$ctrl.onTabMenuItemClick($event)> </dt-tabs> <div class=top-navbar__tools layout=row layout-align=\"start center\"> <div class=top-navbar__tools-item> <a class=\"top-navbar__tools-btn cursor-pointer\" layout=row layout-align=\"start center\" ng-if=$ctrl.searchQuery dt-save-view on-save-view=$ctrl.onSaveView($event) search-query=$ctrl.searchQuery>Save as view<md-icon>add_circle</md-icon></a> </div> <div class=top-navbar__tools-item> <a class=\"top-navbar__tools-btn cursor-pointer\" dt-edit-navbar=$ctrl.loadAppNavigation()>Edit navbar</a> </div> </div> </div>";

/***/ }),

/***/ "FyPS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _batteryStatus = __webpack_require__("RcIP");

var _batteryStatus2 = _interopRequireDefault(_batteryStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("P3sd");

exports.default = {
    bindings: {
        battery: '<'
    },
    template: template,
    controller: _batteryStatus2.default
};

/***/ }),

/***/ "FznX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FolderPathController = function () {
    /** @ngInject */
    FolderPathController.$inject = ["EventEmitter", "DialogService", "FolderService", "CharsService"];
    function FolderPathController(EventEmitter, DialogService, FolderService, CharsService) {
        _classCallCheck(this, FolderPathController);

        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.FolderService = FolderService;
        this.CharsService = CharsService;
    }

    _createClass(FolderPathController, [{
        key: '$onInit',
        value: function $onInit() {
            this.folderPathPlaceholder = '';
            this.chars = this.CharsService.getList();
            this.folderSeparator = ' › ';
            this.maxChars = Infinity;
            this.ratio = 1;
            this.initFlag = true;

            if (this.folderPath.length) {
                this.update();
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.emptyTrail) {
                this.emptyTrail = changes.emptyTrail.currentValue;
            }
            if (changes.folderId) {
                this.folderId = changes.folderId.currentValue;
            }
            if (this.folderId) {
                this.folderPath = this.FolderService.buildFolderPath(this.folderId);
                if (this.emptyTrail) {
                    this.folderPath.push({
                        name: ''
                    });
                }
            } else {
                this.folderPath = [];
            }

            if (this.folderPath.length && this.initFlag) {
                this.update();
            }
        }
    }, {
        key: 'update',
        value: function update() {
            this.createStr();

            if (this.maxWidth) {
                this.calcMaxChars();
            }

            this.render();
        }
    }, {
        key: 'createStr',
        value: function createStr() {
            var _this = this;

            this.folderPathText = this.folderPath.reduce(function (sum, item, index) {
                var part = void 0;

                if (index !== _this.folderPath.length - 1) {
                    part = sum + item.name + ' \u203A ';
                } else {
                    part = sum + item.name;
                }

                return part;
            }, '');
        }
    }, {
        key: 'calcMaxChars',
        value: function calcMaxChars() {
            this.calcRation();

            this.maxChars = 0;

            var maxWidth = this.maxWidth - 16 * this.ratio;

            for (var i = 0; i < this.folderPathText.length; i++) {
                var charWidth = void 0;

                try {
                    charWidth = this.chars[this.folderPathText.charAt(i)].width * this.ratio;
                } catch (error) {
                    charWidth = 10 * this.ratio;
                }

                if (maxWidth - charWidth > 0) {
                    maxWidth -= charWidth;
                    this.maxChars += 1;
                } else {
                    break;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.folderPathText.length > this.maxChars) {
                if (this.folderPath.length < 2) {
                    this.folderPathPlaceholder = this.folderPathText.slice(0, this.maxChars) + '...';
                } else {
                    var temp = this.folderPathText.slice(-this.maxChars).split(this.folderSeparator);
                    temp.shift();

                    if (temp.length > 1) {
                        this.folderPathPlaceholder = '...' + this.folderSeparator + '\n                        ' + temp.filter(function (item) {
                            return item.length;
                        }).map(function (item) {
                            return item.trim();
                        }).join(this.folderSeparator);
                    } else {
                        var placeholder = '...' + this.folderSeparator + this.folderPath.pop().name;

                        if (placeholder.length > this.maxChars) {
                            this.folderPathPlaceholder = placeholder.slice(0, this.maxChars) + '...';
                        } else {
                            this.folderPathPlaceholder = placeholder;
                        }
                    }
                }
                this.folderPathFull = this.folderPathText;
            } else {
                this.folderPathPlaceholder = this.folderPathText;
                this.folderPathFull = null;
            }
        }
    }, {
        key: 'calcRation',
        value: function calcRation() {
            this.ratio = window.devicePixelRatio;
            this.ratio *= !isNaN(parseInt(this.fontSize, 10)) ? parseInt(this.fontSize, 10) / 10 : 1;
        }
    }]);

    return FolderPathController;
}();

exports.default = FolderPathController;

/***/ }),

/***/ "G+YA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _list = __webpack_require__("CIJ6");

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("RYK1");

exports.default = {
    bindings: {
        entities: '<',
        entityState: '@'
    },
    controller: _list2.default,
    template: template
};

/***/ }),

/***/ "G4Gs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingStar = __webpack_require__("uWoC");

var _thingStar2 = _interopRequireDefault(_thingStar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("wyRe");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingStar2.default
};

/***/ }),

/***/ "G9fG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


foldersRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = foldersRouter;

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _foldersAndLabels = __webpack_require__("VByS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @ngInject */
function foldersRouter($stateProvider) {
    var foldersState = {
        url: '/folders',
        views: {
            contentBody: {
                component: _foldersAndLabels.Folders.Component.selector
            }
        }
    };

    $stateProvider.state('main.folders-and-labels.folders', foldersState).state('main.folders-and-labels.folders.folder', {
        url: '/{folderId}',
        resolve: {
            /** @ngInject */
            folder: ["FolderService", "$stateParams", function folder(FolderService, $stateParams) {
                return (0, _cloneDeep3.default)(FolderService.getFolder($stateParams.folderId));
            }]
        },
        /** @ngInject */
        onEnter: ["folder", "$state", function onEnter(folder, $state) {
            // eslint-disable-line consistent-return
            if (!folder) {
                return $state.target('main.folders-and-labels.folders');
            }
        }],

        component: _foldersAndLabels.Folders.FolderDetails.selector
    });
}

/***/ }),

/***/ "GHPA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__("Hs3Y");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ConfigApi settings
 * @type {{name: string, definition: ConfigApi}}
 */
exports.default = {
  name: 'ConfigApi',
  definition: _config2.default
};

/***/ }),

/***/ "GJWX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _feedbackForm = __webpack_require__("Uoev");

var _feedbackForm2 = _interopRequireDefault(_feedbackForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("rOGV");

exports.default = {
    bindings: {
        onCancel: '&'
    },
    controller: _feedbackForm2.default,
    template: template
};

/***/ }),

/***/ "GLmD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingStar = __webpack_require__("cv2b");

var _thingStar2 = _interopRequireDefault(_thingStar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("euRd"); // eslint-disable-line global-require
    __webpack_require__("jY6q"); // eslint-disable-line global-require
}

exports.default = {
    selector: 'dtThingStar',
    options: _thingStar2.default
};

/***/ }),

/***/ "GSZi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * ViewsApi class.
 * Use this service to interact with API.
 */

var ViewsApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    ViewsApi.$inject = ["$http"];
    function ViewsApi($http) {
        _classCallCheck(this, ViewsApi);

        this.$http = $http;
        this.listUrl = _utils2.default.buildApiUrl('views.list');
    }

    /**
     * Get Views
     * @returns {promise}
     */


    _createClass(ViewsApi, [{
        key: 'getList',
        value: function getList() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.$http.get(this.listUrl, { params: params }).then(responseDataExtractor);
        }

        /**
         * Create View
         * @param {Object} view - View object
         * @returns {promise}
         */

    }, {
        key: 'createView',
        value: function createView(view) {
            return this.$http.post(this.listUrl, view).then(responseDataExtractor);
        }

        /**
         * Get View by given view id
         * @param {number} viewId - View id
         * @returns {promise}
         */

    }, {
        key: 'getView',
        value: function getView(viewId) {
            var url = _utils2.default.buildApiUrl('views.entity', { viewId: viewId });

            return this.$http.get(url).then(responseDataExtractor);
        }
    }, {
        key: 'saveView',
        value: function saveView(viewId, data) {
            var url = _utils2.default.buildApiUrl('views.entity', { viewId: viewId });

            return this.$http.put(url, data).then(responseDataExtractor);
        }

        /**
         * Delete View by given view id
         * @param {number} viewId - View id
         * @returns {promise}
         */

    }, {
        key: 'deleteView',
        value: function deleteView(viewId) {
            var url = _utils2.default.buildApiUrl('views.entity', { viewId: viewId });

            return this.$http.delete(url).then(responseDataExtractor);
        }
    }]);

    return ViewsApi;
}();

exports.default = ViewsApi;

/***/ }),

/***/ "GUdK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InterceptorConfig = exports.AuthService = undefined;

var _auth = __webpack_require__("+288");

var _auth2 = _interopRequireDefault(_auth);

var _auth3 = __webpack_require__("XndK");

var _auth4 = _interopRequireDefault(_auth3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthService = {
    name: 'AuthService',
    definition: _auth4.default
};

exports.AuthService = AuthService;
exports.InterceptorConfig = _auth2.default;

/***/ }),

/***/ "Gl4w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Service = undefined;

var _help = __webpack_require__("HrHh");

var _help2 = _interopRequireDefault(_help);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * HelpService settings
 * @type {{name: string, definition: HelpService}}
 */
var Service = {
    name: 'HelpService',
    definition: _help2.default
};

exports.Service = Service;

/***/ }),

/***/ "GmSh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.AddFolderComponent = undefined;

var _addFolder = __webpack_require__("uRgF");

var _addFolder2 = _interopRequireDefault(_addFolder);

var _tree = __webpack_require__("PtwN");

var _tree2 = _interopRequireDefault(_tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtAdminFolderTree',
    options: _tree2.default
};

exports.AddFolderComponent = _addFolder2.default;
exports.Component = Component;

/***/ }),

/***/ "Gokj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Constant = exports.Service = undefined;

var _things = __webpack_require__("mpUf");

var _things2 = _interopRequireDefault(_things);

var _things3 = __webpack_require__("K+aS");

var _things4 = _interopRequireDefault(_things3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ThingsApi settings
 * @type {{name: string, definition: ThingsApi}}
 */
var Service = {
    name: 'ThingsApi',
    definition: _things2.default
};

exports.Service = Service;
exports.Constant = _things4.default;

/***/ }),

/***/ "Gqf/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _note = __webpack_require__("Pvku");

var _note2 = _interopRequireDefault(_note);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddNoteDialogController = function () {
    /** @ngInject */
    AddNoteDialogController.$inject = ["DialogService", "notes", "thingId", "NotesApi", "ToastService", "Loader", "ErrorsService"];
    function AddNoteDialogController(DialogService, notes, thingId, NotesApi, ToastService, Loader, ErrorsService) {
        _classCallCheck(this, AddNoteDialogController);

        this.DialogService = DialogService;
        this.notes = notes;
        this.NotesApi = NotesApi;
        this.thingId = thingId;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    _createClass(AddNoteDialogController, [{
        key: 'onInit',
        value: function onInit() {
            this.genericErrors = this.ErrorsService.getGenericErrors();
        }
    }, {
        key: 'addNote',
        value: function addNote() {
            var _this = this;

            if (!this.newNote.length) return;

            this.Loader.show();

            var note = new _note2.default(this.thingId, this.newNote);

            this.NotesApi.createNote(note).then(function (data) {
                _this.notes.push(data);

                _this.newNote = '';
                _this.Loader.hide();
                _this.ToastService.showSimpleTranslated('comment_was_created');
                _this.cancel();
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.DialogService.cancel();
        }
    }]);

    return AddNoteDialogController;
}();

exports.default = AddNoteDialogController;

/***/ }),

/***/ "GtqN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


mdCustomColumnDirectiveController.$inject = ["$mdUtil", "$compile"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mdCustomColumnDirectiveController;

var _angular = __webpack_require__("aeQg");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @ngInject */
function mdCustomColumnDirectiveController($mdUtil, $compile) {
    function postLink($scope, $element, $attrs, $ctrls) {
        var headCtrl = $ctrls.shift();
        var tableCtrl = $ctrls.shift();
        $scope.orderCounter = {};

        function attachSortIcon() {
            var icons = ['table-sortable', 'table-sorted'];

            icons.forEach(function (icon) {
                var sortIcon = _angular2.default.element('<md-icon class="md-custom-column-arrow ' + icon + '" md-svg-icon="' + icon + '">');

                $compile(sortIcon.addClass('md-sort-icon').attr('ng-class', 'getDirection()'))($scope);

                if ($element.hasClass('md-numeric')) {
                    $element.prepend(sortIcon);
                } else {
                    $element.append(sortIcon);
                }
            });
        }

        function detachSortIcon() {
            Array.prototype.some.call($element.find('md-icon'), function (icon) {
                return icon.classList.contains('md-sort-icon') && $element[0].removeChild(icon);
            });
        }

        function getIndex() {
            return Array.prototype.indexOf.call($element.parent().children(), $element[0]);
        }

        function isActive() {
            return $scope.orderBy && (headCtrl.order === $scope.orderBy || headCtrl.order === '-' + $scope.orderBy);
        }

        function isNumeric() {
            return $attrs.mdNumeric === '' || $scope.numeric;
        }

        function setOrder() {
            if (isNaN($scope.orderCounter[$scope.orderBy])) {
                $scope.orderCounter[$scope.orderBy] = 0;
            }

            $scope.orderCounter[$scope.orderBy] += 1;

            if ($scope.orderCounter[$scope.orderBy] % 3 === 0) {
                headCtrl.order = '';
            } else if (isActive()) {
                headCtrl.order = $scope.getDirection() === 'md-asc' ? '-' + $scope.orderBy : $scope.orderBy;
            } else {
                headCtrl.order = $scope.getDirection() === 'md-asc' ? $scope.orderBy : '-' + $scope.orderBy;
            }

            if (_angular2.default.isFunction(headCtrl.onReorder)) {
                $mdUtil.nextTick(function () {
                    headCtrl.onReorder(headCtrl.order);
                });
            }

            $scope.$applyAsync();
        }

        function updateColumn(index, column) {
            tableCtrl.$$columns[index] = column;

            if (column.numeric) {
                $element.addClass('md-numeric');
            } else {
                $element.removeClass('md-numeric');
            }
        }

        function disableSorting() {
            detachSortIcon();
            $element.removeClass('md-sort');
            $element.off('click', setOrder);
        }

        function enableSorting() {
            attachSortIcon();
            $element.addClass('md-sort');
            $element.on('click', setOrder);
        }

        $scope.getDirection = function () {
            if (isActive()) {
                return headCtrl.order.charAt(0) === '-' ? 'md-desc' : 'md-asc';
            }

            return $attrs.mdDesc === '' || $scope.$eval($attrs.mdDesc) ? 'md-desc' : 'md-asc';
        };

        $scope.$watch(isActive, function (active) {
            if (active) {
                $element.addClass('md-active');
            } else {
                $element.removeClass('md-active');
            }
        });

        $scope.$watch(getIndex, function (index) {
            updateColumn(index, { 'numeric': isNumeric() });
        });

        $scope.$watch(isNumeric, function (numeric) {
            updateColumn(getIndex(), { 'numeric': numeric });
        });

        $scope.$watch('orderBy', function (newValue) {
            if (newValue) {
                if (!$element.hasClass('md-sort')) {
                    enableSorting();
                }
            } else if ($element.hasClass('md-sort')) {
                disableSorting();
            }
        });
    }

    function compile(tElement) {
        tElement.addClass('md-column');
        return postLink;
    }

    return {
        compile: compile,
        require: ['^^mdHead', '^^mdTable'],
        restrict: 'A',
        scope: {
            numeric: '=?mdNumeric',
            orderBy: '@?mdOrderBy'
        }
    };
}

/***/ }),

/***/ "Gwh9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _customers = __webpack_require__("yR4c");

var _customers2 = _interopRequireDefault(_customers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("EScj");

exports.default = {
    controller: _customers2.default,
    template: template
};

/***/ }),

/***/ "H10Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = undefined;

var _apiAccess = __webpack_require__("KfLe");

var _apiAccess2 = _interopRequireDefault(_apiAccess);

var _apiAccess3 = __webpack_require__("hkk2");

var _apiAccess4 = _interopRequireDefault(_apiAccess3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtApiAccessView',
    options: _apiAccess4.default
};

exports.Config = _apiAccess2.default;
exports.Component = Component;

/***/ }),

/***/ "H1Ft":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _advancedInformation = __webpack_require__("InIr");

var _advancedInformation2 = _interopRequireDefault(_advancedInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("+jTT");

exports.default = {
    bindings: {
        advancedInformation: '<'
    },
    template: template,
    controller: _advancedInformation2.default
};

/***/ }),

/***/ "H2Td":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


developerSettingsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = developerSettingsRouter;

var _developerSettings = __webpack_require__("xcRF");

/** @ngInject */
function developerSettingsRouter($stateProvider) {
    var baseState = {
        redirectTo: 'main.developer-settings.api-access',
        views: {
            content: {
                component: _developerSettings.Component.selector
            }
        }
    };

    $stateProvider.state('main.developer-settings', baseState);
}

/***/ }),

/***/ "H9HM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LabelsAutocompleteController = function () {
    /** @ngInject */
    LabelsAutocompleteController.$inject = ["EventEmitter", "LabelsApi"];
    function LabelsAutocompleteController(EventEmitter, LabelsApi) {
        _classCallCheck(this, LabelsAutocompleteController);

        this.eventEmitter = EventEmitter;
        this.LabelsApi = LabelsApi;
    }

    _createClass(LabelsAutocompleteController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.cache = [];
            this.LabelsApi.fetch().then(function (data) {
                _this.cache = data.labels || [];
                _this.searchIndex = _utils2.default.buildSearchIndex(_this.cache);
            });
        }
    }, {
        key: 'added',
        value: function added(_ref) {
            var entity = _ref.entity;

            this.onAdd(this.eventEmitter({
                label: entity
            }));
        }
    }, {
        key: 'removed',
        value: function removed(_ref2) {
            var entity = _ref2.entity;

            this.onRemove(this.eventEmitter({
                label: entity
            }));
        }
    }, {
        key: 'changed',
        value: function changed(_ref3) {
            var entities = _ref3.entities;

            this.onChange(this.eventEmitter({
                labels: entities
            }));
        }
    }, {
        key: 'search',
        value: function search(_ref4) {
            var query = _ref4.query;

            return _utils2.default.searchInIndex(this.searchIndex, query);
        }
    }]);

    return LabelsAutocompleteController;
}();

exports.default = LabelsAutocompleteController;

/***/ }),

/***/ "HJdB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UACRoleUsers = exports.Component = exports.Config = undefined;

var _roles = __webpack_require__("uK+v");

var _roles2 = _interopRequireDefault(_roles);

var _roles3 = __webpack_require__("R+eB");

var _roles4 = _interopRequireDefault(_roles3);

var _roleUsers = __webpack_require__("X995");

var _roleUsers2 = _interopRequireDefault(_roleUsers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtRolesView',
    options: _roles4.default
};

exports.Config = _roles2.default;
exports.Component = Component;
exports.UACRoleUsers = _roleUsers2.default;

/***/ }),

/***/ "HOVG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Service = undefined;

var _notifications = __webpack_require__("zzTv");

var _notifications2 = _interopRequireDefault(_notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NotificationsService settings
 * @type {{name: string, definition: NotificationsService}}
 */
var Service = {
    name: 'NotificationsService',
    definition: _notifications2.default
};

exports.Service = Service;

/***/ }),

/***/ "HUdY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    function link($scope, $element) {
        var el = $element[0];
        if ($scope.$ctrl.showAriaLabel) {
            var label = $scope.$ctrl.getAriaLabel();

            el.setAttribute('aria-label', label);
            el.removeAttribute('aria-hidden');
        } else {
            el.setAttribute('aria-hidden', 'true');
        }
    }

    return {
        restrict: 'A',
        link: link
    };
};

/***/ }),

/***/ "HVS3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _selector = __webpack_require__("5t+A");

var _selector2 = _interopRequireDefault(_selector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtFolderSelector',
    options: _selector2.default
};

/***/ }),

/***/ "HZ5s":
/***/ (function(module, exports) {

module.exports = "<a href=# class=\"space-m-v-s space-m-l-xs md-block\" ng-click=$ctrl.enableEditMode() ng-if=!$ctrl.editMode aria-label=\"Add Folder\"> <md-icon class=\"material-icons material-icons--s\">add</md-icon> Create folder here </a> <form ng-if=$ctrl.editMode class=entity-label__create name=addFolderForm md-theme=dark ng-submit=$ctrl.submit()> <md-content class=space-p-h-s> <md-input-container class=md-block> <label>Folder Name</label> <input type=text ng-model=$ctrl.name name=name required autocomplete=off> <div ng-messages=addFolderForm.name.$error> <div ng-message=required>Folder name is required.</div> </div> </md-input-container> <md-input-container class=md-block class=space-m-v-n> <label>Description</label> <input type=text name=description ng-model=$ctrl.description> <div class=md-caption-1>What goes in this folder?</div> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=space-m-h-n ng-click=$ctrl.disableEditMode() aria-label=Cancel>cancel</md-button> <md-button class=space-m-h-n type=submit ng-disabled=addFolderForm.$invalid aria-label=Add>Add</md-button> </div> </md-content> </form>";

/***/ }),

/***/ "Hbnl":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Dashboard'\"></dt-content-header> <div layout=row layout-align=\"start start\" lex> <div class=placeholder-block layout-margin> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <div class=placeholder-block__content> <img src=/assets/images/dashboards.png class=placeholder-block__image alt=\"This functionality don't supported\"> </div> </div> </div> ";

/***/ }),

/***/ "Hlvk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _folderDetails = __webpack_require__("FIke");

var _folderDetails2 = _interopRequireDefault(_folderDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("liSP");

exports.default = {
    bindings: {
        folder: '<',
        onSaved: '&',
        onEditCancelled: '&',
        onDeleted: '&'
    },
    controller: _folderDetails2.default,
    template: template
};

/***/ }),

/***/ "HqL4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/alert-chart-icon-16.png";

/***/ }),

/***/ "HrHh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * HelpService class.
 * User this service to handle help configuration and manage help data from API.
 */
var HelpService = function () {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    HelpService.$inject = ["RemoteConfigService"];
    function HelpService(RemoteConfigService) {
        _classCallCheck(this, HelpService);

        this.RemoteConfigService = RemoteConfigService;

        this.config = (0, _cloneDeep3.default)(this.RemoteConfigService.getServiceConfig('help'));

        this.itemsParsed = {};

        this.parseItems();
    }

    /**
     * Initialize item in map by given url
     * @param {string} url - String url value, will be used as key in map
     */


    _createClass(HelpService, [{
        key: 'initParsedItem',
        value: function initParsedItem(url) {
            if (!(url in this.itemsParsed)) {
                this.itemsParsed[url] = [];
            }
        }

        /**
         * Parse loaded configuration and prepare items map
         */

    }, {
        key: 'parseItems',
        value: function parseItems() {
            var _this = this;

            Object.keys(this.config).forEach(function (url) {
                _this.initParsedItem(url);

                var items = _this.itemsParsed[url];
                var config = _this.config[url];

                if (config.items && config.items.length) {
                    items.push.apply(items, _toConsumableArray(config.items));
                }

                if (config.inherit && config.inherit.length && config.inherit !== url) {
                    var inheritUrl = config.inherit;
                    var inheritConfig = _this.itemsParsed[inheritUrl] || null;

                    if (inheritConfig && inheritConfig.length) {
                        items.push.apply(items, _toConsumableArray(inheritConfig));
                    } else if (_this.config[inheritUrl] && _this.config[inheritUrl].length) {
                        items.push.apply(items, _toConsumableArray(_this.config[inheritUrl]));
                    }
                }

                _this.itemsParsed[url] = _utils2.default.sortItemsByKey(items, 'title');
            });
        }

        /**
         * Get help url by url from the items map
         * @param {string} url - Url value
         * @returns {{}|null} Return help config or null if not absent
         */

    }, {
        key: 'getHelpByUrl',
        value: function getHelpByUrl(url) {
            return this.itemsParsed[url] || null;
        }

        /**
         * Get all help configs
         * @returns {{}} Return help configs (NOTICE: Parsed and converted to map)
         */

    }, {
        key: 'getAllHelp',
        value: function getAllHelp() {
            return this.itemsParsed;
        }

        /**
         * Get list of all help configs items
         * @returns {Array} Return array of help items
         */

    }, {
        key: 'getHelpList',
        value: function getHelpList() {
            var _this2 = this;

            var items = [];

            Object.keys(this.config).forEach(function (url) {
                if (_this2.config[url].items && _this2.config[url].items.length) {
                    items.push.apply(items, _toConsumableArray(_this2.config[url].items));
                }
            });

            return items;
        }
    }]);

    return HelpService;
}();

exports.default = HelpService;

/***/ }),

/***/ "Hs3Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("KlZP"); // eslint-disable-line global-require
}

/**
 * ConfigApi class.
 */

var ConfigApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    ConfigApi.$inject = ["$http"];
    function ConfigApi($http) {
        _classCallCheck(this, ConfigApi);

        this.$http = $http;
        this.config = _local2.default.api.config;
    }

    /**
     * Get Application Config
     * @returns {promise}
     */


    _createClass(ConfigApi, [{
        key: 'getConfig',
        value: function getConfig() {
            return this.$http.get(this.config.url).then(function (response) {
                return response.data;
            });
        }
    }]);

    return ConfigApi;
}();

exports.default = ConfigApi;

/***/ }),

/***/ "Hv3s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateAppDialogController = function () {
    /** @ngInject */
    CreateAppDialogController.$inject = ["DialogService", "apps", "DeveloperApi", "ToastService", "Loader", "ErrorsService"];
    function CreateAppDialogController(DialogService, apps, DeveloperApi, ToastService, Loader, ErrorsService) {
        _classCallCheck(this, CreateAppDialogController);

        this.DialogService = DialogService;
        this.apps = apps;
        this.DeveloperApi = DeveloperApi;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    _createClass(CreateAppDialogController, [{
        key: 'onInit',
        value: function onInit() {
            this.genericErrors = this.ErrorsService.getGenericErrors();
            this.app = {
                name: null
            };
        }
    }, {
        key: 'createApp',
        value: function createApp() {
            var _this = this;

            if (!this.app.name.length) return;

            this.Loader.show();

            this.DeveloperApi.create(this.app).then(function (data) {
                _this.apps.push(data);

                _this.app.name = '';
                _this.Loader.hide();
                _this.ToastService.show(_this.ToastService.createSimple({
                    text: 'App created',
                    position: 'bottom right'
                }));
                _this.cancel();
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.DialogService.cancel();
        }
    }]);

    return CreateAppDialogController;
}();

exports.default = CreateAppDialogController;

/***/ }),

/***/ "I2Bg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Config = exports.FolderSelectorComponent = undefined;

var _folderSelector = __webpack_require__("HVS3");

var _folderSelector2 = _interopRequireDefault(_folderSelector);

var _tree = __webpack_require__("0ATH");

var _tree2 = _interopRequireDefault(_tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FolderSelectorComponent = _folderSelector2.default;
exports.Config = _tree2.default;

/***/ }),

/***/ "IBtN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * GeoService class.
 * Use this service to handle Geo configs.
 */
var GeoService = function () {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    GeoService.$inject = ["RemoteConfigService"];
    function GeoService(RemoteConfigService) {
        _classCallCheck(this, GeoService);

        this.RemoteConfigService = RemoteConfigService;
        this.data = (0, _cloneDeep3.default)(this.RemoteConfigService.getServiceConfig('geo'));
        this.earthRadius = 6371e3; // metres
    }

    /**
     * Get list of coordinates
     * @returns {Object} Return all coordinates configs
     */


    _createClass(GeoService, [{
        key: 'getCoordsList',
        value: function getCoordsList() {
            return this.data;
        }

        /**
         * Get coordinates by defined key
         * @param {string} key - Coordinates key
         * @returns {{}|null} Return coordinates config or null if absent
         */

    }, {
        key: 'getCoordsByKey',
        value: function getCoordsByKey(key) {
            return this.data[key] || null;
        }
    }, {
        key: 'getDistanceBetweenCoords',
        value: function getDistanceBetweenCoords(p1Lat, p1Lng, p2Lat, p2Lng) {
            var R = this.earthRadius;

            function toRadians(deg) {
                var multiplier = Math.PI / 180;
                return deg * multiplier;
            }

            function halfOf(value) {
                return value / 2;
            }

            var phi1 = toRadians(p1Lat);
            var phi2 = toRadians(p2Lat);
            var deltaPhi = toRadians(p2Lat - p1Lat);
            var deltaLambda = toRadians(p2Lng - p1Lng);

            var a1 = Math.sin(halfOf(deltaPhi)) * Math.sin(halfOf(deltaPhi));
            var a2 = Math.cos(phi1) * Math.cos(phi2) * Math.sin(halfOf(deltaLambda)) * Math.sin(halfOf(deltaLambda));

            var a = a1 + a2;

            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            return R * c;
        }
    }]);

    return GeoService;
}();

exports.default = GeoService;

/***/ }),

/***/ "IDjL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RolesController = function () {
    /** @ngInject */
    RolesController.$inject = ["RolesApi", "UsersApi", "DialogService", "ToastService", "$timeout", "Loader", "$q"];
    function RolesController(RolesApi, UsersApi, DialogService, ToastService, $timeout, Loader, $q) {
        _classCallCheck(this, RolesController);

        this.RolesApi = RolesApi;
        this.UsersApi = UsersApi;
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.$timeout = $timeout;
        this.Loader = Loader;
        this.$q = $q;
    }

    _createClass(RolesController, [{
        key: '$onInit',
        value: function $onInit() {
            this.roles = [];
            this.rolesFiltered = [];
            this.currentRole = null;
            this.currentRoleHistory = null;
            this.queryForSearchRoles = '';

            this.updateToast = this.createSimpleToast({
                text: 'Role was updated',
                position: 'bottom right',
                hideDelay: 3000
            });

            this.getRoles();
        }
    }, {
        key: 'createSimpleToast',
        value: function createSimpleToast(config) {
            return this.ToastService.createSimple(config);
        }
    }, {
        key: 'getRoles',
        value: function getRoles() {
            var _this = this;

            return this.loadRoles().then(function () {
                _this.filterRoles(_this.queryForSearchRoles);
            });
        }
    }, {
        key: 'loadRoles',
        value: function loadRoles() {
            var _this2 = this;

            return this.RolesApi.getList().then(function (data) {
                _this2.roles = data.roles || [];
                return _this2.roles;
            }, function () {
                _this2.roles = [];

                return _this2.roles;
            });
        }
    }, {
        key: 'getRole',
        value: function getRole(id) {
            var _this3 = this;

            return this.RolesApi.getRole(id).then(function (role) {
                _this3.currentRole = role;
                _this3.currentRoleHistory = (0, _cloneDeep3.default)(_this3.currentRole);
            });
        }
    }, {
        key: 'onDeleteCurrentRole',
        value: function onDeleteCurrentRole() {
            var _this4 = this;

            this.DialogService.confirm({
                title: 'Delete Role?',
                textContent: 'Would you like to delete role "' + this.currentRole.name + '"?',
                ariaLabel: 'delete-role',
                ok: 'Delete',
                cancel: 'Cancel'
            }).then(function () {
                _this4.RolesApi.deleteRole(_this4.currentRole.id).then(function () {
                    // TODO: refactor when elastic will work correctly with cache
                    _this4.$timeout(function () {
                        _this4.loadRoles().then(function () {
                            _this4.filterRoles(_this4.queryForSearchRoles);
                            _this4.currentRole = null;

                            if (_this4.Loader.isShowLoader()) {
                                _this4.Loader.hide();
                            }
                        });
                    }, 1000);
                });
            });
        }
    }, {
        key: 'onUpdateCurrentRole',
        value: function onUpdateCurrentRole() {
            var _this5 = this;

            this.Loader.show();

            this.RolesApi.updateRole(this.currentRole.id, this.currentRole).then(function () {
                _this5.ToastService.show(_this5.updateToast);

                // TODO: refactor when elastic will work correctly with cache
                _this5.$timeout(function () {
                    _this5.getRole(_this5.currentRole.id).then(function () {
                        _this5.Loader.hide();
                    });
                }, 1000);
            });
        }
    }, {
        key: 'onResetCurrentRole',
        value: function onResetCurrentRole() {
            this.currentRole = (0, _cloneDeep3.default)(this.currentRoleHistory);
        }
    }, {
        key: 'addRole',
        value: function addRole(item) {
            this.roles.unshift(item);
            this.filterRoles(this.queryForSearchRoles);
        }
    }, {
        key: 'filterRoles',
        value: function filterRoles() {
            var queryLowered = this.queryForSearchRoles.toLowerCase();

            this.rolesFiltered = queryLowered ? this.roles.filter(function (role) {
                if (role.name.toLowerCase().indexOf(queryLowered) >= 0) {
                    return true;
                }

                return false;
            }) : this.roles;
        }
    }, {
        key: 'onRolesSelected',
        value: function onRolesSelected(_ref) {
            var entity = _ref.entity;

            this.currentRole = entity;
            this.currentRoleHistory = (0, _cloneDeep3.default)(this.currentRole);
        }
    }, {
        key: 'onRoleCreate',
        value: function onRoleCreate(_ref2) {
            var _this6 = this;

            var name = _ref2.name;

            var newRole = {
                name: name
            };

            this.RolesApi.createRole(newRole).then(function (role) {
                if ((typeof role === 'undefined' ? 'undefined' : _typeof(role)) === 'object') {
                    _this6.addRole(role);
                }
            }, function (error) {
                _this6.DialogService.show({
                    clickOutsideToClose: true,
                    title: 'Error',
                    textContent: error.Error,
                    ariaLabel: 'Error message',
                    ok: 'Close'
                });
            });
        }
    }, {
        key: 'onRemoveUser',
        value: function onRemoveUser(_ref3) {
            var _this7 = this;

            var user = _ref3.user;

            if (user && user.id) {
                this.Loader.show();

                this.RolesApi.deleteUsersFromRole(this.currentRole.id, [user.id.toString()]).then(function () {
                    // TODO: refactor when elastic will work correctly with cache
                    _this7.$timeout(function () {
                        var rolesPromise = _this7.getRoles();
                        var rolePromise = _this7.getRole(_this7.currentRole.id);

                        _this7.$q.all({
                            rolesPromise: rolesPromise,
                            rolePromise: rolePromise
                        }).then(function () {
                            _this7.Loader.hide();
                        });
                    }, 1000);
                });
            }
        }
    }, {
        key: 'onAddUser',
        value: function onAddUser(_ref4) {
            var _this8 = this;

            var user = _ref4.user;

            if (user && user.id) {
                this.Loader.show();

                this.RolesApi.addUsersToRole(this.currentRole.id, [user.id.toString()]).then(function () {
                    // TODO: refactor when elastic will work correctly with cache
                    _this8.$timeout(function () {
                        var rolesPromise = _this8.getRoles();
                        var rolePromise = _this8.getRole(_this8.currentRole.id);

                        _this8.$q.all({
                            rolesPromise: rolesPromise,
                            rolePromise: rolePromise
                        }).then(function () {
                            _this8.Loader.hide();
                        });
                    }, 1000);
                });
            }
        }
    }]);

    return RolesController;
}();

exports.default = RolesController;

/***/ }),

/***/ "IIPq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _content = __webpack_require__("Ulak");

var _content2 = _interopRequireDefault(_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtLayoutContent',
    options: _content2.default
};

/***/ }),

/***/ "IQvl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__("VzBS");

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("mEGA");

exports.default = {
    bindings: {
        nav: '<',
        onToggle: '&'
    },
    controller: _left2.default,
    template: template
};

/***/ }),

/***/ "IU3/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alertsActions = __webpack_require__("AMnj");

var _alertsActions2 = _interopRequireDefault(_alertsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("vuy0");

exports.default = {
    controller: _alertsActions2.default,
    template: template
};

/***/ }),

/***/ "IcLX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autocomplete = __webpack_require__("80IO");

var _autocomplete2 = _interopRequireDefault(_autocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSearchAutocomplete',
    options: _autocomplete2.default
};

/***/ }),

/***/ "Ihtr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/window-open.svg";

/***/ }),

/***/ "Ihv8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'labels';

var ThingLabelsController = function () {
    /** @ngInject */
    ThingLabelsController.$inject = ["EventEmitter"];
    function ThingLabelsController(EventEmitter) {
        _classCallCheck(this, ThingLabelsController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingLabelsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.labels = [];
        }
    }, {
        key: 'changed',
        value: function changed() {
            if (this.labels.length) {
                this.addItemToBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME,
                        value: this.labels
                    }
                }));
            } else {
                this.removeItemFromBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                }));
            }
        }
    }]);

    return ThingLabelsController;
}();

exports.default = ThingLabelsController;

/***/ }),

/***/ "IiHL":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "Impk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FoldersAndLabelsController = function () {
    /** @ngInject */
    FoldersAndLabelsController.$inject = ["$state", "$timeout"];
    function FoldersAndLabelsController($state, $timeout) {
        _classCallCheck(this, FoldersAndLabelsController);

        this.$state = $state;
        this.$timeout = $timeout;
    }

    _createClass(FoldersAndLabelsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.tabs = [{
                title: 'Folders',
                state: 'main.folders-and-labels.folders'
            }, {
                title: 'Labels',
                state: 'main.folders-and-labels.labels'
            }];
            this.tabs.forEach(function (tab) {
                tab.isActive = _this.$state.includes(tab.state);
            });
            this.$timeout(function () {
                _this.onTabClickProxy = _this.onTabClick;
            });
        }

        // TODO: Refactor this
        // This no-op callback is needed to prevent state manipulation on first load

    }, {
        key: 'onTabClickProxy',
        value: function onTabClickProxy() {} // eslint-disable-line class-methods-use-this

    }, {
        key: 'onTabClick',
        value: function onTabClick(_ref) {
            var tab = _ref.tab;

            this.$state.go(tab.state);
        }
    }]);

    return FoldersAndLabelsController;
}();

exports.default = FoldersAndLabelsController;

/***/ }),

/***/ "InIr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdvancedController = function () {
    function AdvancedController() {
        _classCallCheck(this, AdvancedController);
    }

    _createClass(AdvancedController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.advancedInformation) {
                this.advancedInformation = {};
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.advancedInformation) {
                this.advancedInformation = (0, _cloneDeep3.default)(changes.advancedInformation.currentValue);
            }
        }
    }]);

    return AdvancedController;
}();

exports.default = AdvancedController;

/***/ }),

/***/ "Iu/K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _header = __webpack_require__("gfoy");

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtLayoutHeader',
    options: _header2.default
};

/***/ }),

/***/ "Iy3b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/icon_signal3.svg";

/***/ }),

/***/ "J4ii":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Users & Access'\"></dt-content-header> <dt-tabs class=dt-tabs layout=column tabs=$ctrl.tabs on-tab-click=$ctrl.onTabClick($event)> </dt-tabs> <div ui-view=contentBody></div> ";

/***/ }),

/***/ "J6d+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    chart: {
        type: 'area'
    },
    yAxis: {
        plotBands: [{
            from: 0,
            to: 1,
            label: {
                text: 'Open',
                align: 'right',
                x: -10
            },
            zIndex: 5
        }, {
            from: -1,
            to: 0,
            label: {
                text: 'Closed',
                align: 'right',
                x: -10
            },
            zIndex: 5
        }],
        tickInterval: 1,
        min: -1,
        max: 1,
        labels: {
            enabled: false
        },
        title: {
            enabled: false
        }
    },
    plotOptions: {
        area: {
            dataGrouping: {
                enabled: false
            }
        }
    },
    tooltip: {
        formatter: function formatter() {
            return (0, _moment2.default)(this.x).format('dddd, MMM D, HH:mm') + '<br>\u25CF <b>' + (this.y > 0 ? 'Open' : 'Closed') + '</b>';
        }
    }
};

/***/ }),

/***/ "JfqN":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Notifications'\"></dt-content-header> <div layout=row layout-align=\"start start\" lex> <div class=placeholder-block layout-margin> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <div class=placeholder-block__content flex=60> <img src=/assets/images/all-notifications.png class=placeholder-block__image alt=\"This functionality don't supported\"> </div> </div> </div> ";

/***/ }),

/***/ "Jq7Z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=popover__wrap> <div class=popover__content> <span class=popover__content-image> <img src=" + __webpack_require__("dgJw") + " width=96 height=96 alt=\"\"> </span> <div class=popover__content-info> <div class=space-m-v-xs> <b>{{ $ctrl.userProfile.name }}</b> </div> <div class=space-m-v-xs> <span class=text-primary>{{ $ctrl.userProfile.email }}</span> </div> <md-button ng-click=$ctrl.goToAccouunt() class=\"md-primary md-raised space-m-h-n\">My Account</md-button> </div> </div> <div class=popover__footer> <div class=popover__footer-control> <span class=flex></span> <md-button class=md-primary ng-click=$ctrl.signOut()>Sign out</md-button> </div> </div> </div> ";

/***/ }),

/***/ "Jtzf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


sensorsAndConnectorsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sensorsAndConnectorsRouter;

var _sensorsAndConnectors = __webpack_require__("sKsN");

/** @ngInject */
function sensorsAndConnectorsRouter($stateProvider) {
    $stateProvider.state('main.sensors', {
        abstract: true,
        views: {
            content: {
                component: _sensorsAndConnectors.Component.selector
            }
        }
    }).state('main.sensors.list', {
        url: '/sensors-and-connectors?q&tabId',
        reloadOnSearch: false,
        component: 'dtSensorListContainer'
    }).state('main.sensors.list.search', {
        url: '/search',
        views: {
            rightPanel: {
                component: 'dtThingsSearchAdvanced'
            }
        }
    }).state('main.sensors.list.thing', {
        url: '/{thingId}',
        resolve: {
            /** @ngInject */
            thing: ["ThingsApi", "$stateParams", function thing(ThingsApi, $stateParams) {
                return ThingsApi.entity($stateParams.thingId).catch(function () {
                    return null;
                });
            }]
        },
        /** @ngInject */
        onEnter: ["thing", "$state", function onEnter(thing, $state) {
            // eslint-disable-line consistent-return
            if (!thing) {
                return $state.target('main.sensors.list');
            }
        }],

        views: {
            rightPanel: {
                component: 'dtThingDetails'
            }
        }
    }).state('main.sensors.list.thing.graph', {
        url: '/graph',
        views: {
            'centralPanel@^.^': { // ^ means go level up in state hierarchy
                component: 'dtThingChart'
            }
        }
    });
}

/***/ }),

/***/ "JwvL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Config = {"nanoMultiplier":1000000,"format":{"datetime":"YYYY-MM-DD HH:mm:ss","date":"YYYY-MM-DD","time":"HH:mm:ss"},"api":{"host":"https://api.disruptive-technologies.com","version":"/v1","config":{"url":"/data/config.json"},"menu":{"appMenuUrl":"/data/app.menu.json"},"developer":{"applicationList":"/data/app.developer.json"},"things":{"list":"/things","entity":"/things/%thingId%","watch":"/things/%thingId%/watch","subscribe":"/subscribe","history":"/things/%thingId%/query","historyAggregated":"/things/%thingId%/aggregate","star":"/things/%thingId%/star","unstar":"/things/%thingId%/unstar"},"authUsers":{"listUrl":"/data/auth-users.json","searchUrl":"/data/auth-users.json"},"notes":{"list":"/notes","entity":"/notes/%noteId%"},"labels":{"list":"/labels","entity":"/labels/%labelId%"},"notifications":{"list":"/notifications"},"history":{"listUrl":"/data/history.json"},"events":{"listUrl":"/data/events.json"},"folders":{"list":"/folders","entity":"/folders/%folderId%","move":"/folders/%folderId%/move"},"views":{"list":"/navigation/views","entity":"/navigation/views/%viewId%"},"navigation":{"sensorsAndConnectorsUrl":"/data/navigation-sensors-and-connectors.json"},"categories":{"list":"/navigation/categories","entity":"/navigation/categories/%categoryId%"},"customers":{"listUrl":"/data/customers.json","searchUrl":"/data/customers.json","getUrl":"/data/customer.json","activateUrl":"/data/customer.json","deactivateUrl":"/data/customer.json","requestAccessUrl":"/data/customer.json","resetPasswordUrl":"/data/customer.json"},"privileges":{"listUrl":"/data/privileges.json"},"roles":{"listUrl":"/data/roles.json","createUrl":"/data/role.json","getUrl":"/data/role.json","deleteUrl":"/data/role.json","updateUrl":"/data/role.json","deleteUsersUrl":"/data/roles-users.json","addUsersUrl":"/data/roles-users.json"},"users":{"listUrl":"/data/users.json","searchUrl":"/data/users.json","createUrl":"/data/user.json","getUrl":"/data/user.json","deleteUrl":"/data/user.json","updateUrl":"/data/user.json","resetPasswordUrl":"/data/user.json","uploadProfileImageUrl":"/data/user.json"},"alertsActions":{"listUrl":"data/alerts-actions.json"},"feedback":{"url":"/zendesk-tickets"}},"services":{"google":{"maps":{"key":"AIzaSyDKFd36662Ahl-7fkpGTVnrMYTE-mAS9PA"}}},"auth":{"openid":{"authority":"https://identity.disruptive-technologies.com/openid/","client_id":"888774","redirect_uri":"https://studio.v1.disruptive-technologies.com/auth/process","silent_redirect_uri":"https://studio.v1.disruptive-technologies.com/silent.html","response_type":"id_token token","loadUserInfo":true,"automaticSilentRenew":null,"scope":"openid profile email"}}}; // eslint-disable-line no-undef

/**
 * Application Global Configuration.
 * That object is dynamically created and injected by Webpack.
 */
exports.default = Config;

/***/ }),

/***/ "Jyq7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoleUsersController = function () {
    /** @ngInject */
    RoleUsersController.$inject = ["EventEmitter", "UsersApi"];
    function RoleUsersController(EventEmitter, UsersApi) {
        _classCallCheck(this, RoleUsersController);

        this.eventEmitter = EventEmitter;
        this.UsersApi = UsersApi;
    }

    _createClass(RoleUsersController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!Array.isArray(this.users)) {
                this.users = [];
            }

            this.searchText = '';
            this.pendingSearch = null;
            this.lastSearch = 0;
            this.defaulImageUrl = '/assets/images/avatar.png';
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.users) {
                if (!changes.users.isFirstChange() && !Array.isArray(changes.users.currentValue)) {
                    this.users = [];
                }

                this.searchText = '';
            }
        }
    }, {
        key: 'selectedUserChange',
        value: function selectedUserChange(user) {
            this.selectedUser = user;
        }
    }, {
        key: 'searchUsers',
        value: function searchUsers(criteria) {
            var _this = this;

            this.pendingSearch = this.UsersApi.search(criteria).then(function (response) {
                var data = [];
                if (response && response.users && response.users.length) {
                    data = response.users;
                }

                data = data.map(function (user) {
                    if (!('first_name' in user) || !('last_name' in user)) {
                        user.fullName = 'NoNaMe';
                    } else {
                        user.fullName = user.first_name + ' ' + user.last_name;
                    }
                    if (!user.image) {
                        user.image = _this.defaulImageUrl;
                    }

                    return user;
                });

                data = data.filter(function (user) {
                    var result = true;
                    var length = _this.users.length;

                    if (!length) return result;

                    for (var i = 0; i < length; i++) {
                        if (_this.users[i].id === user.id) {
                            result = false;
                            break;
                        }
                    }

                    return result;
                });

                return data;
            });

            return this.pendingSearch;
        }
    }, {
        key: 'onAdd',
        value: function onAdd(user) {
            this.onAddUser(this.eventEmitter({
                user: (0, _cloneDeep3.default)(user)
            }));

            this.searchText = '';
        }
    }, {
        key: 'onRemove',
        value: function onRemove(user) {
            this.onRemoveUser(this.eventEmitter({
                user: (0, _cloneDeep3.default)(user)
            }));
        }
    }]);

    return RoleUsersController;
}();

exports.default = RoleUsersController;

/***/ }),

/***/ "K+aS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * ThingListMetaFields settings
 * @type {{name: string, value: Array<string>}}
 */
exports.default = {
  name: 'ThingListMetaFields',
  value: ['query', 'limit', 'offset', 'order']
};

/***/ }),

/***/ "KMsy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Directive = undefined;

var _saveView = __webpack_require__("PNGm");

var _saveView2 = _interopRequireDefault(_saveView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Directive = {
    selector: 'dtSaveView',
    options: _saveView2.default
};

exports.Directive = Directive;

/***/ }),

/***/ "KfLe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


apiAccessRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = apiAccessRouter;

var _developerSettings = __webpack_require__("xcRF");

/** @ngInject */
function apiAccessRouter($stateProvider) {
    var apiAccessState = {
        url: '/developer-settings',
        views: {
            contentBody: {
                component: _developerSettings.apiAccess.Component.selector
            }
        }
    };

    $stateProvider.state('main.developer-settings.api-access', apiAccessState);
}

/***/ }),

/***/ "KgCR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddFolderController = function () {
    /** @ngInject */
    AddFolderController.$inject = ["EventEmitter"];
    function AddFolderController(EventEmitter) {
        _classCallCheck(this, AddFolderController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(AddFolderController, [{
        key: '$onInit',
        value: function $onInit() {
            this.editMode = false;
            this.reset();
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.name = '';
            this.description = '';
        }
    }, {
        key: 'enableEditMode',
        value: function enableEditMode() {
            this.editMode = true;
        }
    }, {
        key: 'disableEditMode',
        value: function disableEditMode() {
            this.reset();
            this.editMode = false;
        }
    }, {
        key: 'submit',
        value: function submit() {
            if (this.name) {
                var folder = {
                    parent_id: this.parentId,
                    name: this.name,
                    description: this.description
                };
                this.onSubmit(this.eventEmitter({
                    folder: folder
                }));
                this.disableEditMode();
            }
        }
    }]);

    return AddFolderController;
}();

exports.default = AddFolderController;

/***/ }),

/***/ "Kkkf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _createApp = __webpack_require__("Hv3s");

var _createApp2 = _interopRequireDefault(_createApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var createAppTemplate = __webpack_require__("E+Tu");

var ApiAccessController = function () {
    /** @ngInject */
    ApiAccessController.$inject = ["Loader", "DialogService", "DeveloperApi", "ToastService", "$timeout"];
    function ApiAccessController(Loader, DialogService, DeveloperApi, ToastService, $timeout) {
        _classCallCheck(this, ApiAccessController);

        this.Loader = Loader;
        this.ToastService = ToastService;
        this.DialogService = DialogService;
        this.DeveloperApi = DeveloperApi;
        this.$timeout = $timeout;
    }

    _createClass(ApiAccessController, [{
        key: '$onInit',
        value: function $onInit() {
            this.developer = {
                access: false,
                key: 'zx89jiaojd9--as988d8as7d8hjak',
                apps: []
            };

            this.acceptTerms = false;
            this.processing = false;
            this.currentApp = null;
            this.showAppSecret = false;
            this.inputFileId = 'applicationIconFile';
        }
    }, {
        key: 'enableApiAccess',
        value: function enableApiAccess() {
            var _this = this;

            this.Loader.show();
            this.processing = true;

            this.Loader.show();

            this.$timeout(function () {
                _this.DeveloperApi.getListOfApps().then(function (data) {
                    _this.developer.apps = data.applications || [];
                    _this.Loader.hide();
                    _this.processing = false;
                    _this.developer.access = true;
                });
            }, 1000);
        }
    }, {
        key: 'select',
        value: function select(item) {
            this.currentApp = (0, _cloneDeep3.default)(item);
            this.currentAppId = item.id;
            this.showAppSecret = false;
        }
    }, {
        key: 'create',
        value: function create(ev) {
            // TODO: should be implement after update real API
            this.DialogService.show({
                controller: _createApp2.default,
                controllerAs: '$ctrl',
                template: createAppTemplate,
                parent: document.body,
                targetEvent: ev,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    apps: this.developer.apps
                }
            });
        }
    }, {
        key: 'toggleAppSecret',
        value: function toggleAppSecret() {
            this.showAppSecret = !this.showAppSecret;
        }
    }, {
        key: 'showUpload',
        value: function showUpload() {
            // TODO: should be implement after update real API
            document.querySelector('#' + this.inputFileId).click();
        }
    }, {
        key: 'regenerateKey',
        value: function regenerateKey() {
            var _this2 = this;

            this.DialogService.confirm({
                title: 'Regenerate Key?',
                textContent: 'Do you really want to change key?',
                ariaLabel: 'regenerate-key',
                ok: 'Ok',
                cancel: 'Cancel'
            }).then(function () {
                // TODO: refactor to API usage, mock for now
                _this2.developer.key = 'as988d8as7d8hjak--zx89jiaojd9';
            });
        }
    }, {
        key: 'regenerateSecretKey',
        value: function regenerateSecretKey() {
            var _this3 = this;

            this.DialogService.confirm({
                title: 'Regenerate Secret Key?',
                textContent: 'Do you really want to change secret key?',
                ariaLabel: 'regenerate-secret-key',
                ok: 'Ok',
                cancel: 'Cancel'
            }).then(function () {
                // TODO: refactor to API usage, mock for now
                _this3.currentApp.secret = Math.floor(Math.random() * 1000000000000000000);
            });
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this4 = this;

            this.DialogService.confirm({
                title: 'Delete Application?',
                textContent: 'Do you really want to delete application "' + this.currentApp.name + '"?',
                ariaLabel: 'delete-app',
                ok: 'Delete',
                cancel: 'Cancel'
            }).then(function () {
                _this4.developer.apps = _this4.developer.apps.filter(function (item) {
                    return item.id !== _this4.currentAppId;
                });
                _this4.cancel();
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.currentApp = null;
            this.currentAppId = null;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this5 = this;

            // TODO: should be implementing with real api
            this.Loader.show();

            this.DeveloperApi.update(this.currentApp).then(function (data) {
                _this5.developer.apps.forEach(function (item) {
                    if (item.id === data.id) {
                        item.name = data.name;
                        item.description = data.description;
                    }
                });

                _this5.Loader.hide();
                _this5.ToastService.show(_this5.ToastService.createSimple({
                    text: 'App updated',
                    position: 'bottom right'
                }));
            });
        }
    }]);

    return ApiAccessController;
}();

exports.default = ApiAccessController;

/***/ }),

/***/ "KlZP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/config.json";

/***/ }),

/***/ "L0bV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contentHeader = __webpack_require__("/jyb");

var _contentHeader2 = _interopRequireDefault(_contentHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtContentHeader',
    options: _contentHeader2.default
};

/***/ }),

/***/ "LD/t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dashboard = __webpack_require__("ciI2");

var _dashboard2 = _interopRequireDefault(_dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Hbnl");

exports.default = {
    controller: _dashboard2.default,
    template: template
};

/***/ }),

/***/ "LMEn":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Account Settings'\"></dt-content-header> <div layout=row layout-align=\"start start\" layout-margin flex class=placeholder-block> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <div class=\"box flex-30\" layout-padding> <form class=form-grid action=#> <div class=\"container-fluid space-b-s\"> <h3 class=box-title>Basic info</h3> <div class=\"row start-xs space-m-b-n\"> <div class=col-xs-6> <md-input-container class=space-m-v-n> <label for=firstName>First Name</label> <input type=text name=firstName id=firstName> </md-input-container> <md-input-container class=space-m-v-n> <label for=middleName>Middle Name</label> <input type=text name=middleName id=middleName> </md-input-container> <md-input-container class=space-m-v-n> <label for=lastName>Last Name</label> <input type=text name=lastName id=lastName> </md-input-container> </div> <div class=col-xs-6> <div class=avatar layout=column layout-align=\"start center\"> <div class=avatar__image> <img ng-src=assets/images/avatar_256x256.png width=112 height=112 alt=Avatar> </div> <md-button class=\"md-button md-primary md-button--xs\">Change profile image</md-button> </div> </div> </div> <md-input-container class=\"md-block space-m-v-n\"> <label for=email>E-mail</label> <input type=text name=email id=email> </md-input-container> <md-input-container class=\"md-block space-m-v-n\"> <label for=title>Title</label> <input type=text name=title id=title> </md-input-container> </div> <div class=\"container-fluid space-b-s\"> <h3 class=box-title>Preferences</h3> <div class=\"row middle-xs space-m-b-xl\"> <div class=col-xs-4> <div class=\"md-caption text-info\">Time</div> </div> <div class=col-xs-8> <md-radio-group layout=row ng-model=radio layout=row layout-align=\"start center\"> <md-radio-button value=12 class=\"md-primary flex\"> <span class=md-body-1>12 hour</span> </md-radio-button> <md-radio-button value=24 class=\"md-primary flex\"> <span class=md-body-1>24 hour</span> </md-radio-button> </md-radio-group> </div> </div> <div class=\"row middle-xs space-m-b-xl\"> <div class=col-xs-4> <div class=\"md-caption text-info\">Temperature</div> </div> <div class=col-xs-8> <md-radio-group layout=row ng-model=radio layout=row layout-align=\"start center\"> <md-radio-button value=12 class=\"md-primary flex\"> <span class=md-body-1>Fahrenheit</span> </md-radio-button> <md-radio-button value=24 class=\"md-primary flex\"> <span class=md-body-1>Celcius</span> </md-radio-button> </md-radio-group> </div> </div> <div class=\"row middle-xs space-m-b-xl\"> <div class=col-xs-4> <div class=\"md-caption text-info\">Distance</div> </div> <div class=col-xs-8> <md-radio-group layout=row ng-model=radio layout=row layout-align=\"start center\"> <md-radio-button value=12 class=\"md-primary flex\"> <span class=md-body-1>Miles</span> </md-radio-button> <md-radio-button value=24 class=\"md-primary flex\"> <span class=md-body-1>Kilometers</span> </md-radio-button> </md-radio-group> </div> </div> <div class=\"row middle-xs space-m-b-xl\"> <div class=col-xs-4> <md-button class=\"md-button md-primary md-raised\">Log out</md-button> </div> </div> </div> <div class=container-fluid> <section layout=column> <md-divider class=space-m-v-m></md-divider> <div layout=row layout-align=end> <md-button class=\"md-button md-primary\">Cancel</md-button> <md-button class=\"md-button md-primary\">Save Changes</md-button> </div> </section> </div> </form> </div> <div class=\"box flex-20\" layout-padding> <section> <div class=container-fluid> <div layout=row layout-align=\"start center\"> <h3 class=box-title>Roles assigned</h3> <dt-help-icon class=space-m-h-xs message-key=help_icon_user_settings_roles_assigned></dt-help-icon> </div> <ul class=\"custom-list custom-list--simple space-m-t-n\"> <li class=space-m-b-m layout=row layout-align=\"start center\"> <i class=\"fa fa-users space-m-r-s\" aria-hidden=true></i> <div class=md-body-1>Admin</div> </li> <li class=space-m-b-m layout=row layout-align=\"start center\"> <i class=\"fa fa-users space-m-r-s\" aria-hidden=true></i> <div class=md-body-1>Janiator</div> </li> </ul> </div> </section> </div> </div> ";

/***/ }),

/***/ "Lghj":
/***/ (function(module, exports) {

module.exports = "<div class=container ng-class=\"{ 'is-editing': $ctrl.isSearchFocused }\"> <div flex> <dt-simple-search class=dt-things-toolbox__search-box query=$ctrl.predefinedQuery on-focus-change=$ctrl.onSearchFocusChange($event) on-search-result=$ctrl.passSearchResult($event) on-before-search=$ctrl.closeFilterParams() on-empty-search=$ctrl.clearSearch()> </dt-simple-search> </div> <md-button class=\"md-icon-button md-primary\" ng-hide=$ctrl.showFilterParams ng-click=$ctrl.toggleFilterParams()> <i class=material-icons>filter_list</i> </md-button> <md-button ng-show=$ctrl.showFilterParams ng-click=$ctrl.toggleFilterParams() class=\"md-icon-button md-primary\"> <i class=material-icons>clear</i> </md-button> <md-button class=md-default ng-click=$ctrl.showGraphs()> View Graphs </md-button> <md-button ng-disabled=true class=md-default ng-click=$ctrl.openBulkEditPopup($event)> Bulk Edit </md-button> <md-menu md-offset=\"17 50\"> <md-button ng-disabled=true class=md-default ng-click=$mdOpenMenu($event)> Export List <md-icon class=material-icons>arrow_drop_down</md-icon> </md-button> <md-menu-content width=2> <md-menu-item> <md-button> <span md-menu-align-target>JSON</span> </md-button> </md-menu-item> <md-menu-item> <md-button> <span md-menu-align-target>CSV</span> </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> <div class=\"box box--exceed\"> <md-list class=filter-list ng-if=$ctrl.showFilterParams> <md-list-item ng-click=$ctrl.searchStarred()> <md-icon class=\"space-m-h-xs space-m-t-s\" md-svg-icon=star-o></md-icon> <div class=\"md-body-1 space-m-l-s\" flex>Starred</div> </md-list-item> <md-list-item ng-click=$ctrl.searchByType(thing.type) ng-repeat=\"thing in ::$ctrl.things track by $index\" layout=row layout-align=\"start center\"> <dt-icon icon-class=::thing.icon icon-size=::$ctrl.iconSize show-aria-label=true></dt-icon> <div class=md-body-1 flex>{{ ::thing.titlePlural }}</div> </md-list-item> <div layout=row layout-align=\"center center\"> <md-button class=\"md-primary md-raised\" ng-click=$ctrl.onClickAdvancedSearch()>Show more search options</md-button> </div> </md-list> </div> ";

/***/ }),

/***/ "Ls7g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alertsActionsContent = __webpack_require__("D0uB");

var _alertsActionsContent2 = _interopRequireDefault(_alertsActionsContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("TUme");

exports.default = {
    bindings: {
        rule: '<',
        onRemove: '&',
        onCancel: '&'
    },
    controller: _alertsActionsContent2.default,
    template: template
};

/***/ }),

/***/ "LzqP":
/***/ (function(module, exports) {

module.exports = "<div class=block-title>Most recent events</div> <ul class=\"custom-list custom-list--style-1\"> <li layout=row layout-align=\"start start\"> <div class=date-field layout=column layout-align=\"start start\"> <span> Jul 9, 2016 </span> <span> 15:09 <i class=\"fa fa-3 fa-exclamation-circle fa--alert\" aria-hidden=true></i> </span> </div> <div layout=row layout-align=\"space-between start\" flex> <div> <div class=content-title>Button pressed</div> <div class=md-caption>Someone's at the door</div> </div> </div> </li> <li layout=row layout-align=\"start start\"> <div class=date-field layout=column layout-align=\"start start\"> <span> Jul 8, 2016 </span> <span> 11:04 </span> </div> <div layout=row layout-align=\"space-between start\" flex> <div> <div class=content-title>Sensor access changed</div> <div class=md-caption>1 user can now Edit</div> </div> </div> </li> <li layout=row layout-align=\"start start\"> <div class=date-field layout=column layout-align=\"start start\"> <span> Jul 8, 2016 </span> <span> 10:59 </span> </div> <div layout=row layout-align=\"space-between start\" flex> <div> <div class=content-title>Rule added</div> <div class=md-caption>\"Alert when pressed\" added to rules</div> </div> </div> </li> </ul> <div layout=row layout-align=end> <a href=\"\" class=\"md-primary md-caption\">See all events</a> </div> ";

/***/ }),

/***/ "M/Jo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


companySettingsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = companySettingsRouter;

var _companySettings = __webpack_require__("V1ly");

/** @ngInject */
function companySettingsRouter($stateProvider) {
    var baseState = {
        url: '/company-settings',
        views: {
            content: {
                component: _companySettings.Component.selector
            }
        }
    };

    $stateProvider.state('main.company-settings', baseState);
}

/***/ }),

/***/ "M7rA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chars = __webpack_require__("iOF9");

var _chars2 = _interopRequireDefault(_chars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * GeoService settings
 * @type {{name: string, definition: GeoService}}
 */

exports.default = {
  name: 'CharsService',
  definition: _chars2.default
};

/***/ }),

/***/ "ME/g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alertsActionsNav = __webpack_require__("0H2f");

var _alertsActionsNav2 = _interopRequireDefault(_alertsActionsNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("zQTU");

exports.default = {
    bindings: {
        alertsActions: '<',
        onPushCurrent: '&'
    },
    controller: _alertsActionsNav2.default,
    template: template
};

/***/ }),

/***/ "MR1Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Loader = function () {
    function Loader() {
        _classCallCheck(this, Loader);

        this.showLoader = false;
    }

    _createClass(Loader, [{
        key: "show",
        value: function show() {
            this.showLoader = true;
        }
    }, {
        key: "hide",
        value: function hide() {
            this.showLoader = false;
        }
    }, {
        key: "toggle",
        value: function toggle() {
            this.showLoader = !this.showLoader;
        }
    }, {
        key: "isShowLoader",
        value: function isShowLoader() {
            return this.showLoader;
        }
    }]);

    return Loader;
}();

exports.default = Loader;

/***/ }),

/***/ "MV+4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleSearchController = function () {
    /**
     * @param EventEmitter
     * @ngInject
     */
    SimpleSearchController.$inject = ["EventEmitter"];
    function SimpleSearchController(EventEmitter) {
        _classCallCheck(this, SimpleSearchController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(SimpleSearchController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isFocused = false;
        }
    }, {
        key: 'triggerSearch',
        value: function triggerSearch() {
            this.onBeforeSearch();

            if (this.query.length) {
                this.triggerSearchResult();
            } else {
                this.onEmptySearch();
            }
        }
    }, {
        key: 'focused',
        value: function focused() {
            this.isFocused = true;
            this.triggerFocusChange();
        }
    }, {
        key: 'blurred',
        value: function blurred() {
            if (this.addFocus) {
                this.addFocus = false;
                return;
            }

            this.isFocused = false;
            this.triggerFocusChange();
        }
    }, {
        key: 'isInFocus',
        value: function isInFocus() {
            return this.isFocused;
        }
    }, {
        key: 'triggerFocusChange',
        value: function triggerFocusChange() {
            this.onFocusChange(this.eventEmitter({
                isFocused: this.isFocused
            }));
        }
    }, {
        key: 'triggerSearchResult',
        value: function triggerSearchResult() {
            this.onSearchResult(this.eventEmitter({
                query: this.query
            }));
        }
    }, {
        key: 'clearSearch',
        value: function clearSearch() {
            this.query = '';
            this.searchThingForm.search.$rollbackViewValue();
            this.addFocus = true;
            this.onEmptySearch();
        }
    }]);

    return SimpleSearchController;
}();

exports.default = SimpleSearchController;

/***/ }),

/***/ "MdYb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _list = __webpack_require__("G+YA");

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtEntitiesList',
    options: _list2.default
};

/***/ }),

/***/ "MgRh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    chart: {
        height: 216
    },
    title: {
        text: 'Recent Activity'
    },
    legend: {
        enabled: false
    }
};

/***/ }),

/***/ "MjS9":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-grid__col form-grid__col__label form-grid__col__label--long\"> <i class=\"fa fa-battery-full\" aria-hidden=true></i> <label class=form-grid__label>Battery level</label> <dt-help-icon message-key=help_icon_advanced_search_battery></dt-help-icon> </div> <div class=form-grid__col> <div class=form-grid__row> <div class=form-grid__col> <div class=form-grid__row> <label class=md-caption for=above-battery>above</label> <md-input-container class=\"form-element form-element--simple space-m-h-xs\"> <input type=text id=above-battery aria-label=\"Battery power above value\" ng-change=$ctrl.onChange(); ng-model-options=\"{\n                                'updateOn': 'default blur',\n                                'debounce': {\n                                    'default': 350,\n                                    'blur': 0\n                                }\n                            }\" ng-model=$ctrl.aboveValue> </md-input-container> <span class=md-caption>%</span> </div> </div> <div class=form-grid__col> <div class=form-grid__row> <label class=md-caption for=below-battery>below</label> <md-input-container class=\"form-element form-element--simple space-m-h-xs\"> <input type=text id=below-battery aria-label=\"Battery power below value\" ng-change=$ctrl.onChange(); ng-model-options=\"{\n                                'updateOn': 'default blur',\n                                'debounce': {\n                                    'default': 350,\n                                    'blur': 0\n                                }\n                            }\" ng-model=$ctrl.belowValue> </md-input-container> <span class=md-caption>%</span> </div> </div> </div> </div>";

/***/ }),

/***/ "N+h1":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("thFQ"),
    arrayIncludes = __webpack_require__("mBEK"),
    arrayIncludesWith = __webpack_require__("hjtK"),
    cacheHas = __webpack_require__("qxaq"),
    createSet = __webpack_require__("53v/"),
    setToArray = __webpack_require__("ZEJm");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "NAwI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/icon_signal4.svg";

/***/ }),

/***/ "NNTt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/alerts.json";

/***/ }),

/***/ "NTe/":
/***/ (function(module, exports) {

module.exports = "<div class=rules> <div class=rule-item> <div class=space-m-v-s layout=row layout-align=\"start center\"> <dt-icon> <span class=\"icons icons--transparent\"> <md-icon md-svg-icon=door aria-label=Door></md-icon> </span> </dt-icon> <div class=\"md-body-label space-m-l-s\">Door</div> </div> <dt-rule> <div class=dt-rule> <md-button class=\"md-button--icon md-raised\" aris-label=toggle> <i class=\"fa fa-caret-right\" ng-class=\"collapsed ? 'fa-caret-right' : 'fa-caret-down'\"></i> </md-button> <div class=dt-rule-text> <div class=dt-rule-text-title>Open door outside office hours alert</div> <md-button class=md-button--icon> <md-icon class=material-icons>remove_circle_outline</md-icon> </md-button> </div> </div> </dt-rule> </div> <div class=rule-item> <div class=space-m-v-s layout=row layout-align=\"start center\"> <dt-icon> <span class=\"icons icons--transparent\"> <md-icon md-svg-icon=temperature aria-label=Temperature></md-icon> </span> </dt-icon> <div class=\"md-body-label space-m-l-s\">Temperature</div> </div> <dt-rule> <div class=dt-rule> <md-button class=\"md-button--icon md-raised\" aris-label=toggle> <i class=\"fa fa-caret-down\" ng-class=\"collapsed ? 'fa-caret-right' : 'fa-caret-down'\"></i> </md-button> <div class=dt-rule-text> <div class=dt-rule-text-title>Hight temperature severe alert</div> <md-button class=md-button--icon> <md-icon class=material-icons>remove_circle_outline</md-icon> </md-button> </div> </div> </dt-rule> <div class=rule-management> <section layout-padding> <div class=md-block-header>When this happens</div> <div class=md-body-label>If <span class=\"text-selectable text-selectable--info\">any</span> of the following applies:</div> <section> <div class=\"box box--light-grey space-m-b-m space-m-l-xl\"> <div layout-padding layout=row layout-align=\"start center\"> <div class=md-subhead>Temperature is more than</div> <md-input-container class=input-container--short> <input type=text class=text-right value=24 aria-label=\"Temperature above rule\"> </md-input-container> <div class=md-body-1>&deg;C</div> </div> </div> <div layout=row layout-align=\"start center\"> <div class=\"md-body-label space-m-h-s\">Or</div> <div class=\"box box--light-grey\" flex> <div layout-padding layout=row layout-align=\"start center\"> <div class=md-subhead>Temperature is less than</div> <md-input-container class=input-container--short> <input type=text class=text-right value=18 aria-label=\"Temperature below rule\"> </md-input-container> <div class=md-body-1>&deg;C</div> </div> </div> </div> </section> </section> <section layout-padding> <div class=md-block-header>Do this</div> <div class=md-body-label>Create notification</div> <div class=row> <div class=col-xs-2 layout=row layout-align=\"start center\"> <div class=md-caption>Severity:</div> </div> <div class=col-xs layout=row layout-align=\"start center\"> <i class=\"material-icons material-icons--help space-m-r-xs\">info</i> <div class=md-caption>Warning:</div> </div> </div> <div class=row> <div class=col-xs-2> <div class=md-caption>Dismissal:</div> </div> <div class=col-xs> <div class=md-caption>Clear when rule no longer applies</div> </div> </div> <div> <md-input-container class=md-block> <label for=notify>Notification message</label> <input type=text name=notify id=notify value=\"Temperature outside threshold\"> <div class=md-input-hint>Seen in sensor details when rule applies</div> </md-input-container> </div> <div class=md-body-label>Send email</div> <div> <md-chips ng-model=labelsSelected> <md-chip-template> <span>{{$chip}}</span> </md-chip-template> </md-chips> </div> </section> </div> </div> </div>";

/***/ }),

/***/ "NY2E":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/alerts-actions.png";

/***/ }),

/***/ "NboS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/table-sortable.svg";

/***/ }),

/***/ "NgYl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _roleUsers = __webpack_require__("Jyq7");

var _roleUsers2 = _interopRequireDefault(_roleUsers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("78T7");

exports.default = {
    bindings: {
        users: '<',
        onAddUser: '&',
        onRemoveUser: '&'
    },
    controller: _roleUsers2.default,
    template: template
};

/***/ }),

/***/ "NkKs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeneralInformationController = function () {
    function GeneralInformationController() {
        _classCallCheck(this, GeneralInformationController);
    }

    _createClass(GeneralInformationController, [{
        key: "$onInit",
        value: function $onInit() {
            if (!this.isEditing) {
                this.isEditing = false;
            }
        }
    }]);

    return GeneralInformationController;
}();

exports.default = GeneralInformationController;

/***/ }),

/***/ "Nl++":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/icon_signal2.svg";

/***/ }),

/***/ "Nm+6":
/***/ (function(module, exports) {

module.exports = "<script type=text/ng-template id=item-node.template.html> <div class=\"entity-label entity-label--active-no-arrow edit-navbar-tree-node space-p-h-n\"\n         ng-class=\"{'is-active': ctrl.editingItem.id == item.id}\"\n         ng-click=\"ctrl.editItem(item, 'node-input-' + item.id);\"\n         layout=\"row\" layout-align=\"start center\">\n\n        <md-button ng-if=\"item.type === 'CATEGORY'\" ng-disabled=\"!item.items.length\" class=\"md-button--icon space-m-r-s\" ng-click=\"toggle(); $event.stopPropagation();\" aria-label=\"Toggle\">\n            <i class=\"fa\" ng-class=\"collapsed ? 'fa-caret-right' : 'fa-caret-down'\" aria-hidden=\"true\"></i>\n        </md-button>\n        <!--<i class=\"fa {{ item.type == 'CATEGORY' ? 'fa-folder-o' : 'fa-search' }}\" aria-hidden=\"true\"></i>-->\n        <!--<i class=\"fa fa-arrows\" ui-tree-handle aria-hidden=\"true\"></i>-->\n\n        <div class=\"entity-label__content flex\" ng-class=\"{'space-m-l-s': item.type === 'VIEW'}\">\n            <div class=\"entity-label__name\" title=\"{{item.title}}\">{{ item.title }}</div>\n\n            <input\n                id=\"node-input-{{item.id}}\"\n                class=\"edit-navbar-tree-node-input md-body-2 space-p-l-xs flex\" type=\"text\"\n                ng-blur=\"ctrl.saveItem()\"\n                ng-keypress=\"($event.which === 13) && ctrl.saveItem()\"\n                ng-model=\"item.title\">\n        </div>\n\n        <i class=\"material-icons material-icons--s edit-navbar-tree-node-delete\" aria-hidden=\"true\"\n           ng-click=\"ctrl.deleteItem(item);\">delete</i>\n\n        <div ui-tree-handle class=\"entity-label__handle\">\n            <i class=\"material-icons material-icons--s\">open_with</i>\n        </div>\n    </div>\n\n    <ol ui-tree-nodes ng-model=\"item.items\" class=\"custom-list custom-list--entities\" ng-class=\"{'is-hidden': collapsed}\">\n        <li ng-repeat=\"item in item.items\" ui-tree-node ng-include=\"'item-node.template.html'\">\n        </li>\n    </ol> </script> <md-dialog style=width:490px dt-block-loader=ctrl.loading> <md-dialog-content class=md-dialog-content style=height:400px ng-click=ctrl.blurFocusedItems($event)> <h2 class=md-dialog-title>Edit Navbar</h2> <p>Drag and drop to rearrange navbar items. Click/tap on a navbar item to change the name and show delete button.</p> <section layout=column> <div class=text-right> <a href=# ng-click=\"$event.preventDefault(); ctrl.expandAll();\">Expand all</a> / <a href=# ng-click=\"$event.preventDefault(); ctrl.collapseAll();\">Collapse all</a> </div> <div id=tree-root-views class=folder-tree ui-tree=ctrl.treeOptions data-empty-placeholder-enabled=false> <ol ui-tree-nodes ng-model=ctrl.categories class=\"custom-list custom-list--entities\"> <li ng-repeat=\"item in ctrl.categories\" ui-tree-node ng-include=\"'item-node.template.html'\" data-collapsed=false></li> </ol> <a href=# class=\"space-m-v-s space-m-l-xs md-block\" ng-click=ctrl.showAddCategoryForm() ng-if=!ctrl.addCategoryVisible aria-label=\"Add category\"> <md-icon class=\"material-icons material-icons--s\">add</md-icon> Create new category </a> <form ng-if=ctrl.addCategoryVisible class=entity-label__create name=ctrl.addCategoryForm md-theme=dark ng-submit=ctrl.addCategory()> <md-content class=space-p-h-s> <md-input-container class=md-block> <label>Category Name</label> <input type=text ng-model=ctrl.categoryName get-focus=ctrl.addCategoryVisible name=name required autocomplete=off> <div ng-messages=ctrl.addCategoryForm.name.$error> <div ng-message=required>You did not enter category name</div> </div> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=space-m-h-n ng-click=ctrl.hideAddCategoryForm() aria-label=Cancel>cancel</md-button> <md-button class=space-m-h-n type=submit ng-disabled=ctrl.addCategoryForm.$invalid aria-label=Add>Add</md-button> </div> </md-content> </form> </div> </section> </md-dialog-content> <md-dialog-actions class=\"space-p-r-m space-p-b-s\"> <md-button class=md-primary ng-click=ctrl.done()> Done </md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "Nr0z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingsList = __webpack_require__("m9ZF");

var _thingsList2 = _interopRequireDefault(_thingsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingsList',
    options: _thingsList2.default
};

/***/ }),

/***/ "Nw2O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpMenu = __webpack_require__("VaJM");

var _helpMenu2 = _interopRequireDefault(_helpMenu);

var _applicationHelp = __webpack_require__("EAMX");

var _applicationHelp2 = _interopRequireDefault(_applicationHelp);

var _feedbackForm = __webpack_require__("dKJL");

var _feedbackForm2 = _interopRequireDefault(_feedbackForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtHelpMenu',
    options: _helpMenu2.default
};

exports.default = {
    Component: Component,
    ApplicationHelp: _applicationHelp2.default,
    FeedbackForm: _feedbackForm2.default
};

/***/ }),

/***/ "O8Jr":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Developer Settings'\"></dt-content-header> <dt-tabs class=dt-tabs layout=column tabs=$ctrl.tabs on-tab-click=$ctrl.onTabClick($event)> </dt-tabs> <div ui-view=contentBody></div> ";

/***/ }),

/***/ "OOZJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alertBox = __webpack_require__("FbvC");

var _alertBox2 = _interopRequireDefault(_alertBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("0//z");

exports.default = {
    bindings: {
        alerts: '<',
        selectedThingId: '<'
    },
    template: template,
    controller: _alertBox2.default
};

/***/ }),

/***/ "OU4C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.ico";

/***/ }),

/***/ "OWmn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = __webpack_require__("4JbS");

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DialogService settings
 * @type {{name: string, definition: DialogService}}
 */
exports.default = {
  name: 'DialogService',
  definition: _dialog2.default
};

/***/ }),

/***/ "OZ2k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    rangeSelector: {
        buttonSpacing: 5,
        selected: 1
    }
};

/***/ }),

/***/ "OaHE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var COMPONENT_NAME = 'uac-add-user';

var AddUserController = function () {
    /** @ngInject */
    AddUserController.$inject = ["EventEmitter", "ErrorsService"];
    function AddUserController(EventEmitter, ErrorsService) {
        _classCallCheck(this, AddUserController);

        this.eventEmitter = EventEmitter;
        this.ErrorsService = ErrorsService;
    }

    _createClass(AddUserController, [{
        key: '$onInit',
        value: function $onInit() {
            this.user = {
                first_name: '',
                last_name: '',
                middle_name: '',
                email: '',
                title: ''
            };

            this.genericErrors = this.ErrorsService.getGenericErrors();
            this.componentErrors = this.ErrorsService.getComponentErrors(COMPONENT_NAME);
        }
    }, {
        key: 'create',
        value: function create() {
            this.onCreate(this.eventEmitter({
                user: (0, _cloneDeep3.default)(this.user)
            }));
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.onCancel();
        }
    }]);

    return AddUserController;
}();

exports.default = AddUserController;

/***/ }),

/***/ "Oaxr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingName = __webpack_require__("8+ZO");

var _thingName2 = _interopRequireDefault(_thingName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingName',
    options: _thingName2.default
};

/***/ }),

/***/ "Odso":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'last_updated';
var ANY_TEXT = 'Any';
var CUSTOM_TEXT = 'Custom';

var ThingUpdatedController = function () {
    /** @ngInject */
    ThingUpdatedController.$inject = ["EventEmitter"];
    function ThingUpdatedController(EventEmitter) {
        _classCallCheck(this, ThingUpdatedController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingUpdatedController, [{
        key: '$onInit',
        value: function $onInit() {
            this.selectedOption = null;
            this.customAfter = (0, _moment2.default)().subtract(1, 'week').toDate();
            this.customBefore = (0, _moment2.default)().toDate();
            this.anyText = ANY_TEXT;
            this.customText = CUSTOM_TEXT;
            this.values = {
                'Today': (0, _moment2.default)().format('YYYY-MM-DD'),
                'Yesterday': (0, _moment2.default)().subtract(1, 'day').format('YYYY-MM-DD'),
                'Last 30 days': (0, _moment2.default)().subtract(30, 'days').format('YYYY-MM-DD'),
                'Last 60 days': (0, _moment2.default)().subtract(60, 'days').format('YYYY-MM-DD'),
                'Last 90 days': (0, _moment2.default)().subtract(90, 'days').format('YYYY-MM-DD')
            };
        }
    }, {
        key: 'isAnySelected',
        value: function isAnySelected() {
            return this.selectedOption === ANY_TEXT;
        }
    }, {
        key: 'isCustomSelected',
        value: function isCustomSelected() {
            return this.selectedOption === CUSTOM_TEXT;
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            // eslint-disable-line consistent-return
            if (this.isAnySelected()) {
                return this.removeItemFromBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                }));
            }

            var value = {};

            if (this.isCustomSelected()) {
                value.after = (0, _moment2.default)(this.customAfter).format('YYYY-MM-DD');
                value.before = (0, _moment2.default)(this.customBefore).format('YYYY-MM-DD');
            } else {
                value.after = this.selectedOption;
            }

            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: value
                }
            }));
        }
    }]);

    return ThingUpdatedController;
}();

exports.default = ThingUpdatedController;

/***/ }),

/***/ "OiHR":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-grid__col form-grid__col__label\"> <label class=form-grid__label>Status</label> <dt-help-icon message-key=help_icon_advanced_search_status></dt-help-icon> </div> <div class=form-grid__col> <md-checkbox ng-repeat=\"notification in $ctrl.notifications\" ng-checked=$ctrl.exists(notification) ng-click=$ctrl.toggle(notification) class=md-default-theme ng-class=\"{'space-m-r-l': !$last}\" aria-label=checkbox> <span class=md-caption>{{ notification.title }}</span> </md-checkbox> </div> ";

/***/ }),

/***/ "P3sd":
/***/ (function(module, exports) {

module.exports = "<i class=\"fa {{ $ctrl.batteryIcon }}\" aria-hidden=true></i> ";

/***/ }),

/***/ "P3ud":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


InterceptorsConfig.$inject = ["$httpProvider"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InterceptorsConfig;
/**
 * httpInterceptor global config.
 * Register httpInterceptor in $httpProvider interceptors.
 * @param {$httpProvider} $httpProvider - Angular $httpProvider service
 * @constructor
 * @ngInject
 */
function InterceptorsConfig($httpProvider) {
  $httpProvider.interceptors.push('httpInterceptor');
}

/***/ }),

/***/ "PCux":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ "PNGm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


saveViewDirectiveConfig.$inject = ["DialogService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = saveViewDirectiveConfig;

var _popup = __webpack_require__("mvlx");

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saveViewPopupTemplate = __webpack_require__("zZQo");

/** @ngInject */
function saveViewDirectiveConfig(DialogService) {
    function link($scope, $element) {
        function showSaveViewPopup(ev) {
            DialogService.show({
                controller: _popup2.default,
                controllerAs: 'ctrl',
                template: saveViewPopupTemplate,
                parent: document.body,
                targetEvent: ev,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    searchQuery: $scope.searchQuery,
                    onSaveView: $scope.onSaveView
                }
            });
        }

        $element.on('click', showSaveViewPopup);

        $element.on('$destroy', function () {
            $element.off('click', showSaveViewPopup);
        });
    }

    return {
        restrict: 'A',
        scope: {
            searchQuery: '<',
            onSaveView: '&'
        },
        link: link
    };
}

/***/ }),

/***/ "PUh1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingDescription = __webpack_require__("2hpa");

var _thingDescription2 = _interopRequireDefault(_thingDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingDescription',
    options: _thingDescription2.default
};

/***/ }),

/***/ "PYb+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _advancedInformation = __webpack_require__("H1Ft");

var _advancedInformation2 = _interopRequireDefault(_advancedInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAdvanced',
    options: _advancedInformation2.default
};

/***/ }),

/***/ "Phke":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EmptyStateController = function () {
    /** @ngInject */
    EmptyStateController.$inject = ["TranslationService"];
    function EmptyStateController(TranslationService) {
        _classCallCheck(this, EmptyStateController);

        this.TranslationService = TranslationService;
    }

    _createClass(EmptyStateController, [{
        key: '$onInit',
        value: function $onInit() {
            var states = {
                'main.folders-and-labels.folders': {
                    content: 'help_menu_main_folders-and-labels_folders',
                    icon: 'fa-folder-open'
                },
                'main.folders-and-labels.labels': {
                    content: 'help_menu_main_folders-and-labels_labels',
                    icon: 'fa-tags'
                }
            };

            this.content = this.TranslationService.getLine(states[this.state].content);
            this.icon = states[this.state].icon;
        }
    }]);

    return EmptyStateController;
}();

exports.default = EmptyStateController;

/***/ }),

/***/ "Pj1t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BulkEditController = function () {
    /** @ngInject */
    BulkEditController.$inject = ["ThingsApi", "selectedThings", "DialogService"];
    function BulkEditController(ThingsApi, selectedThings, DialogService) {
        _classCallCheck(this, BulkEditController);

        this.ThingsApi = ThingsApi;
        this.selectedThings = selectedThings;
        this.DialogService = DialogService;

        this.selectedFolderId = null;

        this.editAllWarning = this.selectedThings.isQuery;
    }

    _createClass(BulkEditController, [{
        key: "acceptWarning",
        value: function acceptWarning() {
            this.editAllWarning = false;
        }
    }, {
        key: "declineWarning",
        value: function declineWarning() {
            this.cancel();
        }
    }, {
        key: "cancel",
        value: function cancel() {
            this.DialogService.cancel();
        }
    }, {
        key: "onFolderChange",
        value: function onFolderChange(folderId) {
            this.selectedFolderId = folderId;
        }

        // onLabelsAdded(ev) {
        //     console.log(ev);
        // }

    }]);

    return BulkEditController;
}();

exports.default = BulkEditController;

/***/ }),

/***/ "Pnd4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingDetailsFolder = __webpack_require__("R4gT");

var _thingDetailsFolder2 = _interopRequireDefault(_thingDetailsFolder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("k/Q+");

exports.default = {
    bindings: {
        folderId: '<',
        onUpdate: '&'
    },

    template: template,
    controller: _thingDetailsFolder2.default
};

/***/ }),

/***/ "Pnia":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _searchBox = __webpack_require__("mxiS");

var _searchBox2 = _interopRequireDefault(_searchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("jbMY");

exports.default = {
    bindings: {
        query: '<',
        onSearch: '&',
        onClear: '&'
    },
    template: template,
    controller: _searchBox2.default
};

/***/ }),

/***/ "Pnr7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LabelDetails = exports.Component = exports.Config = undefined;

var _labels = __webpack_require__("xK5u");

var _labels2 = _interopRequireDefault(_labels);

var _labels3 = __webpack_require__("n6dy");

var _labels4 = _interopRequireDefault(_labels3);

var _labelDetails = __webpack_require__("qwi1");

var _labelDetails2 = _interopRequireDefault(_labelDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtLabelsView',
    options: _labels4.default
};

exports.Config = _labels2.default;
exports.Component = Component;
exports.LabelDetails = _labelDetails2.default;

/***/ }),

/***/ "PtwN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tree = __webpack_require__("bsgfj");

var _tree2 = _interopRequireDefault(_tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("U7yK");

exports.default = {
    bindings: {
        data: '<',
        selectedFolderId: '<',
        onFolderSelected: '&',
        onFolderCreated: '&',
        onFolderMoved: '&'
    },
    controller: _tree2.default,
    template: template
};

/***/ }),

/***/ "Pvku":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Note class.
 */
var Note =
/**
 * @param {String} objectId - Object id
 * @param {String} content - content
 * @constructor
 */
function Note(objectId, content) {
  _classCallCheck(this, Note);

  this.object_id = objectId;
  this.content = content;
};

exports.default = Note;

/***/ }),

/***/ "QA0p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LABELS_ADDED_KEY = 'labels_added';
var LABELS_REMOVED_KEY = 'labels_removed';

var ThingDetailLabelsController = function () {
    /** @ngInject */
    ThingDetailLabelsController.$inject = ["EventEmitter", "$timeout"];
    function ThingDetailLabelsController(EventEmitter, $timeout) {
        _classCallCheck(this, ThingDetailLabelsController);

        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
    }

    _createClass(ThingDetailLabelsController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.labels) {
                this.originalLabels = (0, _cloneDeep3.default)(changes.labels.currentValue);
            }
        }
    }, {
        key: 'onLabelsAdded',
        value: function onLabelsAdded(_ref) {
            var _this = this;

            var label = _ref.label;

            var preUpdatePromise = this.$timeout(_utils2.default.noop, 0).then(function () {
                return label;
            });

            if (!label.id) {
                preUpdatePromise = this.preUpdate(this.eventEmitter({
                    data: label
                }));
            }

            preUpdatePromise.then(function (item) {
                _this.onUpdate(_this.eventEmitter({
                    patch: _defineProperty({}, LABELS_ADDED_KEY, [item.id]),
                    data: {
                        labels: [].concat(_toConsumableArray(_this.originalLabels), [item])
                    }
                }));
            });
        }
    }, {
        key: 'onLabelsRemoved',
        value: function onLabelsRemoved(_ref2) {
            var label = _ref2.label;

            this.onUpdate(this.eventEmitter({
                patch: _defineProperty({}, LABELS_REMOVED_KEY, [label.id]),
                data: {
                    labels: this.originalLabels.filter(function (item) {
                        return item.id !== label.id;
                    })
                }
            }));
        }
    }]);

    return ThingDetailLabelsController;
}();

exports.default = ThingDetailLabelsController;

/***/ }),

/***/ "QDzy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/icon_signal0.svg";

/***/ }),

/***/ "QQMY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HealthCheckerService = exports.CharsService = exports.Errors = exports.Geo = exports.Help = exports.TranslationService = exports.ToastService = exports.Auth = exports.NavigationService = exports.FolderService = exports.DialogService = exports.Notifications = exports.Things = exports.Config = exports.Interceptors = exports.Api = undefined;

var _api = __webpack_require__("mg0t");

var Api = _interopRequireWildcard(_api);

var _interceptors = __webpack_require__("B+33");

var Interceptors = _interopRequireWildcard(_interceptors);

var _config = __webpack_require__("cx3I");

var Config = _interopRequireWildcard(_config);

var _things = __webpack_require__("rA0j");

var Things = _interopRequireWildcard(_things);

var _notifications = __webpack_require__("HOVG");

var Notifications = _interopRequireWildcard(_notifications);

var _errors = __webpack_require__("y4pL");

var Errors = _interopRequireWildcard(_errors);

var _help = __webpack_require__("Gl4w");

var Help = _interopRequireWildcard(_help);

var _geo = __webpack_require__("uA57");

var Geo = _interopRequireWildcard(_geo);

var _dialog = __webpack_require__("OWmn");

var _dialog2 = _interopRequireDefault(_dialog);

var _folders = __webpack_require__("jMGr");

var _folders2 = _interopRequireDefault(_folders);

var _healthChecker = __webpack_require__("eshw");

var _healthChecker2 = _interopRequireDefault(_healthChecker);

var _navigation = __webpack_require__("2efs");

var _navigation2 = _interopRequireDefault(_navigation);

var _auth = __webpack_require__("GUdK");

var Auth = _interopRequireWildcard(_auth);

var _toast = __webpack_require__("eI8x");

var _toast2 = _interopRequireDefault(_toast);

var _translation = __webpack_require__("jrjf");

var _translation2 = _interopRequireDefault(_translation);

var _chars = __webpack_require__("M7rA");

var _chars2 = _interopRequireDefault(_chars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.Api = Api;
exports.Interceptors = Interceptors;
exports.Config = Config;
exports.Things = Things;
exports.Notifications = Notifications;
exports.DialogService = _dialog2.default;
exports.FolderService = _folders2.default;
exports.NavigationService = _navigation2.default;
exports.Auth = Auth;
exports.ToastService = _toast2.default;
exports.TranslationService = _translation2.default;
exports.Help = Help;
exports.Geo = Geo;
exports.Errors = Errors;
exports.CharsService = _chars2.default;
exports.HealthCheckerService = _healthChecker2.default;

/***/ }),

/***/ "QeIE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


shyDirectiveConfig.$inject = ["$window"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shyDirectiveConfig;

var _angular = __webpack_require__("aeQg");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: remove use of angular here

/** @ngInject */
function shyDirectiveConfig($window) {
    function link($scope, $element) {
        var document = $window.document;
        var body = document.body;

        var viewTop = void 0;
        var viewBottom = void 0;
        var elemRect = void 0;
        var elemTop = void 0;

        var theyLookedAtMe = false;
        var theyLookAtMe = false;

        function areTheyLookingAtMe() {
            viewTop = body.scrollTop;
            viewBottom = viewTop + body.offsetHeight;
            elemRect = $element[0].getBoundingClientRect();
            elemTop = elemRect.top + viewTop;

            return elemTop <= viewBottom && elemTop >= viewTop;
        }

        function onScrolled() {
            $scope.shouldTrigger = false;

            theyLookedAtMe = theyLookAtMe;
            theyLookAtMe = areTheyLookingAtMe();

            if (theyLookAtMe && !theyLookedAtMe) {
                $scope.onVisible();
            }
        }

        function trigger() {
            if (areTheyLookingAtMe()) {
                $scope.onVisible();
            }
        }

        $scope.$watch('shouldTrigger', function (triggerNow) {
            if (triggerNow) {
                trigger();
                $scope.shouldTrigger = false;
            }
        });

        if ($scope.scrollSelector) {
            var scrollNode = document.querySelector($scope.scrollSelector);
            scrollNode = _angular2.default.element(scrollNode);

            scrollNode.on('scroll', onScrolled);

            $element.on('$destroy', function () {
                scrollNode.off('scroll', onScrolled);
            });
        }
    }

    return {
        restrict: 'A',
        scope: {
            scrollSelector: '<',
            shouldTrigger: '=',
            onVisible: '&'
        },
        link: link
    };
}

/***/ }),

/***/ "R+eB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _roles = __webpack_require__("IDjL");

var _roles2 = _interopRequireDefault(_roles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("4atV");

exports.default = {
    controller: _roles2.default,
    template: template
};

/***/ }),

/***/ "R4gT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThingDetailLabelsController = function () {
    /** @ngInject */
    ThingDetailLabelsController.$inject = ["EventEmitter", "FolderService"];
    function ThingDetailLabelsController(EventEmitter, FolderService) {
        _classCallCheck(this, ThingDetailLabelsController);

        this.eventEmitter = EventEmitter;
        this.FolderService = FolderService;
    }

    _createClass(ThingDetailLabelsController, [{
        key: "onFolderChanged",
        value: function onFolderChanged(_ref) {
            var folderId = _ref.folderId;

            if (this.folderId !== folderId) {
                this.onUpdate(this.eventEmitter({
                    patch: {
                        folder_id: folderId
                    },
                    data: {
                        folder: this.FolderService.getFolder(folderId)
                    }
                }));
            }
        }
    }]);

    return ThingDetailLabelsController;
}();

exports.default = ThingDetailLabelsController;

/***/ }),

/***/ "R5Ds":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo.png";

/***/ }),

/***/ "RLG5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IconClass = {
    BLANK: 'sensor-blank',
    TOUCH: 'window'
};

var IconController = function () {
    function IconController() {
        _classCallCheck(this, IconController);
    }

    _createClass(IconController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.iconClass) {
                this.iconClass = IconClass.BLANK;
            }
        }
    }, {
        key: 'getAriaLabel',
        value: function getAriaLabel() {
            return (this.iconClass.charAt(0).toUpperCase() + this.iconClass.slice(1)).split('-').join(' ');
        }
    }]);

    return IconController;
}();

exports.default = IconController;

/***/ }),

/***/ "RXTU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/temperature.svg";

/***/ }),

/***/ "RYK1":
/***/ (function(module, exports) {

module.exports = "<ul class=\"custom-list custom-list--entities\"> <li data-ng-repeat=\"entity in $ctrl.entities\"> <div class=entity-label ui-sref-active=is-active ui-sref={{$ctrl.entityState}}> <div class=entity-label__content> <span class=entity-label__name data-ng-bind=entity.name></span> </div> <span flex></span> <div class=entity-label__info> </div> </div> </li> </ul> ";

/***/ }),

/***/ "RcIP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BatteryIcons = {
    'VALUE_0': 'fa-battery-empty',
    'VALUE_25': 'fa-battery-quarter',
    'VALUE_50': 'fa-battery-half',
    'VALUE_75': 'fa-battery-three-quarters',
    'VALUE_100': 'fa-battery-full'
};

var BatteryStatusController = function () {
    function BatteryStatusController() {
        _classCallCheck(this, BatteryStatusController);
    }

    _createClass(BatteryStatusController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.battery) {
                this.batteryIcon = BatteryIcons.VALUE_0;
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.battery && !isNaN(parseInt(changes.battery.currentValue, 10))) {
                this.battery = parseInt((0, _cloneDeep3.default)(changes.battery.currentValue), 10);
            } else {
                this.battery = 0;
            }

            this.calculateIcon();
        }
    }, {
        key: 'calculateIcon',
        value: function calculateIcon() {
            if (this.battery < 25) {
                this.batteryIcon = BatteryIcons.VALUE_0;
                return;
            }

            if (this.battery < 50) {
                this.batteryIcon = BatteryIcons.VALUE_25;
                return;
            }

            if (this.battery < 75) {
                this.batteryIcon = BatteryIcons.VALUE_50;
                return;
            }

            if (this.battery < 90) {
                this.batteryIcon = BatteryIcons.VALUE_75;
                return;
            }

            this.batteryIcon = BatteryIcons.VALUE_100;
        }
    }]);

    return BatteryStatusController;
}();

exports.default = BatteryStatusController;

/***/ }),

/***/ "Ro2m":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("IiHL"),
    baseIsNaN = __webpack_require__("hgJw"),
    strictIndexOf = __webpack_require__("SftN");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "SI0v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _round2 = __webpack_require__("gSU/");

var _round3 = _interopRequireDefault(_round2);

var _sum2 = __webpack_require__("16Ic");

var _sum3 = _interopRequireDefault(_sum2);

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataConverter = function () {
    function DataConverter() {
        _classCallCheck(this, DataConverter);
    }

    _createClass(DataConverter, null, [{
        key: 'getRoundedFloatOrNull',
        value: function getRoundedFloatOrNull(value) {
            var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            if (!value) {
                return null;
            }

            return (0, _round3.default)(parseFloat(value), precision);
        }
    }, {
        key: 'getDecimalIntOrNull',
        value: function getDecimalIntOrNull(value) {
            if (!value || value === '0') {
                return null;
            }

            return parseInt(value, 10);
        }
    }, {
        key: 'temperature',
        value: function temperature(data) {
            var ranges = [];
            var average = [];

            var timestamp = void 0;

            data.forEach(function (entry) {
                timestamp = (0, _moment2.default)(entry.time).valueOf();
                ranges.push([timestamp, DataConverter.getRoundedFloatOrNull(entry.MIN_TEMPERATURE), DataConverter.getRoundedFloatOrNull(entry.MAX_TEMPERATURE)]);
                average.push([timestamp, DataConverter.getRoundedFloatOrNull(entry.MEAN_TEMPERATURE)]);
            });

            return {
                ranges: ranges,
                average: average
            };
        }
    }, {
        key: 'touch',
        value: function touch(data) {
            var result = [];

            data.forEach(function (entry) {
                result.push([(0, _moment2.default)(entry.time).valueOf(), DataConverter.getDecimalIntOrNull(entry.COUNT_TOUCH)]);
            });

            return result;
        }
    }, {
        key: 'proximityNavigator',
        value: function proximityNavigator(data) {
            var result = [];

            data.forEach(function (entry) {
                result.push([(0, _moment2.default)(entry.time).valueOf(), DataConverter.getDecimalIntOrNull(entry.COUNT_OBJECT_PRESENT)]);
            });

            return result;
        }
    }, {
        key: 'proximity',
        value: function proximity(data) {
            var result = [];

            var timestamp = void 0;
            var prevStatus = void 0;
            var status = void 0;

            data.forEach(function (entry) {
                timestamp = (0, _moment2.default)(entry.time).valueOf();
                status = entry.object_present ? -1 : 1;
                if (prevStatus) {
                    if (status !== prevStatus) {
                        result.push([timestamp, prevStatus]);
                    }
                }
                prevStatus = status;
                result.push([timestamp, status]);
            });

            return result;
        }
    }, {
        key: 'calculateInterval',
        value: function calculateInterval(start, end) {
            var itemCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 40;

            var seconds = (end - start) / itemCount / 1000;
            return _utils2.default.intervalToText(seconds);
        }
    }, {
        key: 'getPureValues',
        value: function getPureValues(data) {
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            return data.map(function (item) {
                return item[index];
            }).filter(function (item) {
                return item !== null;
            });
        }
    }, {
        key: 'temperatureStats',
        value: function temperatureStats(data) {
            var averages = DataConverter.getPureValues(data.average);
            var minimums = DataConverter.getPureValues(data.ranges);
            var maximums = DataConverter.getPureValues(data.ranges, 2);

            if (!averages.length) {
                return null;
            }

            return {
                lowest: (0, _round3.default)(Math.min.apply(Math, _toConsumableArray(minimums)), 2) + '\xB0C',
                average: (0, _round3.default)((0, _sum3.default)(averages) / averages.length, 2) + '\xB0C',
                highest: (0, _round3.default)(Math.max.apply(Math, _toConsumableArray(maximums)), 2) + '\xB0C'
            };
        }
    }, {
        key: 'touchStats',
        value: function touchStats(data) {
            var values = DataConverter.getPureValues(data);

            if (!values.length) {
                return null;
            }

            return {
                'total presses': (0, _sum3.default)(values)
            };
        }
    }, {
        key: 'proximityStats',
        value: function proximityStats(values) {
            if (!values.length) {
                return null;
            }

            var openings = [];

            var openedAt = null;

            values.forEach(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    time = _ref2[0],
                    status = _ref2[1];

                if (status === 1) {
                    if (!openedAt) {
                        openedAt = time;
                    }
                } else if (openedAt) {
                    openings.push(time - openedAt);
                    openedAt = null;
                }
            });

            if (openedAt) {
                var _values = _slicedToArray(values[values.length - 1], 1),
                    lastTime = _values[0];

                openings.push(lastTime - openedAt);
            }

            var result = {
                'times opened': '' + openings.length
            };

            if (openings.length > 1) {
                var averageInterval = Math.round((0, _sum3.default)(openings) / openings.length / 1000);
                result['average open for'] = _utils2.default.intervalToText(averageInterval);
            }

            return result;
        }
    }]);

    return DataConverter;
}();

exports.default = DataConverter;

/***/ }),

/***/ "SItB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppController = function () {
    /** @ngInject */
    AppController.$inject = ["UiTreeHelper"];
    function AppController(UiTreeHelper) {
        _classCallCheck(this, AppController);

        this.UiTreeHelper = UiTreeHelper;
    }

    _createClass(AppController, [{
        key: '$onInit',
        value: function $onInit() {
            // redefine method for calculation correct width
            this.UiTreeHelper.width = function (element) {
                return element.prop('clientWidth');
            };
        }
    }]);

    return AppController;
}();

exports.default = AppController;

/***/ }),

/***/ "SKXG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    plotOptions: {
        line: {
            marker: {
                radius: 0,
                states: {
                    hover: {
                        radiusPlus: 5
                    }
                }
            }
        }
    }
};

/***/ }),

/***/ "SKhp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


screenshotDirectiveConfig.$inject = ["$compile", "Loader"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = screenshotDirectiveConfig;

var _html2canvas = __webpack_require__("yOnv");

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _angular = __webpack_require__("aeQg");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @ngInject */
function screenshotDirectiveConfig($compile, Loader) {
    function link($scope, $element) {
        var previewEl = $element[0].querySelector('.dtHelp-screenshot__preview');
        $scope.isPreviewRender = false;

        function prepareContent() {
            $scope.canvas = null;
            $scope.flagDraw = null;
            $scope.rectangles = [];
            $scope.currentRect = null;
            $scope.selectingMode = 'highlight';
            $scope.canvasCtx = null;

            $scope.contentEl = _angular2.default.element(document.getElementById('help-screenshot-content'));
            $scope.contentEl.addClass('is-load');
            $scope.contentHightlightsEl = _angular2.default.element(document.getElementById('screenshot-content-hightlights'));
            $scope.contentHidesEl = _angular2.default.element(document.getElementById('help-screenshot-content-hides'));

            document.addEventListener('keydown', $scope.destruct);
            $scope.contentEl[0].ondragstart = function () {
                return false;
            };
        }

        $scope.destruct = function (e) {
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();

                $scope.contentEl.remove();

                document.querySelector('.md-panel-outer-wrapper').style.display = 'block';
                document.removeEventListener('keydown', $scope.destruct);
            }
        };

        /**
         * Start Navbar
         */
        $scope.setHighlightMode = function () {
            $scope.selectingMode = 'highlight';
        };

        $scope.setHideMode = function () {
            $scope.selectingMode = 'hide';
        };

        function createNavBar() {
            var navbar = $compile('<div class="help-screenshot-navbar" dt-drag>\n                <a href="#" class="md-secondary help-screenshot-navbar-button"\n                    ng-class="{\'is-active\': selectingMode === \'highlight\'}"\n                    ng-click="setHighlightMode(); $event.preventDefault();">\n                    \n                    <i class="material-icons">remove_red_eye</i>\n                    Highlight\n                    <md-tooltip\n                        class="dt-theme" md-z-index="1000" md-direction="top">Click on relevant item</md-tooltip>\n                </a>\n                \n                <a href="#" class="md-secondary help-screenshot-navbar-button"\n                        ng-class="{\'is-active\': selectingMode === \'hide\'}"\n                        ng-click="setHideMode(); $event.preventDefault();">\n                        \n                    <i class="material-icons">block</i>\n                    Hide\n                    <md-tooltip\n                        class="dt-theme" md-z-index="1000" md-direction="top">Click on relevant item</md-tooltip>\n                </a>\n                \n                <span flex></span>\n                \n                <a href="#" class="md-primary help-screenshot-navbar-button"\n                    ng-click="onDone(); $event.preventDefault();">Done</a>\n                \n                <md-icon\n                    class="material-icons material-icons--s drag-handler" dt-drag-handle>open_with</md-icon>')($scope);

            $scope.contentEl.append(navbar);
        }
        /**
         * End NavBar
         */
        function renderRect(rectId) {
            var currentRect = _angular2.default.element($scope.currentRect);
            var top = currentRect.css('top');
            var left = currentRect.css('left');
            var height = currentRect.css('height');
            var width = currentRect.css('width');

            var rect = $compile('<div class="help-screenshot-rect" id="' + rectId + '"\n                    style="top: ' + top + '; left: ' + left + '; height: ' + height + '; width: ' + width + ';">\n                <md-button class="md-icon-button md-primary" ng-click="removeRect(\'' + rectId + '\');">\n                        <md-icon>add_circle</md-icon>\n                </md-button>\n            </div>')($scope);

            if ($scope.selectingMode === 'highlight') {
                $scope.contentHightlightsEl.append(rect);
            } else {
                $scope.contentHidesEl.append(rect);
            }

            _angular2.default.element($scope.currentRect).remove();
        }

        function clean() {
            $scope.startX = null;
            $scope.startY = null;
            $scope.coord_x = null;
            $scope.coord_y = null;
            $scope.rectWidth = null;
            $scope.rectHeight = null;
            $scope.currentRect = null;
        }

        function start(ev) {
            if (ev.which !== 1 || ev.target.getAttribute('data-rect-id') || ev.target.classList.contains('help-screenshot-shape')) return;

            // update flag
            $scope.flagDraw = true;
            // calc coordinates
            $scope.startY = ev.clientY - $scope.canvas.offsetTop;
            $scope.coord_y = $scope.startY;

            $scope.startX = ev.clientX - $scope.canvas.offsetLeft;
            $scope.coord_x = $scope.startX;
            // create rectangle
            $scope.currentRect = document.createElement('div');
            $scope.currentRect.style.top = $scope.coord_y + 'px';
            $scope.currentRect.style.left = $scope.coord_x + 'px';

            $scope.currentRect.id = 'help-screenshot-current-rect';
            $scope.currentRect.className = 'help-screenshot-current-rect';
            $scope.contentEl.append($scope.currentRect);
        }

        function move(ev) {
            if (!$scope.flagDraw) return;

            var endX = ev.clientX - $scope.canvas.offsetLeft;
            var endY = ev.clientY - $scope.canvas.offsetTop;

            $scope.rectWidth = endX - $scope.startX;
            $scope.rectHeight = endY - $scope.startY;

            if ($scope.rectWidth < 0) {
                $scope.rectWidth = Math.abs($scope.rectWidth);

                $scope.currentRect.style.left = endX + 'px';
                $scope.coord_x = endX;
            }

            if ($scope.rectHeight < 0) {
                $scope.rectHeight = Math.abs($scope.rectHeight);

                $scope.currentRect.style.top = endY + 'px';
                $scope.coord_y = endY;
            }

            $scope.currentRect.style.width = $scope.rectWidth + 'px';
            $scope.currentRect.style.height = $scope.rectHeight + 'px';
        }

        function stop() {
            if (!$scope.flagDraw) return;

            $scope.flagDraw = false;

            if ($scope.rectWidth < 15 || $scope.rectHeight < 15) {
                _angular2.default.element($scope.currentRect).remove();
                return;
            }

            var rectId = 'rect-' + +new Date();

            $scope.currentRect.id = rectId;

            $scope.rectangles.push({
                x: $scope.coord_x,
                y: $scope.coord_y,
                width: $scope.rectWidth,
                height: $scope.rectHeight,
                type: $scope.selectingMode,
                id: rectId
            });

            $scope.canvasCtx.clearRect($scope.coord_x, $scope.coord_y, $scope.rectWidth, $scope.rectHeight);

            if ($scope.selectingMode === 'highlight') {
                // redraw hides
                $scope.rectangles.filter(function (item) {
                    return item.type === 'hide';
                }).forEach(function (item) {
                    var x = item.x,
                        y = item.y,
                        height = item.height,
                        width = item.width;


                    $scope.canvasCtx.clearRect(x, y, width, height);
                    $scope.canvasCtx.fillStyle = 'rgba(0,0,0, .8)';
                    $scope.canvasCtx.fillRect(x, y, width, height);
                });
            } else {
                $scope.canvasCtx.fillStyle = 'rgba(0,0,0, .8)';
                $scope.canvasCtx.fillRect($scope.coord_x, $scope.coord_y, $scope.rectWidth, $scope.rectHeight);
            }

            renderRect(rectId);

            clean();
        }

        function prepareCanvas(canvas) {
            var width = document.documentElement.clientWidth;
            var height = document.documentElement.clientHeight;

            var contentCanvas = $compile('<div class="help-screenshot-content-canvas" id="help-screenshot-content-canvas"\n                        style="width:' + width + 'px; height:' + height + 'px">\n                    <canvas id="help-screenshot-canvas" width="' + width + '" height="' + height + '"></canvas>\n                </div>')($scope);

            $scope.contentEl.prepend(contentCanvas);
            _angular2.default.element(document.getElementById('help-screenshot-content-canvas')).prepend(canvas);

            $scope.canvas = document.getElementById('help-screenshot-canvas');

            $scope.canvasCtx = $scope.canvas.getContext('2d');
            $scope.canvasCtx.fillStyle = 'rgba(0,0,0, .4)';
            $scope.canvasCtx.fillRect(0, 0, $scope.canvas.offsetWidth, $scope.canvas.offsetHeight);

            $scope.contentEl[0].addEventListener('mousedown', start);
            $scope.contentEl[0].addEventListener('mousemove', move);
            $scope.contentEl[0].addEventListener('mouseup', stop);
            $scope.contentEl[0].addEventListener('mouseleave', stop);
        }

        /**
         * Start canvas
         */
        function redrawRects() {
            $scope.rectangles.filter(function (item) {
                return item.type === 'highlight';
            }).forEach(function (item) {
                var x = item.x,
                    y = item.y,
                    height = item.height,
                    width = item.width;


                $scope.canvasCtx.clearRect(x, y, width, height);
            });

            $scope.rectangles.filter(function (item) {
                return item.type === 'hide';
            }).forEach(function (item) {
                var x = item.x,
                    y = item.y,
                    height = item.height,
                    width = item.width;


                $scope.canvasCtx.clearRect(x, y, width, height);
                $scope.canvasCtx.fillStyle = 'rgba(0,0,0, .8)';
                $scope.canvasCtx.fillRect(x, y, width, height);
            });
        }

        $scope.removeRect = function (rectId) {
            var _$scope$rectangles$fi = $scope.rectangles.filter(function (item) {
                return item.id === rectId;
            }),
                _$scope$rectangles$fi2 = _slicedToArray(_$scope$rectangles$fi, 1),
                rect = _$scope$rectangles$fi2[0];

            var index = $scope.rectangles.indexOf(rect);

            var x = rect.x,
                y = rect.y,
                width = rect.width,
                height = rect.height;


            _angular2.default.element(document.getElementById(rect.id).remove());

            $scope.canvasCtx.clearRect(x, y, width, height);
            $scope.canvasCtx.fillStyle = 'rgba(0,0,0, .4)';
            $scope.canvasCtx.fillRect(x, y, width, height);

            $scope.rectangles.splice(index, 1);

            redrawRects();
        };
        /**
         * End canvas
         */

        function onScreenshot() {
            // hide unnecessary content
            document.querySelector('.md-panel-outer-wrapper').style.display = 'none';

            // need global loader
            Loader.show();
            $scope.$applyAsync();

            (0, _html2canvas2.default)(document.querySelector('.application-container'), {
                onrendered: function onrendered(canvas) {
                    prepareContent();

                    createNavBar();

                    prepareCanvas(canvas);

                    Loader.hide();
                }
            });

            var content = $compile('<div class="help-screenshot-content" id="help-screenshot-content">\n                    <div class="help-screenshot-content-hightlights" id="screenshot-content-hightlights"></div>\n                    <div class="help-screenshot-content-hides" id="help-screenshot-content-hides"></div>\n                </div>')($scope);

            _angular2.default.element(document.body).append(content);
        }

        function renderPreview() {
            // hide unnecessary content
            document.querySelector('.md-panel-outer-wrapper').style.visibility = 'hidden';

            (0, _html2canvas2.default)(document.body, {
                onrendered: function onrendered(canvas) {
                    $scope.isPreviewRender = true;
                    $scope.currentCanvas = canvas;
                    canvas.style.width = '100%';
                    canvas.style.height = 'auto';
                    previewEl.appendChild(canvas);
                    previewEl.addEventListener('click', onScreenshot);
                    $scope.$applyAsync();
                }
            });

            // show unnecessary content
            document.querySelector('.md-panel-outer-wrapper').style.visibility = 'visible';
        }

        $scope.onDone = function () {
            $scope.rectangles = [];

            // hide unnecessary content
            _angular2.default.element(document.querySelectorAll('.help-screenshot-rect .md-icon-button')).css('display', 'none');
            _angular2.default.element(document.querySelectorAll('.help-screenshot-navbar')).css('display', 'none');

            (0, _html2canvas2.default)(document.body, {
                onrendered: function onrendered(canvas) {
                    $scope.isPreviewRender = true;
                    canvas.style.width = '100%';
                    canvas.style.height = 'auto';
                    previewEl.appendChild(canvas);
                    previewEl.addEventListener('click', onScreenshot);
                    $scope.$applyAsync();
                }
            });

            _angular2.default.element(document.querySelector('#help-screenshot-content')).remove();

            // show unnecessary content
            document.querySelector('.md-panel-outer-wrapper').style.display = 'block';
            // update preview
            _angular2.default.element(previewEl).empty();
            $scope.isPreviewRender = false;
        };

        $scope.$watch('updateScreenshot', function (value) {
            if (value) {
                renderPreview();
            }
        });
    }

    return {
        restrict: 'E',
        template: '<div class="dtHelp-screenshot__preview" dt-block-loader="!isPreviewRender"></div>',
        scope: {
            updateScreenshot: '<'
        },
        link: link
    };
}

/***/ }),

/***/ "SNdJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingStar = __webpack_require__("G4Gs");

var _thingStar2 = _interopRequireDefault(_thingStar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingStar',
    options: _thingStar2.default
};

/***/ }),

/***/ "SftN":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "SjHa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _roles = __webpack_require__("BEV6");

var _roles2 = _interopRequireDefault(_roles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * RolesApi settings
 * @type {{name: string, definition: RolesApi}}
 */
exports.default = {
  name: 'RolesApi',
  definition: _roles2.default
};

/***/ }),

/***/ "StB+":
/***/ (function(module, exports) {

module.exports = "<div class=box dt-sticky dt-sticky-from=67 dt-sticky-to=16 sticky-class=sticky container=.dt-layout-content__container> <div class=dt-thing-details__container layout=column> <div class=\"dt-thing-details__toolbar layout-row layout-align-start-center\"> <span flex></span> <md-button ui-sref=main.sensors.list class=md-icon-button> <i class=\"material-icons material-icons--s\">clear</i> </md-button> </div> <section class=dt-thing-details__info layout=column> <div class=space-m-t-n layout-margin> <section class=space-m-t-n layout=row layout-align=\"space-between center\"> <div class=flex layout=row layout-align=\"start center\"> <dt-icon icon-class=$ctrl.thing.getTypeConfig().icon icon-size=s color-class=$ctrl.thing.getNotificationConfig().color has-exclamation=$ctrl.thing.getNotificationConfig().exclamation class=\"space-m-r-s space-p-r-xs\"></dt-icon> <dt-thing-details-name name=$ctrl.thing.name on-update=$ctrl.updateThing($event)></dt-thing-details-name> </div> <div class=dt-thing-details__info-value> {{ $ctrl.thing.getNotificationConfig().color }}{{ $ctrl.thing.getStateValue() }} </div> </section> <section layout=row layout-align=\"start center\"> <div class=dt-thing-details__info-caption ng-if=!$ctrl.isUpdatedLongAgo> last reported<span class=space-m-l-s> <md-tooltip class=dt-theme>{{$ctrl.thing.state.updated | date:'MMM d, yyyy HH:mm:ss'}}</md-tooltip> {{ $ctrl.thing.state.updated | date:'HH:mm' }} </span> </div> <div class=dt-thing-details__info-caption ng-if=$ctrl.isUpdatedLongAgo> last reported<span class=space-m-l-s>{{ $ctrl.thing.state.updated | date:'MMM d, yyyy HH:mm:ss' }}</span> </div> <span flex></span> <dt-radio-status radio=$ctrl.thing.state.properties.rssi_strength></dt-radio-status> <dt-battery-status class=space-m-l-m battery=$ctrl.thing.state.properties.battery_percentage></dt-battery-status> <dt-thing-star class=space-m-l-m starred=$ctrl.thing.starred thing-id=::$ctrl.thing.id on-toggle-status=$ctrl.onChangeThingStarred($event)> </dt-thing-star> </section> </div> </section> <dt-alert-box selected-thing-id=$ctrl.thing.id></dt-alert-box> <section layout-margin layout=column> <dt-thing-details-folder folder-id=$ctrl.thing.folder.id on-update=$ctrl.updateThing($event)> </dt-thing-details-folder> <dt-thing-details-labels labels=$ctrl.thing.labels pre-update=$ctrl.processLabel($event) on-update=$ctrl.updateThing($event)> </dt-thing-details-labels> <dt-edit-thing-location layout=column class=dt-thing-details__location on-update=$ctrl.updateThing($event) location=$ctrl.thing.location thing-id=$ctrl.thing.id> </dt-edit-thing-location> <div layout=row> <dt-thing-description description=$ctrl.thing.description on-update=$ctrl.updateThing($event) class=dt-thing-details__description flex> </dt-thing-description> <dt-notes class=dt-thing-details__notes flex thing-id=$ctrl.thing.id></dt-notes> </div> <div style=height:234px> <dt-thing-details-chart ng-if=$ctrl.showChart chart-data=$ctrl.history chart-type=$ctrl.chartType></dt-thing-details-chart> </div> <div class=\"placeholder-block placeholder-block--component\"> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <dt-recent-events events=$ctrl.events></dt-recent-events> <dt-permissions owner=$ctrl.owner users=$ctrl.users></dt-permissions> </div> </section> </div> </div> ";

/***/ }),

/***/ "Swwy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _timePeriod = __webpack_require__("elwl");

var _timePeriod2 = _interopRequireDefault(_timePeriod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("hn1p");

exports.default = {
    controller: _timePeriod2.default,
    template: template
};

/***/ }),

/***/ "TGAd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PermissionsController = function () {
    function PermissionsController() {
        _classCallCheck(this, PermissionsController);
    }

    _createClass(PermissionsController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.owner) {
                this.owner = (0, _cloneDeep3.default)(changes.owner.currentValue);
            }

            if (changes.users) {
                this.users = (0, _cloneDeep3.default)(changes.users.currentValue);
            }
        }
    }]);

    return PermissionsController;
}();

exports.default = PermissionsController;

/***/ }),

/***/ "TR+I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Notifications = exports.CompanySettings = exports.AccountSettings = exports.AlertsActions = exports.DeveloperSettings = exports.UsersAndAccess = exports.FoldersAndLabels = exports.SensorsAndConnectors = exports.Dashboard = undefined;

var _dashboard = __webpack_require__("tJDh");

var Dashboard = _interopRequireWildcard(_dashboard);

var _sensorsAndConnectors = __webpack_require__("sKsN");

var SensorsAndConnectors = _interopRequireWildcard(_sensorsAndConnectors);

var _foldersAndLabels = __webpack_require__("VByS");

var FoldersAndLabels = _interopRequireWildcard(_foldersAndLabels);

var _usersAndAccess = __webpack_require__("flzX");

var UsersAndAccess = _interopRequireWildcard(_usersAndAccess);

var _developerSettings = __webpack_require__("xcRF");

var DeveloperSettings = _interopRequireWildcard(_developerSettings);

var _alertsActions = __webpack_require__("mT7A");

var AlertsActions = _interopRequireWildcard(_alertsActions);

var _accountSettings = __webpack_require__("ffSu");

var AccountSettings = _interopRequireWildcard(_accountSettings);

var _companySettings = __webpack_require__("V1ly");

var CompanySettings = _interopRequireWildcard(_companySettings);

var _notifications = __webpack_require__("TntW");

var Notifications = _interopRequireWildcard(_notifications);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.Dashboard = Dashboard;
exports.SensorsAndConnectors = SensorsAndConnectors;
exports.FoldersAndLabels = FoldersAndLabels;
exports.UsersAndAccess = UsersAndAccess;
exports.DeveloperSettings = DeveloperSettings;
exports.AlertsActions = AlertsActions;
exports.AccountSettings = AccountSettings;
exports.CompanySettings = CompanySettings;
exports.Notifications = Notifications;

/***/ }),

/***/ "TUme":
/***/ (function(module, exports) {

module.exports = "<header class=\"block-header block-header--accent\" layout=column> <md-input-container class=\"input-container--large space-m-v-n md-block\" md-no-float> <input type=text ng-model=$ctrl.rule.title placeholder=\"Name rule\"> </md-input-container> <p>When button is <b>pressed</b></p> </header> <form action=#> <dt-time-period></dt-time-period> <dt-alerts-actions-content-actions class=md-block actions=$ctrl.rule.actions></dt-alerts-actions-content-actions> </form> <footer class=block-footer> <div class=block-footer__actions-bar> <a href=# class=md-secondary ng-click=\"$ctrl.remove($event); $event.preventDefault();\"> <i class=\"material-icons material-icons--s\">delete</i> Delete this rule </a> <span flex></span> <md-button class=md-primary ng-click=$ctrl.cancel();>Cancel</md-button> <md-button class=md-primary>Save changes</md-button> </div> </footer> ";

/***/ }),

/***/ "TmhV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge2 = __webpack_require__("yubd");

var _merge3 = _interopRequireDefault(_merge2);

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapController = function () {
    /** @ngInject */
    MapController.$inject = ["$q", "EventEmitter"];
    function MapController($q, EventEmitter) {
        _classCallCheck(this, MapController);

        this.$q = $q;
        this.defer = this.$q.defer();
        this.eventEmitter = EventEmitter;
        this.geocoder = new google.maps.Geocoder();
    }

    _createClass(MapController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.handleOptions();

            this.$q.when(this.defer.promise).then(function (map) {
                google.maps.event.trigger(map, 'resize');

                var input = document.getElementById('ngMapAutocomplete');
                map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
                var autocomplete = new google.maps.places.Autocomplete(input);
                autocomplete.bindTo('bounds', map);

                map.setCenter(new google.maps.LatLng(_this.centerCoordinates.lat, _this.centerCoordinates.lng));
            });

            this.mapClickedBound = this.onMapClick.bind(this);
            this.boundsChangedBound = this.boundsChanged.bind(this);
            this.centerChangedBound = this.centerChanged.bind(this);
        }
    }, {
        key: 'handleOptions',
        value: function handleOptions() {
            this.options = {
                scrollwheel: true,
                zoom: 6
            };

            (0, _merge3.default)(this.options, this.mapOptions);
        }
    }, {
        key: 'boundsChanged',
        value: function boundsChanged() {
            if (this.map) {
                var bounds = this.map.getBounds();
                var boundsStr = bounds.toString();

                var _boundsStr$split$map = boundsStr.split(',').map(function (value) {
                    return parseFloat(value.replace(/[ ()]/g, ''));
                }),
                    _boundsStr$split$map2 = _slicedToArray(_boundsStr$split$map, 4),
                    swLat = _boundsStr$split$map2[0],
                    swLng = _boundsStr$split$map2[1],
                    neLat = _boundsStr$split$map2[2],
                    neLng = _boundsStr$split$map2[3];

                this.onBoundsChanged(this.eventEmitter({
                    bounds: {
                        southWest: {
                            lat: swLat,
                            lng: swLng
                        },
                        northEast: {
                            lat: neLat,
                            lng: neLng
                        }
                    }
                }));
            }
        }
    }, {
        key: 'centerChanged',
        value: function centerChanged() {
            if (this.map) {
                var lat = this.map.center.lat();
                var lng = this.map.center.lng();
                this.onCenterChanged(this.eventEmitter({
                    center: {
                        lat: lat,
                        lng: lng
                    }
                }));
            }
        }
    }, {
        key: 'onSearch',
        value: function onSearch(ev, $ctrl) {
            var place = this.getPlace();

            $ctrl.map.setCenter(place.geometry.location);
        }
    }, {
        key: 'onMapInitialized',
        value: function onMapInitialized(map) {
            this.defer.resolve(map);
            this.map = map;
        }
    }, {
        key: 'onMapClick',
        value: function onMapClick(ev) {
            if (this.onMarkerCoordinatesChanged) {
                this.markerCoordinatesChanged(ev);
            }
        }
    }, {
        key: 'markerCoordinatesChanged',
        value: function markerCoordinatesChanged(ev) {
            if (!this.marker) {
                this.marker = {};
            }
            this.marker.lat = ev.latLng.lat();
            this.marker.lng = ev.latLng.lng();
            this.getGeoLocation(this.marker);
        }
    }, {
        key: 'getGeoLocation',
        value: function getGeoLocation() {
            var _this2 = this;

            if (!this.marker || !this.marker.lat || !this.marker.lng) return;
            this.geocoder.geocode({ 'location': this.marker }, function (results, status) {
                if (status === 'OK') {
                    _this2.marker.address = results[0].formatted_address;
                    _this2.pushData();
                }
            });
        }
    }, {
        key: 'pushData',
        value: function pushData() {
            this.onMarkerCoordinatesChanged(this.eventEmitter({
                marker: (0, _cloneDeep3.default)(this.marker)
            }));
        }
    }]);

    return MapController;
}();

exports.default = MapController;

/***/ }),

/***/ "TntW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = undefined;

var _notifications = __webpack_require__("iNTz");

var _notifications2 = _interopRequireDefault(_notifications);

var _notifications3 = __webpack_require__("F+hJ");

var _notifications4 = _interopRequireDefault(_notifications3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__("pKWn"); // eslint-disable-line

var Component = {
    selector: 'dtNotifications',
    options: _notifications4.default
};

exports.Config = _notifications2.default;
exports.Component = Component;

/***/ }),

/***/ "TpVu":
/***/ (function(module, exports) {

module.exports = "<md-dialog class=md-dialog--m> <md-dialog-content class=md-dialog-content> <h2 class=md-dialog-title>Folders</h2> <dt-folder-selector pre-selected=$ctrl.preSelected on-change=$ctrl.onFolderChange($event)></dt-folder-selector> </md-dialog-content> <md-dialog-actions class=\"space-p-b-m space-p-r-m\"> <md-button class=md-primary ng-click=$ctrl.close()> Cancel </md-button> <md-button class=md-primary ng-click=$ctrl.submit() ng-disabled=!$ctrl.folderId> Assign sensor to this folder </md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "U0SW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingFolders = __webpack_require__("cRAP");

var _thingFolders2 = _interopRequireDefault(_thingFolders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingFolders',
    options: _thingFolders2.default
};

/***/ }),

/***/ "U7yK":
/***/ (function(module, exports) {

module.exports = " <script type=text/ng-template id=folder-level.tpl.html> <li ng-repeat=\"folder in folder.children\" ui-tree-node data-expand-on-hover=\"true\">\n        <div class=\"entity-label space-p-h-n\" ui-sref-active=\"is-active\" ui-sref=\"main.folders-and-labels.folders.folder({ folderId: folder.id })\">\n            <md-button ng-disabled=\"$ctrl.reorderMode && !folder.children\" class=\"md-button--icon space-m-r-s\" ng-click=\"toggle(); $event.stopPropagation();\" aria-label=\"Toggle\">\n                <i class=\"fa\" ng-class=\"collapsed ? 'fa-caret-right' : 'fa-caret-down'\" aria-hidden=\"true\"></i>\n            </md-button>\n\n            <div class=\"entity-label__content\" ng-class=\"{flex:!$ctrl.reorderMode}\">\n                <div class=\"entity-label__name\" title=\"{{folder.name}}\">{{ folder.name }}</div>\n            </div>\n\n            <!--<div class=\"entity-label__info\">-->\n                <!--<div class=\"entity-label__amount\">{{ folder.count }}</div>-->\n            <!--</div>-->\n\n            <div ui-tree-handle class=\"entity-label__handle\" ng-if=\"$ctrl.reorderMode\">\n                <i class=\"material-icons material-icons--s\">open_with</i>\n            </div>\n        </div>\n\n        <ol class=\"custom-list custom-list--entities\"\n            ng-include=\"'folder-level.tpl.html'\"\n            ui-tree-nodes\n            ng-model=\"folder.children\"\n            ng-class=\"{'is-hidden': collapsed}\">\n        </ol>\n    </li>\n\n    <li data-nodrag ng-show=\"!$ctrl.reorderMode\">\n        <dt-folder-tree-add-folder parent-id=\"folder.id\" on-submit=\"$ctrl.createFolder($event)\"></dt-folder-tree-add-folder>\n    </li> </script> <div class=text-right> <a href=# ng-click=\"$event.preventDefault(); $ctrl.expandAll();\">Expand all</a> / <a href=# ng-click=\"$event.preventDefault(); $ctrl.collapseAll();\">Collapse all</a> </div> <div class=folder-tree ng-init=$ctrl.initTreeScope(this); ui-tree=$ctrl.treeOptions> <dt-folder-tree-add-folder ng-if=!$ctrl.data.length on-submit=$ctrl.createFolder($event)></dt-folder-tree-add-folder> <ol ui-tree-nodes class=\"custom-list custom-list--entities\" ng-model=$ctrl.data ng-if=$ctrl.data.length> <li ng-repeat=\"folder in $ctrl.data\" ui-tree-node data-expand-on-hover=true data-collapsed=false> <div class=\"entity-label space-p-h-n\" ui-sref-active=is-active ui-sref=\"main.folders-and-labels.folders.folder({ folderId: folder.id })\"> <md-button ng-disabled=\"$ctrl.reorderMode && !folder.children\" class=\"md-button--icon space-m-r-s\" ng-click=\"toggle(); $event.stopPropagation();\" aria-label=Toggle> <i class=fa ng-class=\"collapsed ? 'fa-caret-right' : 'fa-caret-down'\" aria-hidden=true></i> </md-button> <div class=entity-label__content ng-class={flex:!$ctrl.reorderMode}> <div class=entity-label__name title={{folder.name}}>{{ folder.name }}</div> </div> <div ui-tree-handle class=entity-label__handle ng-if=$ctrl.reorderMode> <i class=\"material-icons material-icons--s\">open_with</i> </div> </div> <ol class=\"custom-list custom-list--entities\" ng-include=\"'folder-level.tpl.html'\" ui-tree-nodes ng-model=folder.children ng-class=\"{'is-hidden': collapsed}\"> </ol> </li> <li data-nodrag ng-show=!$ctrl.reorderMode> <dt-folder-tree-add-folder on-submit=$ctrl.createFolder($event)></dt-folder-tree-add-folder> </li> </ol> </div> <div ng-if=$ctrl.data.length> <md-button ng-if=!$ctrl.reorderMode ng-click=$ctrl.enableReorderMode() class=\"md-primary space-m-l-n\">Reorganize folders</md-button> <md-button ng-if=$ctrl.reorderMode ng-click=$ctrl.disableReorderMode() class=\"md-primary space-m-l-n\">Create folders</md-button> </div> ";

/***/ }),

/***/ "UAGM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * ToastService class.
 * This service is made to handle Toasts in application
 */
var ToastService = function () {
    /**
     * @param {$mdToast} $mdToast - Angular-Material $mdToast service
     * @ngInject
     * @constructor
     */
    ToastService.$inject = ["$mdToast", "TranslationService"];
    function ToastService($mdToast, TranslationService) {
        _classCallCheck(this, ToastService);

        this.toast = $mdToast;
        this.defaultText = 'Empty toast';
        this.defaultPosition = 'bottom right';
        this.defaultHideDelay = 3000;
        this.TranslationService = TranslationService;
    }

    /**
     * Show toast by given configuration
     * @param {Object} toast - Toast configuration
     * @returns {promise}
     */


    _createClass(ToastService, [{
        key: 'show',
        value: function show(toast) {
            return this.toast.show(toast);
        }

        /**
         * Create simple Toast for futher user (e.g. show later)
         * @param {{text: string, position: string, hideDelay: integer}} config - Toast configuration
         * @returns {Object} Returns $mdToast object
         */

    }, {
        key: 'createSimple',
        value: function createSimple(config) {
            return this.toast.build({
                template: '<md-toast class="dt-theme dt-animated">\n                    <div class="md-toast-content">\n                        <div>' + config.text + '</div>\n                        <span flex></span>\n                        <md-button class="md-icon-button md-action" ng-click="$ctrl.close()">\n                            <md-icon>clear</md-icon>\n                        </md-button>\n                    </div>\n                </md-toast>',
                controller: function () {
                    /** @ngInject */
                    ToastController.$inject = ["$mdToast"];
                    function ToastController($mdToast) {
                        _classCallCheck(this, ToastController);

                        this.toast = $mdToast;
                    }

                    _createClass(ToastController, [{
                        key: 'close',
                        value: function close() {
                            this.toast.hide();
                        }
                    }]);

                    return ToastController;
                }(),
                controllerAs: '$ctrl',
                position: config.position || this.defaultPosition,
                hideDelay: config.hideDelay || this.defaultHideDelay,
                bindToController: true
            });
        }
    }, {
        key: 'showSimpleTranslated',
        value: function showSimpleTranslated(textKey) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var text = this.TranslationService.getLine(textKey);
            return this.showSimpleText(text, config);
        }
    }, {
        key: 'showSimpleText',
        value: function showSimpleText(text) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            config.text = text;
            var simpleToast = this.createSimple(config);
            return this.show(simpleToast);
        }
    }]);

    return ToastService;
}();

exports.default = ToastService;

/***/ }),

/***/ "UCXy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * RemoteConfig class.
 * Use this service to manage configuration from API/Server.
 */
var RemoteConfig = function () {
    /**
     * @param {ConfigApi} ConfigApi - Configuration API service
     * @constructor
     * @ngInject
     */
    RemoteConfig.$inject = ["ConfigApi"];
    function RemoteConfig(ConfigApi) {
        _classCallCheck(this, RemoteConfig);

        this.api = ConfigApi;
        this.config = null;
        this.partner = null;
        this.things = null;
        this.notifications = null;
        this.services = null;
        this.errors = null;
    }

    /**
     * Load configuration
     * @returns {Object} Return configuration object
     */


    _createClass(RemoteConfig, [{
        key: 'loadConfig',
        value: function loadConfig() {
            var _this = this;

            return this.api.getConfig().then(function (config) {
                _this.config = config;

                _this.parseConfig();

                return config;
            });
        }

        /**
         * Parse loaded configuration for partials
         */

    }, {
        key: 'parseConfig',
        value: function parseConfig() {
            if (!this.config || !Object.keys(this.config).length) return;

            this.initPartnerConfig().initThingsConfig().initNotificationsConfig().initErrorsConfig().initServicesConfig();
        }

        /**
         * Initialize Partner configuration
         * @returns {RemoteConfig}
         */

    }, {
        key: 'initPartnerConfig',
        value: function initPartnerConfig() {
            if (this.config.partner) this.partner = (0, _cloneDeep3.default)(this.config.partner);

            return this;
        }

        /**
         * Initialize Things configuration
         * @returns {RemoteConfig}
         */

    }, {
        key: 'initThingsConfig',
        value: function initThingsConfig() {
            if (this.config.things) this.things = (0, _cloneDeep3.default)(this.config.things);

            return this;
        }

        /**
         * Initialize Notifications configuration
         * @returns {RemoteConfig}
         */

    }, {
        key: 'initNotificationsConfig',
        value: function initNotificationsConfig() {
            if (this.config.notifications) this.notifications = (0, _cloneDeep3.default)(this.config.notifications);

            return this;
        }

        /**
         * Initialize Errors configuration
         * @returns {RemoteConfig}
         */

    }, {
        key: 'initErrorsConfig',
        value: function initErrorsConfig() {
            if (this.config.errors) this.errors = (0, _cloneDeep3.default)(this.config.errors);

            return this;
        }

        /**
         * Initialize Services configuration
         * @returns {RemoteConfig}
         */

    }, {
        key: 'initServicesConfig',
        value: function initServicesConfig() {
            if (this.config.services) this.services = (0, _cloneDeep3.default)(this.config.services);

            return this;
        }

        /**
         * Get Partner configuration
         * @returns {null|object}
         */

    }, {
        key: 'getParnerConfig',
        value: function getParnerConfig() {
            return this.partner;
        }

        /**
         * Get Things configuration
         * @returns {null|object}
         */

    }, {
        key: 'getThingsConfig',
        value: function getThingsConfig() {
            return this.things;
        }

        /**
         * Get Notifications configuration
         * @returns {null|object}
         */

    }, {
        key: 'getNotificationsConfig',
        value: function getNotificationsConfig() {
            return this.notifications;
        }

        /**
         * Get Errors configuration
         * @returns {null|object}
         */

    }, {
        key: 'getErrorsConfig',
        value: function getErrorsConfig() {
            return this.errors;
        }

        /**
         * Get Services configuration
         * @returns {null|object}
         */

    }, {
        key: 'getServicesConfig',
        value: function getServicesConfig() {
            return this.services;
        }

        /**
         * Get Service configuration by service name
         * @returns {Object} Return service configuration by service name or empty object if absent
         */

    }, {
        key: 'getServiceConfig',
        value: function getServiceConfig(serviceName) {
            return this.services[serviceName] || {};
        }
    }]);

    return RemoteConfig;
}();

exports.default = RemoteConfig;

/***/ }),

/***/ "UDfw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * LabelsApi class.
 */

var LabelsApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    LabelsApi.$inject = ["$http"];
    function LabelsApi($http) {
        _classCallCheck(this, LabelsApi);

        this.$http = $http;
        this.listUrl = _utils2.default.buildApiUrl('labels.list');
    }

    /**
     * Fetch labels
     * @returns {promise}
     */


    _createClass(LabelsApi, [{
        key: 'fetch',
        value: function fetch() {
            return this.$http.get(this.listUrl).then(responseDataExtractor);
        }
    }, {
        key: 'entity',
        value: function entity(labelId) {
            var url = _utils2.default.buildApiUrl('labels.entity', { labelId: labelId });
            return this.$http.get(url).then(responseDataExtractor);
        }

        /**
         * Search labels by query
         * @param {string} query - Search pattern
         * @param {Object} metadata - Request settings, like: limit, ofset etc.
         * @returns {promise}
         */

    }, {
        key: 'search',
        value: function search(query) {
            var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.$http.get(this.listUrl, {
                params: _extends({
                    query: query + '*'
                }, metadata)
            }).then(responseDataExtractor);
        }

        /**
         * Create label
         * @param {String} name - Title of label
         * @returns {promise}
         */

    }, {
        key: 'create',
        value: function create(name) {
            return this.$http.post(this.listUrl, { name: name }).then(responseDataExtractor);
        }

        /**
         * Update label by id
         * @params {String} labelId - Label id
         * @params {String} name - Label title
         * @returns {promise}
         */

    }, {
        key: 'update',
        value: function update(labelId, name) {
            var url = _utils2.default.buildApiUrl('labels.entity', { labelId: labelId });
            return this.$http.put(url, { name: name }).then(responseDataExtractor);
        }

        /**
         * Remove label by id
         * @param {String} labelId - label id
         * @returns {promise}
         */

    }, {
        key: 'remove',
        value: function remove(labelId) {
            var url = _utils2.default.buildApiUrl('labels.entity', { labelId: labelId });
            return this.$http.delete(url).then(responseDataExtractor);
        }
    }]);

    return LabelsApi;
}();

exports.default = LabelsApi;

/***/ }),

/***/ "UGM9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopoverController = function () {
    /** @ngInject */
    PopoverController.$inject = ["AuthService", "$state"];
    function PopoverController(AuthService, $state) {
        _classCallCheck(this, PopoverController);

        this.AuthService = AuthService;
        this.$state = $state;
    }

    _createClass(PopoverController, [{
        key: '$onInit',
        value: function $onInit() {
            var authData = this.AuthService.getAuthData();

            if (authData) {
                this.userProfile = authData.profile;
            }
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            this.AuthService.signOut();
        }
    }, {
        key: 'goToAccouunt',
        value: function goToAccouunt() {
            this.$state.go('main.account-settings');
            this.onClose();
        }
    }]);

    return PopoverController;
}();

exports.default = PopoverController;

/***/ }),

/***/ "Uiye":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'state.battery';

var ThingBatteryController = function () {
    /** @ngInject */
    ThingBatteryController.$inject = ["EventEmitter"];
    function ThingBatteryController(EventEmitter) {
        _classCallCheck(this, ThingBatteryController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingBatteryController, [{
        key: '$onInit',
        value: function $onInit() {
            this.aboveValue = '';
            this.belowValue = '';
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var thingBattery = this.getThingBattery();

            if (Object.keys(thingBattery).length) {
                this.fillBucket();

                this.pushUpdate(this.eventEmitter({
                    value: thingBattery
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'getThingBattery',
        value: function getThingBattery() {
            var thingBattery = {};

            if (this.aboveValue.toString().length) {
                thingBattery.above = this.aboveValue;
            }

            if (this.belowValue.toString().length) {
                thingBattery.below = this.belowValue;
            }

            return thingBattery;
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket() {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.getThingBattery()
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            this.aboveValue = '';
            this.belowValue = '';

            this.clearBucket();
        }
    }]);

    return ThingBatteryController;
}();

exports.default = ThingBatteryController;

/***/ }),

/***/ "Ulak":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var template = __webpack_require__("vNKU");

exports.default = {
    template: template,
    transclude: true
};

/***/ }),

/***/ "Unb/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingName = __webpack_require__("xggF");

var _thingName2 = _interopRequireDefault(_thingName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("i3LK");

exports.default = {
    bindings: {
        name: '<',
        onUpdate: '&'
    },
    template: template,
    controller: _thingName2.default
};

/***/ }),

/***/ "Uoev":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeedbackFormController = function () {
    /** @ngInject */
    FeedbackFormController.$inject = ["FeedbackApi", "ToastService", "AuthService"];
    function FeedbackFormController(FeedbackApi, ToastService, AuthService) {
        _classCallCheck(this, FeedbackFormController);

        this.FeedbackApi = FeedbackApi;
        this.ToastService = ToastService;
        this.AuthService = AuthService;
    }

    _createClass(FeedbackFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isScreenshot = true;
            this.getAuthData();
            this.isRendered = true;
        }
    }, {
        key: 'getAuthData',
        value: function getAuthData() {
            var authData = this.AuthService.getAuthData();

            if (authData) {
                this.userProfile = authData.profile;
            }
        }

        /**
         * Convert image to base64
         * @param el - image element in DOM
         */

    }, {
        key: 'toBase64',
        value: function toBase64() {
            // eslint-disable-line class-methods-use-this
            var canvas = document.querySelector('.dtHelp-screenshot__preview canvas');
            if (!canvas) return '';

            return canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, '');
        }
    }, {
        key: 'send',
        value: function send() {
            var _this = this;

            this.inProgress = true;

            var image = this.toBase64();
            var feedback = {
                name: this.userProfile.name,
                email: this.feedbackFormData.email,
                subject: this.feedbackFormData.subject,
                body: this.feedbackFormData.body,
                image_base64: image
            };

            this.FeedbackApi.create(feedback).then(function () {
                _this.ToastService.showSimpleTranslated('ticket_was_submitted');
            }).catch(function () {
                _this.ToastService.showSimpleTranslated('ticket_wasnt_submitted');
            }).finally(function () {
                _this.inProgress = false;
                _this.onCancel();
            });
        }
    }]);

    return FeedbackFormController;
}();

exports.default = FeedbackFormController;

/***/ }),

/***/ "Uptj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SpecificTimeController = function SpecificTimeController(EventEmitter) {
    _classCallCheck(this, SpecificTimeController);

    this.eventEmitter = EventEmitter;
};

exports.default = SpecificTimeController;

/***/ }),

/***/ "UxZi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecentEventsController = function () {
    function RecentEventsController() {
        _classCallCheck(this, RecentEventsController);
    }

    _createClass(RecentEventsController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.events) {
                this.events = (0, _cloneDeep3.default)(changes.events.currentValue);
            }
        }
    }]);

    return RecentEventsController;
}();

exports.default = RecentEventsController;

/***/ }),

/***/ "V/ns":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-grid__col form-grid__col8\"> <label class=md-body-1>Owner</label> </div> <div class=form-grid__col> <md-chips class=dt-chips ng-model=$ctrl.users md-autocomplete-snap md-transform-chip=$ctrl.transformChip($chip) md-require-match=$ctrl.autocompleteRequireMatch md-on-add=$ctrl.onChange() md-on-remove=$ctrl.onChange()> <md-autocomplete md-search-text=$ctrl.query md-items=\"item in $ctrl.searchUsers($ctrl.query)\" md-item-text=item.fullName md-delay=$ctrl.blurTime md-no-cache> <span md-highlight-text=$ctrl.query>{{item.fullName}}, {{item.email}}</span> </md-autocomplete> <md-chip-template> <div class=md-contact-avatar> <img ng-src=\"{{ $chip.image }}\" alt=\"{{ $chip.fullName }}\" ng-if=$chip.image /> </div> <div class=md-contact-name>{{ $chip.fullName }}</div> </md-chip-template> </md-chips> </div> <div class=\"form-grid__col form-grid__col12\"> <dt-help-icon message-key=help_icon_advanced_search_owner></dt-help-icon> </div>";

/***/ }),

/***/ "V0Iz":
/***/ (function(module, exports) {

module.exports = "<div class=hint ng-class=\"{'is-visible': $ctrl.showSelectAllHint}\"> <div class=hint__content layout=row layout-align=\"center center\"> <div ng-class=\"{'is-active': !$ctrl.allSelected}\" ng-click=$ctrl.toggleAllSelected(false) class=hint__item layout=column layout-align=\"center center\"> <span class=md-caption>Select only these {{ $ctrl.selected.length }} items visible</span> </div> <div ng-class=\"{'is-active': $ctrl.allSelected}\" ng-click=$ctrl.toggleAllSelected(true) class=hint__item layout=column layout-align=\"center center\"> <span class=md-caption>Select all {{ $ctrl.metadata.total }} items matching query</span> </div> <md-button class=md-icon-button ng-click=$ctrl.hideSelectAllHint()> <i class=material-icons>clear</i> </md-button> </div> </div> <md-table-container class=\"table-container sensor-table\"> <table md-table md-row-select multiple=true ng-model=$ctrl.selected> <thead md-head md-order=$ctrl.order md-on-reorder=$ctrl.onReorderBinded> <tr md-row> <th md-column class=\"text-center table-header dt-favorite sensor-table__cell-xs\"> <md-icon md-svg-icon=star aria-label=starred aria-hidden=true></md-icon> </th> <th md-column class=\"table-header column-width--xs\" style=width:24px><span class=text-uppercase>type</span></th> <th md-custom-column md-order-by=name class=table-header style=width:140px><span class=text-uppercase>name</span></th> <th md-column md-numeric class=\"text-uppercase table-header column-width--s\"> <span>state</span> </th> <th md-column class=\"table-header column-width--m\"> <span class=text-uppercase>location & folder</span> </th> <th md-custom-column md-order-by=state.updated md-desc=true class=table-header style=width:120px><span class=text-uppercase>last reported</span></th> <th md-custom-column class=table-header style=width:36px md-order-by=state.properties.battery_percentage> <i class=\"fa fa-battery-full\" aria-hidden=true style=font-size:12px></i> </th> <th md-custom-column class=table-header style=width:36px md-order-by=state.properties.rssi_strength> <i class=\"fa fa-signal\" aria-hidden=true style=font-size:16px></i> </th> </tr> </thead> <tbody md-body> <tr md-row md-select=thing md-select-id=id ui-sref-active=md-row-active ui-sref=\"main.sensors.list.thing({thingId: thing.id})\" ng-repeat=\"thing in $ctrl.things track by thing.id\"> <td md-cell class=\"text-center dt-favorite\"> <div class=md-cell__wrap> <dt-thing-star starred=thing.starred thing-id=::thing.id on-toggle-status=\"$ctrl.onChangeThingStarred($event, thing)\"></dt-thing-star> </div> </td> <td md-cell> <div class=md-cell__wrap> <dt-icon icon-size=s icon-class=::thing.getTypeConfig().icon></dt-icon> </div> </td> <td md-cell class=\"md-cell thing-name-cell cell-{{::thing.id}}-name\"> <div class=md-cell__wrap> <p class=dt-thing_name>{{ thing.name }}</p> </div> </td> <td md-cell class=\"md-cell cell-{{::thing.id}}-state\"> <div class=md-cell__wrap> <div class=text-state> {{ thing.getStateValue() }} </div> </div> </td> <td md-cell class=\"md-cell space-p-l-n\" get-width=cellWidth> <div layout=row layout-align=\"start center\" class=md-cell__wrap> <div class=\"text-center u-width-48\" style=min-width:48px> <md-icon ng-if=$ctrl.hasLocation(thing.location) ng-click=\"$ctrl.showLocation($event, thing.location); $event.stopPropagation();\" class=\"material-icons cursor-pointer space-m-h-n location_marker\">location_on</md-icon> </div> <dt-folder-path folder-id=thing.folder.id max-width=cellWidth-60 font-size=12></dt-folder-path> </div> </td> <td md-cell> <div class=md-cell__wrap am-time-ago=thing.state.updated> <md-tooltip class=dt-theme>{{thing.state.updated | date:'MMM d, yyyy HH:mm:ss'}}</md-tooltip> </div> </td> <td md-cell class=\"md-cell cell-{{::thing.id}}-battery_percentage\"> <div class=md-cell__wrap> <dt-battery-status battery=thing.state.properties.battery_percentage></dt-battery-status> </div> </td> <td md-cell class=\"md-cell cell-{{::thing.id}}-rssi_strength\"> <div class=md-cell__wrap> <dt-radio-status radio=thing.state.properties.rssi_strength></dt-radio-status> </div> </td> </tr> </tbody> </table> </md-table-container> ";

/***/ }),

/***/ "V1ly":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = undefined;

var _companySettings = __webpack_require__("M/Jo");

var _companySettings2 = _interopRequireDefault(_companySettings);

var _companySettings3 = __webpack_require__("5kxK");

var _companySettings4 = _interopRequireDefault(_companySettings3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtCompanySettings',
    options: _companySettings4.default
};

exports.Config = _companySettings2.default;
exports.Component = Component;

/***/ }),

/***/ "VB4T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dragDrop = __webpack_require__("D6f4");

var _dragDrop2 = _interopRequireDefault(_dragDrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtDrag',
    options: _dragDrop2.default
};

/***/ }),

/***/ "VByS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = exports.Labels = exports.Folders = undefined;

var _folders = __webpack_require__("1wn3");

var Folders = _interopRequireWildcard(_folders);

var _labels = __webpack_require__("Pnr7");

var Labels = _interopRequireWildcard(_labels);

var _foldersAndLabels = __webpack_require__("lHsQ");

var _foldersAndLabels2 = _interopRequireDefault(_foldersAndLabels);

var _foldersAndLabels3 = __webpack_require__("5XkD");

var _foldersAndLabels4 = _interopRequireDefault(_foldersAndLabels3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Component = {
    selector: 'dtFoldersAndLabels',
    options: _foldersAndLabels4.default
};

exports.Folders = Folders;
exports.Labels = Labels;
exports.Config = _foldersAndLabels2.default;
exports.Component = Component;

/***/ }),

/***/ "VLtw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FolderSelectorController = function () {
    /** @ngInject */
    FolderSelectorController.$inject = ["EventEmitter", "FolderService", "$scope"];
    function FolderSelectorController(EventEmitter, FolderService, $scope) {
        _classCallCheck(this, FolderSelectorController);

        this.eventEmitter = EventEmitter;
        this.FolderService = FolderService;
        this.$scope = $scope;
    }

    _createClass(FolderSelectorController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.data = this.FolderService.getTree();
            this.expandedByDefault = {};
            this.selected = {};

            if (this.preSelected && this.preSelected.length) {
                this.preSelected.forEach(function (folderId) {
                    _this.selected[folderId] = true;
                });
                this.makePreSelectedExpanded();
            }
            this.searchIndex = this.prepareSearchIndex();

            this.$scope.$watch('$ctrl.expandSelected', function (value) {
                if (value) {
                    _this.collapseAll();
                    Object.keys(_this.selected).forEach(function (folderId) {
                        _this.expandFolderPath(folderId);
                    });
                    _this.expandSelected = false;
                }
            });
        }
    }, {
        key: 'expandAll',
        value: function expandAll() {
            this.$scope.$broadcast('angular-ui-tree:expand-all');
        }
    }, {
        key: 'collapseAll',
        value: function collapseAll() {
            this.$scope.$broadcast('angular-ui-tree:collapse-all');
        }
    }, {
        key: 'makePreSelectedExpanded',
        value: function makePreSelectedExpanded() {
            var _this2 = this;

            this.preSelected.forEach(function (folderId) {
                var folderPath = _this2.FolderService.buildFolderPath(folderId);
                folderPath.forEach(function (folder) {
                    _this2.expandedByDefault[folder.id] = true;
                });
            });
        }
    }, {
        key: 'prepareSearchIndex',
        value: function prepareSearchIndex() {
            var _this3 = this;

            var data = [];
            Object.keys(this.FolderService.folderMap).forEach(function (folderId) {
                var folderPath = _this3.FolderService.buildFolderPath(folderId);
                var name = folderPath.map(function (folder) {
                    return folder.name;
                }).join(' > ');
                data.push({
                    id: folderId,
                    name: name
                });
            });
            return _utils2.default.buildSearchIndex(data);
        }
    }, {
        key: 'onSearch',
        value: function onSearch(_ref) {
            var query = _ref.query;

            return _utils2.default.searchInIndex(this.searchIndex, query);
        }
    }, {
        key: 'onFolderFound',
        value: function onFolderFound(_ref2) {
            var item = _ref2.item;

            if (item) {
                this.collapseAll();
                var folder = this.FolderService.getFolder(item.id);
                this.selectFolder(folder);
                this.expandFolderPath(folder.id);
            }
        }
    }, {
        key: 'initTreeScope',
        value: function initTreeScope(scope) {
            this.treeScope = scope;
        }
    }, {
        key: 'expandFolderPath',
        value: function expandFolderPath(folderId) {
            if (this.treeScope.$nodesScope) {
                var folderPath = this.FolderService.buildFolderPath(folderId);
                folderPath.reduce(function (parentScope, folder) {
                    var childNodes = parentScope.childNodes();

                    var _childNodes$filter = childNodes.filter(function (_ref3) {
                        var $modelValue = _ref3.$modelValue;
                        return $modelValue && $modelValue.id === folder.id;
                    }),
                        _childNodes$filter2 = _slicedToArray(_childNodes$filter, 1),
                        scope = _childNodes$filter2[0];

                    if (scope) {
                        scope.expand();
                    }
                    return scope;
                }, this.treeScope.$nodesScope);
            }
        }
    }, {
        key: 'selectFolder',
        value: function selectFolder(folder) {
            var _this4 = this;

            var isDblClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!this.multiSelect) {
                Object.keys(this.selected).forEach(function (folderId) {
                    delete _this4.selected[folderId];
                });
            }
            if (this.selected[folder.id]) {
                delete this.selected[folder.id];
            } else {
                this.selected[folder.id] = true;
            }
            this.changed(isDblClicked);
        }
    }, {
        key: 'changed',
        value: function changed(dblClicked) {
            var eventData = {
                dblClicked: dblClicked
            };
            var folderIds = Object.keys(this.selected);
            if (this.multiSelect) {
                eventData.folderIds = folderIds;
            } else {
                eventData.folderId = folderIds.length ? folderIds[0] : null;
            }
            this.onChange(this.eventEmitter(eventData));
        }
    }]);

    return FolderSelectorController;
}();

exports.default = FolderSelectorController;

/***/ }),

/***/ "VaJM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpMenu = __webpack_require__("n2Z8");

var _helpMenu2 = _interopRequireDefault(_helpMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Acgv");

exports.default = {
    bindings: {
        mdPanelRef: '<'
    },
    controller: _helpMenu2.default,
    template: template
};

/***/ }),

/***/ "VhMM":
/***/ (function(module, exports) {

module.exports = "<form name=$ctrl.labelForm novalidate class=\"content-box folder-details\" dt-sticky dt-sticky-from=62 dt-sticky-to=16 sticky-class=sticky container=.dt-layout-content__container> <div class=content-box__header layout-gt-xs=row layout-xs=column layout-align-xs=stretch layout-wrap layout-padding> <div class=\"content-block space-p-r-m\" flex> <md-input-container class=\"md-block input-container--large space-m-b-s space-m-t-n\"> <input name=name ng-model=$ctrl.label.name type=text aria-label=\"label name\" required autocomplete=off ng-change=$ctrl.validateLabel()> <div class=md-input-hint>ID: {{ $ctrl.label.id }}</div> <div ng-messages=$ctrl.labelForm.name.$error> <div ng-message=required>The label must have a name.</div> <div ng-message=unique> This label already exists. Please choose a different name.</div> </div> </md-input-container> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-s> <span class=\"icons icons--l\"> <md-icon md-svg-icon=sensor-blank aria-hidden=true></md-icon> </span> </dt-icon> <a ui-sref=\"main.sensors.list({q: $ctrl.searchQuery})\" class=space-m-h-s> <md-icon class=\"material-icons material-icons--s\">search</md-icon> Show sensors </a> </div> </div> </div> <footer class=content-box__footer style=border-top:none> <a href=# class=md-secondary ng-click=\"$ctrl.showDeleteConfirmation(); $event.preventDefault()\"> <i class=\"material-icons material-icons--s\">delete</i> Delete label </a> <span flex></span> <md-button class=md-primary ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=md-primary ng-click=$ctrl.save() ng-disabled=$ctrl.labelForm.$invalid>Save changes</md-button> </footer> </form>";

/***/ }),

/***/ "VzBS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LeftNavigationController = function () {
    function LeftNavigationController() {
        _classCallCheck(this, LeftNavigationController);

        this.collapsed = false;
    }

    _createClass(LeftNavigationController, [{
        key: "toggle",
        value: function toggle() {
            this.collapsed = !this.collapsed;
            if (this.onToggle) {
                this.onToggle({
                    isCollapsed: this.collapsed
                });
            }
        }
    }, {
        key: "isCollapsed",
        get: function get() {
            return this.collapsed;
        }
    }]);

    return LeftNavigationController;
}();

exports.default = LeftNavigationController;

/***/ }),

/***/ "W13y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/alerts-actions.json";

/***/ }),

/***/ "W1Kw":
/***/ (function(module, exports) {

module.exports = "<md-tabs class=dt-theme flex md-selected=$ctrl.selectedTabId ng-if=$ctrl.tabs.length> <md-tab ng-repeat=\"(tabId, tab) in $ctrl.tabs track by $index\" ng-if=tab.title ng-disabled=tab.disabled ng-click=\"$ctrl.onClick(tab, $event)\" md-active=tab.isActive md-on-select=\"$ctrl.onSelect(tab, $event)\" md-on-deselect=\"$ctrl.onDeselect(tab, $event)\"> <md-tab-label> <md-icon class=material-icons ng-if=tab.icon> {{ tab.icon }} </md-icon> <md-menu ng-if=\"tab.items && tab.items.length\"> <i class=material-icons ng-click=$mdMenu.open($event)> arrow_drop_down </i> <md-menu-content> <md-menu-item ng-repeat=\"item in tab.items track by $index\"> <md-button ng-click=\"$ctrl.onMenuItemClick(tab, tabId, item, $event)\" aria-label=\"{{ item.title }}\"> <md-icon class=material-icons ng-if=item.icon> {{ item.icon }} </md-icon> {{ item.title }} </md-button> </md-menu-item> </md-menu-content> </md-menu> <span class=tab-title>{{ tab.title }}</span> </md-tab-label> </md-tab> </md-tabs> ";

/***/ }),

/***/ "W6Gc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _userPopover = __webpack_require__("nH1p");

var _userPopover2 = _interopRequireDefault(_userPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtUserPopover',
    options: _userPopover2.default
};

/***/ }),

/***/ "WBbd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingLocation = __webpack_require__("EZyF");

var _thingLocation2 = _interopRequireDefault(_thingLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("ldQf");

exports.default = {
    bindings: {
        thingId: '<',
        location: '<',
        onUpdate: '&'
    },
    template: template,
    controller: _thingLocation2.default
};

/***/ }),

/***/ "WCDB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdvancedSearch = exports.SimpleSearchComponent = undefined;

var _simple = __webpack_require__("jkOr");

var _simple2 = _interopRequireDefault(_simple);

var _advanced = __webpack_require__("94vt");

var AdvancedSearch = _interopRequireWildcard(_advanced);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SimpleSearchComponent = _simple2.default;
exports.AdvancedSearch = AdvancedSearch;

/***/ }),

/***/ "WMEc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingChart = __webpack_require__("/MXH");

var _thingChart2 = _interopRequireDefault(_thingChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("ocvI");

__webpack_require__("HqL4");
__webpack_require__("3FGJ");

exports.default = {
    bindings: {
        thing: '<',
        eventReceived: '<'
    },
    template: template,
    controller: _thingChart2.default
};

/***/ }),

/***/ "WRGe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extend2 = __webpack_require__("iyRQ");

var _extend3 = _interopRequireDefault(_extend2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Customer class.
 */
var Customer =
/**
 * @param {Object} data - Customer data
 * @constructor
 */
function Customer(data) {
  _classCallCheck(this, Customer);

  (0, _extend3.default)(this, data);

  this.fullName = this.fullName || this.first_name + ' ' + this.last_name;
};

exports.default = Customer;

/***/ }),

/***/ "WT14":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


graphsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = graphsRouter;
/** @ngInject */
function graphsRouter($stateProvider) {
    var baseState = {
        url: '/sensors-and-connectors/graphs',
        component: 'dtGraphs'
    };

    $stateProvider.state('main.sensors.graphs', baseState);
}

/***/ }),

/***/ "WUsz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'devices';

var ThingTypeController = function () {
    /** @ngInject */
    ThingTypeController.$inject = ["EventEmitter", "ThingsService"];
    function ThingTypeController(EventEmitter, ThingsService) {
        _classCallCheck(this, ThingTypeController);

        this.eventEmitter = EventEmitter;
        this.ThingsService = ThingsService;
    }

    _createClass(ThingTypeController, [{
        key: '$onInit',
        value: function $onInit() {
            this.types = [];
            this.things = this.ThingsService.getAllThings();
            this.typesMap = {};
            this.typesRulesMap = {};
            this.createTypesMap();
            this.createTypesRulesMap();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'createTypesMap',
        value: function createTypesMap() {
            var _this = this;

            this.things.forEach(function (thing) {
                _this.typesMap[thing.type] = false;
            });
        }
    }, {
        key: 'createTypesRulesMap',
        value: function createTypesRulesMap() {
            var _this2 = this;

            this.things.forEach(function (thing) {
                if (thing.rules && thing.rules.items && thing.rules.items.length) {
                    var value = {};

                    _this2.typesRulesMap[thing.type] = value;

                    thing.rules.items.forEach(function (rule) {
                        if (rule.items) {
                            rule.items.forEach(function (subrule) {
                                value[subrule.name] = {
                                    value: rule.type === 'input' ? '' : false
                                };
                                value[subrule.name].defaultValue = value[subrule.name].value;
                            });
                        } else {
                            value[rule.name] = {
                                value: rule.type === 'input' ? '' : false
                            };
                            value[rule.name].defaultValue = value[rule.name].value;
                        }
                    });
                }
            });
        }
    }, {
        key: 'toggle',
        value: function toggle(thing) {
            var currentState = this.typesMap[thing.type] || false;
            var newState = !currentState;

            if (!newState) {
                var typesLength = this.types.length;

                for (var i = 0; i < typesLength; ++i) {
                    if (this.types[i].type === thing.type) {
                        this.types.splice(i, 1);
                        break;
                    }
                }
            } else {
                this.types.push({ type: thing.type });
            }

            this.typesMap[thing.type] = newState;
            this.onChange();
        }
    }, {
        key: 'parseValueFormat',
        value: function parseValueFormat(format) {
            // eslint-disable-line class-methods-use-this
            return format.replace('%s', '').trim();
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var thingTypes = this.getThingTypes();

            if (thingTypes.length) {
                this.fillBucket(thingTypes);

                this.pushUpdate(this.eventEmitter({
                    value: thingTypes
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'getThingTypes',
        value: function getThingTypes() {
            var _this3 = this;

            if (!this.types.length) {
                return [];
            }

            var types = [];

            this.types.forEach(function (thing) {
                if (thing.type in _this3.typesMap && _this3.typesMap[thing.type] === true) {
                    var thingType = {
                        type: thing.type
                    };

                    if (thing.type in _this3.typesRulesMap) {
                        var rules = _this3.typesRulesMap[thing.type];
                        Object.keys(rules).forEach(function (ruleName) {
                            if (rules[ruleName].value === true || rules[ruleName].value.length) {
                                if (!('state' in thingType)) {
                                    thingType.state = {};
                                }
                                thingType.state[ruleName] = rules[ruleName].value;
                            }
                        });
                    }

                    types.push(thingType);
                }
            });

            return types;
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket(thingTypes) {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: thingTypes || this.getThingTypes()
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            this.types = [];
            this.typesMap = {};
            this.typesRulesMap = {};
            this.createTypesMap();
            this.createTypesRulesMap();

            this.clearBucket();
        }
    }]);

    return ThingTypeController;
}();

exports.default = ThingTypeController;

/***/ }),

/***/ "WWbn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingUpdated = __webpack_require__("Odso");

var _thingUpdated2 = _interopRequireDefault(_thingUpdated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("bRow");

exports.default = {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingUpdated2.default
};

/***/ }),

/***/ "WXL7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Routes = exports.Component = undefined;

var _graphs = __webpack_require__("WT14");

var _graphs2 = _interopRequireDefault(_graphs);

var _graphs3 = __webpack_require__("nQjj");

var _graphs4 = _interopRequireDefault(_graphs3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtGraphs',
    options: _graphs4.default
};

exports.Component = Component;
exports.Routes = _graphs2.default;

/***/ }),

/***/ "WaeA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingLabels = __webpack_require__("zFAJ");

var _thingLabels2 = _interopRequireDefault(_thingLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingLabels',
    options: _thingLabels2.default
};

/***/ }),

/***/ "Wavz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("jGr0"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * NavigationService class.
 */

var NavigationService = function () {
    /** @ngInject */
    NavigationService.$inject = ["$q", "ViewsApi", "CategoriesApi"];
    function NavigationService($q, ViewsApi, CategoriesApi) {
        _classCallCheck(this, NavigationService);

        this.$q = $q;
        this.ViewsApi = ViewsApi;
        this.CategoriesApi = CategoriesApi;
    }

    /**
     * Get Sensors and Connectors navigation data
     * @returns {promise}
     */


    _createClass(NavigationService, [{
        key: 'getSensorsAndConnectors',
        value: function getSensorsAndConnectors() {
            return this.$q.all({
                views: this.ViewsApi.getList({
                    page_size: 100
                }),
                categories: this.CategoriesApi.getList({
                    page_size: 100
                })
            }).then(function (_ref) {
                var views = _ref.views,
                    categories = _ref.categories;

                var objects = [];
                var viewsArr = views.views || [];
                var categoriesArr = categories.categories || [];
                var categoriesMap = {};
                var usedCategories = [];

                categoriesArr.forEach(function (category) {
                    category.type = 'CATEGORY';
                    categoriesMap[category.id] = category;
                });

                viewsArr.forEach(function (view) {
                    view.type = 'VIEW';
                    if (view.category_id && categoriesMap[view.category_id]) {
                        var category = categoriesMap[view.category_id];
                        if (!category.children) {
                            category.children = [];
                        }
                        category.children.push(view);
                        if (category.children.length === 1) {
                            objects.push(category);
                        }
                        usedCategories.push(category.id);
                    } else {
                        objects.push(view);
                    }
                });

                Object.keys(categoriesMap).filter(function (id) {
                    return usedCategories.indexOf(id) < 0;
                }).forEach(function (id) {
                    objects.push(categoriesMap[id]);
                });

                return { objects: objects };
            });

            // return this.$http.get(this.config.sensorsAndConnectorsUrl).then(responseDataExtractor);
        }

        /**
         * Update Sensors and Connectors navigation data
         * @param {Array<Object>} objects - Objects to be saved as Sensors and Connectors navigation data
         * @returns {promise}
         */

    }, {
        key: 'updateSensorsAndConnectors',
        value: function updateSensorsAndConnectors(objects) {
            return this.$http.put(this.config.sensorsAndConnectorsUrl, { objects: objects }).then(responseDataExtractor);
        }
    }]);

    return NavigationService;
}();

exports.default = NavigationService;

/***/ }),

/***/ "Werf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rule = __webpack_require__("4jHz");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("etko");

exports.default = {
    bindings: {
        rule: '<'
    },
    controller: _rule2.default,
    template: template
};

/***/ }),

/***/ "Ww8C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _backdrop = __webpack_require__("fcPR");

var _backdrop2 = _interopRequireDefault(_backdrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtBackdrop',
    options: _backdrop2.default
};

/***/ }),

/***/ "WxCw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


alertsAndActionsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = alertsAndActionsRouter;

var _alertsActions = __webpack_require__("mT7A");

/** @ngInject */
function alertsAndActionsRouter($stateProvider) {
    var baseState = {
        url: '/alerts-actions',
        views: {
            content: {
                component: _alertsActions.Component.selector
            }
        }
    };

    $stateProvider.state('main.alerts-actions', baseState);
}

/***/ }),

/***/ "X26P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = __webpack_require__("eNGi");

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * EventsApi settings
 * @type {{name: string, definition: EventsApi}}
 */
exports.default = {
  name: 'EventsApi',
  definition: _events2.default
};

/***/ }),

/***/ "X2ui":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mdCustomColumn = __webpack_require__("GtqN");

var _mdCustomColumn2 = _interopRequireDefault(_mdCustomColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'mdCustomColumn',
    options: _mdCustomColumn2.default
};

/***/ }),

/***/ "X995":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _roleUsers = __webpack_require__("NgYl");

var _roleUsers2 = _interopRequireDefault(_roleUsers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtRoleUsers',
    options: _roleUsers2.default
};

/***/ }),

/***/ "XEyd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recentEvents = __webpack_require__("UxZi");

var _recentEvents2 = _interopRequireDefault(_recentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("LzqP");

exports.default = {
    bindings: {
        events: '<'
    },
    template: template,
    controller: _recentEvents2.default
};

/***/ }),

/***/ "XHK+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoaderType = {
    LINE: 'progress-linear'
};

var LoaderController = function () {
    /** @ngInject */
    LoaderController.$inject = ["Loader"];
    function LoaderController(Loader) {
        _classCallCheck(this, LoaderController);

        this.Loader = Loader;
    }

    _createClass(LoaderController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.loaderType) {
                this.loaderType = LoaderType.LINE;
            }
            this.showLoader = false;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.loaderType) {
                this.loaderType = (0, _cloneDeep3.default)(changes.loaderType.currentValue);
            }
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            return this.Loader.isShowLoader();
        }
    }]);

    return LoaderController;
}();

exports.default = LoaderController;

/***/ }),

/***/ "XK6R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__("aeQg");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContentHeaderController = function () {
    /** @ngInject */
    ContentHeaderController.$inject = ["$mdPanel"];
    function ContentHeaderController($mdPanel) {
        _classCallCheck(this, ContentHeaderController);

        this.$mdPanel = $mdPanel;
    }

    _createClass(ContentHeaderController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.stateTitle) {
                this.stateTitle = 'Specify State Title';
            }
        }
    }, {
        key: 'showHelpMenu',
        value: function showHelpMenu(ev) {
            var _this = this;

            this.isActive = true;

            var mdPanel = this.$mdPanel;

            var panelPosition = mdPanel.newPanelPosition().relativeTo(ev.target).addPanelPosition(mdPanel.xPosition.ALIGN_END, mdPanel.yPosition.BELOW);

            var config = {
                attachTo: _angular2.default.element(document.querySelector('.application-container')),
                controller: function controller() {},
                controllerAs: '$ctrl',
                template: '<dt-help-menu md-panel-ref="$ctrl.mdPanelRef"></dt-help-menu>',
                targetEvent: ev,
                panelClass: 'md-panel--arrow-top',
                position: panelPosition,
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true,
                onRemoving: function onRemoving() {
                    _this.isActive = false;
                }
            };

            mdPanel.open(config);
        }
    }]);

    return ContentHeaderController;
}();

exports.default = ContentHeaderController;

/***/ }),

/***/ "Xe80":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("sMLS"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

var AuthUsersApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    AuthUsersApi.$inject = ["$http"];
    function AuthUsersApi($http) {
        _classCallCheck(this, AuthUsersApi);

        this.$http = $http;
        this.config = _local2.default.api.authUsers;
    }

    /**
     * Get AuthUsers
     * @returns {promise}
     */


    _createClass(AuthUsersApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }

        /**
         * Search AuthUsers by query
         * @param {string} query - Search pattern
         * @param {Object} metadata - Request settings, like: limit, ofset etc.
         * @returns {promise}
         */

    }, {
        key: 'search',
        value: function search(query) {
            var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.$http.get(this.config.searchUrl, {
                params: _extends({
                    query: query + '*'
                }, metadata)
            }).then(responseDataExtractor);
        }
    }]);

    return AuthUsersApi;
}();

exports.default = AuthUsersApi;

/***/ }),

/***/ "Xmc5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingNotes = __webpack_require__("4OjK");

var _thingNotes2 = _interopRequireDefault(_thingNotes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingNotes',
    options: _thingNotes2.default
};

/***/ }),

/***/ "XndK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _oidcClient = __webpack_require__("tE9h");

var _auth = __webpack_require__("c/HW");

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = function () {
    function AuthService() {
        var _this = this;

        _classCallCheck(this, AuthService);

        this.client = new _oidcClient.UserManager(_auth2.default);
        this.authData = null;

        this.client.events.addAccessTokenExpiring(function () {
            _this.silentLogin().catch(function () {
                _this.login();
            });
        });

        this.storeUser = this.storeUser.bind(this);
    }

    _createClass(AuthService, [{
        key: 'getUser',
        value: function getUser() {
            return this.client.getUser().then(this.storeUser);
        }
    }, {
        key: 'storeUser',
        value: function storeUser(data) {
            this.authData = data;
            return data;
        }
    }, {
        key: 'getAuthData',
        value: function getAuthData() {
            return this.authData;
        }
    }, {
        key: 'getAccessToken',
        value: function getAccessToken() {
            if (this.authData) {
                return this.authData.access_token;
            }
            return null;
        }
    }, {
        key: 'login',
        value: function login() {
            return this.client.signinRedirect();
        }
    }, {
        key: 'silentLogin',
        value: function silentLogin() {
            return this.client.signinSilent().then(this.storeUser);
        }
    }, {
        key: 'authorize',
        value: function authorize() {
            return this.client.signinRedirectCallback().then(this.storeUser);
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            this.client.signoutRedirect();
        }
    }]);

    return AuthService;
}();

exports.default = AuthService;

/***/ }),

/***/ "Xq0/":
/***/ (function(module, exports) {

module.exports = "<div layout-gt-xs=row layout-xs=column layout-align-gt-xs=\"start start\" layout-margin flex layout-wrap> <div class=content-box flex-gt-xs=30 flex-xs-auto layout-padding> <div> <h3 class=\"box-title space-m-t-n\">Labels</h3> <dt-search-autocomplete placeholder=\"Search labels\" text-key=name on-selected=$ctrl.onLabelFound($event) on-search=$ctrl.onSearch($event)></dt-search-autocomplete> <a href=# class=\"md-block space-m-v-m\" ng-click=\"$ctrl.showCreateForm(); $event.preventDefault();\" ng-if=$ctrl.isCreateBtn> <md-icon class=\"material-icons material-icons--s\">add</md-icon> Create new label </a> <form class=\"entity-label__create space-m-v-m space-p-t-s\" md-theme=dark dt-block-loader=$ctrl.processing name=$ctrl.addLabelForm ng-submit=$ctrl.submit() ng-if=$ctrl.isCreateForm> <md-content class=space-p-h-s> <md-input-container class=md-block> <label>Label Name</label> <input type=text aria-label=\"label name\" name=name required autocomplete=off ng-model=$ctrl.name ng-change=$ctrl.validateName($ctrl.name)> <div ng-messages=$ctrl.addLabelForm.name.$error> <div ng-message=required>Label name is required.</div> <div ng-message=unique>Name of label should be unique.</div> </div> </md-input-container> <div layout=row layout-align=\"end center\"> <md-button class=space-m-h-n ng-click=$ctrl.showCreateBtn() aria-label=Cancel>cancel</md-button> <md-button type=submit class=space-m-h-n ng-disabled=$ctrl.addLabelForm.$invalid aria-label=Add>Add</md-button> </div> </md-content> </form> <dt-entities-list selected-entity-id=$ctrl.currentLabel.id on-entity-created=$ctrl.create($event) entities=$ctrl.labels entity-type=label entity-state=\"main.folders-and-labels.labels.label({labelId: entity.id})\"> </dt-entities-list> </div> </div> <ui-view on-saved=$ctrl.saveLabel($event) on-deleted=$ctrl.deleteLabel($event) on-edit-cancelled=$ctrl.cancelEdit() on-name-change=$ctrl.validateLabel($event) flex></ui-view> <dt-empty-state ng-if=\"!$ctrl.labels.length && $ctrl.labelsLoaded\" state={{$ctrl.$state.current.name}}></dt-empty-state> </div> ";

/***/ }),

/***/ "Xs8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingRegistered = __webpack_require__("fNck");

var _thingRegistered2 = _interopRequireDefault(_thingRegistered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("zxh4");

exports.default = {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingRegistered2.default
};

/***/ }),

/***/ "Xt60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _onEnter = __webpack_require__("1j4k");

var _onEnter2 = _interopRequireDefault(_onEnter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'onEnter',
    options: _onEnter2.default
};

/***/ }),

/***/ "YIC/":
/***/ (function(module, exports) {

module.exports = "<script type=text/ng-template id=generic-messages.html> <div ng-repeat=\"item in $ctrl.genericErrors track by $index\" ng-message-exp=\"item.type\">\n        {{ item.message }}\n    </div> </script> <md-dialog flex=30> <md-dialog-content class=md-dialog-content> <h2 class=md-dialog-title>Add Comment</h2> <form name=newNoteForm novalidate> <md-input-container class=md-block> <label>Add new comment</label> <textarea name=new_note id=new_note ng-model=$ctrl.newNote md-autofocus required></textarea> <div ng-if=newNoteForm.new_note.$touched ng-messages=newNoteForm.new_note.$error> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> </form> </md-dialog-content> <md-dialog-actions class=\"space-p-r-m space-p-b-s\"> <md-button class=md-primary ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=md-primary ng-disabled=newNoteForm.$invalid ng-click=$ctrl.addNote()>Add</md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "YKAe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emptyState = __webpack_require__("Phke");

var _emptyState2 = _interopRequireDefault(_emptyState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("k1ea");

exports.default = {
    bindings: {
        state: '@'
    },
    controller: _emptyState2.default,
    template: template
};

/***/ }),

/***/ "YXbO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


getWidthDirectiveConfig.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getWidthDirectiveConfig;
/** @ngInject */
function getWidthDirectiveConfig($timeout) {
    function link($scope, $element) {
        $scope.element = $element[0];

        $timeout(function () {
            $scope.getWidth = $element[0].clientWidth;
        }, 1);

        $scope.$watch('element.clientWidth', function (newValue, oldValue) {
            $timeout(function () {
                if (newValue === oldValue || !newValue) return;

                $scope.getWidth = $element[0].clientWidth;
            }, 40);
        });
    }

    return {
        restrict: 'A',
        scope: {
            getWidth: '='
        },
        link: link
    };
}

/***/ }),

/***/ "YqLS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpIcon = __webpack_require__("og3r");

var _helpIcon2 = _interopRequireDefault(_helpIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("5qCE");

exports.default = {
    bindings: {
        messageKey: '@'
    },
    controller: _helpIcon2.default,
    template: template
};

/***/ }),

/***/ "Yyya":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _generalInformation = __webpack_require__("NkKs");

var _generalInformation2 = _interopRequireDefault(_generalInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("yjGC");

exports.default = {
    bindings: {
        isEditing: '<',
        location: '<',
        pushData: '&'
    },
    template: template,
    controller: _generalInformation2.default
};

/***/ }),

/***/ "ZAqp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingLocation = __webpack_require__("WBbd");

var _thingLocation2 = _interopRequireDefault(_thingLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtEditThingLocation',
    options: _thingLocation2.default
};

/***/ }),

/***/ "ZDG3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sensors = __webpack_require__("sn8m");

var _sensors2 = _interopRequireDefault(_sensors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("zwEQ");

exports.default = {
    template: template,
    controller: _sensors2.default
};

/***/ }),

/***/ "ZRAK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extend2 = __webpack_require__("iyRQ");

var _extend3 = _interopRequireDefault(_extend2);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Event class.
 */
var Event =
/**
 * @param {Object} data - Event data
 * @constructor
 */
function Event(data) {
  _classCallCheck(this, Event);

  (0, _extend3.default)(this, data);

  this.createdFormatted = _utils2.default.convertTimestampToFormat(this.created, _local2.default.format.datetime);
};

exports.default = Event;

/***/ }),

/***/ "ZUS+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingOwner = __webpack_require__("dCp4");

var _thingOwner2 = _interopRequireDefault(_thingOwner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingOwner',
    options: _thingOwner2.default
};

/***/ }),

/***/ "ZV/g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntitiesAutocompleteController = function () {
    /** @ngInject */
    EntitiesAutocompleteController.$inject = ["EventEmitter"];
    function EntitiesAutocompleteController(EventEmitter) {
        _classCallCheck(this, EntitiesAutocompleteController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(EntitiesAutocompleteController, [{
        key: "$onInit",
        value: function $onInit() {
            if (!this.entities) {
                this.entities = [];
            }
        }
    }, {
        key: "getText",
        value: function getText(item) {
            if (this.textKey) {
                return item[this.textKey] || item;
            }
            return item;
        }
    }, {
        key: "added",
        value: function added(entity) {
            this.onAdd(this.eventEmitter({
                entity: entity
            }));
            this.changed();
        }
    }, {
        key: "removed",
        value: function removed(entity) {
            this.onRemove(this.eventEmitter({
                entity: entity
            }));
            this.changed();
        }
    }, {
        key: "changed",
        value: function changed() {
            this.onChange(this.eventEmitter({
                entities: this.entities
            }));
        }
    }, {
        key: "search",
        value: function search() {
            return this.onSearch(this.eventEmitter({
                query: this.query
            }));
        }
    }]);

    return EntitiesAutocompleteController;
}();

exports.default = EntitiesAutocompleteController;

/***/ }),

/***/ "Zaj5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingBattery = __webpack_require__("xpNK");

var _thingBattery2 = _interopRequireDefault(_thingBattery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingBattery',
    options: _thingBattery2.default
};

/***/ }),

/***/ "Zd5J":
/***/ (function(module, exports) {

module.exports = "<md-progress-linear class=progress-linear md-mode=indeterminate ng-show=$ctrl.isLoading()></md-progress-linear>";

/***/ }),

/***/ "ZscP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alertsActions = __webpack_require__("+FUi");

var _alertsActions2 = _interopRequireDefault(_alertsActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * AlertsActionsApi settings
 * @type {{name: string, definition: AlertsActionsApi}}
 */
exports.default = {
  name: 'AlertsActionsApi',
  definition: _alertsActions2.default
};

/***/ }),

/***/ "aIVe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _addUser = __webpack_require__("OaHE");

var _addUser2 = _interopRequireDefault(_addUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("u3OS");

exports.default = {
    bindings: {
        onCreate: '&',
        onCancel: '&'
    },
    controller: _addUser2.default,
    template: template
};

/***/ }),

/***/ "aIVg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _developerSettings = __webpack_require__("yEJU");

var _developerSettings2 = _interopRequireDefault(_developerSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("O8Jr");

exports.default = {
    controller: _developerSettings2.default,
    template: template
};

/***/ }),

/***/ "aU5s":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"center start\" flex layout-margin> <div class=\"box placeholder-block\" flex=70> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <div class=dt-things-toolbox> <div class=container ng-class=\"{ 'is-editing': $ctrl.isEditing }\"> <div flex> <div class=dt-things-toolbox__search-box> <div class=dt-things-toolbox__search-icon> <md-icon class=material-icons aria-label=search>search</md-icon> </div> </div> </div> <md-button ng-click=$ctrl.onCreateNewUserClick() class=\"md-primary md-raised\"> Create new user </md-button> </div> </div> <dt-uac-add-user ng-if=$ctrl.showAddUser on-create=$ctrl.onUserCreate($event) on-cancel=$ctrl.onCancelUserCreate()> </dt-uac-add-user> <md-table-container class=table-container> <table md-table md-row-select multiple=multiple ng-model=$ctrl.selectedUsers> <thead md-head> <tr md-row> <th md-column md-order-by=user.fullName> <span>Name</span> </th> <th md-column md-order-by=user.email> <span>Email</span> </th> <th md-column> <span>Roles</span> </th> <th md-column md-order-by=user.total_things> <span>Sensors owned</span> </th> <th md-column> <span class=space-p-l-m>Actions</span> </th> </tr> </thead> <tbody md-body> <tr md-row md-select=user md-select-id=id ng-repeat=\"user in $ctrl.users track by user.id\"> <td md-cell> <div class=md-body-1>{{ ::user.fullName }}</div>  </td><td md-cell> <a href=\"mailto:{{ ::user.email }}\">{{ ::user.email }}</a> </td> <td md-cell> <span ng-if=user.roles.length class=dt-label-inline ng-repeat=\"role in ::user.roles track by $index\"> {{ ::role.name }} </span> </td> <td md-cell> <div class=\"row middle-xs\"> <div class=\"col-xs-3 text-right\"> <b>{{ ::user.total_things }}</b> </div> <div class=col-xs> <md-button class=\"md-primary md-button--with-icon md-button--s\"> <md-icon class=material-icons>search</md-icon> <span>Show sensors</span> </md-button> </div> </div> </td> <td md-cell> <div layout=row> <md-button class=\"md-primary md-hue-1 md-button--s\" ng-click=$ctrl.onUserResetPassword(user)> Reset password </md-button> <md-button class=\"md-warn md-button--s\" ng-click=$ctrl.onUserDelete(user)> Delete </md-button> </div> </td> </tr> </tbody> </table> </md-table-container> <div layout=row layout-align=\"start center\" layout-padding ng-if=$ctrl.hasRoles> <div class=md-body-1> Bulk edit </div> <div> <md-input-container class=space-m-v-n> <label>Choose role</label> <md-select ng-model=$ctrl.selectedRole> <md-option ng-repeat=\"role in $ctrl.roles track by $index\" ng-value=role>{{ ::role.name }}</md-option> </md-select> </md-input-container> </div> <div> <md-button class=\"md-primary md-hue-2 md-button--s\" ng-click=$ctrl.onAssignRole($event) ng-disabled=\"!$ctrl.selectedRole || !$ctrl.selectedUsers || !$ctrl.selectedUsers.length\"> Assign roles </md-button> </div> </div> </div> </div> ";

/***/ }),

/***/ "aYHq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// All value valid for fontSize: 10px

exports.default = {
    data: {
        A: {
            width: 6.4
        },
        B: {
            width: 6.5
        },
        C: {
            width: 6.4
        },
        E: {
            width: 5.6
        },
        F: {
            width: 5.2
        },
        G: {
            width: 7.3
        },
        H: {
            width: 7.4
        },
        I: {
            width: 2.8
        },
        J: {
            width: 2.7
        },
        K: {
            width: 6.2
        },
        L: {
            width: 5.2
        },
        M: {
            width: 7.4
        },
        N: {
            width: 7.6
        },
        O: {
            width: 7.8
        },
        P: {
            width: 6.1
        },
        Q: {
            width: 7.8
        },
        R: {
            width: 6.2
        },
        S: {
            width: 5.5
        },
        T: {
            width: 5.6
        },
        U: {
            width: 7.3
        },
        V: {
            width: 6
        },
        W: {
            width: 9.3
        },
        X: {
            width: 5.8
        },
        Y: {
            width: 5.7
        },
        Z: {
            width: 5.8
        },
        a: {
            width: 5.6
        },
        b: {
            width: 6.14
        },
        c: {
            width: 4.8
        },
        e: {
            width: 5.7
        },
        f: {
            width: 3.4
        },
        g: {
            width: 5.5
        },
        h: {
            width: 6.2
        },
        i: {
            width: 2.6
        },
        j: {
            width: 2.6
        },
        k: {
            width: 5.3
        },
        l: {
            width: 2.6
        },
        m: {
            width: 9.4
        },
        n: {
            width: 6.2
        },
        o: {
            width: 6.1
        },
        p: {
            width: 6.2
        },
        q: {
            width: 6.2
        },
        r: {
            width: 4.1
        },
        s: {
            width: 4.8
        },
        t: {
            width: 3.6
        },
        u: {
            width: 6.2
        },
        v: {
            width: 5.1
        },
        w: {
            width: 7.8
        },
        x: {
            width: 5.3
        },
        y: {
            width: 5.1
        },
        z: {
            width: 4.7
        },
        0: {
            width: 5.8
        },
        1: {
            width: 5.8
        },
        2: {
            width: 5.8
        },
        3: {
            width: 5.8
        },
        4: {
            width: 5.8
        },
        5: {
            width: 5.8
        },
        6: {
            width: 5.8
        },
        7: {
            width: 5.8
        },
        8: {
            width: 5.8
        },
        9: {
            width: 5.8
        },
        '-': {
            width: 2.22
        },
        ' ': {
            width: 2.61
        },
        '›': {
            width: 3.15
        },
        '(': {
            width: 2.97
        },
        ')': {
            width: 2.97
        },
        '=': {
            width: 5.72
        },
        '@': {
            width: 9
        }
    }
};

/***/ }),

/***/ "aabv":
/***/ (function(module, exports) {

module.exports = "<script type=text/ng-template id=generic-messages.html> <div ng-repeat=\"item in $ctrl.genericErrors track by $index\" ng-message-exp=\"item.type\">\n        {{ item.message }}\n    </div> </script> <md-dialog flex=30> <md-toolbar class=md-hue-2> <div class=md-toolbar-tools> <span class=md-title>Create Rule</span> <span flex></span> <md-button ng-click=$ctrl.cancel() class=md-icon-button> <md-icon class=material-icons>clear</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=md-dialog-content> <form name=newRuleForm novalidate> <md-input-container class=md-block> <label>Name</label> <input type=text name=new_rule id=new_rule ng-model=$ctrl.rule.title md-autofocus required> <div ng-if=newRuleForm.new_rule.$touched ng-messages=newRuleForm.new_rule.$error> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> <md-button class=\"md-raised md-primary\" ng-disabled=newRuleForm.$invalid ng-click=$ctrl.create()>Ok</md-button> </form> </md-dialog-content> </md-dialog> ";

/***/ }),

/***/ "amTI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = __webpack_require__("TmhV");

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("8UR1");

exports.default = {
    bindings: {
        mapOptions: '<',
        centerCoordinates: '<',
        marker: '=',
        onCenterChanged: '&',
        onBoundsChanged: '&',
        onMarkerCoordinatesChanged: '&?'
    },
    template: template,
    controller: _map2.default
};

/***/ }),

/***/ "auPI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingDetails = __webpack_require__("pJNW");

var _thingDetails2 = _interopRequireDefault(_thingDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("StB+");

exports.default = {
    bindings: {
        thing: '<',
        thingUpdate: '<',
        onThingUpdated: '&'
    },
    template: template,
    controller: _thingDetails2.default
};

/***/ }),

/***/ "axRE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _layout = __webpack_require__("bmse");

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("3zRx");

exports.default = {
    template: template,
    controller: _layout2.default
};

/***/ }),

/***/ "bArM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _specificTime = __webpack_require__("Uptj");

var _specificTime2 = _interopRequireDefault(_specificTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("tOXP");

exports.default = {
    controller: _specificTime2.default,
    template: template
};

/***/ }),

/***/ "bIf/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApplicationHelpController = function () {
    /** @ngInject */
    ApplicationHelpController.$inject = ["TranslationService", "$state"];
    function ApplicationHelpController(TranslationService, $state) {
        _classCallCheck(this, ApplicationHelpController);

        this.TranslationService = TranslationService;
        this.$state = $state;
    }

    _createClass(ApplicationHelpController, [{
        key: '$onInit',
        value: function $onInit() {
            this.inProgress = false;
            this.updateMessage();
        }
    }, {
        key: 'updateMessage',
        value: function updateMessage() {
            var stateKey = this.$state.current.name.split('.').join('_');
            this.messageKey = 'help_menu_' + stateKey;
            this.helpMessage = this.TranslationService.getLine(this.messageKey);
        }
    }]);

    return ApplicationHelpController;
}();

exports.default = ApplicationHelpController;

/***/ }),

/***/ "bKZY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompanySettingsController =
/** @ngInject */
["EventEmitter", function CompanySettingsController(EventEmitter) {
    _classCallCheck(this, CompanySettingsController);

    this.eventEmiter = EventEmitter;
}];

exports.default = CompanySettingsController;

/***/ }),

/***/ "bRow":
/***/ (function(module, exports) {

module.exports = "<div class=form-grid__row> <label class=md-caption>Last updated</label> <md-input-container class=\"form-element form-element--simple space-m-h-s\" style=width:80px> <md-select aria-label=\"Last updated\" ng-model=$ctrl.selectedOption ng-change=$ctrl.onChange()> <md-option>{{ ::$ctrl.anyText }}</md-option> <md-option ng-repeat=\"(label, value) in ::$ctrl.values\" ng-value=value> {{::label}} </md-option> <md-option ng-value=$ctrl.customText>{{ ::$ctrl.customText }}</md-option> </md-select> </md-input-container> <md-icon class=\"material-icons material-icons--help\">help</md-icon> </div> <div ng-if=$ctrl.isCustomSelected() layout=column style=margin-top:15px> <md-datepicker ng-model=$ctrl.customAfter md-placeholder=\"From Date\" md-hide-icons=calendar></md-datepicker> <span style=\"margin:10px 0\">to</span> <md-datepicker ng-model=$ctrl.customBefore md-placeholder=\"To Date\" md-hide-icons=calendar></md-datepicker> </div>";

/***/ }),

/***/ "bThm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("OU4C");

__webpack_require__("BM+i");

/***/ }),

/***/ "beYs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlertsActionsContentActionsController = function () {
    function AlertsActionsContentActionsController(EventEmitter, $timeout, ToastService, Loader) {
        _classCallCheck(this, AlertsActionsContentActionsController);

        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
        this.ToastService = ToastService;
        this.Loader = Loader;
    }

    _createClass(AlertsActionsContentActionsController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.actions) {
                this.actions = [];
            }
        }
    }, {
        key: 'addNotification',
        value: function addNotification() {
            var notification = {
                id: Math.floor(Math.random() * 1000),
                type: 'notification',
                data: {
                    users: null,
                    email: null,
                    message: null
                }
            };

            this.addAlert(notification);
        }
    }, {
        key: 'addEmail',
        value: function addEmail() {
            var email = {
                id: Math.floor(Math.random() * 1000),
                type: 'email',
                data: {
                    users: null,
                    email: null,
                    message: null
                }
            };

            this.addAlert(email);
        }
    }, {
        key: 'addWebHook',
        value: function addWebHook() {
            var webHook = {
                id: Math.floor(Math.random() * 1000),
                type: 'webhook',
                data: {
                    users: null,
                    email: null,
                    message: null
                }
            };

            this.addAlert(webHook);
        }
    }, {
        key: 'addAlert',
        value: function addAlert(action) {
            this.actions.push(action);
        }
    }, {
        key: 'removeAction',
        value: function removeAction(_ref) {
            var _this = this;

            var action = _ref.action;

            this.Loader.show();

            this.$timeout(function () {
                _this.actions = _this.actions.filter(function (item) {
                    return item.id !== action.id;
                });

                _this.ToastService.show(_this.ToastService.createSimple({
                    text: 'Rule was deleted',
                    position: 'bottom right'
                }));

                _this.Loader.hide();
            }, 1000);
        }
    }]);

    return AlertsActionsContentActionsController;
}();

exports.default = AlertsActionsContentActionsController;

/***/ }),

/***/ "bmEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("8HS2"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * HistoryApi class.
 */

var HistoryApi = function () {
    /**
     * @param $http
     * @constructor
     * @ngInject
     */
    HistoryApi.$inject = ["$http"];
    function HistoryApi($http) {
        _classCallCheck(this, HistoryApi);

        this.$http = $http;
        this.config = _local2.default.api.history;
    }

    /**
     * Get History data
     * @returns {promise}
     */


    _createClass(HistoryApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }
    }]);

    return HistoryApi;
}();

exports.default = HistoryApi;

/***/ }),

/***/ "bmse":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _appMenu = __webpack_require__("k5AM");

var _appMenu2 = _interopRequireDefault(_appMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LayoutController = function () {
    function LayoutController() {
        _classCallCheck(this, LayoutController);

        this.appMenu = _appMenu2.default;
        this.navCollapsed = false;
    }

    _createClass(LayoutController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isMobileNav = null;
        }
    }, {
        key: 'showMobileNav',
        value: function showMobileNav() {
            this.isMobileNav = true;
        }
    }, {
        key: 'hideMobileNav',
        value: function hideMobileNav() {
            this.isMobileNav = false;
        }
    }, {
        key: 'onNavToggle',
        value: function onNavToggle(isCollapsed) {
            this.navCollapsed = isCollapsed;
        }
    }, {
        key: 'isNavCollapsed',
        get: function get() {
            return this.navCollapsed;
        }
    }]);

    return LayoutController;
}();

exports.default = LayoutController;

/***/ }),

/***/ "bqBt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'alerts.status';

var ThingStatusController = function () {
    /** @ngInject */
    ThingStatusController.$inject = ["NotificationsService", "EventEmitter"];
    function ThingStatusController(NotificationsService, EventEmitter) {
        _classCallCheck(this, ThingStatusController);

        this.NotificationsService = NotificationsService;
        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingStatusController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.thingStatus) {
                this.thingStatus = [];
            }

            this.notifications = this.NotificationsService.getAllNotifications();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            if (this.thingStatus.length) {
                this.fillBucket();

                this.pushUpdate(this.eventEmitter({
                    value: this.thingStatus
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'exists',
        value: function exists(notification) {
            return this.thingStatus.indexOf(notification.value) > -1;
        }
    }, {
        key: 'toggle',
        value: function toggle(notification) {
            var index = this.thingStatus.indexOf(notification.value);

            if (index > -1) {
                this.thingStatus.splice(index, 1);
            } else {
                this.thingStatus.push(notification.value);
            }

            this.onChange();
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket() {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingStatus
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            // this.thingStatus = [];

            this.clearBucket();
        }
    }]);

    return ThingStatusController;
}();

exports.default = ThingStatusController;

/***/ }),

/***/ "bsgfj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeController = function () {
    /** @ngInject */
    TreeController.$inject = ["EventEmitter", "FolderService", "treeConfig", "$timeout", "$scope"];
    function TreeController(EventEmitter, FolderService, treeConfig, $timeout, $scope) {
        _classCallCheck(this, TreeController);

        this.eventEmitter = EventEmitter;
        this.FolderService = FolderService;
        this.treeConfig = treeConfig;
        this.$timeout = $timeout;
        this.$scope = $scope;
    }

    _createClass(TreeController, [{
        key: '$onInit',
        value: function $onInit() {
            this.treeConfig.dragClass = 'angular-ui-tree-drag ui-tree--folder';
            this.treeOptions = {
                beforeDrop: this.treeBeforeDrop.bind(this)
            };
        }
    }, {
        key: 'expandAll',
        value: function expandAll() {
            this.$scope.$broadcast('angular-ui-tree:expand-all');
        }
    }, {
        key: 'collapseAll',
        value: function collapseAll() {
            this.$scope.$broadcast('angular-ui-tree:collapse-all');
        }
    }, {
        key: 'onPostDigest',
        value: function onPostDigest() {
            return this.$timeout(_utils2.default.noop, 0);
        }
    }, {
        key: 'treeBeforeDrop',
        value: function treeBeforeDrop(_ref) {
            var srcScope = _ref.source.nodeScope,
                _ref$dest = _ref.dest,
                dstScope = _ref$dest.nodesScope,
                index = _ref$dest.index;
            var sourceFolder = srcScope.$modelValue;

            var parentFolder = null;
            if (dstScope.$nodeScope) {
                parentFolder = dstScope.$nodeScope.$modelValue;
            }
            this.onFolderMoved(this.eventEmitter({
                folder: sourceFolder,
                parent: parentFolder,
                index: index
            }));
            return false;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(_ref2) {
            var selectedFolderId = _ref2.selectedFolderId;

            if (selectedFolderId && selectedFolderId.currentValue) {
                this.expandFolderPath(selectedFolderId.currentValue);
            }
        }
    }, {
        key: 'enableReorderMode',
        value: function enableReorderMode() {
            this.reorderMode = true;
        }
    }, {
        key: 'disableReorderMode',
        value: function disableReorderMode() {
            this.reorderMode = false;
        }
    }, {
        key: 'initTreeScope',
        value: function initTreeScope(scope) {
            this.treeScope = scope;
        }
    }, {
        key: 'expandFolderPath',
        value: function expandFolderPath(folderId) {
            var _this = this;

            this.onPostDigest().then(function () {
                if (_this.treeScope.$nodesScope) {
                    var folderPath = _this.FolderService.buildFolderPath(folderId);
                    folderPath.reduce(function (parentScope, folder) {
                        var childNodes = parentScope.childNodes();

                        var _childNodes$filter = childNodes.filter(function (_ref3) {
                            var $modelValue = _ref3.$modelValue;
                            return $modelValue && $modelValue.id === folder.id;
                        }),
                            _childNodes$filter2 = _slicedToArray(_childNodes$filter, 1),
                            scope = _childNodes$filter2[0];

                        if (scope) {
                            scope.expand();
                        }
                        return scope;
                    }, _this.treeScope.$nodesScope);
                }
            });
        }
    }, {
        key: 'createFolder',
        value: function createFolder(_ref4) {
            var folder = _ref4.folder;

            this.onFolderCreated(this.eventEmitter({
                folder: folder
            }));
        }
    }, {
        key: 'selectFolder',
        value: function selectFolder(folder) {
            this.onFolderSelected(this.eventEmitter({
                folder: folder
            }));
        }
    }]);

    return TreeController;
}();

exports.default = TreeController;

/***/ }),

/***/ "btPW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _addUser = __webpack_require__("aIVe");

var _addUser2 = _interopRequireDefault(_addUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtUacAddUser',
    options: _addUser2.default
};

/***/ }),

/***/ "bupA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _radioStatus = __webpack_require__("uccH");

var _radioStatus2 = _interopRequireDefault(_radioStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtRadioStatus',
    options: _radioStatus2.default
};

/***/ }),

/***/ "bvol":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabs = __webpack_require__("f1JT");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("W1Kw");

exports.default = {
    bindings: {
        selectedTabId: '=?',
        tabs: '<',
        onTabClick: '&',
        onTabSelect: '&',
        onTabDeselect: '&',
        onTabMenuItemClick: '&'
    },
    template: template,
    controller: _tabs2.default
};

/***/ }),

/***/ "byU/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _folders = __webpack_require__("+o/V");

var _folders2 = _interopRequireDefault(_folders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("myz8");

exports.default = {
    controller: _folders2.default,
    template: template
};

/***/ }),

/***/ "c/HW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _oidcClient = __webpack_require__("tE9h");

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _local2.default.auth.openid, {
    userStore: new _oidcClient.WebStorageStateStore({
        store: window.localStorage
    })
});

/***/ }),

/***/ "cER5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-toolbar class=dt-theme> <div class=md-toolbar-tools> <md-button class=md-icon-button hide-gt-sm ng-click=$ctrl.onShowMobileNav();> <i class=material-icons>menu</i> </md-button> <a href=/ class=logo> <img src=" + __webpack_require__("R5Ds") + " class=hide-tablet alt=\"Disruptive Technologies\"/> <span>STUDIO</span> </a> <span flex></span> <div layout=row layout-align=\"center center\"> <section class=dt-layout-header__tools hide-xs layout=row layout-align=\"center center\"> <md-button href=https://support.disruptive-technologies.com/hc/en-us/articles/360001692834-Where-can-I-find-API-documentation- layout=column target=_blank aria-label=Documentation> <md-icon>library_books</md-icon> <span>Documentation</span> </md-button> <md-button href=https://store.disruptive-technologies.com/ layout=column target=_blank aria-label=\"Order Sensors\"> <md-icon>shopping_cart</md-icon> <span>Order Sensors</span> </md-button> <md-button ng-class=\"{\n                        'md-icon-button': true,\n                        'md-fab notification-fab': $ctrl.notification\n                    }\" ng-click=$ctrl.showNotifications() aria-label=Notifications> <md-icon>notifications_none</md-icon> <div ng-if=$ctrl.notification class=badge>4</div> <md-tooltip class=dt-theme>Notifications</md-tooltip> </md-button> </section> <md-menu hide-gt-xs class=space-m-h-s> <a href=\"\" aria-label=\"Open menu\" ng-click=$mdOpenMenu($event)> <md-icon>more_vert</md-icon> </a> <md-menu-content width=3> <md-menu-item> <md-button class=md-primary href=https://support.disruptive-technologies.com/hc/en-us/articles/360001692834-Where-can-I-find-API-documentation- aria-label=Documentation> <md-icon>library_books</md-icon> <span class=md-caption>Documentation</span> </md-button> </md-menu-item> <md-menu-item> <md-button class=md-primary href=https://store.disruptive-technologies.com/ aria-label=\"Order Sensors\"> <md-icon>shopping_cart</md-icon> <span class=md-caption>Order Sensors</span> </md-button> </md-menu-item> <md-menu-item> <md-button class=md-primary ng-click=$ctrl.showNotifications() aria-label=Notifications> <md-icon>notifications_none</md-icon> <span class=md-caption>Notifications</span> </md-button> </md-menu-item> </md-menu-content> </md-menu> <div class=dt-layout-header__user-info> <a href=\"\" ng-click=\"$ctrl.showUserInfo($event); $event.preventDefault();\"> <img class=user-info__avatar src=" + __webpack_require__("dgJw") + " width=36 height=36 alt=\"\"> </a> </div> </div> </div> </md-toolbar> ";

/***/ }),

/***/ "cLBf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotificationsController =
/** @ngInject */
["EventEmitter", function NotificationsController(EventEmitter) {
    _classCallCheck(this, NotificationsController);

    this.eventEmiter = EventEmitter;
}];

exports.default = NotificationsController;

/***/ }),

/***/ "cRAP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingFolders = __webpack_require__("hz5C");

var _thingFolders2 = _interopRequireDefault(_thingFolders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("mFMv");

exports.default = {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingFolders2.default
};

/***/ }),

/***/ "caQq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge2 = __webpack_require__("yubd");

var _merge3 = _interopRequireDefault(_merge2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FolderService = function () {
    /** @ngInject */
    FolderService.$inject = ["FoldersApi", "$q"];
    function FolderService(FoldersApi, $q) {
        _classCallCheck(this, FolderService);

        this.Api = FoldersApi;
        this.$q = $q;

        this.loadingPromise = null;
        this.folderTree = [];
        this.folderMap = {};
    }

    _createClass(FolderService, [{
        key: 'storeFolder',
        value: function storeFolder(folder) {
            folder.children = [];
            this.folderMap[folder.id] = folder;
        }
    }, {
        key: 'getFolder',
        value: function getFolder(id) {
            return this.folderMap[id];
        }
    }, {
        key: 'loadPage',
        value: function loadPage() {
            var _this = this;

            var pageToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var options = {
                page_size: 100
            };

            if (pageToken) {
                options.page_token = pageToken;
            }

            this.Api.fetch(options).then(this.processPage.bind(this), function () {
                _this.loadingPromise.reject();
            });
        }
    }, {
        key: 'processPage',
        value: function processPage(data) {
            var _this2 = this;

            var folders = data.folders || [];
            folders.forEach(function (folder) {
                _this2.storeFolder(folder);
            });

            if (data.next_page_token) {
                this.loadPage(data.next_page_token);
            } else {
                this.buildTree();
                this.loadingPromise.resolve();
            }
        }
    }, {
        key: 'buildTree',
        value: function buildTree() {
            var _this3 = this;

            Object.keys(this.folderMap).forEach(function (folderId) {
                var folder = _this3.getFolder(folderId);
                _this3.growTree(folder);
            });
        }
    }, {
        key: 'growTree',
        value: function growTree(folder) {
            if (!folder.parent_id) {
                this.folderTree.push(folder);
            } else {
                var parent = this.getFolder(folder.parent_id);
                if (parent) {
                    parent.children.push(folder);
                }
            }
        }
    }, {
        key: 'getChildrenIds',
        value: function getChildrenIds(folder) {
            var _this4 = this;

            var result = [];
            if (folder.children.length) {
                folder.children.forEach(function (child) {
                    result.concat.apply(result, [child.id].concat(_toConsumableArray(_this4.getChildrenIds(child))));
                });
            }
            return result;
        }
    }, {
        key: 'cutTree',
        value: function cutTree(folder) {
            var _this5 = this;

            var childrenIds = this.getChildrenIds(folder);
            childrenIds.forEach(function (childId) {
                delete _this5.folderMap[childId];
            });
            var parentChildren = void 0;
            if (folder.parent_id) {
                var parent = this.getFolder(folder.parent_id);
                if (parent) {
                    parentChildren = parent.children;
                }
            } else {
                parentChildren = this.folderTree;
            }
            if (parentChildren) {
                var folderIndex = parentChildren.indexOf(folder);
                if (folderIndex >= 0) {
                    parentChildren.splice(folderIndex, 1);
                }
            }
        }
    }, {
        key: 'switchBranch',
        value: function switchBranch(folder, parentId, index) {
            var oldChildren = this.folderTree;
            if (folder.parent_id) {
                var oldParentRef = this.getFolder(folder.parent_id);
                oldChildren = oldParentRef.children;
            }
            var oldIndex = oldChildren.indexOf(folder);
            if (oldIndex >= 0) {
                oldChildren.splice(oldIndex, 1);
            }

            var newChildren = this.folderTree;
            if (parentId) {
                var newParentRef = this.getFolder(parentId);
                newChildren = newParentRef.children;
            }
            if (index <= newChildren.length) {
                newChildren.splice(index, 0, folder);
            }

            folder.parent_id = parentId;
        }
    }, {
        key: 'loadFolders',
        value: function loadFolders() {
            if (this.loadingPromise) {
                return this.loadingPromise.promise;
            }

            this.loadingPromise = this.$q.defer();

            this.loadPage();

            return this.loadingPromise.promise;
        }
    }, {
        key: 'getTree',
        value: function getTree() {
            return this.folderTree;
        }
    }, {
        key: 'buildFolderPath',
        value: function buildFolderPath(folderId) {
            var path = [];
            var folder = this.getFolder(folderId);
            if (folder) {
                path.unshift(folder);
                while (folder.parent_id && !path.find(function (item) {
                    return item.id === folder.parent_id;
                })) {
                    // eslint-disable-line no-loop-func,max-len
                    var parent = this.getFolder(folder.parent_id);
                    path.unshift(parent);
                    folder = parent;
                }
            }
            return path;
        }
    }, {
        key: 'addFolder',
        value: function addFolder(data) {
            var _this6 = this;

            return this.Api.create(data).then(function (folder) {
                _this6.storeFolder(folder);
                _this6.growTree(folder);
                return folder;
            });
        }
    }, {
        key: 'saveFolder',
        value: function saveFolder(folder) {
            var _this7 = this;

            delete folder.children;
            return this.Api.update(folder.id, folder).then(function () {
                var folderRef = _this7.getFolder(folder.id);
                (0, _merge3.default)(folderRef, folder);
            });
        }
    }, {
        key: 'deleteFolder',
        value: function deleteFolder(folder) {
            var _this8 = this;

            return this.Api.remove(folder.id).then(function () {
                var folderRef = _this8.getFolder(folder.id);
                _this8.cutTree(folderRef);
            });
        }
    }, {
        key: 'moveFolder',
        value: function moveFolder(folder, parent, index) {
            var _this9 = this;

            var parentId = parent ? parent.id : null;
            var params = {};
            if (parentId) {
                params.parent_id = parentId;
            }
            return this.Api.move(folder.id, params).then(function () {
                var folderRef = _this9.getFolder(folder.id);
                _this9.switchBranch(folderRef, parentId, index);
            });
        }
    }]);

    return FolderService;
}();

exports.default = FolderService;

/***/ }),

/***/ "ciI2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardController =
/** @ngInject */
["EventEmitter", function DashboardController(EventEmitter) {
    _classCallCheck(this, DashboardController);

    this.eventEmiter = EventEmitter;
}];

exports.default = DashboardController;

/***/ }),

/***/ "cih7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


appBootstrap.$inject = ["$transitions", "HealthCheckerService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = appBootstrap;

var _angular = __webpack_require__("aeQg");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @ngInject */
function appBootstrap($transitions, HealthCheckerService) {
    $transitions.onStart({}, function (trans) {
        var DialogService = trans.injector().get('DialogService');
        DialogService.cancel();
        var helpMenuNode = document.querySelector('dt-help-menu');
        if (helpMenuNode) {
            var _angular$element$scop = _angular2.default.element(helpMenuNode).scope(),
                $ctrl = _angular$element$scop.$ctrl;

            $ctrl.mdPanelRef.close();
        }
    });

    HealthCheckerService.initTracking();
}

/***/ }),

/***/ "coYr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingLocation = __webpack_require__("yqDe");

var _thingLocation2 = _interopRequireDefault(_thingLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingLocation',
    options: _thingLocation2.default
};

/***/ }),

/***/ "ctaC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/ava-test.png";

/***/ }),

/***/ "cv2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingStar = __webpack_require__("p4B/");

var _thingStar2 = _interopRequireDefault(_thingStar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("o+67");

exports.default = {
    bindings: {
        starred: '<',
        thingId: '<',
        onToggleStatus: '&'
    },
    template: template,
    controller: _thingStar2.default
};

/***/ }),

/***/ "cx3I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RemoteConfigService = undefined;

var _remote = __webpack_require__("uD2R");

var _remote2 = _interopRequireDefault(_remote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RemoteConfigService = _remote2.default;

/***/ }),

/***/ "d1/s":
/***/ (function(module, exports) {

module.exports = "<section> <div layout=row layout-align=\"start center\"> <div class=block-title> sensor access <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </div> </div> <md-list class=md-list--style-2> <div class=\"content-title space-m-t-n\">Manage</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=\"material-icons material-icons--s\">people</md-icon> <span>Building manager</span> <a href=# class=md-caption> <i>Inherited from Bergen</i> </a> </div> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\" ng-if=$ctrl.isEditing> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> </div> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=\"material-icons material-icons--s\">people</md-icon> <span>Admin</span> <a href=# class=md-caption> <i>Inherited from Bergen</i> </a> </div> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\" ng-if=$ctrl.isEditing> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> </div> <md-divider></md-divider> </md-list-item> <div class=content-title>Edit</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=\"material-icons material-icons--s\">person</md-icon> <span>Jan Jansen</span> </div> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\" ng-if=$ctr.isEditing> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> </div> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=\"material-icons material-icons--s\">people</md-icon> <span>HVAC</span> </div> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\" ng-if=$ctrl.isEditing> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> </div> <md-divider></md-divider> </md-list-item> <div class=content-title>View</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=\"material-icons material-icons--s\">people</md-icon> <span>Contractor</span> </div> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\" ng-if=$ctrl.isEditing> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> </div> <md-divider></md-divider> </md-list-item> <div class=content-title>No access</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=\"material-icons material-icons--s\">person</md-icon> <span>Jessica Kang</span> <a href=# class=md-caption><i>Overrides Edit from Basement</i></a> </div> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\" ng-if=$ctrl.isEditing> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> </div> <md-divider></md-divider> </md-list-item> </md-list> </section> ";

/***/ }),

/***/ "d6Vi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notifications = __webpack_require__("FLNi");

var _notifications2 = _interopRequireDefault(_notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'NotificationsApi',
    definition: _notifications2.default
};

/***/ }),

/***/ "dCTD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__("iyRQ");

var _extend3 = _interopRequireDefault(_extend2);

var _round2 = __webpack_require__("gSU/");

var _round3 = _interopRequireDefault(_round2);

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Thing = function () {
    function Thing(data) {
        _classCallCheck(this, Thing);

        (0, _extend3.default)(this, data);

        if (!this.labels) {
            this.labels = [];
        }
    }

    _createClass(Thing, [{
        key: 'setTypeConfig',
        value: function setTypeConfig(typeConfig) {
            this.typeConfig = typeConfig;
        }
    }, {
        key: 'getTypeConfig',
        value: function getTypeConfig() {
            return this.typeConfig;
        }
    }, {
        key: 'getHistoryChartType',
        value: function getHistoryChartType() {
            var typeConfig = this.getTypeConfig();
            if (typeConfig && typeConfig.state && typeConfig.state.history) {
                return typeConfig.state.history.chartType;
            }
            return null;
        }
    }, {
        key: 'isHistoryAggregated',
        value: function isHistoryAggregated() {
            var typeConfig = this.getTypeConfig();
            if (typeConfig && typeConfig.state && typeConfig.state.history) {
                return typeConfig.state.history.isAggregate;
            }
            return false;
        }
    }, {
        key: 'getDefaultHistoryInterval',
        value: function getDefaultHistoryInterval() {
            var typeConfig = this.getTypeConfig();
            if (this.isHistoryAggregated()) {
                return typeConfig.state.history.defaultInterval;
            }
            return null;
        }
    }, {
        key: 'getHistoryFieldsNavigatorConfig',
        value: function getHistoryFieldsNavigatorConfig() {
            var typeConfig = this.getTypeConfig();
            if (typeConfig && typeConfig.state && typeConfig.state.history && typeConfig.state.history.navigator) {
                return typeConfig.state.history.navigator;
            }
            return this.getHistoryFieldsConfig();
        }
    }, {
        key: 'getHistoryFieldsConfig',
        value: function getHistoryFieldsConfig() {
            var typeConfig = this.getTypeConfig();
            var fields = [];
            if (typeConfig && typeConfig.state && typeConfig.state.history) {
                if (this.isHistoryAggregated()) {
                    Object.keys(typeConfig.state.history.functionMap).forEach(function (functionId) {
                        fields.push({
                            name: typeConfig.state.history.key || typeConfig.state.key,
                            'function': typeConfig.state.history.functionMap[functionId]
                        });
                    });
                } else {
                    fields.push(typeConfig.state.history.key || typeConfig.state.key);
                }
            }
            return fields;
        }

        /**
         * Get Thing state value
         * @returns {null|string} Return null if state is absent or parsed state as string
         */

    }, {
        key: 'getStateValue',
        value: function getStateValue() {
            if (!this.state) return 'no state';

            var typeConfig = this.getTypeConfig();

            if (!typeConfig || !typeConfig.state) {
                return 'unknown type';
            }

            var rawValue = this.state.properties[typeConfig.state.key];

            return Thing.prepareStateValue(typeConfig.state.value, rawValue);
        }
    }], [{
        key: 'prepareBooleanValue',
        value: function prepareBooleanValue(rawValue, format) {
            return rawValue ? format.trueValue : format.falseValue;
        }
    }, {
        key: 'prepareNumberValue',
        value: function prepareNumberValue(rawValue, format) {
            return format.replace('%s', (0, _round3.default)(parseFloat(rawValue), 2));
        }
    }, {
        key: 'prepareTimestampValue',
        value: function prepareTimestampValue(rawValue, format) {
            if (!rawValue) {
                return format.noValue;
            }
            var timestamp = (0, _moment2.default)(rawValue);
            if (timestamp.isAfter((0, _moment2.default)().startOf('day'))) {
                return timestamp.format(format.freshValue);
            }
            return timestamp.format(format.oldValue);
        }
    }, {
        key: 'prepareStateValue',
        value: function prepareStateValue(config, rawValue) {
            var value = void 0;

            if (config.type === 'boolean') {
                value = Thing.prepareBooleanValue(rawValue, config.format);
            } else if (config.type === 'number') {
                value = Thing.prepareNumberValue(rawValue, config.format);
            } else if (config.type === 'timestamp') {
                value = Thing.prepareTimestampValue(rawValue, config.format);
            }

            return value;
        }
    }]);

    return Thing;
}();

exports.default = Thing;

/***/ }),

/***/ "dCp4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingOwner = __webpack_require__("DIb8");

var _thingOwner2 = _interopRequireDefault(_thingOwner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("V/ns");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingOwner2.default
};

/***/ }),

/***/ "dKJL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _feedbackForm = __webpack_require__("GJWX");

var _feedbackForm2 = _interopRequireDefault(_feedbackForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtFeedbackForm',
    options: _feedbackForm2.default
};

/***/ }),

/***/ "dUbX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/touch.svg";

/***/ }),

/***/ "dWeu":
/***/ (function(module, exports) {

module.exports = "<md-list class=md-list--style-2> <div class=\"md-body-label space-m-t-m\">Manager</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=material-icons>people</md-icon> <span class=md-subhead>Building manager</span> <i class=md-caption>Inherited from Bergen</i> </div> </div> <md-menu class=md-secondary md-position-mode=\"target-right target\" md-offset=\"0 46\"> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=material-icons>people</md-icon> <span class=md-subhead>Admin</span> <i class=md-caption>Inherited from Bergen</i> </div> </div> <md-menu class=md-secondary md-position-mode=\"target-right target\" md-offset=\"0 46\"> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item ng-show=!updateManagerAccess> <div> <md-button ng-click=\"updateManagerAccess = true\" class=\"md-button md-primary md-button--s space-m-l-n\">+ Add users and role</md-button> </div> <md-divider></md-divider> </md-list-item> <md-list-item ng-show=updateManagerAccess class=md-list-item> <form ng-submit=$event.preventDefault() flex> <md-autocomplete class=md-autocomplete--s ng-disabled=isDisabled md-no-cache=noCache md-selected-item=selectedItem md-search-text-change=searchTextChange(searchText) md-search-text=searchText md-selected-item-change=selectedItemChange(item) md-items=\"item in querySearch(searchText)\" md-item-text=item.display md-min-length=0 placeholder=\"Select users and roles\"> <md-item-template> <span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{item.display}}</span> </md-item-template> <md-not-found> No states matching \"{{searchText}}\" were found. <a ng-click=newState(searchText)>Create a new one!</a> </md-not-found> </md-autocomplete> </form> <md-button class=\"md-primary md-raised space-m-l-m\">Add</md-button> </md-list-item> <div class=\"md-body-label space-m-t-m\">Edit</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=material-icons>person</md-icon> <span class=md-subhead>Jan Jansen</span> </div> </div> <md-menu class=md-secondary md-position-mode=\"target-right target\" md-offset=\"0 46\"> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=material-icons>people</md-icon> <span class=md-subhead>HVAC</span> <i class=md-caption>Inherited from Bergen</i> </div> </div> <md-menu class=md-secondary md-position-mode=\"target-right target\" md-offset=\"0 46\"> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item ng-show=!updateEditAccess> <div> <md-button ng-click=\"updateEditAccess = true\" class=\"md-button md-primary md-button--s space-m-l-n\">+ Add users and role</md-button> </div> <md-divider></md-divider> </md-list-item> <md-list-item ng-show=updateEditAccess class=md-list-item> <form ng-submit=$event.preventDefault() flex> <md-autocomplete class=md-autocomplete--s ng-disabled=isDisabled md-no-cache=noCache md-selected-item=selectedItem md-search-text-change=searchTextChange(searchText) md-search-text=searchText md-selected-item-change=selectedItemChange(item) md-items=\"item in querySearch(searchText)\" md-item-text=item.display md-min-length=0 placeholder=\"Select users and roles\"> <md-item-template> <span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{item.display}}</span> </md-item-template> <md-not-found> No states matching \"{{searchText}}\" were found. <a ng-click=newState(searchText)>Create a new one!</a> </md-not-found> </md-autocomplete> </form> <md-button class=\"md-primary md-raised space-m-l-m\">Add</md-button> </md-list-item> <div class=\"md-body-label space-m-t-m\">View</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=material-icons>people</md-icon> <span class=md-subhead>Contractor</span> </div> </div> <md-menu class=md-secondary md-position-mode=\"target-right target\" md-offset=\"0 46\"> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item ng-show=!updateViewAccess> <md-button ng-click=\"updateViewAccess = true\" class=\"md-button md-primary md-button--s space-m-l-n\">+ Add users and role</md-button> <md-divider></md-divider> </md-list-item> <md-list-item ng-show=updateViewAccess class=md-list-item> <form ng-submit=$event.preventDefault() flex> <md-autocomplete class=md-autocomplete--s ng-disabled=isDisabled md-no-cache=noCache md-selected-item=selectedItem md-search-text-change=searchTextChange(searchText) md-search-text=searchText md-selected-item-change=selectedItemChange(item) md-items=\"item in querySearch(searchText)\" md-item-text=item.display md-min-length=0 placeholder=\"Select users and roles\"> <md-item-template> <span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{item.display}}</span> </md-item-template> <md-not-found> No states matching \"{{searchText}}\" were found. <a ng-click=newState(searchText)>Create a new one!</a> </md-not-found> </md-autocomplete> </form> <md-button class=\"md-primary md-raised space-m-l-m\">Add</md-button> </md-list-item> <div class=\"md-body-label space-m-t-m\">No access</div> <md-list-item class=md-list-item> <div layout=row layout-align=\"space-between center\" flex> <div class=md-list-item-text> <md-icon class=material-icons>people</md-icon> <span class=md-subhead>Jessica Kang</span> <i class=md-caption>Inherited from Bergen</i> </div> </div> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 46\"> <md-button class=md-primary ng-click=$mdOpenMenu($event)>Change</md-button> <md-menu-content class=menu-content--style-1 width=2> <md-radio-group ng-model=credentials_1> <md-menu-item> <md-radio-button value=noaccess>No access</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=view>View</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=edit>Edit</md-radio-button> </md-menu-item> <md-menu-item> <md-radio-button value=manage>Manage</md-radio-button> </md-menu-item> </md-radio-group> </md-menu-content> </md-menu> <md-divider></md-divider> </md-list-item> <md-list-item class=md-list-item ng-show=!updateNoAccess> <md-button ng-click=\"updateNoAccess = true\" class=\"md-button md-primary md-button--s space-m-l-n\">+ Add users and role</md-button> <md-divider></md-divider> </md-list-item> <md-list-item ng-show=updateNoAccess class=md-list-item> <form ng-submit=$event.preventDefault() flex> <md-autocomplete class=md-autocomplete--s ng-disabled=isDisabled md-no-cache=noCache md-selected-item=selectedItem md-search-text-change=searchTextChange(searchText) md-search-text=searchText md-selected-item-change=selectedItemChange(item) md-items=\"item in querySearch(searchText)\" md-item-text=item.display md-min-length=0 placeholder=\"Select users and roles\"> <md-item-template> <span md-highlight-text=ctrl.searchText md-highlight-flags=^i>{{item.display}}</span> </md-item-template> <md-not-found> No states matching \"{{searchText}}\" were found. <a ng-click=newState(searchText)>Create a new one!</a> </md-not-found> </md-autocomplete> </form> <md-button class=\"md-primary md-raised space-m-l-m\">Add</md-button> </md-list-item> </md-list>";

/***/ }),

/***/ "dZ/z":
/***/ (function(module, exports) {

module.exports = "<md-progress-circular class=md-hue-2 md-mode=indeterminate md-diameter=60px></md-progress-circular> <div class=space-m-v-s>DT Studio loading...</div> ";

/***/ }),

/***/ "dZZq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

var _sortBy2 = __webpack_require__("JXMh");

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utils class, helper functions
 */
var Utils = function () {
    function Utils() {
        _classCallCheck(this, Utils);
    }

    _createClass(Utils, null, [{
        key: 'convertTimestampToFormat',

        /**
         * Convert timestamp to given format
         * @param {int} timestamp - Integer representation of unix timestamp, in nanoseconds
         * @param {string} format - DateTime format
         * @returns {string} timestamp converted into string datetime representation
         * @static
         */
        value: function convertTimestampToFormat(timestamp, format) {
            var unixTime = parseInt(timestamp / _local2.default.nanoMultiplier, 10);
            return (0, _moment2.default)(unixTime).format(format);
        }

        /**
         * Replace %key% to value from parameters in given string value
         * @param {Object} parameters - Object with key:value
         * @param {string} value - String value for processing
         * @returns {string} parsed value
         * @static
         */

    }, {
        key: 'formatString',
        value: function formatString(parameters, value) {
            var result = value;

            Object.keys(parameters).forEach(function (parameter) {
                result = result.split('%' + parameter + '%').join(parameters[parameter]);
            });

            return result;
        }

        /**
         * Crawl given obj by given path and return last item from the path
         * @param {Object} obj - Object for crawl
         * @param {string} path - Path with "." delimiter
         * @param {boolean} deleteLast - if True - delete last found object
         * @returns {boolean|object} if deleteLast is given than return is true otherway return is last found object
         * @static
         */

    }, {
        key: 'crawlObjectByPath',
        value: function crawlObjectByPath(obj, path, deleteLast) {
            var pathParts = path.split('.');
            var pathLength = pathParts.length;
            var lastStep = pathLength - 1;
            var currentObject = obj;

            for (var i = 0; i < pathLength; i++) {
                if (deleteLast && i === lastStep) {
                    delete currentObject[pathParts[i]];

                    return true;
                }

                currentObject = currentObject[pathParts[i]];
            }

            return currentObject;
        }

        /**
         * Create structure in obj from given path and assign value to last item
         * @param {Object} obj - Original object
         * @param {string} path - Path with "." delimiter
         * @param {*} value - Value to assign to last item in path created in obj
         * @returns {Object} Last object created in obj from path
         * @static
         */

    }, {
        key: 'createPath',
        value: function createPath(obj, path, value) {
            var pathParts = path.split('.');
            var pathLength = pathParts.length;
            var lastStep = pathLength - 1;
            var currentObject = obj;

            for (var i = 0; i < pathLength; i++) {
                var step = pathParts[i];

                if (!(step in currentObject)) {
                    if (value && i === lastStep) {
                        currentObject[step] = value;

                        return currentObject;
                    }

                    currentObject[step] = {};
                } else if (value && i === lastStep) {
                    currentObject[step] = value;

                    return currentObject;
                }

                currentObject = currentObject[step];
            }

            return currentObject;
        }

        /**
         * Sort unsorted array by given key
         * @param {Array} unsorted - Array of object items
         * @param {string} key - Name of key for sort operation
         * @returns {Array} sorted array or empty array if unsorted is not an array or has no items or undefined
         * @static
         */

    }, {
        key: 'sortItemsByKey',
        value: function sortItemsByKey(unsorted, key) {
            if (unsorted && Array.isArray(unsorted) && unsorted.length) {
                return (0, _sortBy3.default)(unsorted, key);
            }

            return [];
        }

        /**
         * Remove keys from obj
         * @param {Object} obj
         * @param {Array} keys - Array of key names
         * @returns {Object} If keys is empty original obj is returned, otherwise new object with removed key returned
         * @static
         */

    }, {
        key: 'removeKeysFromObject',
        value: function removeKeysFromObject(obj, keys) {
            if (!keys.length) return obj;

            var tempObj = (0, _cloneDeep3.default)(obj);

            keys.forEach(function (key) {
                if (key in tempObj) {
                    delete tempObj[key];
                }
            });

            return tempObj;
        }

        /**
         * Parse response object for Sensors and Connectors tabs component and fix difference in naming
         * @param {Object} params - Object with function parameters
         * @param {{objects: Array<Object>}} params.data - Response from server
         * @param {Array<string>} [params.removeKeys=[]] - optional, List of key names to be removed from response
         * @param {string} [params.groupType='CATEGORY'] - optional, used to determine if item is category/group
         * @param {boolean} [params.addEmptyItemsArrayOnGroup=false] - optional,
         * if True - will add empty items:[] to category/group
         * @returns {Array} New array of fixed objects
         * @static
         */

    }, {
        key: 'parseNavigationData',
        value: function parseNavigationData(_ref) {
            var data = _ref.data,
                _ref$removeKeys = _ref.removeKeys,
                removeKeys = _ref$removeKeys === undefined ? [] : _ref$removeKeys,
                _ref$groupType = _ref.groupType,
                groupType = _ref$groupType === undefined ? 'CATEGORY' : _ref$groupType,
                _ref$addEmptyItemsArr = _ref.addEmptyItemsArrayOnGroup,
                addEmptyItemsArrayOnGroup = _ref$addEmptyItemsArr === undefined ? false : _ref$addEmptyItemsArr;

            if (!data || !data.objects || !Array.isArray(data.objects) || !data.objects.length) return [];

            var addName = function addName(item) {
                if (!('title' in item) && 'name' in item) {
                    item.title = item.name;
                }
            };
            var parseItem = function parseItem(child) {
                addName(child);

                return Utils.removeKeysFromObject(child, removeKeys);
            };
            var initializeItemsArray = function initializeItemsArray(obj) {
                if (groupType === obj.type && addEmptyItemsArrayOnGroup && !('items' in obj)) {
                    obj.items = [];
                }
            };
            var items = [];

            data.objects.forEach(function (item) {
                addName(item);

                if (item.children && Array.isArray(item.children) && item.children.length) {
                    item.items = item.children.map(parseItem);

                    delete item.children;
                } else if (item.items && Array.isArray(item.items) && item.items.length) {
                    item.items = item.items.map(parseItem);
                }

                initializeItemsArray(item);

                items.push(Utils.removeKeysFromObject(item, removeKeys));
            });

            return items;
        }
    }, {
        key: 'buildApiUrl',
        value: function buildApiUrl(key) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var _key$split = key.split('.'),
                _key$split2 = _slicedToArray(_key$split, 2),
                section = _key$split2[0],
                type = _key$split2[1];

            var url = '' + _local2.default.api.host + _local2.default.api.version + _local2.default.api[section][type];
            return Utils.formatString(params, url);
        }
    }, {
        key: 'compareByKey',
        value: function compareByKey(key) {
            return function (a, b) {
                if (a[key] < b[key]) {
                    return -1;
                }
                if (a[key] > b[key]) {
                    return 1;
                }
                return 0;
            };
        }
    }, {
        key: 'buildSearchIndex',
        value: function buildSearchIndex(data) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var index = [];
            var idKey = config.id || 'id';
            var displayNameKey = config.displayName || 'name';
            data.forEach(function (item) {
                index.push({
                    id: item[idKey],
                    name: item[displayNameKey],
                    searchableName: item[displayNameKey].toLowerCase()
                });
            });
            return index.sort(Utils.compareByKey('searchableName'));
        }
    }, {
        key: 'searchInIndex',
        value: function searchInIndex(index, query) {
            var provideEverything = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var searchableQuery = query.toLowerCase();

            if (!query && provideEverything) {
                return index;
            }

            return index.filter(function (item) {
                return item.searchableName.indexOf(searchableQuery) >= 0;
            });
        }
    }, {
        key: 'intervalToText',
        value: function intervalToText(seconds) {
            var minutes = seconds / 60;
            if (minutes < 5) {
                return '5m';
            }
            if (minutes < 60) {
                return Math.round(minutes) + 'm';
            }
            var hours = minutes / 60;
            if (hours < 24) {
                return Math.round(hours) + 'h';
            }
            var days = hours / 24;
            if (days < 7) {
                return Math.round(days) + 'd';
            }
            var weeks = days / 7;
            return Math.round(weeks) + 'w';
        }
    }, {
        key: 'httpExtractData',
        value: function httpExtractData(response) {
            return response.data;
        }
    }, {
        key: 'noop',
        value: function noop() {}
    }]);

    return Utils;
}();

exports.default = Utils;

/***/ }),

/***/ "dgJw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/avatar_256x256.png";

/***/ }),

/***/ "eBQt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Handlers = {
    name_changed: function name_changed(_ref, last_updated) {
        var name = _ref.name;
        // eslint-disable-line camelcase
        return {
            name: name,
            last_updated: last_updated
        };
    },
    description_changed: function description_changed(_ref2, last_updated) {
        var description = _ref2.description;
        // eslint-disable-line camelcase
        return {
            description: description,
            last_updated: last_updated
        };
    },
    location_changed: function location_changed(_ref3, last_updated) {
        var longitude = _ref3.longitude,
            latitude = _ref3.latitude;
        // eslint-disable-line camelcase
        return {
            location: {
                longitude: longitude,
                latitude: latitude
            },
            last_updated: last_updated
        };
    },
    state_changed: function state_changed(properties, updated) {
        if (!properties.object_present) {
            properties.object_present = false;
        }
        return {
            state: {
                properties: properties,
                updated: updated
            }
        };
    }
};

var RECONNECTION_INTERVAL = 3000; // 3 seconds
var HEARTBEAT_INTERVAL = 600000; // 10 minutes
var SUBSCRIPTION_READY_DELAY = 200; // 200 ms

var ThingUpdatesSubscription = function () {
    function ThingUpdatesSubscription(url, onMessageCallback) {
        _classCallCheck(this, ThingUpdatesSubscription);

        this.url = url;
        this.onMessageCallback = onMessageCallback;

        this.isAlive = null;
        this.restartTimerId = null;
        this.heartbeatTimerId = null;
        this.statusTimerId = null;

        this.start = this.start.bind(this);
        this.up = this.up.bind(this);

        this.onError = this.onError.bind(this);
        this.onMessage = this.onMessage.bind(this);
        this.onHeartbeatTimeout = this.onHeartbeatTimeout.bind(this);

        this.start();
    }

    _createClass(ThingUpdatesSubscription, [{
        key: "start",
        value: function start() {
            this.evtSource = new EventSource(this.url());

            this.evtSource.onerror = this.onError;
            this.evtSource.onmessage = this.onMessage;

            this.scheduleUp();

            this.scheduleHeartbeatTimeout();
        }
    }, {
        key: "stop",
        value: function stop() {
            this.evtSource.close();

            clearTimeout(this.restartTimerId);
            clearTimeout(this.heartbeatTimerId);
            clearTimeout(this.statusTimerId);

            this.down();
        }
    }, {
        key: "up",
        value: function up() {
            this.isAlive = true;
        }
    }, {
        key: "down",
        value: function down() {
            this.isAlive = false;
        }
    }, {
        key: "scheduleStart",
        value: function scheduleStart() {
            clearTimeout(this.restartTimerId);
            this.restartTimerId = setTimeout(this.start, RECONNECTION_INTERVAL);
        }
    }, {
        key: "scheduleHeartbeatTimeout",
        value: function scheduleHeartbeatTimeout() {
            clearTimeout(this.heartbeatTimerId);
            this.heartbeatTimerId = setTimeout(this.onHeartbeatTimeout, HEARTBEAT_INTERVAL);
        }
    }, {
        key: "scheduleUp",
        value: function scheduleUp() {
            clearTimeout(this.statusTimerId);
            this.statusTimerId = setTimeout(this.up, SUBSCRIPTION_READY_DELAY);
        }
    }, {
        key: "onHeartbeatTimeout",
        value: function onHeartbeatTimeout() {
            this.stop();
            this.start();
        }
    }, {
        key: "onError",
        value: function onError() {
            this.stop();
            this.scheduleStart();
        }
    }, {
        key: "onMessage",
        value: function onMessage(ev) {
            this.scheduleHeartbeatTimeout();

            var data = JSON.parse(ev.data);
            if (data && data.result) {
                var update = data.result;
                var patch = {};
                Object.keys(Handlers).forEach(function (section) {
                    if (section in update) {
                        patch = _extends({}, Handlers[section](update[section], update.timestamp));
                    }
                });
                this.onMessageCallback(update.thing_id, patch);
            }
        }
    }]);

    return ThingUpdatesSubscription;
}();

exports.default = ThingUpdatesSubscription;

/***/ }),

/***/ "eI8x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__("UAGM");

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ToastService settings
 * @type {{name: string, definition: ToastService}}
 */
exports.default = {
  name: 'ToastService',
  definition: _toast2.default
};

/***/ }),

/***/ "eNGi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

var _event = __webpack_require__("ZRAK");

var _event2 = _interopRequireDefault(_event);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("fxNh"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    var data = response.data;

    data.objects = data.objects.map(function (thing) {
        return new _event2.default(thing);
    });

    return data;
}

/**
 * EventsApi class.
 */

var EventsApi = function () {
    /**
     * @param {$http} $http - Angular $http service.
     * @constructor
     * @ngInject
     */
    EventsApi.$inject = ["$http"];
    function EventsApi($http) {
        _classCallCheck(this, EventsApi);

        this.$http = $http;
        this.config = _local2.default.api.events;
    }

    /**
     * Get Events
     * @returns {promise}
     */


    _createClass(EventsApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }
    }]);

    return EventsApi;
}();

exports.default = EventsApi;

/***/ }),

/***/ "eWur":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingPicture = __webpack_require__("iOie");

var _thingPicture2 = _interopRequireDefault(_thingPicture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("2gIx");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingPicture2.default
};

/***/ }),

/***/ "elwl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimePeriodController = function () {
    /** @ngInject */
    TimePeriodController.$inject = ["EventEmitter"];
    function TimePeriodController(EventEmitter) {
        _classCallCheck(this, TimePeriodController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(TimePeriodController, [{
        key: '$onInit',
        value: function $onInit() {
            this.timePeriod = {
                id: Math.floor(Math.random() * 1000)
            };

            this.ruleTimePeriod = 'always';
            this.timePeriods = [];
            this.timePeriods.push(this.timePeriod);
        }
    }, {
        key: 'addTimePeriod',
        value: function addTimePeriod() {
            this.timePeriods.push(this.period);
        }
    }, {
        key: 'isOptionTimePeriod',
        value: function isOptionTimePeriod() {
            return this.ruleTimePeriod === 'specific';
        }
    }]);

    return TimePeriodController;
}();

exports.default = TimePeriodController;

/***/ }),

/***/ "eoha":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingUpdated = __webpack_require__("WWbn");

var _thingUpdated2 = _interopRequireDefault(_thingUpdated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingUpdated',
    options: _thingUpdated2.default
};

/***/ }),

/***/ "eoya":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search = __webpack_require__("5XMH");

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("F7qz");

exports.default = {
    bindings: {
        onSearchResult: '&',
        onSaveView: '&',
        onCloseSideNav: '&'
    },
    template: template,
    controller: _search2.default
};

/***/ }),

/***/ "eshw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _healthChecker = __webpack_require__("u/Qv");

var _healthChecker2 = _interopRequireDefault(_healthChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'HealthCheckerService',
    definition: _healthChecker2.default
};

/***/ }),

/***/ "etko":
/***/ (function(module, exports) {

module.exports = "<div class=dtRule__content> <span class=dtRule__label data-ng-bind=$ctrl.rule.title></span> </div> <div class=dtRule__info> <div class=dtRule__amount ng-if=$ctrl.rule.amount> <span ng-if=$ctrl.rule.amount.break data-ng-bind=$ctrl.rule.amount.break> </span>/<span ng-if=$ctrl.rule.amount.all data-ng-bind=$ctrl.rule.amount.all></span> </div> </div> ";

/***/ }),

/***/ "euRd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/star.json";

/***/ }),

/***/ "f0H3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actions = __webpack_require__("beYs");

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("ixe6");

exports.default = {
    bindings: {
        actions: '<'
    },
    controller: _actions2.default,
    template: template
};

/***/ }),

/***/ "f1JT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabsController = function () {
    /** @ngInject */
    TabsController.$inject = ["$log", "EventEmitter"];
    function TabsController($log, EventEmitter) {
        _classCallCheck(this, TabsController);

        this.$log = $log;
        this.eventEmitter = EventEmitter;
    }

    _createClass(TabsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.selectedTabId = 0;

            if (!this.tabs) {
                this.tabs = [];
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.tabs) {
                this.findOneToBeActivated((0, _cloneDeep3.default)(changes.tabs.currentValue));
            } else {
                this.tabs = [];
            }
        }
    }, {
        key: 'findOneToBeActivated',
        value: function findOneToBeActivated(tabs) {
            var selectedTabId = null;
            var selectedTabObject = null;
            var selectedMenuItemObject = null;
            var isMenuItem = false;

            this.tabs = tabs;

            var tabsLength = tabs.length;
            for (var i = 0; i < tabsLength; ++i) {
                var tab = tabs[i];
                if ('activate' in tab) {
                    selectedTabId = i;
                    selectedTabObject = tab;
                    delete tab.activate;

                    break;
                }

                if ('items' in tab && tab.items.length) {
                    var itemsLength = tab.items.length;
                    for (var c = 0; c < itemsLength; ++c) {
                        var view = tab.items[c];
                        if ('activate' in view) {
                            selectedTabId = i;
                            selectedTabObject = tab;
                            selectedMenuItemObject = view;
                            isMenuItem = true;
                            delete view.activate;

                            break;
                        }
                    }
                }
            }

            this.emulateItemSelection(selectedTabObject, selectedTabId, selectedMenuItemObject, isMenuItem);
        }
    }, {
        key: 'emulateItemSelection',
        value: function emulateItemSelection(selectedTabObject, selectedTabId, selectedMenuItemObject, isMenuItem) {
            if (null !== selectedTabId) {
                if (isMenuItem) {
                    this.onMenuItemClick(selectedTabObject, selectedTabId, selectedMenuItemObject, false);
                } else {
                    this.selectedTabId = selectedTabId;
                    this.onClick(selectedTabObject, false);
                }
            }
        }
    }, {
        key: 'onClick',
        value: function onClick(tab, $event) {
            this.itemHandler('click', tab, $event);
        }
    }, {
        key: 'onSelect',
        value: function onSelect(tab, $event) {
            this.itemHandler('select', tab, $event);
        }
    }, {
        key: 'onDeselect',
        value: function onDeselect(tab, $event) {
            this.itemHandler('deselect', tab, $event);
        }
    }, {
        key: 'onMenuItemClick',
        value: function onMenuItemClick(tab, tabId, item, $event) {
            this.selectedTabId = tabId;
            this.menuItemHandler('menu-item-click', tab, item, $event);
        }
    }, {
        key: 'itemHandler',
        value: function itemHandler(action, tab, $event) {
            var _this = this;

            var actions = {
                'click': function click(config) {
                    var handler = config.handler;
                    var type = typeof handler === 'undefined' ? 'undefined' : _typeof(handler);

                    if (type === 'function') {
                        handler();
                    } else {
                        _this.onTabClick(_this.eventEmitter({ tab: tab, event: $event }));
                    }
                },
                'select': function select(config) {
                    var handler = config.handler;
                    var type = typeof handler === 'undefined' ? 'undefined' : _typeof(handler);

                    if (type === 'object' && 'select' in handler) {
                        handler.select();
                    } else {
                        _this.onTabSelect(_this.eventEmitter({ tab: tab, event: $event }));
                    }
                },
                'deselect': function deselect(config) {
                    var handler = config.handler;
                    var type = typeof handler === 'undefined' ? 'undefined' : _typeof(handler);

                    if (type === 'object' && 'deselect' in handler) {
                        handler.deselect();
                    } else {
                        _this.onTabDeselect(_this.eventEmitter({ tab: tab, event: $event }));
                    }
                },
                'default': function _default(config, unspecifiedAction) {
                    _this.$log.warn('DT-TABS: Provided unspecified action for item \'' + config.title + '\': ' + unspecifiedAction);
                }
            };

            (actions[action] || actions.default)(tab, action);
        }
    }, {
        key: 'menuItemHandler',
        value: function menuItemHandler(action, tab, item, $event) {
            var _this2 = this;

            var actions = {
                'menu-item-click': function menuItemClick(config) {
                    var handler = config.handler;
                    var type = typeof handler === 'undefined' ? 'undefined' : _typeof(handler);

                    if (type === 'function') {
                        handler();
                    } else {
                        _this2.onTabMenuItemClick(_this2.eventEmitter({ tab: tab, item: item, event: $event }));
                    }
                },
                'default': function _default(config, unspecifiedAction) {
                    _this2.$log.warn('DT-TABS: Provided unspecified action for item \'' + config.title + '\': ' + unspecifiedAction);
                }
            };

            (actions[action] || actions.default)(tab, action);
        }
    }]);

    return TabsController;
}();

exports.default = TabsController;

/***/ }),

/***/ "f5k9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'metadata.name';

var ThingNameController = function () {
    /** @ngInject */
    ThingNameController.$inject = ["EventEmitter"];
    function ThingNameController(EventEmitter) {
        _classCallCheck(this, ThingNameController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingNameController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.thingName) {
                this.thingName = '';
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            if (this.thingName.length) {
                this.fillBucket();

                this.pushUpdate(this.eventEmitter({
                    value: this.thingName
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket() {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingName
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            this.thingName = '';

            this.clearBucket();
        }
    }]);

    return ThingNameController;
}();

exports.default = ThingNameController;

/***/ }),

/***/ "f9ym":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _specificTime = __webpack_require__("bArM");

var _specificTime2 = _interopRequireDefault(_specificTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSpecificTime',
    options: _specificTime2.default
};

/***/ }),

/***/ "fE0V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alerts = __webpack_require__("FSQp");

var _alerts2 = _interopRequireDefault(_alerts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * AlertsApi settings
 * @type {{name: string, definition: AlertsApi}}
 */
exports.default = {
  name: 'AlertsApi',
  definition: _alerts2.default
};

/***/ }),

/***/ "fNck":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'registered';
var ANY_TEXT = 'Any';
var CUSTOM_TEXT = 'Custom';

var ThingRegisteredController = function () {
    /** @ngInject */
    ThingRegisteredController.$inject = ["EventEmitter"];
    function ThingRegisteredController(EventEmitter) {
        _classCallCheck(this, ThingRegisteredController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingRegisteredController, [{
        key: '$onInit',
        value: function $onInit() {
            this.selectedOption = null;
            this.customAfter = (0, _moment2.default)().subtract(1, 'week').toDate();
            this.customBefore = (0, _moment2.default)().toDate();
            this.anyText = ANY_TEXT;
            this.customText = CUSTOM_TEXT;
            this.values = {
                'Today': (0, _moment2.default)().format('YYYY-MM-DD'),
                'Yesterday': (0, _moment2.default)().subtract(1, 'day').format('YYYY-MM-DD'),
                'Last 30 days': (0, _moment2.default)().subtract(30, 'days').format('YYYY-MM-DD'),
                'Last 60 days': (0, _moment2.default)().subtract(60, 'days').format('YYYY-MM-DD'),
                'Last 90 days': (0, _moment2.default)().subtract(90, 'days').format('YYYY-MM-DD')
            };
        }
    }, {
        key: 'isAnySelected',
        value: function isAnySelected() {
            return this.selectedOption === ANY_TEXT;
        }
    }, {
        key: 'isCustomSelected',
        value: function isCustomSelected() {
            return this.selectedOption === CUSTOM_TEXT;
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            // eslint-disable-line consistent-return
            if (this.isAnySelected()) {
                return this.removeItemFromBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                }));
            }

            var value = {};

            if (this.isCustomSelected()) {
                value.after = (0, _moment2.default)(this.customAfter).format('YYYY-MM-DD');
                value.before = (0, _moment2.default)(this.customBefore).format('YYYY-MM-DD');
            } else {
                value.after = this.selectedOption;
            }

            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: value
                }
            }));
        }
    }]);

    return ThingRegisteredController;
}();

exports.default = ThingRegisteredController;

/***/ }),

/***/ "falf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


usersAndAccessRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = usersAndAccessRouter;

var _usersAndAccess = __webpack_require__("flzX");

/** @ngInject */
function usersAndAccessRouter($stateProvider) {
    var baseState = {
        redirectTo: 'main.users-and-access.users',
        views: {
            content: {
                component: _usersAndAccess.Component.selector
            }
        }
    };

    $stateProvider.state('main.users-and-access', baseState);
}

/***/ }),

/***/ "fcPR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    function link($scope, $element) {
        function remove() {
            $scope.onHide();

            if (document.getElementById('dt-backdrop')) {
                document.body.removeChild(document.getElementById('dt-backdrop'));
            }

            $scope.$applyAsync();
        }

        function create() {
            var backdrop = document.createElement('div');

            backdrop.id = 'dt-backdrop';
            backdrop.classList.add('dt-backdrop');
            backdrop.addEventListener('click', remove, false);

            document.body.appendChild(backdrop);
        }

        $scope.$watch('dtBackdrop', function (value) {
            if (value) {
                create();
            } else {
                remove();
            }
        });

        $element.on('$destroy', function () {
            if (document.getElementById('dt-backdrop')) {
                document.body.removeChild(document.getElementById('dt-backdrop'));
            }
        });
    }

    return {
        restrict: 'A',
        scope: {
            dtBackdrop: '<',
            onHide: '&'
        },
        link: link
    };
};

/***/ }),

/***/ "fdDM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _autocomplete = __webpack_require__("H9HM");

var _autocomplete2 = _interopRequireDefault(_autocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("/t3i");

exports.default = {
    bindings: {
        labels: '<',
        editable: '<',
        requireMatch: '<',
        placeholder: '@',
        secondaryPlaceholder: '@',
        onChange: '&',
        onAdd: '&',
        onRemove: '&'
    },
    controller: _autocomplete2.default,
    template: template
};

/***/ }),

/***/ "feVk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

var _customer = __webpack_require__("WRGe");

var _customer2 = _interopRequireDefault(_customer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("4lQk"); // eslint-disable-line global-require
    __webpack_require__("8RgO"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    var data = response.data;

    if ('customers' in data) {
        data.customers = data.customers.map(function (customer) {
            return new _customer2.default(customer);
        });
    }

    return data;
}

/**
 * CustomersApi class.
 */

var CustomersApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    CustomersApi.$inject = ["$http"];
    function CustomersApi($http) {
        _classCallCheck(this, CustomersApi);

        this.$http = $http;
        this.config = _local2.default.api.customers;
    }

    /**
     * Get Customers
     * @returns {promise}
     */


    _createClass(CustomersApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }

        /**
         * Search Customers by query
         * @param {string} query - Search pattern
         * @param {Object} metadata - Request settings, like: limit, ofset etc.
         * @returns {promise}
         */

    }, {
        key: 'search',
        value: function search(query) {
            var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.$http.get(this.config.searchUrl, {
                params: _extends({
                    query: query + '*'
                }, metadata)
            }).then(responseDataExtractor);
        }

        /**
         * Get Customer by customer id
         * @param {number} customerId - Customer id
         * @returns {promise}
         */

    }, {
        key: 'getCustomer',
        value: function getCustomer(customerId) {
            var url = _utils2.default.formatString({ customerId: customerId }, this.config.getUrl);

            return this.$http.get(url).then(responseDataExtractor);
        }

        /**
         * Activate Customer by customer id
         * @param {number} customerId - Customer id
         * @returns {promise}
         */

    }, {
        key: 'activateCustomer',
        value: function activateCustomer(customerId) {
            var url = _utils2.default.formatString({ customerId: customerId }, this.config.activateUrl);

            return this.$http.post(url).then(responseDataExtractor);
        }

        /**
         * Deactivate Customer by customer id
         * @param {number} customerId - Customer id
         * @returns {promise}
         */

    }, {
        key: 'deactivateCustomer',
        value: function deactivateCustomer(customerId) {
            var url = _utils2.default.formatString({ customerId: customerId }, this.config.deactivateUrl);

            return this.$http.post(url).then(responseDataExtractor);
        }

        /**
         * Request access to view Customer info
         * @param {{customer_id: string, message: string}} request - Request body
         * @returns {promise}
         */

    }, {
        key: 'requestAccessToCustomer',
        value: function requestAccessToCustomer(request) {
            var url = _utils2.default.formatString({ customerId: request.customer_id }, this.config.requestAccessUrl);

            return this.$http.post(url, _extends({}, request)).then(responseDataExtractor);
        }

        /**
         * Reset Customer password by customer id
         * @param {number} customerId - Customer id
         * @returns {promise}
         */

    }, {
        key: 'resetPasswordForCustomer',
        value: function resetPasswordForCustomer(customerId) {
            var url = _utils2.default.formatString({ customerId: customerId }, this.config.resetPasswordUrl);

            return this.$http.post(url).then(responseDataExtractor);
        }
    }]);

    return CustomersApi;
}();

exports.default = CustomersApi;

/***/ }),

/***/ "ffSu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = undefined;

var _accountSettings = __webpack_require__("w1+Z");

var _accountSettings2 = _interopRequireDefault(_accountSettings);

var _accountSettings3 = __webpack_require__("zUGe");

var _accountSettings4 = _interopRequireDefault(_accountSettings3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtAccountSettings',
    options: _accountSettings4.default
};

exports.Config = _accountSettings2.default;
exports.Component = Component;

/***/ }),

/***/ "fgtS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _addNote = __webpack_require__("Gqf/");

var _addNote2 = _interopRequireDefault(_addNote);

var _editNote = __webpack_require__("gKaV");

var _editNote2 = _interopRequireDefault(_editNote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddNoteTemplate = __webpack_require__("YIC/");

var EditNoteTemplate = __webpack_require__("6WEP");

var NotesController = function () {
    /** @ngInject */
    NotesController.$inject = ["NotesApi", "$q", "DialogService", "ToastService", "Loader"];
    function NotesController(NotesApi, $q, DialogService, ToastService, Loader) {
        _classCallCheck(this, NotesController);

        this.$q = $q;
        this.NotesApi = NotesApi;
        this.DialogService = DialogService;
        this.ToastService = ToastService;
        this.Loader = Loader;
    }

    _createClass(NotesController, [{
        key: '$onInit',
        value: function $onInit() {
            this.limit = 100;
            this.pageToken = '';
            this.getNotes();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset && changes.reset.currentValue === 'reset') {
                this.notes = (0, _cloneDeep3.default)(this.clonedNotes);
            }

            if (changes.thingId && changes.thingId.currentValue) {
                this.pageToken = '';
                this.getNotes();
            }
        }
    }, {
        key: 'getNotes',
        value: function getNotes() {
            var _this = this;

            var config = {
                object_id: this.thingId,
                page_size: this.limit,
                page_token: this.pageToken
            };

            this.NotesApi.getListByObject(config).then(function (data) {
                _this.notes = data.notes || [];
                _this.clonedNotes = (0, _cloneDeep3.default)(_this.notes);
                _this.pageToken = data.next_page_token;
            }, function () {
                _this.notes = [];
            });
        }
    }, {
        key: 'removeNote',
        value: function removeNote(index, noteId) {
            var _this2 = this;

            this.Loader.show();

            this.NotesApi.deleteNote(noteId).then(function () {
                _this2.notes.splice(index, 1);
                _this2.Loader.hide();
                _this2.ToastService.showSimpleTranslated('comment_was_removed');
            });
        }
    }, {
        key: 'addNoteDialog',
        value: function addNoteDialog($event) {
            this.DialogService.show({
                controller: _addNote2.default,
                controllerAs: '$ctrl',
                template: AddNoteTemplate,
                parent: document.body,
                targetEvent: $event,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    thingId: this.thingId,
                    notes: this.notes
                }
            });
        }
    }, {
        key: 'editNoteDialog',
        value: function editNoteDialog($event, note) {
            this.DialogService.show({
                controller: _editNote2.default,
                controllerAs: '$ctrl',
                template: EditNoteTemplate,
                parent: document.body,
                targetEvent: $event,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    note: note
                }
            });
        }
    }]);

    return NotesController;
}();

exports.default = NotesController;

/***/ }),

/***/ "flzX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = exports.Customers = exports.Roles = exports.Users = undefined;

var _users = __webpack_require__("/Wte");

var Users = _interopRequireWildcard(_users);

var _roles = __webpack_require__("HJdB");

var Roles = _interopRequireWildcard(_roles);

var _customers = __webpack_require__("wL9e");

var Customers = _interopRequireWildcard(_customers);

var _usersAndAccess = __webpack_require__("falf");

var _usersAndAccess2 = _interopRequireDefault(_usersAndAccess);

var _usersAndAccess3 = __webpack_require__("npfx");

var _usersAndAccess4 = _interopRequireDefault(_usersAndAccess3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Component = {
    selector: 'dtUsersAndAccess',
    options: _usersAndAccess4.default
};

exports.Users = Users;
exports.Roles = Roles;
exports.Customers = Customers;
exports.Config = _usersAndAccess2.default;
exports.Component = Component;

/***/ }),

/***/ "fxNh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/events.json";

/***/ }),

/***/ "g7I2":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-grid__row form-grid__row--static\"> <div class=form-grid__col> <md-checkbox class=md-default-theme ng-model=$ctrl.locationEnabled ng-change=$ctrl.changed() aria-label=checkbox> <span class=md-body-1>Location</span> </md-checkbox> <dt-help-icon message-key=help_icon_advanced_search_location></dt-help-icon> </div> </div> <dt-map class=dt-map--ring ng-class=\"{'disabled-block': !$ctrl.locationEnabled}\" map-options=$ctrl.mapOptions on-center-changed=$ctrl.centerChanged($event) on-bounds-changed=$ctrl.boundsChanged($event) center-coordinates=$ctrl.centerCoordinates></dt-map> ";

/***/ }),

/***/ "gDsE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _add = __webpack_require__("KgCR");

var _add2 = _interopRequireDefault(_add);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("HZ5s");

exports.default = {
    bindings: {
        onSubmit: '&',
        parentId: '<'
    },
    template: template,
    controller: _add2.default
};

/***/ }),

/***/ "gKaV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditNoteDialogController = function () {
    /** @ngInject */
    EditNoteDialogController.$inject = ["DialogService", "note", "NotesApi", "ToastService", "Loader", "ErrorsService"];
    function EditNoteDialogController(DialogService, note, NotesApi, ToastService, Loader, ErrorsService) {
        _classCallCheck(this, EditNoteDialogController);

        this.DialogService = DialogService;
        this.NotesApi = NotesApi;
        this.note = note;
        this.content = this.note.content;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    _createClass(EditNoteDialogController, [{
        key: 'onInit',
        value: function onInit() {
            this.genericErrors = this.ErrorsService.getGenericErrors();
        }
    }, {
        key: 'updateNote',
        value: function updateNote() {
            var _this = this;

            if (!this.content.length) return;
            this.Loader.show();

            this.NotesApi.editNote(this.note.id, this.content).then(function () {
                _this.note.content = _this.content;
                _this.Loader.hide();
                _this.ToastService.showSimpleTranslated('comment_was_updated');
                _this.cancel();
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.DialogService.cancel();
        }
    }]);

    return EditNoteDialogController;
}();

exports.default = EditNoteDialogController;

/***/ }),

/***/ "gfoy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _header = __webpack_require__("q2XB");

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("cER5");

exports.default = {
    bindings: {
        onShowMobileNav: '&'
    },
    template: template,
    controller: _header2.default
};

/***/ }),

/***/ "gmaI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("k0Kv"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * PrivilegesApi class.
 */

var PrivilegesApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    PrivilegesApi.$inject = ["$http"];
    function PrivilegesApi($http) {
        _classCallCheck(this, PrivilegesApi);

        this.$http = $http;
        this.config = _local2.default.api.privileges;
    }

    /**
     * Get Privileges
     * @returns {promises}
     */


    _createClass(PrivilegesApi, [{
        key: 'getList',
        value: function getList() {
            return this.$http.get(this.config.listUrl).then(responseDataExtractor);
        }
    }]);

    return PrivilegesApi;
}();

exports.default = PrivilegesApi;

/***/ }),

/***/ "gtHx":
/***/ (function(module, exports) {

module.exports = "<div class=block-title>Description</div> <div ng-if=!$ctrl.editMode> <div ng-if=$ctrl.description ng-click=$ctrl.enableEditMode() class=\"md-caption-1 block-bordered-hover\"> {{ $ctrl.description }} </div> <a ng-if=!$ctrl.description href=# ng-click=\"$event.preventDefault(); $ctrl.enableEditMode();\" class=font-size-12> + Add description </a> </div> <div ng-if=$ctrl.editMode> <md-input-container flex> <textarea ng-model=$ctrl.description ng-blur=$ctrl.disableEditMode() on-enter=$ctrl.disableEditMode() consider-special-keys=true get-focus=$ctrl.editMode aria-label=\"Thing description\"></textarea> </md-input-container> </div> ";

/***/ }),

/***/ "gw8L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccessManagementController = function AccessManagementController() {
  _classCallCheck(this, AccessManagementController);
};

exports.default = AccessManagementController;

/***/ }),

/***/ "hCZE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alertsActionsNav = __webpack_require__("ME/g");

var _alertsActionsNav2 = _interopRequireDefault(_alertsActionsNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAlertsActionsNav',
    options: _alertsActionsNav2.default
};

/***/ }),

/***/ "hETz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OnEnterDirective = exports.mdCustomColumnDirective = exports.SplashScreen = exports.UserPopover = exports.SearchBox = exports.EditNavBarDirective = exports.LabelsAutocompleteComponent = exports.SearchAutocompleteComponent = exports.EntitiesAutocompleteComponent = exports.EntitiesListComponent = exports.SaveView = exports.RadioStatusComponent = exports.ThingStarComponent = exports.FolderPathEditDirective = exports.FolderPathComponent = exports.BatteryStatusComponent = exports.RuleComponent = exports.RulesListComponent = exports.AccessManagementComponent = exports.Tree = exports.Navigation = exports.MapComponent = exports.ChartDirective = exports.BlockLoaderDirective = exports.BackropDirective = exports.GetWidthDirective = exports.GetFocusDirective = exports.StickyDirective = exports.ShyDirective = exports.DragDrop = exports.ScreenshotDirective = exports.HelpMenuComponent = exports.HelpIconComponent = exports.IconDirective = exports.IconComponent = exports.EmptyState = exports.LoaderService = exports.LoaderComponent = exports.ContentHeaderComponent = exports.ContentComponent = exports.HeaderComponent = exports.LayoutComponent = undefined;

var _layout = __webpack_require__("igbh");

var _layout2 = _interopRequireDefault(_layout);

var _content = __webpack_require__("IIPq");

var _content2 = _interopRequireDefault(_content);

var _contentHeader = __webpack_require__("L0bV");

var _contentHeader2 = _interopRequireDefault(_contentHeader);

var _header = __webpack_require__("Iu/K");

var _header2 = _interopRequireDefault(_header);

var _loader = __webpack_require__("ro6T");

var _emptyState = __webpack_require__("s9eL");

var _emptyState2 = _interopRequireDefault(_emptyState);

var _icon = __webpack_require__("l2Hp");

var _helpIcon = __webpack_require__("B2oC");

var _helpIcon2 = _interopRequireDefault(_helpIcon);

var _helpMenu = __webpack_require__("Nw2O");

var _helpMenu2 = _interopRequireDefault(_helpMenu);

var _screenshot = __webpack_require__("FUR/");

var _screenshot2 = _interopRequireDefault(_screenshot);

var _dragDrop = __webpack_require__("VB4T");

var _dragDrop2 = _interopRequireDefault(_dragDrop);

var _shy = __webpack_require__("5WPP");

var _shy2 = _interopRequireDefault(_shy);

var _sticky = __webpack_require__("7Dj5");

var _sticky2 = _interopRequireDefault(_sticky);

var _getFocus = __webpack_require__("jvs+");

var _getFocus2 = _interopRequireDefault(_getFocus);

var _getWidth = __webpack_require__("5kx/");

var _getWidth2 = _interopRequireDefault(_getWidth);

var _backdrop = __webpack_require__("Ww8C");

var _backdrop2 = _interopRequireDefault(_backdrop);

var _blockLoader = __webpack_require__("ilt8");

var _blockLoader2 = _interopRequireDefault(_blockLoader);

var _chart = __webpack_require__("3/H6");

var _chart2 = _interopRequireDefault(_chart);

var _map = __webpack_require__("67p2");

var _map2 = _interopRequireDefault(_map);

var _tree = __webpack_require__("I2Bg");

var Tree = _interopRequireWildcard(_tree);

var _navbar = __webpack_require__("zF9l");

var Navigation = _interopRequireWildcard(_navbar);

var _accessManagement = __webpack_require__("BM2Z");

var _accessManagement2 = _interopRequireDefault(_accessManagement);

var _rulesList = __webpack_require__("tlV/");

var _rulesList2 = _interopRequireDefault(_rulesList);

var _rule = __webpack_require__("0+U/");

var _rule2 = _interopRequireDefault(_rule);

var _batteryStatus = __webpack_require__("nZcg");

var _batteryStatus2 = _interopRequireDefault(_batteryStatus);

var _folderPath = __webpack_require__("CX8Z");

var _folderPath2 = _interopRequireDefault(_folderPath);

var _folderPathEdit = __webpack_require__("3ulZ");

var _folderPathEdit2 = _interopRequireDefault(_folderPathEdit);

var _thingStar = __webpack_require__("GLmD");

var _thingStar2 = _interopRequireDefault(_thingStar);

var _radioStatus = __webpack_require__("bupA");

var _radioStatus2 = _interopRequireDefault(_radioStatus);

var _saveView = __webpack_require__("KMsy");

var SaveView = _interopRequireWildcard(_saveView);

var _editNavbar = __webpack_require__("i0k+");

var _editNavbar2 = _interopRequireDefault(_editNavbar);

var _entitiesList = __webpack_require__("MdYb");

var _entitiesList2 = _interopRequireDefault(_entitiesList);

var _entitiesAutocomplete = __webpack_require__("5GET");

var _entitiesAutocomplete2 = _interopRequireDefault(_entitiesAutocomplete);

var _searchAutocomplete = __webpack_require__("IcLX");

var _searchAutocomplete2 = _interopRequireDefault(_searchAutocomplete);

var _labelsAutocomplete = __webpack_require__("07mR");

var _labelsAutocomplete2 = _interopRequireDefault(_labelsAutocomplete);

var _searchBox = __webpack_require__("rkt6");

var _searchBox2 = _interopRequireDefault(_searchBox);

var _userPopover = __webpack_require__("W6Gc");

var _userPopover2 = _interopRequireDefault(_userPopover);

var _splashScreen = __webpack_require__("sTKR");

var _splashScreen2 = _interopRequireDefault(_splashScreen);

var _mdCustomColumn = __webpack_require__("X2ui");

var _mdCustomColumn2 = _interopRequireDefault(_mdCustomColumn);

var _onEnter = __webpack_require__("Xt60");

var _onEnter2 = _interopRequireDefault(_onEnter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.LayoutComponent = _layout2.default;
exports.HeaderComponent = _header2.default;
exports.ContentComponent = _content2.default;
exports.ContentHeaderComponent = _contentHeader2.default;
exports.LoaderComponent = _loader.LoaderComponent;
exports.LoaderService = _loader.LoaderService;
exports.EmptyState = _emptyState2.default;
exports.IconComponent = _icon.IconComponent;
exports.IconDirective = _icon.IconDirective;
exports.HelpIconComponent = _helpIcon2.default;
exports.HelpMenuComponent = _helpMenu2.default;
exports.ScreenshotDirective = _screenshot2.default;
exports.DragDrop = _dragDrop2.default;
exports.ShyDirective = _shy2.default;
exports.StickyDirective = _sticky2.default;
exports.GetFocusDirective = _getFocus2.default;
exports.GetWidthDirective = _getWidth2.default;
exports.BackropDirective = _backdrop2.default;
exports.BlockLoaderDirective = _blockLoader2.default;
exports.ChartDirective = _chart2.default;
exports.MapComponent = _map2.default;
exports.Navigation = Navigation;
exports.Tree = Tree;
exports.AccessManagementComponent = _accessManagement2.default;
exports.RulesListComponent = _rulesList2.default;
exports.RuleComponent = _rule2.default;
exports.BatteryStatusComponent = _batteryStatus2.default;
exports.FolderPathComponent = _folderPath2.default;
exports.FolderPathEditDirective = _folderPathEdit2.default;
exports.ThingStarComponent = _thingStar2.default;
exports.RadioStatusComponent = _radioStatus2.default;
exports.SaveView = SaveView;
exports.EntitiesListComponent = _entitiesList2.default;
exports.EntitiesAutocompleteComponent = _entitiesAutocomplete2.default;
exports.SearchAutocompleteComponent = _searchAutocomplete2.default;
exports.LabelsAutocompleteComponent = _labelsAutocomplete2.default;
exports.EditNavBarDirective = _editNavbar2.default;
exports.SearchBox = _searchBox2.default;
exports.UserPopover = _userPopover2.default;
exports.SplashScreen = _splashScreen2.default;
exports.mdCustomColumnDirective = _mdCustomColumn2.default;
exports.OnEnterDirective = _onEnter2.default;

/***/ }),

/***/ "hJ5p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bulkEdit = __webpack_require__("Pj1t");

var _bulkEdit2 = _interopRequireDefault(_bulkEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bulkEditTemplate = __webpack_require__("rGCW");

var ThingsToolboxController = function () {
    /**
     * @param ThingsService
     * @param EventEmitter
     * @param DialogService
     * @param $state
     * @ngInject
     */
    ThingsToolboxController.$inject = ["ThingsService", "EventEmitter", "DialogService", "$state"];
    function ThingsToolboxController(ThingsService, EventEmitter, DialogService, $state) {
        _classCallCheck(this, ThingsToolboxController);

        this.ThingsService = ThingsService;
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.$state = $state;
    }

    _createClass(ThingsToolboxController, [{
        key: '$onInit',
        value: function $onInit() {
            this.showFilterParams = false;
            this.isSearchFocused = false;
            this.iconSize = 'm';
            this.things = this.ThingsService.getAllThings();
        }
    }, {
        key: 'searchByType',
        value: function searchByType(type) {
            this.predefinedQuery = 'type.id:' + type;
            this.passSearchResult({
                query: this.predefinedQuery
            });
            this.closeFilterParams();
        }
    }, {
        key: 'searchStarred',
        value: function searchStarred() {
            this.predefinedQuery = 'starred:true';
            this.passSearchResult({
                query: this.predefinedQuery
            });
            this.closeFilterParams();
        }
    }, {
        key: 'toggleFilterParams',
        value: function toggleFilterParams() {
            this.showFilterParams = !this.showFilterParams;
        }
    }, {
        key: 'clearSearch',
        value: function clearSearch() {
            this.onEmptySearch();
        }
    }, {
        key: 'closeFilterParams',
        value: function closeFilterParams() {
            this.showFilterParams = false;
        }
    }, {
        key: 'isShowFilterParams',
        value: function isShowFilterParams() {
            return this.showFilterParams;
        }
    }, {
        key: 'onSearchFocusChange',
        value: function onSearchFocusChange($event) {
            if (this.showFilterParams) {
                this.showFilterParams = !$event.isFocused;
            }
            this.isSearchFocused = $event.isFocused;
        }
    }, {
        key: 'onClickAdvancedSearch',
        value: function onClickAdvancedSearch() {
            this.toggleFilterParams();

            this.onShowAdvancedSearch();
        }
    }, {
        key: 'showGraphs',
        value: function showGraphs() {
            this.$state.go('main.sensors.graphs');
        }
    }, {
        key: 'openBulkEditPopup',
        value: function openBulkEditPopup(ev) {
            this.DialogService.show({
                controller: _bulkEdit2.default,
                controllerAs: '$ctrl',
                template: bulkEditTemplate,
                parent: document.body,
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    selectedThings: this.selectedThings
                }
            });
        }
    }, {
        key: 'passSearchResult',
        value: function passSearchResult(_ref) {
            var query = _ref.query;

            this.onSearchResult(this.eventEmitter({ query: query }));
        }
    }]);

    return ThingsToolboxController;
}();

exports.default = ThingsToolboxController;

/***/ }),

/***/ "hTSO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ "hgJw":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "hjtK":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "hkk2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _apiAccess = __webpack_require__("Kkkf");

var _apiAccess2 = _interopRequireDefault(_apiAccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("4+qO");

exports.default = {
    controller: _apiAccess2.default,
    template: template
};

/***/ }),

/***/ "hn1p":
/***/ (function(module, exports) {

module.exports = "<md-radio-group layout=row layout-align=\"start start\" ng-model=$ctrl.ruleTimePeriod> <div>Rule is active</div> <md-radio-button class=\"space-m-l-xl space-m-r-l\" value=always> Always </md-radio-button> <div layout=column class=space-m-l-xl> <md-radio-button class=space-m-b-s value=specific> Specific time only </md-radio-button> <div ng-if=$ctrl.isOptionTimePeriod()> <dt-specific-time class=md-block ng-repeat=\"item in $ctrl.timePeriods track by $index\"></dt-specific-time> <div> <a href=# class=md-caption ng-click=\"$ctrl.addTimePeriod(); $event.preventDefault();\">+ Add another time period</a> </div> </div> </div> </md-radio-group> ";

/***/ }),

/***/ "hr0G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingsToolbox = __webpack_require__("jhaL");

var _thingsToolbox2 = _interopRequireDefault(_thingsToolbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingsToolbox',
    options: _thingsToolbox2.default
};

/***/ }),

/***/ "hz5C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'folders';

var ThingFoldersController = function () {
    /** @ngInject */
    ThingFoldersController.$inject = ["EventEmitter"];
    function ThingFoldersController(EventEmitter) {
        _classCallCheck(this, ThingFoldersController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingFoldersController, [{
        key: '$onInit',
        value: function $onInit() {
            this.selectedItems = [];
            this.folderModel = {};
        }
    }, {
        key: 'showSelectedFolders',
        value: function showSelectedFolders() {
            this.triggerExpansionOfSelected = true;
        }
    }, {
        key: 'unselectFolders',
        value: function unselectFolders() {
            var _this = this;

            this.selectedItems = this.selectedItems.filter(function (folderId) {
                delete _this.folderModel[folderId];
                return false;
            });
            this.prepareBucket();
        }
    }, {
        key: 'folderModelChanged',
        value: function folderModelChanged(_ref) {
            var folderIds = _ref.folderIds;

            this.selectedItems = folderIds;
            this.prepareBucket();
        }
    }, {
        key: 'prepareBucket',
        value: function prepareBucket() {
            if (this.selectedItems.length) {
                this.addItemToBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME,
                        value: this.selectedItems
                    }
                }));
            } else {
                this.removeItemFromBucket(this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                }));
            }
        }
    }]);

    return ThingFoldersController;
}();

exports.default = ThingFoldersController;

/***/ }),

/***/ "i017":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/app.menu.json";

/***/ }),

/***/ "i0k+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _editNavbar = __webpack_require__("yH9N");

var _editNavbar2 = _interopRequireDefault(_editNavbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtEditNavbar',
    options: _editNavbar2.default
};

/***/ }),

/***/ "i2/F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThingName = exports.ThingDetailsFolder = exports.ThingDetailsLabels = exports.RecentEventsComponent = exports.PermissionsComponent = exports.NotesComponent = exports.ThingDescription = exports.ThingLocation = exports.GeneralInformationComponent = exports.DetailsChartComponent = exports.AlertBoxComponent = exports.AdvancedInformationComponent = exports.Component = undefined;

var _thingDetails = __webpack_require__("auPI");

var _thingDetails2 = _interopRequireDefault(_thingDetails);

var _advancedInformation = __webpack_require__("PYb+");

var _advancedInformation2 = _interopRequireDefault(_advancedInformation);

var _alertBox = __webpack_require__("v7S/");

var _alertBox2 = _interopRequireDefault(_alertBox);

var _detailsChart = __webpack_require__("18Me");

var _detailsChart2 = _interopRequireDefault(_detailsChart);

var _generalInformation = __webpack_require__("Ffr7");

var _generalInformation2 = _interopRequireDefault(_generalInformation);

var _thingLocation = __webpack_require__("ZAqp");

var _thingLocation2 = _interopRequireDefault(_thingLocation);

var _thingName = __webpack_require__("CUUb");

var _thingName2 = _interopRequireDefault(_thingName);

var _thingDetailsLabels = __webpack_require__("7mjG");

var _thingDetailsLabels2 = _interopRequireDefault(_thingDetailsLabels);

var _thingDetailsFolder = __webpack_require__("wJTK");

var _thingDetailsFolder2 = _interopRequireDefault(_thingDetailsFolder);

var _thingDescription = __webpack_require__("PUh1");

var _thingDescription2 = _interopRequireDefault(_thingDescription);

var _notes = __webpack_require__("lb0K");

var _notes2 = _interopRequireDefault(_notes);

var _permissions = __webpack_require__("mvAe");

var _permissions2 = _interopRequireDefault(_permissions);

var _recentEvents = __webpack_require__("wJzk");

var _recentEvents2 = _interopRequireDefault(_recentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtThingDetails',
    options: _thingDetails2.default
};

exports.Component = Component;
exports.AdvancedInformationComponent = _advancedInformation2.default;
exports.AlertBoxComponent = _alertBox2.default;
exports.DetailsChartComponent = _detailsChart2.default;
exports.GeneralInformationComponent = _generalInformation2.default;
exports.ThingLocation = _thingLocation2.default;
exports.ThingDescription = _thingDescription2.default;
exports.NotesComponent = _notes2.default;
exports.PermissionsComponent = _permissions2.default;
exports.RecentEventsComponent = _recentEvents2.default;
exports.ThingDetailsLabels = _thingDetailsLabels2.default;
exports.ThingDetailsFolder = _thingDetailsFolder2.default;
exports.ThingName = _thingName2.default;

/***/ }),

/***/ "i3LK":
/***/ (function(module, exports) {

module.exports = "<md-input-container class=space-m-b-n> <label>Sensor name</label> <input type=text ng-blur=$ctrl.save() on-enter=$ctrl.save() ng-model=$ctrl.name /> </md-input-container>";

/***/ }),

/***/ "iJjq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
  return response.data;
}

/**
 * NavigationApi class.
 */

var NavigationApi = function () {
  /**
   * @param {$http} $http - Angular $http service
   * @constructor
   * @ngInject
   */
  NavigationApi.$inject = ["$http"];
  function NavigationApi($http) {
    _classCallCheck(this, NavigationApi);

    this.$http = $http;
  }

  /**
   * Get Sensors and Connectors navigation data
   * @returns {promise}
   */


  _createClass(NavigationApi, [{
    key: "getSensorsAndConnectors",
    value: function getSensorsAndConnectors() {
      return this.$http.get(this.config.sensorsAndConnectorsUrl).then(responseDataExtractor);
    }

    /**
     * Update Sensors and Connectors navigation data
     * @param {Array<Object>} objects - Objects to be saved as Sensors and Connectors navigation data
     * @returns {promise}
     */

  }, {
    key: "updateSensorsAndConnectors",
    value: function updateSensorsAndConnectors(objects) {
      return this.$http.put(this.config.sensorsAndConnectorsUrl, { objects: objects }).then(responseDataExtractor);
    }
  }]);

  return NavigationApi;
}();

exports.default = NavigationApi;

/***/ }),

/***/ "iNTz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


notificationsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = notificationsRouter;

var _notifications = __webpack_require__("TntW");

/** @ngInject */
function notificationsRouter($stateProvider) {
    var baseState = {
        url: '/notifications',
        views: {
            content: {
                component: _notifications.Component.selector
            }
        }
    };

    $stateProvider.state('main.notifications', baseState);
}

/***/ }),

/***/ "iOF9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chars = __webpack_require__("aYHq");

var _chars2 = _interopRequireDefault(_chars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * CharsService class.
 * Use this service to get usefull information about char.
 */
var CharsService = function () {
  /**
   * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
   * @constructor
   * @ngInject
   */
  function CharsService() {
    _classCallCheck(this, CharsService);

    this.data = _chars2.default.data;
  }

  /**
   * Get list of coordinates
   * @returns {Object} Return all coordinates configs
   */


  _createClass(CharsService, [{
    key: 'getList',
    value: function getList() {
      return this.data;
    }

    /**
     * Get char information
     * @param {string} char - Char symbol
     * @returns {{}|null} Return char config or null if absent
     */

  }, {
    key: 'getChar',
    value: function getChar(char) {
      return this.data[char] || null;
    }
  }]);

  return CharsService;
}();

exports.default = CharsService;

/***/ }),

/***/ "iOie":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'metadata.photo_url';

var ThingPictureController = function () {
    /** @ngInject */
    ThingPictureController.$inject = ["EventEmitter"];
    function ThingPictureController(EventEmitter) {
        _classCallCheck(this, ThingPictureController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingPictureController, [{
        key: '$onInit',
        value: function $onInit() {
            this.thingPicture = false;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            if (this.thingPicture) {
                this.fillBucket();

                this.pushUpdate(this.eventEmitter({
                    value: this.thingPicture
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket() {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingPicture
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            this.thingPicture = false;

            this.clearBucket();
        }
    }]);

    return ThingPictureController;
}();

exports.default = ThingPictureController;

/***/ }),

/***/ "igbh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _layout = __webpack_require__("axRE");

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtLayout',
    options: _layout2.default
};

/***/ }),

/***/ "ilcP":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"start start\" flex layout-margin ng-switch on=$ctrl.mainViewType> <div class=content-box layout=column flex ng-switch-when=LIST> <div layout=row layout-align=\"start center\" layout-wrap class=space-m-b-l> <dt-search-box class=flex flex=noshrink query=$ctrl.listMetadata.query on-search=$ctrl.search($event) on-clear=$ctrl.clearSearchResult() on-more-options-clicked=$ctrl.showAdvancedSearch($event);></dt-search-box> <div class=things-toolbox__controls> <md-button ng-disabled=true class=md-primary ui-sref=main.sensors.graphs> View Graphs </md-button> <span title=\"This feature is not available yet\"> <md-button ng-disabled=true class=md-primary> Bulk Edit </md-button> </span> <span title=\"This feature is not available yet\"> <md-menu md-offset=\"-50 60\"> <md-button class=md-primary ng-click=$mdOpenMenu($event) ng-disabled=true> Export List <md-icon class=material-icons>arrow_drop_down</md-icon> </md-button> <md-menu-content width=3> <md-menu-item> <md-button> <span md-menu-align-target>JSON</span> </md-button> </md-menu-item> <md-menu-item> <md-button> <span md-menu-align-target>CSV</span> </md-button> </md-menu-item> </md-menu-content> </md-menu> </span> </div> </div> <div class=\"dt-animated dt-fade-in\" ng-if=\"$ctrl.showUpdateButton && !$ctrl.showWarning\" layout=row layout-align=\"center center\" layout-padding> <md-button class=\"md-fab md-mini md-primary\" ng-click=$ctrl.loadList() aria-label=\"Refresh List\"> <md-icon>refresh</md-icon> </md-button> Sorting may no longer be valid due to live sensor updates </div> <div class=\"dt-animated dt-fade-in\" ng-if=$ctrl.showWarning layout=row layout-align=\"center center\" layout-padding> <md-button class=\"md-fab md-mini md-primary\" ng-click=$ctrl.loadList() aria-label=\"Refresh List\"> <md-icon>refresh</md-icon> </md-button> <span>The list might not be up to date because the connection was lost</span> </div> <dt-things-list things=$ctrl.things metadata=$ctrl.thingsMetadata on-list-reorder=$ctrl.onListReorder(order) on-select-thing=$ctrl.onSelectThing($event); on-thing-starred=$ctrl.thingUpdated($event) selected-things=$ctrl.selectedThings> </dt-things-list> <div data-im-so-shy data-scroll-selector=\"'.dt-layout-content__container'\" data-on-visible=$ctrl.onListEndReached() data-should-trigger=$ctrl.enableInfinteScroll></div> </div> <div class=content-box layout=column flex ng-switch-when=GRAPH> <div ui-view=centralPanel event-received=$ctrl.lastEventReceived></div> </div> <div class=sidebar-right ui-view=rightPanel thing-update=$ctrl.thingUpdate on-thing-updated=$ctrl.thingUpdated($event) on-search-result=\"$ctrl.search($event, true)\" on-save-view=$ctrl.updateNavBar() on-nav-bar-update=$ctrl.updateNavBar() ng-show=$ctrl.isSideNavOpen></div> </div>";

/***/ }),

/***/ "ilt8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _blockLoader = __webpack_require__("suGq");

var _blockLoader2 = _interopRequireDefault(_blockLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtBlockLoader',
    options: _blockLoader2.default
};

/***/ }),

/***/ "isvF":
/***/ (function(module, exports) {

module.exports = "<span class=\"icons icons--{{ $ctrl.colorClass }} icons--{{ $ctrl.iconSize }}\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=true data-ng-if=$ctrl.hasExclamation></i> <md-icon dt-icon-attributes md-svg-icon=\"{{ $ctrl.iconClass }}\"></md-icon> </span> ";

/***/ }),

/***/ "ixe6":
/***/ (function(module, exports) {

module.exports = "<h4 class=block-title>Actions</h4> <div>What do you want to happen when this rule is triggered?</div> <div ng-repeat=\"action in $ctrl.actions track by $index\"> <dt-alerts-actions-create-notification ng-if=\"action.type === 'notification'\" action=action on-close=$ctrl.removeAction($event);></dt-alerts-actions-create-notification> <dt-alerts-actions-send-mail ng-if=\"action.type === 'email'\" action=action on-close=$ctrl.removeAction($event);></dt-alerts-actions-send-mail> <dt-alerts-actions-trigger-webhook ng-if=\"action.type === 'webhook'\" action=action on-close=$ctrl.removeAction($event);></dt-alerts-actions-trigger-webhook> </div> <section> <div>Add more actions:</div> <div class=\"list-button space-m-b-m\"> <div class=list-button__content> <md-button class=md-button--bigger md-colors=\"{background: 'blueGrey-400'}\" ng-click=$ctrl.addNotification()>Create Notification</md-button> <md-button class=md-button--bigger md-colors=\"{background: 'blueGrey-400'}\" ng-click=$ctrl.addEmail()>Send email</md-button> <md-button class=md-button--bigger md-colors=\"{background: 'blueGrey-400'}\" ng-click=$ctrl.addWebHook()>Trigger Webhook</md-button> <md-button class=md-primary>Show more</md-button> </div> </div> </section> ";

/***/ }),

/***/ "iy6E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mapPopup = __webpack_require__("t5Zq");

var _mapPopup2 = _interopRequireDefault(_mapPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapPopupTemplate = __webpack_require__("0F4W");

var ThingsListController = function () {
    /** @ngInject */
    ThingsListController.$inject = ["EventEmitter", "DialogService", "GeoService"];
    function ThingsListController(EventEmitter, DialogService, GeoService) {
        _classCallCheck(this, ThingsListController);

        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.GeoService = GeoService;
    }

    _createClass(ThingsListController, [{
        key: '$onInit',
        value: function $onInit() {
            this.order = '';
            this.selected = [];
            this.allSelected = false;
            this.showSelectAllHint = false;
            this.orderCounter = {};
            this.defaultCoordinates = this.GeoService.getCoordsByKey('default') || {};

            this.onReorderBinded = this.onReorder.bind(this);
            this.onListItemSelectedBinded = this.onListItemSelected.bind(this);
            this.onListItemUnselectedBinded = this.onListItemUnselected.bind(this);
        }
    }, {
        key: 'showLocation',
        value: function showLocation(ev, location) {
            var marker = void 0;
            var centerCoordinates = void 0;

            if (location) {
                centerCoordinates = {
                    lat: location.latitude,
                    lng: location.longitude,
                    address: location.address
                };

                marker = centerCoordinates;
            } else {
                centerCoordinates = {
                    lat: this.defaultCoordinates.lat,
                    lng: this.defaultCoordinates.lng
                };
            }

            this.DialogService.show({
                controller: _mapPopup2.default,
                template: MapPopupTemplate,
                controllerAs: '$ctrl',
                parent: document.body,
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                locals: {
                    marker: marker,
                    centerCoordinates: centerCoordinates,
                    updateMarker: null,
                    isEditing: false
                }
            });
        }
    }, {
        key: 'hasLocation',
        value: function hasLocation(location) {
            // eslint-disable-line class-methods-use-this
            return location && location.latitude && location.longitude;
        }
    }, {
        key: 'onReorder',
        value: function onReorder(order) {
            this.onListReorder({
                order: order
            });
        }
    }, {
        key: 'onChangeThingStarred',
        value: function onChangeThingStarred(_ref, thing) {
            var starred = _ref.starred;

            this.onThingStarred(this.eventEmitter({
                thing: {
                    id: thing.id,
                    starred: starred
                }
            }));
        }
    }, {
        key: 'onListItemSelected',
        value: function onListItemSelected() {
            if (this.things.length === this.selected.length) {
                this.showSelectAllHint = true;
            }
            this.prepareSelectedThings(this.allSelected);
        }
    }, {
        key: 'onListItemUnselected',
        value: function onListItemUnselected() {
            this.hideSelectAllHint();
            this.toggleAllSelected(false);
        }
    }, {
        key: 'hideSelectAllHint',
        value: function hideSelectAllHint() {
            this.showSelectAllHint = false;
        }
    }, {
        key: 'toggleAllSelected',
        value: function toggleAllSelected(state) {
            this.allSelected = state;
            this.prepareSelectedThings(this.allSelected);
        }
    }, {
        key: 'prepareSelectedThings',
        value: function prepareSelectedThings(isQuery) {
            this.selectedThings.isQuery = isQuery;
            this.selectedThings.list = this.selected;
            this.selectedThings.totalSelected = isQuery ? this.metadata.total : this.selected.length;
        }
    }, {
        key: 'onThingSelect',
        value: function onThingSelect(thing) {
            this.onSelectThing(this.eventEmitter({
                thing: thing
            }));
        }

        // TODO: Dirty check - we must refactor this

    }, {
        key: 'isThingSelected',
        value: function isThingSelected(thing) {
            return null !== this.selectedThing && this.selectedThing === thing;
        }
    }, {
        key: 'getThings',
        value: function getThings() {
            return this.things;
        }
    }]);

    return ThingsListController;
}();

exports.default = ThingsListController;

/***/ }),

/***/ "j9t6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    chart: {
        type: 'scatter'
    },
    yAxis: {
        tickInterval: 1
    },
    plotOptions: {
        scatter: {
            marker: {
                radius: 3
            }
        }
    },
    tooltip: {
        formatter: function formatter() {
            return (0, _moment2.default)(this.x).format('dddd, MMM D, HH:mm') + '<br>\u25CF Touch Count: <b>' + this.y + '</b>';
        }
    }
};

/***/ }),

/***/ "jGr0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/navigation-sensors-and-connectors.json";

/***/ }),

/***/ "jJjP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


stickyDirectiveConfig.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = stickyDirectiveConfig;
/** @ngInject */
function stickyDirectiveConfig($timeout) {
    function link($scope, $element) {
        var scrollContainer = document.querySelector($scope.container);
        var from = parseInt($scope.dtStickyFrom, 10);
        var to = parseInt($scope.dtStickyTo, 10);
        var gutter = 16;
        var scrollTop = 0;

        function setFixedMode() {
            $element.css('top', from + 'px').addClass('sticky-fixed');

            if ($element[0].offsetHeight > scrollContainer.offsetHeight - from - to) {
                $element.css('bottom', to + 'px');
            }
        }

        function removeFixedMod() {
            $element[0].scrollTop = 0;
            $element.removeClass('sticky-fixed');
        }

        function onScroll() {
            scrollTop = scrollContainer.scrollTop;
            $element.parent().css('min-height', $element[0].offsetHeight + 'px');

            if (scrollTop > from + gutter) {
                setFixedMode();
            } else {
                removeFixedMod();
            }
        }

        $timeout(function () {
            onScroll();
        }, 1);

        scrollContainer.addEventListener('scroll', onScroll);

        $element.on('$destroy', function () {
            scrollContainer.removeEventListener('scroll', onScroll);
        });
    }

    return {
        restrict: 'A',
        scope: {
            container: '@',
            dtStickyFrom: '@',
            dtStickyTo: '@'
        },
        link: link
    };
}

/***/ }),

/***/ "jMGr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _folders = __webpack_require__("caQq");

var _folders2 = _interopRequireDefault(_folders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'FolderService',
    definition: _folders2.default
};

/***/ }),

/***/ "jY6q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/unstar.json";

/***/ }),

/***/ "jbMY":
/***/ (function(module, exports) {

module.exports = "<form class=dtSearch-box__tools ng-submit=$ctrl.search()> <md-button class=\"md-primary md-icon-button dtSearch-box__search-btn\" ng-click=$ctrl.search()> <md-icon class=\"material-icons material-icons--m\">search</md-icon> </md-button> <input class=dtSearch-box__input type=search placeholder=\"Search for things\" ng-focus=$ctrl.focused() ng-blur=$ctrl.blurred() ng-change=$ctrl.queryChanged() ng-model=$ctrl.query> <div class=dtSearch-box__controls> <md-button class=md-icon-button ng-if=$ctrl.query ng-click=$ctrl.clear()> <md-icon class=material-icons>clear</md-icon> </md-button> <md-button class=md-icon-button ng-click=$ctrl.toggleDropdownPanel()> <md-icon class=material-icons>arrow_drop_down</md-icon> </md-button> </div> </form> <div class=dtSearch-box__dropdown ng-if=$ctrl.dropdownVisible> <md-list class=dtSearch-box__nav> <md-list-item ui-sref=main.sensors.list.search ng-click=$ctrl.hideDropdownPanel();> <md-button class=\"md-primary u-events-none\">Show more search options</md-button> <div class=md-secondary> <md-icon class=\"md-primary material-icons material-icons--m\">arrow_forward</md-icon> </div> </md-list-item> <md-list-item ng-click=$ctrl.searchStarred()> <md-icon class=\"space-m-h-xs space-m-t-s\" md-svg-icon=star></md-icon> <div class=md-body-1 flex>Starred things</div> </md-list-item> <md-list-item layout=row layout-align=\"start center\" ng-click=$ctrl.searchByType(thing.type) ng-repeat=\"thing in ::$ctrl.things track by $index\"> <span class=\"icons icons--m space-m-r-s\"> <md-icon md-svg-icon=\"{{ ::thing.icon }}\"></md-icon> </span> <div class=md-body-1>{{ ::thing.titlePlural }}</div> </md-list-item> </md-list> </div> ";

/***/ }),

/***/ "jhaL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingsToolbox = __webpack_require__("hJ5p");

var _thingsToolbox2 = _interopRequireDefault(_thingsToolbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Lghj");

exports.default = {
    bindings: {
        predefinedQuery: '<',
        onShowAdvancedSearch: '&',
        onSearchResult: '&',
        onEmptySearch: '&',
        selectedThings: '<'
    },
    template: template,
    controller: _thingsToolbox2.default
};

/***/ }),

/***/ "jkOr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search = __webpack_require__("32Ub");

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSimpleSearch',
    options: _search2.default
};

/***/ }),

/***/ "joEl":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Folders & Labels'\"></dt-content-header> <dt-tabs flex tabs=$ctrl.tabs on-tab-click=$ctrl.onTabClickProxy($event)></dt-tabs> <div ui-view=contentBody></div> ";

/***/ }),

/***/ "jrjf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _translation = __webpack_require__("sZOI");

var _translation2 = _interopRequireDefault(_translation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'TranslationService',
    definition: _translation2.default
};

/***/ }),

/***/ "jvs+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getFocus = __webpack_require__("x2ce");

var _getFocus2 = _interopRequireDefault(_getFocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'getFocus',
    options: _getFocus2.default
};

/***/ }),

/***/ "k/Q+":
/***/ (function(module, exports) {

module.exports = "<div class=block-title>Folder</div> <div layout=row layout-align=\"start center\"> <dt-folder-path ng-if=$ctrl.folderId folder-id=$ctrl.folderId class=font-size-12></dt-folder-path> <a dt-folder-path-edit=$ctrl.folderId dt-folder-path-edit-callback=$ctrl.onFolderChanged($event) href=# ng-click=$event.preventDefault() ng-class=\"{'space-m-l-s': $ctrl.folderId}\"> <span ng-if=!$ctrl.folderId class=font-size-12>Put this sensor in a folder to keep things organized</span> <i class=\"material-icons material-icons--s\" aria-hidden=true>edit</i> </a> </div> ";

/***/ }),

/***/ "k0Kv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/priveleges.json";

/***/ }),

/***/ "k1Jq":
/***/ (function(module, exports) {

module.exports = "<div class=\"box box--grey space-m-v-m\" layout-padding> <md-button class=\"md-primary md-icon-button box__btn-close\" ng-click=$ctrl.close();> <i class=material-icons>add_circle_outline</i> </md-button> <div class=content-title layout=row layout-align=\"start center\"> <span>Trigger webhook</span> <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </div> <div> <md-input-container class=md-block> <label>Endpoint URL</label> <input type=text required> <div class=\"md-input-hint md-caption-1\">Where the webhook is sent</div> </md-input-container> </div> </div> ";

/***/ }),

/***/ "k1ea":
/***/ (function(module, exports) {

module.exports = "<div class=empty-state> <div class=empty-state__header> <i class=\"fa fa-4 {{$ctrl.icon}}\"></i> </div> <div class=empty-state__content ng-bind-html=$ctrl.content></div> </div> ";

/***/ }),

/***/ "k5AM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    sections: [{
        name: 'Operations',
        items: [{
            name: 'Dashboard',
            icon: 'dashboard',
            state: 'main.dashboard'
        }, {
            name: 'Sensors & Connectors',
            icon: 'panorama',
            state: 'main.sensors.list'
        }]
    }, {
        name: 'Settings',
        items: [{
            name: 'Users and Access',
            icon: 'supervisor_account',
            state: 'main.users-and-access'
        }, {
            name: 'Folders and Labels',
            icon: 'label_outline',
            state: 'main.folders-and-labels'
        }, {
            name: 'Alerts & Actions',
            icon: 'notifications',
            state: 'main.alerts-actions'
            // ,
            // {
            //     name: 'Developer Settings',
            //     icon: 'keyboard',
            //     state: 'main.developer-settings'
            // }
        }]
    }],
    removed: [{
        name: 'Tools',
        items: [{
            name: 'Google BigQuery',
            icon: 'cloud_queue',
            state: 'main.google-big-query'
        }, {
            name: 'Grafana',
            icon: 'panorama',
            state: 'main.grafana'
        }]
    }]
};

/***/ }),

/***/ "kMUV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sendMail = __webpack_require__("7tBR");

var _sendMail2 = _interopRequireDefault(_sendMail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAlertsActionsSendMail',
    options: _sendMail2.default
};

/***/ }),

/***/ "kVuF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _triggerWebhook = __webpack_require__("lAlX");

var _triggerWebhook2 = _interopRequireDefault(_triggerWebhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAlertsActionsTriggerWebhook',
    options: _triggerWebhook2.default
};

/***/ }),

/***/ "kaWl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uniqBy2 = __webpack_require__("vYb2");

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SensorsAndConnectorsController = function () {
    /** @ngInject */
    SensorsAndConnectorsController.$inject = ["EventEmitter", "ThingsApi", "Loader", "ToastService", "$state", "$scope", "$stateParams"];
    function SensorsAndConnectorsController(EventEmitter, ThingsApi, Loader, ToastService, $state, $scope, $stateParams) {
        _classCallCheck(this, SensorsAndConnectorsController);

        this.EventEmitter = EventEmitter;
        this.ThingsApi = ThingsApi;
        this.Loader = Loader;
        this.ToastService = ToastService;
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;

        this.performHealthCheck = this.performHealthCheck.bind(this);
        this.onUpdateReceived = this.onUpdateReceived.bind(this);
    }

    _createClass(SensorsAndConnectorsController, [{
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.searchQuery && !changes.searchQuery.isFirstChange()) {
                this.loadDataByQuery(this.searchQuery);
            }
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.showUpdateButton = false;

            this.things = [];

            this.enableInfinteScroll = true;

            this.listMetadata = {
                query: this.searchQuery,
                order: null,
                page_size: 20
            };
            this.nextPageToken = '';
            this.selectedThings = {};

            this.loadList();

            this.$scope.$on('health-checker-page-visible', this.performHealthCheck);
            this.$scope.$on('health-checker-network-up', this.performHealthCheck);
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.unsubscribeFromLiveUpdates();
        }
    }, {
        key: 'performHealthCheck',
        value: function performHealthCheck() {
            if (this.liveDataSubscription && !this.liveDataSubscription.isAlive) {
                this.showWarning = true;
                this.loadList();
            }
        }
    }, {
        key: 'thingUpdated',
        value: function thingUpdated(_ref) {
            var thing = _ref.thing;

            var thingRef = this.thingsMap[thing.id];
            if (thingRef) {
                if (thing.id === this.currentThingId && thing.starred !== thingRef.starred) {
                    this.thingUpdate = thing;
                }

                ['starred', 'location', 'folder'].forEach(function (key) {
                    if (key in thing) {
                        thingRef[key] = thing[key];
                    }
                });
            }
        }
    }, {
        key: 'loadList',
        value: function loadList() {
            var _this = this;

            var pageToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.Loader.show();
            this.showUpdateButton = false;
            this.ThingsApi.getList(_extends({}, this.listMetadata, {
                page_token: pageToken
            })).then(function (data) {
                _this.Loader.hide();
                _this.nextPageToken = data.next_page_token;
                if (pageToken) {
                    _this.onListUpdated(data);
                } else {
                    _this.onListLoaded(data);
                }
                _this.enableInfinteScroll = true;
            }).catch(function () {
                _this.onLoadingError();
            }).finally(function () {
                _this.Loader.hide();
            });
        }
    }, {
        key: 'clearSearchResult',
        value: function clearSearchResult() {
            this.search({
                query: null
            });
        }
    }, {
        key: 'switchToNextPage',
        value: function switchToNextPage() {
            this.offset += this.perPage;
        }
    }, {
        key: 'onListReorder',
        value: function onListReorder(order) {
            this.listMetadata.order = order;
            this.loadList();
        }
    }, {
        key: 'onLoadingError',
        value: function onLoadingError() {
            this.ToastService.showSimpleTranslated('sensor_list_wasnt_loaded');
        }
    }, {
        key: 'generateThingsMap',
        value: function generateThingsMap() {
            var _this2 = this;

            this.thingsMap = {};
            var thingIds = [];
            this.things.forEach(function (thing) {
                _this2.thingsMap[thing.id] = thing;
                thingIds.push(thing.id);
            });
            this.subscribeToLiveUpdates(thingIds);
            this.showWarning = false;
        }
    }, {
        key: 'onListUpdated',
        value: function onListUpdated(data) {
            var newThings = data.things || [];
            this.things = (0, _uniqBy3.default)([].concat(_toConsumableArray(this.things), _toConsumableArray(newThings)), 'id');
            this.generateThingsMap();
        }
    }, {
        key: 'onListLoaded',
        value: function onListLoaded(data) {
            this.things = data.things || [];
            this.generateThingsMap();
            this.resetSelectedThings();
        }
    }, {
        key: 'unsubscribeFromLiveUpdates',
        value: function unsubscribeFromLiveUpdates() {
            if (this.liveDataSubscription) {
                this.liveDataSubscription.stop();
            }
        }
    }, {
        key: 'subscribeToLiveUpdates',
        value: function subscribeToLiveUpdates(thingIds) {
            this.unsubscribeFromLiveUpdates();

            this.liveDataSubscription = this.ThingsApi.subscribeToAllUpdates(thingIds, this.onUpdateReceived);
        }
    }, {
        key: 'onUpdateReceived',
        value: function onUpdateReceived(thingId, patch) {
            var thing = this.thingsMap[thingId];
            if (!thing) {
                return;
            }

            if (thing.id === this.currentThingId && patch.state) {
                this.lastEventReceived = patch;
            }

            var updatedProps = SensorsAndConnectorsController.getUpdatedProps(thing, patch);
            SensorsAndConnectorsController.animateUpdatedProps(thingId, updatedProps);

            if (patch.state) {
                if (!thing.state) {
                    thing.state = {
                        properties: {}
                    };
                }
                if (!patch.state.properties.touch) {
                    patch.state.properties.last_pressed = thing.state.properties.last_pressed;
                }
                Object.assign(thing.state.properties, patch.state.properties);
                thing.state.updated = patch.state.updated;
            } else {
                Object.assign(thing, patch);
            }

            if (this.listMetadata.order) {
                this.showUpdateButton = true;
            }

            this.$scope.$applyAsync();
        }
    }, {
        key: 'resetSelectedThings',
        value: function resetSelectedThings() {
            this.selectedThings = {
                isQuery: true,
                list: [],
                totalSelected: this.listMetadata.total
            };
        }
    }, {
        key: 'onListEndReached',
        value: function onListEndReached() {
            if (!this.nextPageToken) {
                return;
            }

            this.loadList(this.nextPageToken);
        }
    }, {
        key: 'search',
        value: function search(_ref2) {
            var query = _ref2.query;

            this.$state.go(this.$state.$current.name, {
                q: query,
                tabId: null
            });
        }
    }, {
        key: 'loadDataByQuery',
        value: function loadDataByQuery(query) {
            this.listMetadata.query = query;
            this.loadList();
        }
    }, {
        key: 'currentThingId',
        get: function get() {
            return this.$stateParams.thingId;
        }
    }, {
        key: 'isSideNavOpen',
        get: function get() {
            return this.$state.current.name.indexOf('main.sensors.list.') === 0; // open if the sub-state active
        }
    }, {
        key: 'mainViewType',
        get: function get() {
            return this.$state.current.name === 'main.sensors.list.thing.graph' ? 'GRAPH' : 'LIST';
        }
    }], [{
        key: 'getUpdatedStateProps',
        value: function getUpdatedStateProps(thingType, oldProps, newProps) {
            var propsByType = {
                touch: 'last_pressed',
                temperature: 'temperature',
                proximity: 'object_present'
            };

            var result = {};

            var isTouchType = thingType === 'touch';

            var stateProp = propsByType[thingType];
            if (stateProp) {
                if (!isTouchType || isTouchType && newProps.touch) {
                    if (oldProps[stateProp] !== newProps[stateProp]) {
                        result.state = true;
                    }
                }
            }

            if (oldProps.battery_percentage !== newProps.battery_percentage) {
                result.battery_percentage = true;
            }

            if (oldProps.rssi_strength !== newProps.rssi_strength) {
                result.rssi_strength = true;
            }

            return result;
        }
    }, {
        key: 'getUpdatedProps',
        value: function getUpdatedProps(thing, patch) {
            if (patch.location) {
                return {
                    location: true
                };
            }

            if (patch.name) {
                return {
                    name: true
                };
            }

            if (patch.state && thing.state && thing.type) {
                return SensorsAndConnectorsController.getUpdatedStateProps(thing.type.id, thing.state.properties, patch.state.properties);
            }

            return {};
        }
    }, {
        key: 'animateUpdatedProps',
        value: function animateUpdatedProps(thingId, props) {
            Object.keys(props).forEach(function (prop) {
                var node = document.querySelector('.cell-' + thingId + '-' + prop);
                if (node) {
                    node.classList.add('u-blink-default');
                    setTimeout(function () {
                        node.classList.remove('u-blink-default');
                    }, 2000);
                }
            });
        }
    }]);

    return SensorsAndConnectorsController;
}();

exports.default = SensorsAndConnectorsController;

/***/ }),

/***/ "kpTX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var helpMenuSensorsAndConnectors = '\n    <p>All the things you place a sensor on will show up in this list.</p>\n    <p>\n        Scroll through to view the status of individual sensors. Click on a sensor to bring up details. Search\n        for a specific sensor or groups of sensors, and save your search results for quick recollection.\n    </p>\n';

var helpMenuFoldersAndLabelsFolders = '\n    <p>Use folders to organize your sensors</p>\n    <p>\n        Make folders for floors and rooms, or use them to group sensors by importance. Folders are hierarchical,\n        which means a sensor can only belong to one folder at a time.\n    </p>\n    <p>\n        You can apply rules to folders, which makes it easy to manage many sensors at once. In addition, any rule\n        or access setting applied to a folder automatically applies to all folders within that folder and below.\n    </p>\n';

var helpMenuFoldersAndLabelsLabels = '\n    <p>Tag sensors with labels for more control</p>\n    <p>\n        Labels give you an extra level of organization. If you have sensors across many folders that all require\n        the same rule, using labels will save you time: apply a label to all the sensors,\n        and apply the rule to the label.\n    </p>\n';

exports.default = {
    sensor_list_wasnt_loaded: 'There was an error while loading the list',
    sensor_list_network_offline: 'You are offline. Some functionality may be unavailable.',
    sensor_list_network_online: 'You are online again. Updating...',

    star_was_added: 'Thing is now starred',
    star_wasnt_added: 'Thing could not be starred. <br>Please refresh the page and try again.',
    star_was_removed: 'Thing is no longer starred',
    star_wasnt_removed: 'Could not make thing unstarred. <br>Please refresh the page and try again.',

    comment_was_created: 'Comment successfully created',
    comment_was_updated: 'Comment successfully updated',
    comment_was_removed: 'Comment successfully removed',

    navbar_category_was_created: 'Category successfully created',
    navbar_category_wasnt_created: 'The category could not be created. <br>Please refresh the page and try again.',
    navbar_category_was_updated: 'Category successfully updated',
    navbar_category_wasnt_updated: 'The category could not be updated. <br>Please refresh the page and try again.',
    navbar_category_was_moved: 'Category successfully moved',
    navbar_category_wasnt_moved: 'The category could not be moved. <br>Please refresh the page and try again.',
    navbar_category_was_removed: 'Category successfully removed',
    navbar_category_wasnt_removed: 'The category could not be removed. <br>Please refresh the page and try again.',

    navbar_view_was_created: 'View successfully created',
    navbar_view_wasnt_created: 'The view could not be created. <br>Please refresh the page and try again.',
    navbar_view_was_updated: 'View successfully updated',
    navbar_view_wasnt_updated: 'The view could not be updated. <br>Please refresh the page and try again.',
    navbar_view_was_moved: 'View successfully moved',
    navbar_view_wasnt_moved: 'The view could not be moved. <br>Please refresh the page and try again.',
    navbar_view_was_removed: 'View successfully removed',
    navbar_view_wasnt_removed: 'The view could not be removed. <br>Please refresh the page and try again.',

    label_was_created: 'Label successfully created',
    label_wasnt_created: 'The label could not be created. <br>Please refresh the page and try again.',
    label_was_updated: 'Label successfully updated',
    label_wasnt_updated: 'The label could not be updated <br>Please refresh the page and try again.',
    label_was_removed: 'Label successfully removed.',
    label_wasnt_removed: 'The label could not be removed. <br>Please refresh the page and try again.',

    folder_was_created: 'Folder successfully created',
    folder_wasnt_created: 'The folder could not be created. <br>Please refresh the page and try again.',
    folder_was_updated: 'Folder successfully updated',
    folder_wasnt_updated: 'The folder could not be updated. <br>Please refresh the page and try again.',
    folder_was_removed: 'Folder successfully removed',
    folder_wasnt_removed: 'The folder could not be removed. <br>Please refresh the page and try again.',
    folder_was_moved: 'Folder successfully moved',
    folder_wasnt_moved: 'The folder could not be moved. <br>Please refresh the page and try again.',

    ticket_was_submitted: 'The support ticket was submitted, and a receipt will be sent to the email ' + 'address you entered.',
    ticket_wasnt_submitted: 'The support ticket could not be submitted. Please try again in a few minutes.',

    thing_was_saved: 'Thing successfully saved',
    thing_wasnt_saved: 'The thing could not be saved. <br>Please refresh the page and try again.',

    help_icon_advanced_search_name: 'This is the name of the sensor/thing.',
    help_icon_advanced_search_owner: 'Find sensors associated with a specific user',
    help_icon_advanced_search_status: 'Select one or more of these to only show things with active notifications',
    help_icon_advanced_search_starred: 'Find sensors that are starred',
    help_icon_advanced_search_signal: 'Find things with signal strength within the chosen range.',
    help_icon_advanced_search_location: 'Check this box to find things that are located within the circle in the map ' + 'below. Move the map around and zoom in or out to change the size of the search area. ' + 'Note: Things must have a location saved in order to show up in the results.',
    help_icon_advanced_search_labels: 'Find things that have specific labels assigned to them. ' + 'Enter more than one label to find things with specific label combinations.',
    help_icon_advanced_search_types_and_states: 'Select which thing types to show, then select if they should have a ' + 'specific current state. ',
    help_icon_advanced_search_battery: 'Fill out one field to find things with a battery level above or below the ' + 'specified percentage. Fill out both fields to find things with a battery level within that range',
    help_icon_user_settings_roles_assigned: 'These are the roles assigned to user',

    'help_menu_main_alerts-actions': '<p>Rules make sensors even smarter.</p>' + '<p>With alerts and actions you can make things automatically ' + 'happen depending on a sensor’s current status. Create a rule ' + 'that emails you when someone presses a button, or make one that ' + 'alerts you when a window is left open.</p><p>Rules can also send ' + 'the sensor information to another online service, making the possibilities endless.</p>',
    'help_menu_main_dashboard': '<p>Dashboards gives you an at-a-glance visualization of your sensor activity.</p>' + '<p>You can create and organize your own dashboards by using the extended search in the "Things" menu and ' + 'choose "Visualize" and then save it as a dashboard. Dashboards have a default fixed period from today’s ' + 'date, and you can dynamically adjust the date range.</p>',
    'help_menu_main_sensors_list': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_list_thing': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_list_thing_graph': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_list_search': helpMenuSensorsAndConnectors,
    'help_menu_main_sensors_graphs': helpMenuSensorsAndConnectors,
    'help_menu_main_users-and-access_users': '<p>Create and managed users for every person that needs ' + 'access to DT Studio.</p>' + '<p>Each user gets their own notifications, and you' + 'can define control exactly who can see which sensors.</p>',
    'help_menu_main_users-and-access_roles': '<p>Manage users and access in bulk keep track of access with roles</p>' + '<p>To easily manage who has permission to which sensors and features in DT Studio, you can create and ' + 'assign roles. This also makes notifying several users a simple task: just send the notification to a role, ' + 'and all the users with that role will get the notification.</p>',
    'help_menu_main_users-and-access_customers': '<p>Customers are like users with an extra layer of privacy.</p>' + '<p>If you plan to make apps and sell sensors, we recommend adding users as customers so' + 'they only have access to their own sensors. It also lets them keep sensors private from all' + 'other users, including admins, with the option to allow access on a case by case basis.</p>',
    'help_menu_main_folders-and-labels_folders': helpMenuFoldersAndLabelsFolders,
    'help_menu_main_folders-and-labels_folders_folder': helpMenuFoldersAndLabelsFolders,
    'help_menu_main_folders-and-labels_labels': helpMenuFoldersAndLabelsLabels,
    'help_menu_main_folders-and-labels_labels_label': helpMenuFoldersAndLabelsLabels,
    'help_menu_main_developer-settings_api-access': '<p>API access for further development.</p>' + '<p>To integrate with our API, the API access must be enabled.' + 'Enable it under Developer Settings and start creating apps for your sensors. </p>'
};

/***/ }),

/***/ "l+66":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingRegistered = __webpack_require__("Xs8w");

var _thingRegistered2 = _interopRequireDefault(_thingRegistered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAsThingRegistered',
    options: _thingRegistered2.default
};

/***/ }),

/***/ "l2Hp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IconDirective = exports.IconComponent = undefined;

var _icon = __webpack_require__("3dRZ");

var _icon2 = _interopRequireDefault(_icon);

var _icon3 = __webpack_require__("HUdY");

var _icon4 = _interopRequireDefault(_icon3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconComponent = {
    selector: 'dtIcon',
    options: _icon2.default
};

var IconDirective = {
    selector: 'dtIconAttributes',
    options: _icon4.default
};

/**
 * Example how to use:
 * <dt-icon icon-class="'window'" color-class="'warning'" has-exclamation="true"></dt-icon>
 * <dt-icon icon-class="'door'" color-class="'accent'" has-exclamation="false" icon-size="'xl'"></dt-icon>
 * <dt-icon icon-class="'touch'" has-exclamation="true" icon-size="'l'" show-aria-label="true"></dt-icon>
 */
exports.IconComponent = IconComponent;
exports.IconDirective = IconDirective;

/***/ }),

/***/ "l95T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThingEditDescriptionController = function () {
    /** @ngInject */
    ThingEditDescriptionController.$inject = ["EventEmitter", "$timeout"];
    function ThingEditDescriptionController(EventEmitter, $timeout) {
        _classCallCheck(this, ThingEditDescriptionController);

        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
    }

    _createClass(ThingEditDescriptionController, [{
        key: "$onChanges",
        value: function $onChanges(_ref) {
            var description = _ref.description;

            this.originalDescription = description.currentValue;
        }
    }, {
        key: "enableEditMode",
        value: function enableEditMode() {
            this.editMode = true;
        }
    }, {
        key: "disableEditMode",
        value: function disableEditMode() {
            var _this = this;

            if (this.description !== this.originalDescription) {
                this.onUpdate(this.eventEmitter({
                    patch: {
                        description: this.description
                    }
                }));
            }
            this.$timeout(function () {
                _this.editMode = false;
            });
        }
    }]);

    return ThingEditDescriptionController;
}();

exports.default = ThingEditDescriptionController;

/***/ }),

/***/ "lAlX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _triggerWebhook = __webpack_require__("ASwP");

var _triggerWebhook2 = _interopRequireDefault(_triggerWebhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("k1Jq");

exports.default = {
    bindings: {
        action: '<',
        onClose: '&'
    },
    template: template,
    controller: _triggerWebhook2.default
};

/***/ }),

/***/ "lHsQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


foldersAndLabelsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = foldersAndLabelsRouter;

var _foldersAndLabels = __webpack_require__("VByS");

/** @ngInject */
function foldersAndLabelsRouter($stateProvider) {
    var baseState = {
        redirectTo: 'main.folders-and-labels.folders',
        views: {
            content: {
                component: _foldersAndLabels.Component.selector
            }
        }
    };

    $stateProvider.state('main.folders-and-labels', baseState);
}

/***/ }),

/***/ "lPUQ":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Company Settings'\"></dt-content-header> <div layout=row layout-align=\"start start\" layout-margin flex class=placeholder-block> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available yet</p> </div> <div class=\"box flex-30\" layout-padding> <form class=form-grid action=#> <div class=\"container-fluid space-b-s\"> <h4 class=box-title>Basic info</h4> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=companyName>Company name</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <input type=text id=companyName name=companyName aria-label=\"company name\"> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1>Company type</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <md-select ng-model=abs id=companyType name=companyType aria-label=company-type> <md-option ng-repeat=\"n in [1,2,3,4]\" ng-value=n>Individual {{n}}</md-option> </md-select> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1>Logo</label> </div> <div class=col-xs> <dt-upload-logo> <div class=row ng-class=\"{'is-processing': isProcessing}\"> <div class=col-st> <div class=upload-logo__image> <img src=https://placehold.it/100x50> <md-progress-circular ng-if=isProcessing class=md-hue-2 md-diameter=20px></md-progress-circular> </div> </div> <div class=col-st> <md-button class=\"md-primary md-raised md-cornered\">Upload new</md-button> <input class=upload-logo__input type=file> </div> </div> </dt-upload-logo> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> </div> <div class=\"container-fluid space-b-s\"> <h4 class=box-title>Contact info</h4> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=email>Email</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <input type=text id=email name=email aria-label=email> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=phone-code>Phone</label> </div> <div class=col-xs layout=row layout-align=\"start center\"> <span class=md-body-1>+</span> <md-input-container class=\"u-width-40 space-m-h-s form-element form-element--simple\"> <input type=text id=phone-code name=phone-code aria-label=phone-code> </md-input-container> <md-input-container class=\"form-element form-element--simple\" flex> <input type=text id=phone name=phone aria-label=phone> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=fax-code>Fax</label> </div> <div class=col-xs layout=row layout-align=\"start center\"> <span class=md-body-1>+</span> <md-input-container class=\"u-width-40 space-m-h-s form-element form-element--simple\"> <input type=text id=fax-code name=fax-code aria-label=fax-code> </md-input-container> <md-input-container class=\"form-element form-element--simple\" flex> <input type=text id=fax name=fax aria-label=fax> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=street>Street 1</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <input type=text id=street name=street aria-label=street> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=street-2>Street 2</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <input type=text id=street-2 name=street-2 aria-label=street-2> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=city>City</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <input type=text id=city name=city aria-label=city> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=zipPostalCode>Zip/Postal code</label> </div> <div class=col-xs-4> <md-input-container class=\"md-block form-element form-element--simple\"> <input type=text id=zipPostalCode name=zipPostalCode aria-label=zipPostalCode> </md-input-container> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=country>Country</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <md-select ng-model=country id=country name=country aria-label=country> <md-option ng-repeat=\"n in [1,2,3,4]\" ng-value=n>Norway {{n}}</md-option> </md-select> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=state>State</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <md-select ng-model=state name=state id=state aria-label=state> <md-option ng-repeat=\"n in [1,2,3,4]\" ng-value=n>Hordaland {{n}}</md-option> </md-select> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> </div> <div class=\"container-fluid space-b-s\"> <h4 class=box-title>Tax info</h4> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=taxId>Tax ID</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <input type=text id=taxId name=taxId aria-label=\"tax id\"> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> <div class=\"row middle-xs\"> <div class=col-st-112> <label class=md-body-1 for=taxIdType>Tax ID type</label> </div> <div class=col-xs> <md-input-container class=\"md-block form-element form-element--simple\"> <md-select ng-model=taxIdType name=taxIdType id=taxIdType aria-label=\"tax id type\"> <md-option ng-repeat=\"n in [1,2,3,4]\" ng-value=n>VAT Reg No (EU) {{n}}</md-option> </md-select> </md-input-container> </div> <div class=col-st> <dt-help-icon></dt-help-icon> </div> </div> </div> <section layout=column> <md-divider class=space-m-v-m></md-divider> <div layout=row layout-align=end> <md-button class=\"md-button md-primary\">Cancel</md-button> <md-button class=\"md-button md-primary\">Save Changes</md-button> </div> </section> </form> </div> <div class=\"box flex-30\" layout-padding> <section> <div class=container-fluid> <h4 class=box-title>Administrators for this account</h4> <md-list class=md-list--style3> <md-list-item class=md-2-line> <img ng-src=assets/images/ava-test.png class=md-avatar alt=\"Derek Zoolander\"/> <div class=md-list-item-text> <h3>Derek Zoolander</h3> <p> <a class=# href=mailto:emails@zoolander.com>emails@zoolander.com</a> </p> </div> </md-list-item> <md-list-item class=md-2-line> <img ng-src=assets/images/ava-test.png class=md-avatar alt=\"Ron Burgundy\"/> <div class=md-list-item-text> <h3>Ron Burgundy</h3> <p> <a class=# href=mailto:rburgundy@channel4news.com>rburgundy@channel4news.com</a> </p> </div> </md-list-item> </md-list> <a href=#>Manage users and roles</a> </div> </section> </div> </div> ";

/***/ }),

/***/ "lRq9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/door-closed.svg";

/***/ }),

/***/ "laKs":
/***/ (function(module, exports) {

module.exports = "<div class=block-title>LABELS</div> <dt-labels-autocomplete labels=$ctrl.labels require-match=false editable=true placeholder=\"Start typing to add a label\" secondary-placeholder=\"Add more labels\" on-add=$ctrl.onLabelsAdded($event) on-remove=$ctrl.onLabelsRemoved($event)></dt-labels-autocomplete>";

/***/ }),

/***/ "lb0K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notes = __webpack_require__("rlHJ");

var _notes2 = _interopRequireDefault(_notes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtNotes',
    options: _notes2.default
};

/***/ }),

/***/ "ldQf":
/***/ (function(module, exports) {

module.exports = "<div class=block-title>Sensor Location</div> <div layout=column> <div ng-if=!$ctrl.location> <a href=# ng-click=\"$event.preventDefault(); $ctrl.showLocation($event)\" class=font-size-12> <i class=\"material-icons material-icons--s\" aria-hidden=true>location_on</i> Add physical location </a> </div> <div ng-if=$ctrl.location> <span class=md-caption-1>{{$ctrl.location.address}}</span> <a href=# ng-click=\"$event.preventDefault(); $ctrl.showLocation($event)\"> <i class=\"material-icons material-icons--s\" aria-hidden=true>edit</i> </a> </div> <span class=\"space-m-t-s font-size-12\">Sensor ID: {{$ctrl.thingId}}</span> </div> ";

/***/ }),

/***/ "lfBu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


chartDirectiveConfig.$inject = ["$timeout", "EventEmitter"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = chartDirectiveConfig;

var _highstock = __webpack_require__("4hDN");

var _highstock2 = _interopRequireDefault(_highstock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__("WQ9L")(_highstock2.default);
__webpack_require__("KOkO")(_highstock2.default);

_highstock2.default.setOptions({
    global: {
        useUTC: false
    }
});

/** @ngInject */
function chartDirectiveConfig($timeout, EventEmitter) {
    function link($scope, $element, $attrs, $ctrl) {
        var elementNode = $element[0];
        $ctrl.chart = _highstock2.default[$ctrl.useStockChart ? 'StockChart' : 'chart'](elementNode, $ctrl.config);

        $ctrl.onChartLoaded(EventEmitter({ // eslint-disable-line new-cap
            chart: $ctrl.chart
        }));

        $timeout(function () {
            $ctrl.chart.reflow();
        }, 100);
    }

    var controller = function () {
        function controller() {
            _classCallCheck(this, controller);
        }

        _createClass(controller, [{
            key: '$onChanges',
            value: function $onChanges(changes) {
                var _this = this;

                if (changes.config && !changes.config.isFirstChange()) {
                    // TODO: introduce check of the whole config not just updating the data
                    var series = changes.config.currentValue.series;

                    series.forEach(function (_ref, index) {
                        var data = _ref.data;

                        _this.chart.series[index].setData(data);
                    });
                }
            }
        }]);

        return controller;
    }();

    return {
        restrict: 'E',
        template: '<div class="chart-container"></div>',
        scope: {
            onChartLoaded: '&',
            config: '<',
            useStockChart: '<'
        },
        bindToController: true,
        link: link,
        controller: controller
    };
}

/***/ }),

/***/ "liSP":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-box folder-details\" dt-sticky dt-sticky-from=62 dt-sticky-to=16 sticky-class=sticky container=.dt-layout-content__container> <div class=content-box__header layout-gt-xs=row layout-xs=column layout-align-xs=stretch layout-wrap layout-padding> <div class=\"content-block space-p-r-m\" flex> <dt-folder-path data-ng-if=$ctrl.folder.parent_id folder-id=$ctrl.folder.parent_id empty-trail=true> </dt-folder-path> <md-input-container class=\"md-block input-container--large space-m-v-n\"> <input id=name ng-model=$ctrl.folder.name type=text aria-label=\"Folder name\" autocomplete=off> <div class=md-input-hint>ID: {{ $ctrl.folder.id }}</div> </md-input-container> <md-input-container class=\"md-block space-m-v-s\"> <label for=description>Description</label> <textarea name=description id=description ng-model=$ctrl.folder.description></textarea> </md-input-container> </div> <div class=\"content-block space-p-r-m\" flex> <div class=block-title> Folder Content <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </div> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-s> <span class=\"icons icons--l\"> <md-icon md-svg-icon=temperature aria-hidden=true></md-icon> </span> </dt-icon> <a ui-sref=\"main.sensors.list({q: $ctrl.searchQuery})\" class=space-m-h-s> <md-icon class=\"material-icons material-icons--s\">search</md-icon> Show sensors </a> </div> </div> </div> <footer class=content-box__footer> <a href=# class=md-secondary ng-click=\"$ctrl.showDeleteConfirmation(); $event.preventDefault();\"> <md-icon class=\"material-icons material-icons--s\">delete</md-icon> Delete folder </a> <span flex></span> <md-button class=md-primary ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=md-primary ng-click=$ctrl.save()>Save changes</md-button> </footer> </div> ";

/***/ }),

/***/ "lqki":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FolderPathDialogController = function () {
    /** @ngInject */
    FolderPathDialogController.$inject = ["DialogService", "folderChangedCallback", "folderId", "EventEmitter"];
    function FolderPathDialogController(DialogService, folderChangedCallback, folderId, EventEmitter) {
        _classCallCheck(this, FolderPathDialogController);

        this.DialogService = DialogService;
        this.folderChangedCallback = folderChangedCallback;
        this.originalFolderId = folderId;
        this.folderId = this.originalFolderId;
        this.eventEmitter = EventEmitter;
        if (this.originalFolderId) {
            this.preSelected = [this.originalFolderId];
        }
    }

    _createClass(FolderPathDialogController, [{
        key: "onFolderChange",
        value: function onFolderChange(_ref) {
            var folderId = _ref.folderId,
                dblClicked = _ref.dblClicked;

            this.folderId = folderId;
            if (dblClicked) {
                this.submit();
            }
        }
    }, {
        key: "submit",
        value: function submit() {
            if (this.folderId !== this.originalFolderId) {
                this.folderChangedCallback(this.eventEmitter({
                    folderId: this.folderId
                }));
            }
            this.close();
        }
    }, {
        key: "close",
        value: function close() {
            this.DialogService.cancel();
        }
    }]);

    return FolderPathDialogController;
}();

exports.default = FolderPathDialogController;

/***/ }),

/***/ "lytj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _authUsers = __webpack_require__("Xe80");

var _authUsers2 = _interopRequireDefault(_authUsers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * AuthUsersApi settings
 * @type {{name: string, definition: AuthUsersApi}}
 */
exports.default = {
  name: 'AuthUsersApi',
  definition: _authUsers2.default
};

/***/ }),

/***/ "m/NR":
/***/ (function(module, exports) {

module.exports = "<md-chips class=\"dt-chips dt-theme\" ng-model=$ctrl.entities md-autocomplete-snap md-on-add=$ctrl.added($chip) md-on-remove=$ctrl.removed($chip) md-require-match=::$ctrl.requireMatch md-add-on-blur=::!$ctrl.requireMatch readonly=!$ctrl.editable ng-class=\"{'dt-chips--editing': $ctrl.editable}\"> <md-autocomplete md-autoselect md-select-on-match md-search-text=$ctrl.query md-delay=50 md-no-cache md-items=\"item in $ctrl.search()\" md-item-text=$ctrl.getText(item) placeholder=\"{{ $ctrl.entities.length ? $ctrl.secondaryPlaceholder : $ctrl.placeholder }}\"> <span md-highlight-text=$ctrl.query>{{$ctrl.getText(item)}}</span> </md-autocomplete> <md-chip-template> <span>{{$ctrl.getText($chip)}}</span> </md-chip-template> </md-chips> ";

/***/ }),

/***/ "m9ZF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingsList = __webpack_require__("iy6E");

var _thingsList2 = _interopRequireDefault(_thingsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("V0Iz");

exports.default = {
    bindings: {
        onSelectThing: '&',
        onListReorder: '&',
        onThingStarred: '&',
        things: '<',
        metadata: '<',
        selectedThings: '<'
    },
    template: template,
    controller: _thingsList2.default
};

/***/ }),

/***/ "mBEK":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("Ro2m");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "mEGA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=dt-navbar__list> <section class=dt-navbar__logo hide-gt-sm> <a href=/ class=logo> <img src=" + __webpack_require__("2ncJ") + " alt=\"Disruptive Technologies\"> <span class=space-m-l-s>STUDIO</span> </a> </section> <section class=\"dt-navbar__section dt-navbar__section--home\"> <div layout=row layout-align=\"start center\"> <div ui-sref=main.sensors.list ui-sref-opts=\"{reload: true, inherit: false}\" class=\"dt-navbar-item flex\"> <md-button> <div class=dt-navbar-item__lockup> <i class=material-icons>home</i> <span class=dt-navbar-item__title>Partner Name</span> <md-tooltip md-direction=right ng-if=$ctrl.collapsed>Overview</md-tooltip> </div> </md-button> </div> <md-menu class=\"dt-navbar__settings dt-navbar__settings--expanded\" md-offset=\"40 10\" md-position-mode=\"target target\"> <md-button class=md-icon-button ng-click=$mdMenu.open($event)> <i class=material-icons>settings</i> </md-button> <md-menu-content> <md-menu-item ui-sref=main.company-settings ui-sref-opts=\"{reload: true, inherit: false}\"> <md-button> Company Settings </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> <md-menu class=\"dt-navbar__settings dt-navbar__settings--collapsed\" md-offset=\"68 0\" md-position-mode=\"target target\"> <md-button class=md-icon-button md-no-ink ng-click=$mdOpenMenu($event)> <i class=material-icons>settings</i> <md-tooltip md-direction=right ng-if=$ctrl.collapsed>Settings</md-tooltip> </md-button> <md-menu-content> <md-menu-item> <md-button> Settings project </md-button> </md-menu-item> <md-menu-item> <md-button> Settings project </md-button> </md-menu-item> <md-menu-item> <md-button> Settings project </md-button> </md-menu-item> </md-menu-content> </md-menu> </section> <section class=dt-navbar__section data-ng-repeat=\"section in ::$ctrl.nav.sections track by $index\"> <div class=dt-navbar__heading data-ng-bind=::section.name> </div> <div class=dt-navbar-item data-ng-repeat=\"item in ::section.items track by $index\" ui-sref-active=is-current ui-sref-opts=\"{reload: true, inherit: false}\" ui-sref=\"{{ ::item.state }}\"> <md-button aria-label=\"{{ ::item.name }}\"> <div class=dt-navbar-item__lockup> <i class=material-icons data-ng-bind=::item.icon></i> <span class=dt-navbar-item__title data-ng-bind=::item.name></span> <md-tooltip md-direction=right class=dt-navbar-item__tooltip ng-if=$ctrl.collapsed data-ng-bind=::item.name> </md-tooltip> </div> </md-button> </div> </section> </div> <md-button class=dt-navbar__expand-button aria-label=chevron_left ng-click=$ctrl.toggle()> <i class=material-icons>chevron_left</i> </md-button> ";

/***/ }),

/***/ "mFMv":
/***/ (function(module, exports) {

module.exports = "<section layout=column> <div class=md-subhead> Available folders<span ng-if=$ctrl.selectedItems.length>: <a href=# ng-click=\"$event.preventDefault(); $ctrl.showSelectedFolders();\">{{ $ctrl.selectedItems.length }} selected</a> <md-icon style=cursor:pointer ng-click=$ctrl.unselectFolders()>clear</md-icon> </span> </div> <dt-folder-selector multi-select=true fs-model=$ctrl.folderModel expand-selected=$ctrl.triggerExpansionOfSelected on-change=$ctrl.folderModelChanged($event)></dt-folder-selector> </section>";

/***/ }),

/***/ "mJYQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/icon_signal1.svg";

/***/ }),

/***/ "mT7A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AlertsActionsContent = exports.AlertsActionsNav = exports.Config = exports.Component = undefined;

var _alertsActionsContent = __webpack_require__("CIyU");

var AlertsActionsContent = _interopRequireWildcard(_alertsActionsContent);

var _alertsActionsNav = __webpack_require__("hCZE");

var _alertsActionsNav2 = _interopRequireDefault(_alertsActionsNav);

var _alertsActions = __webpack_require__("WxCw");

var _alertsActions2 = _interopRequireDefault(_alertsActions);

var _alertsActions3 = __webpack_require__("IU3/");

var _alertsActions4 = _interopRequireDefault(_alertsActions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

__webpack_require__("NY2E"); // eslint-disable-line

var Component = {
    selector: 'dtAlertsActions',
    options: _alertsActions4.default
};

exports.Component = Component;
exports.Config = _alertsActions2.default;
exports.AlertsActionsNav = _alertsActionsNav2.default;
exports.AlertsActionsContent = AlertsActionsContent;

/***/ }),

/***/ "mYg8":
/***/ (function(module, exports) {

module.exports = "<div class=form-grid__group> <div class=\"form-grid__row space-m-b-xs\"> <div class=form-grid__col> <label class=form-grid__group__label>Specific types and states</label> <dt-help-icon message-key=help_icon_advanced_search_types_and_states></dt-help-icon> </div> </div> <div class=form-grid__row ng-repeat=\"thing in $ctrl.things\" ng-class=\"{ 'is-unselected': !$ctrl.typesMap[thing.type] }\"> <div class=form-grid__col> <div class=form-grid__row> <div class=form-grid__col> <md-checkbox class=\"md-default-theme md-checkbox--icon\" ng-checked=$ctrl.typesMap[thing.type] ng-click=$ctrl.toggle(thing)> <dt-icon icon-class=thing.icon icon-size=s show-aria-label=true></dt-icon> <span class=form-grid__label>{{ ::thing.titlePlural }}</span> </md-checkbox> </div> </div> <div class=\"form-grid__row form-grid__row--indent-xxl\" ng-if=\"thing.rules && thing.rules.items && thing.rules.items.length\"> <div class=form-grid__col ng-repeat=\"rule in thing.rules.items track by $index\"> <div class=form-grid__row ng-if=\"rule.type === 'input'\"> <label class=\"md-caption label-text\" for=\"{{ rule.name }}\">{{ rule.title}}</label> <md-input-container class=\"form-element form-element--simple space-m-h-xs\" flex> <input type=text aria-label=\"{{ ::thing.titlePlural }} state {{ rule.name }} value\" id=\"{{ rule.name }}\" ng-disabled=!$ctrl.typesMap[thing.type] ng-change=$ctrl.onChange(); ng-model-options=\"{\n                                        'updateOn': 'default blur',\n                                        'debounce': {\n                                            'default': 350,\n                                            'blur': 0\n                                        }\n                                    }\" ng-model=$ctrl.typesRulesMap[thing.type][rule.name].value> </md-input-container> <span class=\"md-caption label-text\" ng-if=\"thing.state && thing.state.value && thing.state.value.format\">{{ $ctrl.parseValueFormat(thing.state.value.format)}}</span> </div> <div class=\"form-grid__row form-grid__row--static gap8\" ng-if=\"rule.type === 'checkboxlist'\"> <div class=form-grid__col ng-if=thing.rules.beforeHint> <span class=\"md-caption label-text\">{{ ::thing.rules.beforeHint }}</span> </div> <div class=form-grid__col ng-repeat=\"subrule in rule.items\"> <md-checkbox class=md-default-theme ng-model=$ctrl.typesRulesMap[thing.type][subrule.name].value aria-label=\"{{ ::subrule.title }}\" ng-change=$ctrl.onChange(); ng-disabled=!$ctrl.typesMap[thing.type]> <span class=\"md-caption space-m-r-m\">{{ ::subrule.title }}</span> </md-checkbox> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "mf7S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _permissions = __webpack_require__("TGAd");

var _permissions2 = _interopRequireDefault(_permissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("d1/s");

exports.default = {
    bindings: {
        owner: '<',
        users: '<',
        isEditing: '<'
    },
    template: template,
    controller: _permissions2.default
};

/***/ }),

/***/ "mg0t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FeedbackApiService = exports.PrivilegesApiService = exports.UsersApiService = exports.RolesApiService = exports.CustomersApiService = exports.AlertsActionsApiService = exports.DeveloperApiService = exports.MenuApiService = exports.CategoriesApiService = exports.NavigationApiService = exports.ViewsApiService = exports.FoldersApiService = exports.ConfigApiService = exports.HistoryApiService = exports.EventsApiService = exports.NotificationsApiService = exports.AlertsApiService = exports.LabelsApiService = exports.NotesApiService = exports.AuthUsersApiService = exports.ThingsApi = undefined;

var _things = __webpack_require__("Gokj");

var ThingsApi = _interopRequireWildcard(_things);

var _authUsers = __webpack_require__("lytj");

var _authUsers2 = _interopRequireDefault(_authUsers);

var _notes = __webpack_require__("BFDt");

var _notes2 = _interopRequireDefault(_notes);

var _labels = __webpack_require__("32b8");

var _labels2 = _interopRequireDefault(_labels);

var _alerts = __webpack_require__("fE0V");

var _alerts2 = _interopRequireDefault(_alerts);

var _notifications = __webpack_require__("d6Vi");

var _notifications2 = _interopRequireDefault(_notifications);

var _events = __webpack_require__("X26P");

var _events2 = _interopRequireDefault(_events);

var _history = __webpack_require__("sAJT");

var _history2 = _interopRequireDefault(_history);

var _config = __webpack_require__("GHPA");

var _config2 = _interopRequireDefault(_config);

var _folders = __webpack_require__("303b");

var _folders2 = _interopRequireDefault(_folders);

var _views = __webpack_require__("ChJs");

var _views2 = _interopRequireDefault(_views);

var _navigation = __webpack_require__("CO3H");

var _navigation2 = _interopRequireDefault(_navigation);

var _categories = __webpack_require__("A+ND");

var _categories2 = _interopRequireDefault(_categories);

var _menu = __webpack_require__("59za");

var _menu2 = _interopRequireDefault(_menu);

var _developer = __webpack_require__("D7iB");

var _developer2 = _interopRequireDefault(_developer);

var _alertsActions = __webpack_require__("ZscP");

var _alertsActions2 = _interopRequireDefault(_alertsActions);

var _customers = __webpack_require__("DI2n");

var _customers2 = _interopRequireDefault(_customers);

var _roles = __webpack_require__("SjHa");

var _roles2 = _interopRequireDefault(_roles);

var _users = __webpack_require__("4/CJ");

var _users2 = _interopRequireDefault(_users);

var _privileges = __webpack_require__("pYgc");

var _privileges2 = _interopRequireDefault(_privileges);

var _feedback = __webpack_require__("5vET");

var _feedback2 = _interopRequireDefault(_feedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.ThingsApi = ThingsApi;
exports.AuthUsersApiService = _authUsers2.default;
exports.NotesApiService = _notes2.default;
exports.LabelsApiService = _labels2.default;
exports.AlertsApiService = _alerts2.default;
exports.NotificationsApiService = _notifications2.default;
exports.EventsApiService = _events2.default;
exports.HistoryApiService = _history2.default;
exports.ConfigApiService = _config2.default;
exports.FoldersApiService = _folders2.default;
exports.ViewsApiService = _views2.default;
exports.NavigationApiService = _navigation2.default;
exports.CategoriesApiService = _categories2.default;
exports.MenuApiService = _menu2.default;
exports.DeveloperApiService = _developer2.default;
exports.AlertsActionsApiService = _alertsActions2.default;
exports.CustomersApiService = _customers2.default;
exports.RolesApiService = _roles2.default;
exports.UsersApiService = _users2.default;
exports.PrivilegesApiService = _privileges2.default;
exports.FeedbackApiService = _feedback2.default;

/***/ }),

/***/ "mnij":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge2 = __webpack_require__("yubd");

var _merge3 = _interopRequireDefault(_merge2);

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

var _presets = __webpack_require__("6u/X");

var _presets2 = _interopRequireDefault(_presets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConfigHelper = function () {
    function ConfigHelper() {
        _classCallCheck(this, ConfigHelper);
    }

    _createClass(ConfigHelper, null, [{
        key: 'title',
        value: function title(text) {
            return {
                title: {
                    text: text
                }
            };
        }
    }, {
        key: 'asyncDataLoading',
        value: function asyncDataLoading(navigatorData, callback) {
            return {
                navigator: {
                    adaptToUpdatedData: false,
                    series: {
                        data: navigatorData
                    }
                },
                scrollbar: {
                    liveRedraw: false
                },
                xAxis: {
                    events: {
                        afterSetExtremes: callback
                    },
                    minRange: 3600
                }
            };
        }
    }, {
        key: 'merged',
        value: function merged() {
            for (var _len = arguments.length, configs = Array(_len), _key = 0; _key < _len; _key++) {
                configs[_key] = arguments[_key];
            }

            return _merge3.default.apply(undefined, [{}, _presets2.default.Base].concat(configs));
        }
    }, {
        key: 'temperaturePreview',
        value: function temperaturePreview(_ref) {
            var average = _ref.average;
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return ConfigHelper.merged(_presets2.default.Temperature, _presets2.default.Preview, _presets2.default.TemperaturePreview, {
                series: [{
                    data: average,
                    name: 'Temperature',
                    zIndex: 1
                }]
            }, config);
        }
    }, {
        key: 'temperatureFull',
        value: function temperatureFull(_ref2) {
            var average = _ref2.average,
                ranges = _ref2.ranges;
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return ConfigHelper.merged(_presets2.default.Temperature, _presets2.default.Full, _presets2.default.TemperatureFull, ConfigHelper.title('Average temperature with highs and lows'), {
                series: [{
                    data: average,
                    name: 'Temperature',
                    zIndex: 1
                }, {
                    data: ranges,
                    name: 'Temperature Range',
                    type: 'arearange',
                    linkedTo: ':previous'
                }]
            }, config);
        }
    }, {
        key: 'touchPreview',
        value: function touchPreview(data) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return ConfigHelper.merged(_presets2.default.Touch, _presets2.default.Preview, _presets2.default.TouchPreview, {
                series: [{
                    type: 'scatter',
                    name: 'Touch Count',
                    marker: {
                        radius: 6
                    },
                    data: data
                }]
            }, config);
        }
    }, {
        key: 'touchFull',
        value: function touchFull(data) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return ConfigHelper.merged(_presets2.default.Touch, _presets2.default.Full, _presets2.default.TouchFull, ConfigHelper.title('Button presses'), {
                yAxis: {
                    title: {
                        text: 'Quantity'
                    },
                    tickInterval: 1
                },
                series: [{
                    type: 'scatter',
                    name: 'Touch Count',
                    marker: {
                        radius: 6
                    },
                    data: data
                }]
            }, config);
        }
    }, {
        key: 'proximityPreview',
        value: function proximityPreview(data) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return ConfigHelper.merged(_presets2.default.Proximity, _presets2.default.Preview, _presets2.default.ProximityPreview, {
                series: [{
                    name: 'Proximity Status',
                    data: data
                }]
            }, config);
        }
    }, {
        key: 'proximityFull',
        value: function proximityFull(data) {
            var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return ConfigHelper.merged(_presets2.default.Proximity, _presets2.default.Full, _presets2.default.ProximityFull, ConfigHelper.title('Proximity Status'), {
                series: [{
                    name: 'Proximity Status',
                    data: data
                }]
            }, config);
        }
    }, {
        key: 'getDefaultTimespan',
        value: function getDefaultTimespan() {
            return {
                start: (0, _moment2.default)().subtract(1, 'day'),
                end: (0, _moment2.default)(),
                interval: '30m'
            };
        }
    }]);

    return ConfigHelper;
}();

exports.default = ConfigHelper;

/***/ }),

/***/ "mpUf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

var _thing = __webpack_require__("dCTD");

var _thing2 = _interopRequireDefault(_thing);

var _thingSubscriber = __webpack_require__("eBQt");

var _thingSubscriber2 = _interopRequireDefault(_thingSubscriber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThingsApi = function () {
    /** @ngInject */
    ThingsApi.$inject = ["$http", "ThingsService", "AuthService"];
    function ThingsApi($http, ThingsService, AuthService) {
        _classCallCheck(this, ThingsApi);

        this.$http = $http;
        this.config = _local2.default.api.things;
        this.ThingsService = ThingsService;
        this.AuthService = AuthService;
        this.listUrl = _utils2.default.buildApiUrl('things.list');
    }

    _createClass(ThingsApi, [{
        key: 'mapToThing',
        value: function mapToThing(item) {
            var thing = new _thing2.default(item);
            thing.setTypeConfig(thing.type ? this.ThingsService.getThingByType(thing.type.id) : null);
            // TODO: remove this after Cloud-Connector time-drift issue resolved
            if (thing.state) {
                if ((0, _moment2.default)(thing.state.updated).isAfter()) {
                    thing.state.updated = (0, _moment2.default)().format();
                }
            }
            return thing;
        }
    }, {
        key: 'getList',
        value: function getList() {
            var _this = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var params = {};

            Object.keys(options).filter(function (key) {
                return options[key];
            }).forEach(function (key) {
                params[key] = options[key];
            });

            return this.$http.get(this.listUrl, { params: params }).then(_utils2.default.httpExtractData).then(function (data) {
                if (data.things) {
                    data.things = data.things.map(_this.mapToThing.bind(_this));
                }
                return data;
            });
        }
    }, {
        key: 'entity',
        value: function entity(thingId) {
            var _this2 = this;

            var url = _utils2.default.buildApiUrl('things.entity', { thingId: thingId });
            return this.$http.get(url).then(_utils2.default.httpExtractData).then(function (thing) {
                return _this2.mapToThing(thing);
            });
        }
    }, {
        key: 'update',
        value: function update(thingId, params) {
            var url = _utils2.default.buildApiUrl('things.entity', { thingId: thingId });

            return this.$http.patch(url, params).then(_utils2.default.httpExtractData);
        }
    }, {
        key: 'getWatchUrl',
        value: function getWatchUrl(thingIds) {
            var _this3 = this;

            var thingIdsUri = thingIds.map(function (id) {
                return '&thing_ids=' + id;
            }).join('');
            var baseUrl = _utils2.default.buildApiUrl('things.subscribe');
            return function () {
                return baseUrl + '?token=' + _this3.AuthService.getAccessToken() + thingIdsUri;
            };
        }
    }, {
        key: 'subscribeToThingUpdates',
        value: function subscribeToThingUpdates(thingId, onUpdateCallback) {
            return this.subscribeToAllUpdates([thingId], onUpdateCallback);
        }
    }, {
        key: 'subscribeToAllUpdates',
        value: function subscribeToAllUpdates(thingIds, onUpdateCallback) {
            return new _thingSubscriber2.default(this.getWatchUrl(thingIds), onUpdateCallback);
        }
    }, {
        key: 'historicalQuery',
        value: function historicalQuery(thingId, params) {
            var requestUrl = _utils2.default.buildApiUrl('things.history', { thingId: thingId });
            return this.$http.post(requestUrl, params).then(_utils2.default.httpExtractData);
        }
    }, {
        key: 'historicalQueryAggregated',
        value: function historicalQueryAggregated(thingId, params) {
            var requestUrl = _utils2.default.buildApiUrl('things.historyAggregated', { thingId: thingId });
            return this.$http.post(requestUrl, params).then(_utils2.default.httpExtractData);
        }
    }, {
        key: 'star',
        value: function star(thingId) {
            var url = _utils2.default.buildApiUrl('things.star', { thingId: thingId });

            return this.$http.post(url, {});
        }
    }, {
        key: 'unstar',
        value: function unstar(thingId) {
            var url = _utils2.default.buildApiUrl('things.unstar', { thingId: thingId });

            return this.$http.post(url, {});
        }
    }]);

    return ThingsApi;
}();

exports.default = ThingsApi;

/***/ }),

/***/ "mpcD":
/***/ (function(module, exports) {

module.exports = "<md-icon class=icon-signal md-svg-icon=\"{{ $ctrl.radioIcon }}\" aria-label=Signal></md-icon>";

/***/ }),

/***/ "mvAe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _permissions = __webpack_require__("mf7S");

var _permissions2 = _interopRequireDefault(_permissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtPermissions',
    options: _permissions2.default
};

/***/ }),

/***/ "mvlx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VIEW_PLACEMENT_TOP = 'top';
var VIEW_PLACEMENT_DROPDOWN = 'dropdown';

var TOAST_CONFIG = {
    hideDelay: 1500
};

var SaveViewPopupController = function () {
    /** @ngInject */
    SaveViewPopupController.$inject = ["ViewsApi", "DialogService", "searchQuery", "onSaveView", "EventEmitter", "ToastService", "CategoriesApi", "$q"];
    function SaveViewPopupController(ViewsApi, DialogService, searchQuery, onSaveView, EventEmitter, ToastService, CategoriesApi, $q) {
        _classCallCheck(this, SaveViewPopupController);

        this.ViewsApi = ViewsApi;
        this.CategoriesApi = CategoriesApi;
        this.DialogService = DialogService;
        this.searchQuery = searchQuery;
        this.eventEmitter = EventEmitter;
        this.onSaveView = onSaveView;
        this.ToastService = ToastService;
        this.$q = $q;

        this.viewPlacement = VIEW_PLACEMENT_TOP;

        this.loadCategories();
    }

    _createClass(SaveViewPopupController, [{
        key: 'onCategoryQueryChanged',
        value: function onCategoryQueryChanged(_ref) {
            var query = _ref.query;

            this.categoryName = query;
            this.categoryId = null;
        }
    }, {
        key: 'onSearch',
        value: function onSearch(_ref2) {
            var query = _ref2.query;

            return _utils2.default.searchInIndex(this.searchIndex, query);
        }
    }, {
        key: 'onCategoryFound',
        value: function onCategoryFound(_ref3) {
            var item = _ref3.item;

            if (item) {
                this.categoryId = item.id;
                this.categoryName = null;
            }
        }
    }, {
        key: 'loadCategories',
        value: function loadCategories() {
            var _this = this;

            this.CategoriesApi.getList({
                page_size: 100
            }).then(function (data) {
                _this.categories = data.categories || [];
                _this.searchIndex = _utils2.default.buildSearchIndex(_this.categories);
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.DialogService.cancel();
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            if (!this.viewName) {
                return;
            }

            var categoryPromise = {};
            if (this.categoryName) {
                categoryPromise = this.CategoriesApi.createCategory({
                    name: this.categoryName
                });
            }

            this.$q.when(categoryPromise).then(function (category) {
                var view = {
                    name: _this2.viewName,
                    search_query: _this2.searchQuery,
                    category_id: category.id || _this2.categoryId
                };
                return _this2.ViewsApi.createView(view);
            }).then(function (view) {
                _this2.onSaveView(_this2.eventEmitter({
                    view: view
                }));
                _this2.ToastService.showSimpleTranslated('navbar_view_was_created', TOAST_CONFIG);
                _this2.DialogService.hide();
            }).catch(function () {
                _this2.ToastService.showSimpleTranslated('navbar_view_wasnt_created', TOAST_CONFIG);
            });
        }
    }, {
        key: 'showDropdown',
        get: function get() {
            return this.viewPlacement === VIEW_PLACEMENT_DROPDOWN;
        }
    }]);

    return SaveViewPopupController;
}();

exports.default = SaveViewPopupController;

/***/ }),

/***/ "mxiS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchBoxController = function () {
    /** @ngInject */
    SearchBoxController.$inject = ["ThingsService", "EventEmitter", "DialogService", "$timeout"];
    function SearchBoxController(ThingsService, EventEmitter, DialogService, $timeout) {
        _classCallCheck(this, SearchBoxController);

        this.ThingsService = ThingsService;
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
    }

    _createClass(SearchBoxController, [{
        key: '$onInit',
        value: function $onInit() {
            this.things = this.ThingsService.getAllThings();
        }
    }, {
        key: 'toggleDropdownPanel',
        value: function toggleDropdownPanel() {
            this.dropdownTouched = true;
            this.dropdownVisible = !this.dropdownVisible;
        }
    }, {
        key: 'showDropdownPanel',
        value: function showDropdownPanel() {
            this.dropdownTouched = true;
            this.dropdownVisible = true;
        }
    }, {
        key: 'hideDropdownPanel',
        value: function hideDropdownPanel() {
            this.dropdownTouched = true;
            this.dropdownVisible = false;
        }
    }, {
        key: 'focused',
        value: function focused() {
            this.dropdownTouched = true;
            if (!this.query) {
                this.showDropdownPanel();
            }
        }
    }, {
        key: 'blurred',
        value: function blurred() {
            var _this = this;

            this.dropdownTouched = false;
            this.$timeout(function () {
                if (!_this.dropdownTouched) {
                    _this.hideDropdownPanel();
                }
            }, 200);
        }
    }, {
        key: 'queryChanged',
        value: function queryChanged() {
            if (this.query) {
                this.hideDropdownPanel();
            } else {
                this.showDropdownPanel();
            }
        }
    }, {
        key: 'search',
        value: function search() {
            this.emitSearchEvent(this.query);
        }
    }, {
        key: 'emitSearchEvent',
        value: function emitSearchEvent(query) {
            this.onSearch(this.eventEmitter({
                query: query
            }));
            this.hideDropdownPanel();
        }
    }, {
        key: 'searchByType',
        value: function searchByType(type) {
            var query = 'type:' + type;
            this.emitSearchEvent(query);
        }
    }, {
        key: 'searchStarred',
        value: function searchStarred() {
            var query = 'starred:true';
            this.emitSearchEvent(query);
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.query = '';
            this.onClear();
        }
    }]);

    return SearchBoxController;
}();

exports.default = SearchBoxController;

/***/ }),

/***/ "myz8":
/***/ (function(module, exports) {

module.exports = "<div layout-gt-xs=row layout-xs=column layout-align-gt-xs=\"start start\" layout-margin flex layout-wrap> <div class=\"content-box folders-list\" flex-xs-auto layout-padding> <div> <h3 class=\"box-title space-m-t-n\">Folders</h3> <dt-search-autocomplete class=\"md-block space-m-b-m\" placeholder=\"Search folders\" text-key=name on-selected=$ctrl.onFolderFound($event) on-search=$ctrl.onSearch($event)></dt-search-autocomplete> <div dt-block-loader=$ctrl.foldersLoading> <dt-admin-folder-tree data=$ctrl.folders selected-folder-id=$ctrl.currentFolderId on-folder-created=$ctrl.createFolder($event) on-folder-selected=$ctrl.editFolder($event) on-folder-moved=$ctrl.moveFolder($event)></dt-admin-folder-tree> </div> </div> </div> <ui-view on-saved=$ctrl.saveFolder($event) on-deleted=$ctrl.deleteFolder($event) on-edit-cancelled=$ctrl.cancelEdit() flex></ui-view> <dt-empty-state ng-if=!$ctrl.folders.length state={{$ctrl.$state.current.name}}></dt-empty-state> </div> ";

/***/ }),

/***/ "n0UU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _charting = __webpack_require__("6EsV");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DetailsChartController = function () {
    /** @ngInject */
    function DetailsChartController() {
        _classCallCheck(this, DetailsChartController);

        this.chartData = [];
        this.chartType = null;
        this.chartConfig = {};
    }

    _createClass(DetailsChartController, [{
        key: 'prepareTemperatureConfig',
        value: function prepareTemperatureConfig() {
            var data = _charting.DataConverter.temperature(this.chartData);
            this.chartConfig = _charting.ConfigHelper.temperaturePreview(data);
        }
    }, {
        key: 'prepareTouchConfig',
        value: function prepareTouchConfig() {
            var data = _charting.DataConverter.touch(this.chartData);
            this.chartConfig = _charting.ConfigHelper.touchPreview(data);
        }
    }, {
        key: 'prepareProximityConfig',
        value: function prepareProximityConfig() {
            var data = _charting.DataConverter.proximity(this.chartData);
            this.chartConfig = _charting.ConfigHelper.proximityPreview(data);
        }
    }, {
        key: 'prepareChartConfig',
        value: function prepareChartConfig() {
            if (this.chartType === 'temperature') {
                this.prepareTemperatureConfig();
            } else if (this.chartType === 'touch') {
                this.prepareTouchConfig();
            } else {
                this.prepareProximityConfig();
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.chartData && changes.chartData.currentValue) {
                this.chartData = changes.chartData.currentValue.values || [];
            }

            if (changes.chartType) {
                this.chartType = changes.chartType.currentValue;
            }

            if (changes.chartData || changes.chartType) {
                this.prepareChartConfig();
            }
        }
    }]);

    return DetailsChartController;
}();

exports.default = DetailsChartController;

/***/ }),

/***/ "n2/Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("2ZN7"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * DeveloperApi class.
 */

var DeveloperApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    DeveloperApi.$inject = ["$http"];
    function DeveloperApi($http) {
        _classCallCheck(this, DeveloperApi);

        this.$http = $http;
        this.config = _local2.default.api.developer;
    }

    /**
     * Get developer application config
     * @returns {promise}
     */


    _createClass(DeveloperApi, [{
        key: 'getListOfApps',
        value: function getListOfApps() {
            return this.$http.get(this.config.applicationList).then(responseDataExtractor);
        }

        /**
         * Create application
         * @returns {promise}
         */

    }, {
        key: 'create',
        value: function create(app) {
            // eslint-disable-line
            // TODO: should be refactoring with real API
            var returnedApp = {
                name: app.name,
                id: Math.floor(Math.random() * 1000000000000000000),
                description: null,
                image: null,
                secret: Math.floor(Math.random() * 1000000000000000000)
            };

            var promise = new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve(returnedApp);
                    reject('Error');
                }, 1000);
            });

            return promise;
        }

        /**
         * Update application
         * @returns {promise}
         */

    }, {
        key: 'update',
        value: function update(app) {
            // eslint-disable-line
            var promise = new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve(app);
                    reject('Error');
                }, 1000);
            });

            return promise;
        }
    }]);

    return DeveloperApi;
}();

exports.default = DeveloperApi;

/***/ }),

/***/ "n2Z8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HelpMenuController = function () {
    function HelpMenuController() {
        _classCallCheck(this, HelpMenuController);
    }

    _createClass(HelpMenuController, [{
        key: '$onInit',

        /** @ngInject */
        value: function $onInit() {
            this.helpMenuType = 'APPLICATION_HELP';
        }
    }, {
        key: 'showFeedbackForm',
        value: function showFeedbackForm() {
            this.helpMenuType = 'FEEDBACK_FORM';
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.mdPanelRef.close();
        }
    }]);

    return HelpMenuController;
}();

exports.default = HelpMenuController;

/***/ }),

/***/ "n6dy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _labels = __webpack_require__("8Kqj");

var _labels2 = _interopRequireDefault(_labels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Xq0/");

exports.default = {
    controller: _labels2.default,
    template: template
};

/***/ }),

/***/ "nH1p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _userPopover = __webpack_require__("UGM9");

var _userPopover2 = _interopRequireDefault(_userPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Jq7Z");

exports.default = {
    bindings: {
        onClose: '&'
    },
    controller: _userPopover2.default,
    template: template
};

/***/ }),

/***/ "nQjj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _graphs = __webpack_require__("Ficg");

var _graphs2 = _interopRequireDefault(_graphs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("ta0e");

exports.default = {
    controller: _graphs2.default,
    template: template
};

/***/ }),

/***/ "nZcg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _batteryStatus = __webpack_require__("FyPS");

var _batteryStatus2 = _interopRequireDefault(_batteryStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtBatteryStatus',
    options: _batteryStatus2.default
};

/***/ }),

/***/ "neeV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountSettingsController =
/** @ngInject */
["EventEmitter", function AccountSettingsController(EventEmitter) {
    _classCallCheck(this, AccountSettingsController);

    this.eventEmiter = EventEmitter;
}];

exports.default = AccountSettingsController;

/***/ }),

/***/ "nlR8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingStatus = __webpack_require__("bqBt");

var _thingStatus2 = _interopRequireDefault(_thingStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("OiHR");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingStatus2.default
};

/***/ }),

/***/ "nmcK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/theft.svg";

/***/ }),

/***/ "np9N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loader = __webpack_require__("XHK+");

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("Zd5J");

exports.default = {
    bindings: {
        loaderType: '<'
    },
    template: template,
    controller: _loader2.default
};

/***/ }),

/***/ "npfx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _usersAndAccess = __webpack_require__("DqNX");

var _usersAndAccess2 = _interopRequireDefault(_usersAndAccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("J4ii");

exports.default = {
    controller: _usersAndAccess2.default,
    template: template
};

/***/ }),

/***/ "o+67":
/***/ (function(module, exports) {

module.exports = "<md-icon class=material-icons ng-click=\"$ctrl.toggle(); $event.stopPropagation();\" md-svg-icon=\"{{ $ctrl.starredIcon }}\" aria-label=\"{{ ::$ctrl.starredAriaLabel }}\" aria-hidden=true> </md-icon> ";

/***/ }),

/***/ "o1sJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/door.svg";

/***/ }),

/***/ "ocvI":
/***/ (function(module, exports) {

module.exports = "<div class=content-box__toolbar layout=row> <span flex></span> <md-button class=\"md-icon-button md-default\" ui-sref=main.sensors.list.thing> <md-icon class=\"material-icons material-icons--s\" style=color:#959595>clear</md-icon> </md-button> </div> <dt-chart ng-if=$ctrl.dataLoaded class=chart ng-class=\"{\n            'chart-proximity-full': $ctrl.chartType === 'proximity',\n            'chart-touch-full': $ctrl.chartType === 'touch',\n            'chart-temperature-full': $ctrl.chartType === 'temperature'\n        }\" on-chart-loaded=$ctrl.onChartLoaded($event) config=$ctrl.chartConfig use-stock-chart=true></dt-chart> <ul class=\"custom-list custom-list--inline\" layout=row layout-align=\"center center\" ng-if=$ctrl.chartStats> <li class=space-m-h-xxl ng-repeat=\"(key, value) in $ctrl.chartStats\"> <div class=block-title>{{ key }}</div> <div class=h1>{{ value }}</div> </li> </ul> ";

/***/ }),

/***/ "og3r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HelpIconController = function () {
    /** @ngInject */
    HelpIconController.$inject = ["TranslationService"];
    function HelpIconController(TranslationService) {
        _classCallCheck(this, HelpIconController);

        this.TranslationService = TranslationService;
    }

    _createClass(HelpIconController, [{
        key: "$onInit",
        value: function $onInit() {
            this.message = this.TranslationService.getLine(this.messageKey);
        }
    }]);

    return HelpIconController;
}();

exports.default = HelpIconController;

/***/ }),

/***/ "og9u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/users.json";

/***/ }),

/***/ "p4B/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThingStarController = function () {
    /** @ngInject */
    ThingStarController.$inject = ["EventEmitter", "ThingsApi", "ToastService"];
    function ThingStarController(EventEmitter, ThingsApi, ToastService) {
        _classCallCheck(this, ThingStarController);

        this.eventEmitter = EventEmitter;
        this.api = ThingsApi;
        this.ToastService = ToastService;
    }

    _createClass(ThingStarController, [{
        key: '$onInit',
        value: function $onInit() {
            if (typeof this.thingId === 'undefined') {
                this.thingId = null;
            }

            this.isProcessing = false;

            if (!this.starred || null === this.thingId) {
                this.starredIcon = 'star-o';
                this.starredAreaLabel = 'Unstarred';
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.starred) {
                this.starred = changes.starred.currentValue;
            }

            if (changes.thingId) {
                this.thingId = changes.thingId.currentValue;
            }

            this.calculateIcon();
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            var _this = this;

            var apiPromise = void 0;

            if (this.isProcessing) return;

            this.starred = !this.starred;
            this.isProcessing = true;

            this.calculateIcon();

            if (this.starred) {
                apiPromise = this.api.star(this.thingId);
            } else {
                apiPromise = this.api.unstar(this.thingId);
            }

            apiPromise.then(function () {
                _this.onToggleStatus(_this.eventEmitter({
                    starred: _this.starred
                }));

                _this.ToastService.showSimpleTranslated(_this.starred ? 'star_was_added' : 'star_was_removed');
            }, function () {
                _this.ToastService.showSimpleTranslated(_this.starred ? 'star_wasnt_added' : 'star_wasnt_removed');

                _this.starred = !_this.starred;
            }).finally(function () {
                _this.isProcessing = false;
            });
        }
    }, {
        key: 'calculateIcon',
        value: function calculateIcon() {
            if (this.starred) {
                this.starredIcon = 'star';
                this.starredAriaLabel = 'Starred';
            } else {
                this.starredIcon = 'star-o';
                this.starredAriaLabel = 'Unstarred';
            }
        }
    }]);

    return ThingStarController;
}();

exports.default = ThingStarController;

/***/ }),

/***/ "p7fo":
/***/ (function(module, exports) {

module.exports = "<div class=block-title>Comments</div> <ul class=notes-list> <li data-ng-repeat=\"note in $ctrl.notes track by $index\"> <div> <span class=\"notes-list__title block-bordered-hover\" ng-click=\"$ctrl.editNoteDialog($event, note)\" data-ng-bind=note.content></span> <md-icon ng-click=\"$ctrl.removeNote($index, note.id)\" class=\"material-icons notes-list__remove\">clear</md-icon> </div> </li> </ul> <a href=\"\" ng-click=\"$ctrl.addNoteDialog($event); $event.preventDefault();\" class=\"md-primary md-caption\">+ Add comment</a> ";

/***/ }),

/***/ "pB1T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/role.json";

/***/ }),

/***/ "pJNW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

var _charting = __webpack_require__("6EsV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThingDetailsController = function () {
    /** @ngInject */
    ThingDetailsController.$inject = ["EventEmitter", "Loader", "$q", "LabelsApi", "ThingsApi", "$scope", "ToastService", "TranslationService"];
    function ThingDetailsController(EventEmitter, Loader, $q, LabelsApi, ThingsApi, $scope, ToastService, TranslationService) {
        _classCallCheck(this, ThingDetailsController);

        this.eventEmitter = EventEmitter;
        this.Loader = Loader;
        this.$q = $q;
        this.LabelsApi = LabelsApi;
        this.ThingsApi = ThingsApi;
        this.evtSource = null;
        this.$scope = $scope;
        this.ToastService = ToastService;
        this.TranslationService = TranslationService;

        this.performHealthCheck = this.performHealthCheck.bind(this);
        this.onUpdateReceived = this.onUpdateReceived.bind(this);
    }

    _createClass(ThingDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.alerts = [];
            this.history = [];
            this.events = [];
            this.owner = {};
            this.users = [];

            this.editMode = false;

            this.subscribeToLiveUpdates();

            this.chartType = this.thing.getHistoryChartType();
            this.showChart = false;

            this.loadHistoricalData();

            this.$scope.$on('health-checker-page-visible', this.performHealthCheck);
            this.$scope.$on('health-checker-network-up', this.performHealthCheck);
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.unsubscribeFromLiveUpdates();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.thingUpdate && !changes.thingUpdate.isFirstChange()) {
                this.thing.starred = changes.thingUpdate.currentValue.starred;
            }
        }
    }, {
        key: 'loadThingState',
        value: function loadThingState() {
            var _this = this;

            this.ThingsApi.entity(this.thing.id).then(function (thing) {
                Object.assign(_this.thing.state, thing.state);
            });
        }
    }, {
        key: 'performHealthCheck',
        value: function performHealthCheck() {
            if (this.liveDataSubscription && !this.liveDataSubscription.isAlive) {
                this.loadThingState();
            }
        }
    }, {
        key: 'onUpdateReceived',
        value: function onUpdateReceived(thingId, patch) {
            if (patch.state) {
                if (!patch.state.properties.touch) {
                    patch.state.properties.last_pressed = this.thing.state.properties.last_pressed;
                }
                Object.assign(this.thing.state.properties, patch.state.properties);
                this.thing.state.updated = patch.state.updated;
            } else {
                Object.assign(this.thing, patch);
            }
            if (patch.state) {
                this.loadHistoricalData();
            }
            this.$scope.$applyAsync();
        }
    }, {
        key: 'unsubscribeFromLiveUpdates',
        value: function unsubscribeFromLiveUpdates() {
            if (this.liveDataSubscription) {
                this.liveDataSubscription.stop();
            }
        }
    }, {
        key: 'subscribeToLiveUpdates',
        value: function subscribeToLiveUpdates() {
            this.unsubscribeFromLiveUpdates();

            this.liveDataSubscription = this.ThingsApi.subscribeToThingUpdates(this.thing.id, this.onUpdateReceived);
        }
    }, {
        key: 'loadHistoricalData',
        value: function loadHistoricalData() {
            var _this2 = this;

            var historyPromise = void 0;

            var _ConfigHelper$getDefa = _charting.ConfigHelper.getDefaultTimespan(),
                start = _ConfigHelper$getDefa.start,
                end = _ConfigHelper$getDefa.end;

            var timePeriod = {
                start: start.format(),
                end: end.format()
            };

            if (this.thing.isHistoryAggregated()) {
                historyPromise = this.ThingsApi.historicalQueryAggregated(this.thing.id, {
                    fields: this.thing.getHistoryFieldsConfig(),
                    interval: this.thing.getDefaultHistoryInterval(),
                    time_period: timePeriod,
                    fill: 'null'
                });
            } else {
                historyPromise = this.ThingsApi.historicalQuery(this.thing.id, {
                    fields: this.thing.getHistoryFieldsConfig(),
                    time_period: timePeriod
                });
            }

            historyPromise.then(function (data) {
                _this2.history = data;
                _this2.showChart = true;
            });
        }
    }, {
        key: 'onChangeThingStarred',
        value: function onChangeThingStarred(_ref) {
            var starred = _ref.starred;

            this.thing.starred = starred;
            this.onThingUpdated(this.eventEmitter({
                thing: this.thing
            }));
        }
    }, {
        key: 'processLabel',
        value: function processLabel(_ref2) {
            var _this3 = this;

            var data = _ref2.data;

            this.Loader.show();
            return this.LabelsApi.create(data).finally(function () {
                _this3.Loader.hide();
            });
        }
    }, {
        key: 'updateThing',
        value: function updateThing(_ref3) {
            var _this4 = this;

            var patch = _ref3.patch,
                data = _ref3.data;

            this.Loader.show();
            return this.ThingsApi.update(this.thing.id, patch).then(function () {
                Object.assign(_this4.thing, data || patch);

                _this4.ToastService.showSimpleTranslated('thing_was_saved');

                _this4.onThingUpdated(_this4.eventEmitter({
                    thing: _this4.thing
                }));
            }).catch(function (_ref4) {
                var response = _ref4.data;

                _this4.ToastService.showSimpleText(response && response.Error ? response.Error : _this4.TranslationService.getLine('thing_wasnt_saved'));
            }).finally(function () {
                _this4.Loader.hide();
            });
        }
    }, {
        key: 'isUpdatedLongAgo',
        get: function get() {
            if (!this.thing.state || !this.thing.state.updated) {
                return true;
            }
            return (0, _moment2.default)(this.thing.state.updated).isBefore((0, _moment2.default)().subtract(1, 'day'));
        }
    }]);

    return ThingDetailsController;
}();

exports.default = ThingDetailsController;

/***/ }),

/***/ "pKWn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/all-notifications.png";

/***/ }),

/***/ "pON3":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-grid__col form-grid__col__label\"> <label class=form-grid__label for=thingName>Name</label> <dt-help-icon message-key=help_icon_advanced_search_name></dt-help-icon> </div> <md-input-container class=\"form-element form-element--simple form-grid__col\"> <input type=text id=thingName aria-label=\"Thing Name\" ng-change=$ctrl.onChange(); ng-model-options=\"{\n                'updateOn': 'default blur',\n                'debounce': {\n                    'default': 350,\n                    'blur': 0\n                }\n            }\" ng-model=$ctrl.thingName> </md-input-container>";

/***/ }),

/***/ "pYgc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _privileges = __webpack_require__("gmaI");

var _privileges2 = _interopRequireDefault(_privileges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * PrivilegesApi settings
 * @type {{name: string, definition: PrivilegesApi}}
 */
exports.default = {
  name: 'PrivilegesApi',
  definition: _privileges2.default
};

/***/ }),

/***/ "pZmp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Plural filter used to convert word into plural meaning
 * @returns {Function}
 */
function pluralFilter() {
    return function (value) {
        return value + 's';
    };
}

/**
 * Plural filter settings
 */
exports.default = {
    name: 'pluralFilter',
    definition: pluralFilter
};

/***/ }),

/***/ "prw6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extend2 = __webpack_require__("iyRQ");

var _extend3 = _interopRequireDefault(_extend2);

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Alert class.
 */
var Alert =
/**
 * @param {Object} data - Alert data
 * @constructor
 */
function Alert(data) {
  _classCallCheck(this, Alert);

  (0, _extend3.default)(this, data);

  this.createdFormatted = _utils2.default.convertTimestampToFormat(this.created, _local2.default.format.datetime);
  this.endedFormatted = _utils2.default.convertTimestampToFormat(this.ended, _local2.default.format.datetime);
};

exports.default = Alert;

/***/ }),

/***/ "q2XB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderController = function () {
    /** @ngInject */
    HeaderController.$inject = ["$state", "$mdPanel"];
    function HeaderController($state, $mdPanel) {
        _classCallCheck(this, HeaderController);

        this.$state = $state;
        this.$mdPanel = $mdPanel;
    }

    _createClass(HeaderController, [{
        key: '$onInit',
        value: function $onInit() {
            this.isMobileNav = false;
        }
    }, {
        key: 'showNotifications',
        value: function showNotifications() {
            this.$state.go('main.notifications');
        }
    }, {
        key: 'showUserInfo',
        value: function showUserInfo(ev) {
            var position = this.$mdPanel.newPanelPosition().relativeTo(ev.target).addPanelPosition(this.$mdPanel.xPosition.ALIGN_END, this.$mdPanel.yPosition.BELOW);

            var config = {
                attachTo: document.body,
                controller: function controller() {},
                controllerAs: '$ctrl',
                template: '<dt-user-popover on-close="$ctrl.closeUserInfo()"></dt-user-popover>',
                panelClass: 'md-panel--arrow-top',
                position: position,
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 100,
                locals: {
                    closeUserInfo: this.closeUserInfo
                }
            };

            this.$mdPanel.open(config);
        }
    }, {
        key: 'closeUserInfo',
        value: function closeUserInfo() {
            this.mdPanelRef.close();
        }
    }]);

    return HeaderController;
}();

exports.default = HeaderController;

/***/ }),

/***/ "qU0y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingDetailsLabels = __webpack_require__("QA0p");

var _thingDetailsLabels2 = _interopRequireDefault(_thingDetailsLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("laKs");

exports.default = {
    bindings: {
        labels: '<',
        preUpdate: '&',
        onUpdate: '&'
    },
    template: template,
    controller: _thingDetailsLabels2.default
};

/***/ }),

/***/ "qwi1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _labelDetails = __webpack_require__("42OU");

var _labelDetails2 = _interopRequireDefault(_labelDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtLabelDetailsView',
    options: _labelDetails2.default
};

/***/ }),

/***/ "rA0j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Service = undefined;

var _things = __webpack_require__("1hZ4");

var _things2 = _interopRequireDefault(_things);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ThingsService settings
 * @type {{name: string, definition: ThingsService}}
 */
var Service = {
    name: 'ThingsService',
    definition: _things2.default
};

exports.Service = Service;

/***/ }),

/***/ "rDim":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/window.svg";

/***/ }),

/***/ "rGCW":
/***/ (function(module, exports) {

module.exports = "<md-dialog flex=30 class=dialog> <md-toolbar class=md-hue-2> <div class=md-toolbar-tools> <span class=md-title>Edit {{ ::$ctrl.selectedThings.totalSelected }} sensors and connectors</span> </div> </md-toolbar> <md-dialog-content class=md-dialog-content> <div layout=column> <div class=space-m-b-m> <div class=md-subhead>Add labels</div> <dt-labels push-update=$ctrl.onLabelsAdded($event) is-editing=true></dt-labels> <p class=md-caption>Start typing and press enter to add label</p> </div> <div class=md-subhead>Move to folder</div> <div class=md-caption>Select a folder in the tree navigation below</div> <dt-folder-selector single-selection=true on-folder-change=$ctrl.onFolderChange(folderId)></dt-folder-selector> </div> </md-dialog-content> <md-dialog-actions class=\"space-p-h-l space-p-b-m\"> <div layout=column layout-align=\"start none\" flex> <md-divider></md-divider> <section layout=row layout-align=\"end center\"> <md-button class=md-default ng-click=$ctrl.cancel()> Cancel </md-button> <md-button class=\"md-primary md-raised\" ng-click=$ctrl.cancel()> Done </md-button> </section> </div> </md-dialog-actions> <div class=dialog-overlay ng-if=$ctrl.editAllWarning> <md-content class=\"md-hue-1 dialog-warning\" layout=column layout-padding> <div layout=row layout-align=\"start start\"> <i class=\"fa fa-3 fa-exclamation-triangle\" md-colors=\"{color: 'red-500'}\" aria-hidden=true></i> <div class=space-m-l-m> <p class=\"md-body-1 space-m-t-n\"> <b>You are about to make changes to {{ ::$ctrl.selectedThings.totalSelected }} sensors and connectors.</b> </p> <p class=md-caption>To edit only a selection of the items matching your query, use the checkboxes in the left-most column before pressing Bulk edit. </p> </div> </div> <div layout=row layout-align=\"end center\"> <md-button class=md-default ng-click=$ctrl.declineWarning()> Cancel </md-button> <md-button class=\"md-primary md-raised\" ng-click=$ctrl.acceptWarning()> Ok </md-button> </div> </md-content> </div> </md-dialog>";

/***/ }),

/***/ "rOGV":
/***/ (function(module, exports) {

module.exports = "<form class=content-box layout-padding name=sendFeedbackForm dt-block-loader=$ctrl.inProgress ng-submit=\"$ctrl.send(); $event.preventDefault();\" novalidate> <div class=box-title>Feedback &amp; Support</div> <div layout=row> <div class=dtFeedbackForm__user-data> <md-input-container class=md-block> <label>Feedback/support topic</label> <input type=text ng-model=$ctrl.feedbackFormData.subject name=subject required> <div ng-messages=sendFeedbackForm.subject.$error> <div ng-message=required>This is required.</div> </div> <div class=md-input-hint>What is this about?</div> </md-input-container> <md-input-container class=md-block> <label>Email</label> <input type=email ng-model=$ctrl.feedbackFormData.email name=email required ng-pattern=/^.+@.+\\..+$/ > <div class=md-input-hint>You’ll get a copy of this ticket sent to this email</div> <div ng-messages=sendFeedbackForm.email.$error> <div ng-message=required>This is required.</div> <div ng-message=pattern>It doesn't look like email.</div> </div> </md-input-container> <md-input-container class=md-block> <label>Description</label> <textarea name=body ng-model=$ctrl.feedbackFormData.body class=md-input md-no-autogrow=true rows=5 required></textarea> <div class=md-input-hint>The more info you provide, the quicker we’ll be able to help</div> <div ng-messages=sendFeedbackForm.body.$error> <div ng-message=required>This is required.</div> </div> </md-input-container> </div> <span flex></span> <div class=dtFeedbackForm__screenshot> <md-checkbox ng-model=$ctrl.isScreenshot> <span class=md-body-1>Include screenshot</span> </md-checkbox> <div ng-if=$ctrl.isScreenshot> <div class=space-m-b-xl>Click on the screenshot below to highlight relevant areas and hide sensitive information.</div> <dt-screenshot update-screenshot=$ctrl.isScreenshot></dt-screenshot> </div> </div> </div> <div layout=row layout-align=end> <md-button class=md-primary ng-click=$ctrl.onCancel()>Cancel</md-button> <md-button type=submit class=md-primary ng-disabled=sendFeedbackForm.$invalid>Send</md-button> </div> </form> ";

/***/ }),

/***/ "rZwI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _range2 = __webpack_require__("Z/kT");

var _range3 = _interopRequireDefault(_range2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'state.rssi';
var ANY_TEXT = 'Any';

var ThingSignalController = function () {
    /** @ngInject */
    ThingSignalController.$inject = ["EventEmitter"];
    function ThingSignalController(EventEmitter) {
        _classCallCheck(this, ThingSignalController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingSignalController, [{
        key: '$onInit',
        value: function $onInit() {
            this.anyText = ANY_TEXT;
            this.aboveValue = '';
            this.belowValue = '';
            this.signals = (0, _range3.default)(6);
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            var thingSignal = this.getThingSignal();

            if (Object.keys(thingSignal).length) {
                this.fillBucket();

                this.pushUpdate(this.eventEmitter({
                    value: thingSignal
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'getThingSignal',
        value: function getThingSignal() {
            var thingBattery = {};

            if (this.aboveValue !== this.anyText && this.aboveValue.toString().length) {
                thingBattery.above = this.aboveValue;
            }

            if (this.belowValue !== this.anyText && this.belowValue.toString().length) {
                thingBattery.below = this.belowValue;
            }

            return thingBattery;
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket() {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.getThingSignal()
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            this.aboveValue = '';
            this.belowValue = '';

            this.clearBucket();
        }
    }]);

    return ThingSignalController;
}();

exports.default = ThingSignalController;

/***/ }),

/***/ "rkt6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _searchBox = __webpack_require__("Pnia");

var _searchBox2 = _interopRequireDefault(_searchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSearchBox',
    options: _searchBox2.default
};

/***/ }),

/***/ "rlHJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notes = __webpack_require__("fgtS");

var _notes2 = _interopRequireDefault(_notes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("p7fo");

exports.default = {
    bindings: {
        thingId: '<'
    },
    template: template,
    controller: _notes2.default
};

/***/ }),

/***/ "ro6T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoaderService = exports.LoaderComponent = undefined;

var _loader = __webpack_require__("np9N");

var _loader2 = _interopRequireDefault(_loader);

var _loader3 = __webpack_require__("MR1Z");

var _loader4 = _interopRequireDefault(_loader3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoaderComponent = {
    selector: 'dtLoader',
    options: _loader2.default
};

var LoaderService = {
    name: 'Loader',
    definition: _loader4.default
};

exports.LoaderComponent = LoaderComponent;
exports.LoaderService = LoaderService;

/***/ }),

/***/ "rpcn":
/***/ (function(module, exports) {

module.exports = "<md-icon class=\"material-icons dt-things-toolbox__search-icon\" aria-label=search>search</md-icon> <form name=$ctrl.searchThingForm ng-submit=$ctrl.triggerSearch()> <input type=text name=search class=dt-things-toolbox__search-input autocomplete=off get-focus=$ctrl.addFocus placeholder=\"Search things\" ng-blur=$ctrl.blurred() ng-focus=$ctrl.focused() ng-model=$ctrl.query> <div class=dt-things-toolbox__clear-icon ng-if=$ctrl.isInFocus()> <md-button class=\"md-icon-button clear-search\" ng-mousedown=$ctrl.clearSearch()> <md-icon class=material-icons>clear</md-icon> <md-tooltip class=dt-theme>clear</md-tooltip> </md-button> </div> </form> ";

/***/ }),

/***/ "s9eL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emptyState = __webpack_require__("YKAe");

var _emptyState2 = _interopRequireDefault(_emptyState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtEmptyState',
    options: _emptyState2.default
};

/***/ }),

/***/ "sAJT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _history = __webpack_require__("bmEn");

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * HistoryApi settings
 * @type {{name: string, definition: HistoryApi}}
 */
exports.default = {
  name: 'HistoryApi',
  definition: _history2.default
};

/***/ }),

/***/ "sKsN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Graphs = exports.ListContainer = exports.Tabs = exports.Routes = exports.Components = exports.Component = undefined;

var _components = __webpack_require__("6Cbs");

var Components = _interopRequireWildcard(_components);

var _graphs = __webpack_require__("WXL7");

var Graphs = _interopRequireWildcard(_graphs);

var _tabs = __webpack_require__("6wga");

var _tabs2 = _interopRequireDefault(_tabs);

var _list = __webpack_require__("7iMI");

var _list2 = _interopRequireDefault(_list);

var _sensors = __webpack_require__("Jtzf");

var _sensors2 = _interopRequireDefault(_sensors);

var _sensors3 = __webpack_require__("ZDG3");

var _sensors4 = _interopRequireDefault(_sensors3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Component = {
    selector: 'dtSensorsAndConnectors',
    options: _sensors4.default
};

exports.Component = Component;
exports.Components = Components;
exports.Routes = _sensors2.default;
exports.Tabs = _tabs2.default;
exports.ListContainer = _list2.default;
exports.Graphs = Graphs;

/***/ }),

/***/ "sL6j":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-grid__col form-grid__col8\"> <label class=md-body-1>Notes</label> </div> <md-input-container class=\"form-element form-element--simple form-grid__col\"> <md-select aria-label=Notes ng-model=absdsad> <md-option ng-repeat=\"n in [1,2,3,4]\" ng-value=n>Option {{n}}</md-option> </md-select> </md-input-container> <div class=\"form-grid__col form-grid__col12\"> <md-icon class=\"material-icons material-icons--help\">help</md-icon> </div>";

/***/ }),

/***/ "sLdy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TriggerWebhook = exports.SendMail = exports.CreateNotifications = exports.Component = undefined;

var _createNotification = __webpack_require__("6yYo");

var _createNotification2 = _interopRequireDefault(_createNotification);

var _sendMail = __webpack_require__("kMUV");

var _sendMail2 = _interopRequireDefault(_sendMail);

var _triggerWebhook = __webpack_require__("kVuF");

var _triggerWebhook2 = _interopRequireDefault(_triggerWebhook);

var _actions = __webpack_require__("f0H3");

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtAlertsActionsContentActions',
    options: _actions2.default
};

exports.Component = Component;
exports.CreateNotifications = _createNotification2.default;
exports.SendMail = _sendMail2.default;
exports.TriggerWebhook = _triggerWebhook2.default;

/***/ }),

/***/ "sMLS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "data/auth-users.json";

/***/ }),

/***/ "sTKR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _splashScreen = __webpack_require__("6cRu");

var _splashScreen2 = _interopRequireDefault(_splashScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtSplashScreen',
    options: _splashScreen2.default
};

/***/ }),

/***/ "sVqQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extend2 = __webpack_require__("iyRQ");

var _extend3 = _interopRequireDefault(_extend2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * User class.
 */
var User =
/**
 * @param {Object} data - User data
 * @constructor
 */
function User(data) {
  _classCallCheck(this, User);

  (0, _extend3.default)(this, data);

  this.fullName = this.fullName || this.first_name + ' ' + this.last_name;
};

exports.default = User;

/***/ }),

/***/ "sZOI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

var _en = __webpack_require__("kpTX");

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TranslationService = function () {
    function TranslationService() {
        _classCallCheck(this, TranslationService);

        this.init();
    }

    _createClass(TranslationService, [{
        key: 'init',
        value: function init() {
            this.currentLang = 'en';

            this.lines = {
                en: _en2.default
            };
        }
    }, {
        key: 'getLine',
        value: function getLine(key) {
            var vars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var line = this.lines[this.currentLang][key] || '';
            return _utils2.default.formatString(vars, line);
        }
    }, {
        key: 'getCurrentLanguage',
        value: function getCurrentLanguage() {
            return this.currentLang;
        }
    }]);

    return TranslationService;
}();

exports.default = TranslationService;

/***/ }),

/***/ "sbbM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rules = __webpack_require__("7HZj");

var _rules2 = _interopRequireDefault(_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("NTe/");

exports.default = {
    controller: _rules2.default,
    template: template
};

/***/ }),

/***/ "slQK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingChart = __webpack_require__("WMEc");

var _thingChart2 = _interopRequireDefault(_thingChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingChart',
    options: _thingChart2.default
};

/***/ }),

/***/ "sn8m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TRACKED_PARAMS = ['q', 'tabId'];

var SensorsController = function () {
    /** @ngInject */
    SensorsController.$inject = ["EventEmitter", "$state", "$stateParams", "$location"];
    function SensorsController(EventEmitter, $state, $stateParams, $location) {
        _classCallCheck(this, SensorsController);

        this.EventEmitter = EventEmitter;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
    }

    _createClass(SensorsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            TRACKED_PARAMS.forEach(function (paramName) {
                _this[paramName] = _this.$stateParams[paramName];
            });
        }
    }, {
        key: 'uiOnParamsChanged',
        value: function uiOnParamsChanged(params) {
            var _this2 = this;

            TRACKED_PARAMS.forEach(function (paramName) {
                if (paramName in params) {
                    _this2[paramName] = params[paramName];
                }
            });
        }
    }]);

    return SensorsController;
}();

exports.default = SensorsController;

/***/ }),

/***/ "suGq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


blockLoaderDirectiveConfig.$inject = ["$compile"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = blockLoaderDirectiveConfig;
/** @ngInject */
function blockLoaderDirectiveConfig($compile) {
    function link($scope, $element) {
        var isActive = false;
        var diameter = $scope.diameter || 60;

        function checkPosition(el) {
            if (window.getComputedStyle(el[0], null).getPropertyValue('position') === 'static') {
                el.css('position', 'relative');
            }
        }

        function hide() {
            var blockLoaderNode = $element[0].querySelector('.block-loader');

            if (blockLoaderNode) {
                blockLoaderNode.parentNode.removeChild(blockLoaderNode);
            }

            isActive = false;
        }

        function show() {
            if (isActive) return;

            checkPosition($element);

            var blockLoader = $compile('<div class="block-loader">\n                        <md-progress-circular\n                            class="md-hue-2"\n                            md-mode="indeterminate"\n                            md-diameter="' + diameter + 'px">\n                        </md-progress-circular>\n                    </div>')($scope);

            $element.append(blockLoader);
            isActive = true;
        }

        $scope.$watch('dtBlockLoader', function (value) {
            if (value) {
                show();
            } else {
                hide();
            }
        });
    }

    return {
        restrict: 'A',
        scope: {
            dtBlockLoader: '<',
            diameter: '<'
        },
        link: link
    };
}

/***/ }),

/***/ "t5Zq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MapPopupController = function () {
    /** @ngInject */
    MapPopupController.$inject = ["marker", "centerCoordinates", "updateMarker", "isEditing", "DialogService", "EventEmitter"];
    function MapPopupController(marker, centerCoordinates, updateMarker, isEditing, DialogService, EventEmitter) {
        _classCallCheck(this, MapPopupController);

        this.marker = marker;
        this.isEditing = isEditing;
        this.updateMarker = updateMarker;
        this.centerCoordinates = centerCoordinates;
        this.DialogService = DialogService;
        this.eventEmitter = EventEmitter;
    }

    _createClass(MapPopupController, [{
        key: "$onInit",
        value: function $onInit() {
            this.currentMarker = null;
        }
    }, {
        key: "cancel",
        value: function cancel() {
            this.DialogService.cancel();
        }
    }, {
        key: "remove",
        value: function remove() {
            this.currentMarker = null;
            this.marker = this.currentMarker;

            this.done();
        }
    }, {
        key: "update",
        value: function update(_ref) {
            var marker = _ref.marker;

            this.currentMarker = marker;
        }
    }, {
        key: "done",
        value: function done() {
            this.updateMarker(this.currentMarker);
            this.cancel();
        }
    }]);

    return MapPopupController;
}();

exports.default = MapPopupController;

/***/ }),

/***/ "tJDh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = undefined;

var _dashboard = __webpack_require__("9D2k");

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dashboard3 = __webpack_require__("LD/t");

var _dashboard4 = _interopRequireDefault(_dashboard3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__("/Mo1"); // eslint-disable-line

var Component = {
    selector: 'dtDashboard',
    options: _dashboard4.default
};

exports.Config = _dashboard2.default;
exports.Component = Component;

/***/ }),

/***/ "tOXP":
/***/ (function(module, exports) {

module.exports = "<div class=list-button> <div class=list-button__content> <md-button class=\"md-button--small md-warn md-raised\">Mo</md-button> <md-button class=\"md-button--small md-warn md-raised\">Tu</md-button> <md-button class=\"md-button--small md-warn md-raised\">We</md-button> <md-button class=\"md-button--small md-warn md-raised\">Th</md-button> <md-button class=\"md-button--small md-warn md-raised\">Fr</md-button> <md-button class=md-button--small md-colors=\"{background: 'blueGrey-400'}\">Sa</md-button> <md-button class=md-button--small md-colors=\"{background: 'blueGrey-400'}\">Su</md-button> </div> </div> <div class=\"between-time space-m-b-s\" layout=row layout-align=\"start center\"> <label>Between</label> <md-input-container class=input-container--short md-no-float> <input type=text placeholder=00:00> </md-input-container> <label>and</label> <md-input-container class=input-container--short md-no-float> <input type=text placeholder=00:00> </md-input-container> </div> ";

/***/ }),

/***/ "ta0e":
/***/ (function(module, exports) {

module.exports = "<div layout-gt-xs=row layout-xs=column layout-align-gt-xs=\"start start\" layout-margin flex layout-wrap> <div class=content-box flex layout-padding> <div class=content-box__toolbar layout=row layout-align=\"start center\"> <span flex></span> <md-button class=md-primary ng-click=$ctrl.save()>save to dashboard</md-button> </div> <h1>Charts</h1> </div> <div class=\"sidebar content-box\" layout-padding> <div class=content-box__toolbar layout=row layout-align=\"start center\"> <span flex></span> <md-button class=\"md-icon-button md-primary\"> <md-icon class=material-icons--s>clear</md-icon> </md-button> </div> <div class=content-box__main> <div class=\"box-title space-m-t-n\">11 selected sensors</div> <div class=block-title> Show Sensor Values <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </div> <md-radio-group class=space-m-b-l layout=row ng-model=testModel1> <md-radio-button class=dt-theme value=testModel1.radio1 name=combined aria-label=Combined> Combined </md-radio-button> <md-radio-button class=dt-theme value=testModel1.radio2 name=individual aria-label=Individual> Individual </md-radio-button> </md-radio-group> <div class=\"md-caption-1 space-m-b-m\">Only selected sensors will appear in the graphs.</div> <div class=sensor-group> <div class=sensor-group__caption> <md-checkbox class=\"dt-theme space-m-b-xs\" ng-model=checkbox.default aria-label=checkbox> <span class=block-title>Temperature sensors (4)</span> </md-checkbox> </div> <ul class=sensor-group__list> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--alert icons--m\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=true></i> <md-icon md-svg-icon=temperature aria-label=temperature></md-icon> </span> </dt-icon> <dt-icon icon-size=icons--m icon-class=alert> </dt-icon> <span class=text-ellipsis>Boiler NE basement corner</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--m\"> <md-icon md-svg-icon=temperature aria-label=temperature></md-icon> </span> </dt-icon> <span class=text-ellipsis>Boiler NE basement corner high capacity looooong</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--alert icons--m\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=true></i> <md-icon md-svg-icon=temperature aria-label=temperature></md-icon> </span> </dt-icon> <span class=text-ellipsis>Boiler NE basement corner high capacity looooong</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--m\"> <md-icon md-svg-icon=temperature aria-label=temperature></md-icon> </span> </dt-icon> <span class=text-ellipsis>Boiler SE basement corner</span> </div> </md-checkbox> </li> </ul> </div> <div class=sensor-group> <div class=sensor-group__caption> <md-checkbox class=\"dt-theme space-m-b-xs\" ng-model=checkbox.default1 aria-label=checkbox> <span class=block-title>Door sensors (1)</span> </md-checkbox> </div> <ul class=sensor-group__list> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--alert icons--m\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=true></i> <md-icon md-svg-icon=door aria-label=door></md-icon> </span> </dt-icon> <span class=text-ellipsis>Main doors S entrance</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--m\"> <md-icon md-svg-icon=door aria-label=door></md-icon> </span> </dt-icon> <span class=text-ellipsis>3rd floor stairways</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--alert icons--m\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=true></i> <md-icon md-svg-icon=door aria-label=door></md-icon> </span> </dt-icon> <span class=text-ellipsis>Side door S entrance</span> </div> </md-checkbox> </li> </ul> </div> <div class=sensor-group> <div class=sensor-group__caption> <md-checkbox class=\"dt-theme space-m-b-xs\" ng-model=checkbox.default2 aria-label=checkbox> <span class=block-title>Button sensors (1)</span> </md-checkbox> </div> <ul class=sensor-group__list> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--warning icons--m\"> <i class=\"fa fa-info-circle\" aria-hidden=true></i> <md-icon md-svg-icon=touch aria-label=touch></md-icon> </span> </dt-icon> <span class=text-ellipsis>Soap dispenser kitchen</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--m\"> <md-icon md-svg-icon=touch aria-label=touch></md-icon> </span> </dt-icon> <span class=text-ellipsis>Soap dispenser kitchen</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--m\"> <md-icon md-svg-icon=touch aria-label=touch></md-icon> </span> </dt-icon> <span class=text-ellipsis>Feedback button “Bad”</span> </div> </md-checkbox> </li> <li> <md-checkbox class=\"dt-theme space-m-b-n\"> <div layout=row layout-align=\"start center\"> <dt-icon class=space-m-r-m> <span class=\"icons icons--m\"> <md-icon md-svg-icon=touch aria-label=touch></md-icon> </span> </dt-icon> <span class=text-ellipsis>Delivery door bell</span> </div> </md-checkbox> </li> </ul> </div> </div> </div> </div> ";

/***/ }),

/***/ "teei":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createNotification = __webpack_require__("wiYI");

var _createNotification2 = _interopRequireDefault(_createNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("z1Cy");

exports.default = {
    bindings: {
        action: '<',
        onClose: '&'
    },
    template: template,
    controller: _createNotification2.default
};

/***/ }),

/***/ "tfDx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ "tlV/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rules = __webpack_require__("sbbM");

var _rules2 = _interopRequireDefault(_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtRulesList',
    options: _rules2.default
};

/***/ }),

/***/ "u/Qv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__("a2/B");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NETWORK_ONLINE_TYPE = 'online';
var PAGE_HIDDEN_THRESHOLD = 900000; // 15 minutes

var HealthChecker = function () {
    /** @ngInject */
    HealthChecker.$inject = ["$window", "$rootScope"];
    function HealthChecker($window, $rootScope) {
        _classCallCheck(this, HealthChecker);

        this.$window = $window;
        this.$rootScope = $rootScope;

        this.pageHiddenAt = null;

        this.networkStatusUpdated = this.networkStatusUpdated.bind(this);
        this.visibilityChanged = this.visibilityChanged.bind(this);
    }

    _createClass(HealthChecker, [{
        key: 'networkStatusUpdated',
        value: function networkStatusUpdated(_ref) {
            var type = _ref.type;

            if (type === NETWORK_ONLINE_TYPE) {
                this.$rootScope.$broadcast('health-checker-network-up');
            }

            this.$rootScope.$applyAsync();
        }
    }, {
        key: 'visibilityChanged',
        value: function visibilityChanged() {
            if (document.hidden) {
                this.pageHiddenAt = (0, _moment2.default)();
            } else if (this.pageHiddenAt && (0, _moment2.default)().diff(this.pageHiddenAt) > PAGE_HIDDEN_THRESHOLD) {
                this.$rootScope.$broadcast('health-checker-page-visible');
            }

            this.$rootScope.$applyAsync();
        }
    }, {
        key: 'initTracking',
        value: function initTracking() {
            this.$window.addEventListener('online', this.networkStatusUpdated);
            this.$window.addEventListener('offline', this.networkStatusUpdated);
            this.$window.addEventListener('visibilitychange', this.visibilityChanged);
        }
    }]);

    return HealthChecker;
}();

exports.default = HealthChecker;

/***/ }),

/***/ "u1r9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RadioIcons = {
    'VALUE_0': 'icon_signal0',
    'VALUE_1': 'icon_signal1',
    'VALUE_2': 'icon_signal2',
    'VALUE_3': 'icon_signal3',
    'VALUE_4': 'icon_signal4',
    'VALUE_5': 'icon_signal5'
};

var RadioStatusController = function () {
    function RadioStatusController() {
        _classCallCheck(this, RadioStatusController);
    }

    _createClass(RadioStatusController, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.radio) {
                this.radioIcon = RadioIcons.VALUE_0;
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.radio && !isNaN(parseInt(changes.radio.currentValue, 10))) {
                this.radio = parseInt((0, _cloneDeep3.default)(changes.radio.currentValue), 10);
            } else {
                this.radio = 0;
            }

            this.calculateIcon();
        }
    }, {
        key: 'calculateIcon',
        value: function calculateIcon() {
            this.radioIcon = RadioIcons['VALUE_' + this.radio];
        }
    }]);

    return RadioStatusController;
}();

exports.default = RadioStatusController;

/***/ }),

/***/ "u3OS":
/***/ (function(module, exports) {

module.exports = "<script type=text/ng-template id=generic-messages.html> <div ng-repeat=\"item in $ctrl.genericErrors track by $index\" ng-message-exp=\"item.type\">\n        {{ item.message }}\n    </div> </script> <div class=\"box box--exceed\" layout-padding> <form name=newUserForm novalidate> <div layout-gt-sm=row> <md-input-container class=md-block flex-gt-sm> <label>First name</label> <input name=firstName ng-model=$ctrl.user.first_name ng-minlength=2 ng-maxlength=20 ng-messages-multiple type=text required=required> <div ng-if=newUserForm.firstName.$touched ng-messages=newUserForm.firstName.$error> <div ng-repeat=\"error in $ctrl.componentErrors.first_name track by $index\" ng-message-exp=error.type> {{ error.message }} </div> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Middle name</label> <input name=middleName ng-model=$ctrl.user.middle_name ng-minlength=2 ng-maxlength=20 ng-messages-multiple type=text required=required> <div ng-if=newUserForm.middleName.$touched ng-messages=newUserForm.middleName.$error> <div ng-repeat=\"error in $ctrl.componentErrors.middle_name track by $index\" ng-message-exp=error.type> {{ error.message }} </div> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Last name</label> <input name=lastName ng-model=$ctrl.user.last_name ng-minlength=2 ng-maxlength=20 ng-messages-multiple type=text required=required> <div ng-if=newUserForm.lastName.$touched ng-messages=newUserForm.lastName.$error> <div ng-repeat=\"error in $ctrl.componentErrors.last_name track by $index\" ng-message-exp=error.type> {{ error.message }} </div> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> </div> <div layout-gt-xs=row> <md-input-container flex-gt-xs> <label>Title</label> <input name=userTitle ng-model=$ctrl.user.title ng-minlength=2 ng-maxlength=20 ng-messages-multiple type=text required=required> <div ng-if=newUserForm.userTitle.$touched ng-messages=newUserForm.userTitle.$error> <div ng-repeat=\"error in $ctrl.componentErrors.title track by $index\" ng-message-exp=error.type> {{ error.message }} </div> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> <md-input-container> <label>Email</label> <input name=userEmail ng-model=$ctrl.user.email ng-minlength=2 ng-maxlength=110 ng-messages-multiple type=email required=required> <div ng-if=newUserForm.userEmail.$touched ng-messages=newUserForm.userEmail.$error> <div ng-repeat=\"error in $ctrl.componentErrors.email track by $index\" ng-message-exp=error.type> {{ error.message }} </div> <div ng-messages-include=generic-messages.html></div> </div> </md-input-container> </div> <div layout-gt-xs=row> <span flex></span> <md-button class=md-raised ng-click=$ctrl.cancel()>Cancel</md-button> <md-button class=\"md-raised md-primary\" ng-disabled=newUserForm.$invalid ng-click=$ctrl.create()>Create user</md-button> </div> </form> </div>";

/***/ }),

/***/ "uA57":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Service = undefined;

var _geo = __webpack_require__("IBtN");

var _geo2 = _interopRequireDefault(_geo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * GeoService settings
 * @type {{name: string, definition: GeoService}}
 */
var Service = {
    name: 'GeoService',
    definition: _geo2.default
};

exports.Service = Service;

/***/ }),

/***/ "uD2R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _remote = __webpack_require__("UCXy");

var _remote2 = _interopRequireDefault(_remote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * RemoteConfigService settings
 * @type {{name: string, definition: RemoteConfigService}}
 */
exports.default = {
  name: 'RemoteConfigService',
  definition: _remote2.default
};

/***/ }),

/***/ "uF0j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sortBy2 = __webpack_require__("JXMh");

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _lucene = __webpack_require__("2luL");

var _lucene2 = _interopRequireDefault(_lucene);

var _controller = __webpack_require__("/GEJ");

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var folderBrowserTemplate = __webpack_require__("7Gr3");

var DEFAULT_TAB_INDEX = 0;

var SensorTabsController = function () {
    /** @ngInject */
    SensorTabsController.$inject = ["EventEmitter", "NavigationService", "DialogService", "$state", "$scope"];
    function SensorTabsController(EventEmitter, NavigationService, DialogService, $state, $scope) {
        _classCallCheck(this, SensorTabsController);

        this.EventEmitter = EventEmitter;
        this.NavigationService = NavigationService;
        this.DialogService = DialogService;
        this.$state = $state;
        this.$scope = $scope;
    }

    _createClass(SensorTabsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.tabs = this.defaultNavigationItems;
            this.loadAppNavigation();
        }
    }, {
        key: 'loadAppNavigation',
        value: function loadAppNavigation() {
            var _this = this;

            return this.NavigationService.getSensorsAndConnectors().then(function (data) {
                _this.tabs = [].concat(_toConsumableArray(_this.defaultNavigationItems), _toConsumableArray((0, _sortBy3.default)(SensorTabsController.processNavigationData(data.objects), 'position')));
            });
        }
    }, {
        key: 'onSaveView',
        value: function onSaveView(_ref) {
            var _this2 = this;

            var view = _ref.view;

            this.loadAppNavigation().then(function () {
                _this2.loadTabData(view.search_query, view.id);
            });
        }
    }, {
        key: 'findTabIndexByItemId',
        value: function findTabIndexByItemId(itemId) {
            return this.tabs.findIndex(function (tab) {
                var isThisTab = tab.id === itemId;

                if (tab.children && !isThisTab) {
                    return tab.children.find(function (view) {
                        return view.id === itemId;
                    });
                }

                return isThisTab;
            });
        }
    }, {
        key: 'loadTabData',
        value: function loadTabData(q, tabId) {
            this.$state.go('main.sensors.list', {
                q: q,
                tabId: tabId
            });
        }
    }, {
        key: 'onTabClick',
        value: function onTabClick(_ref2) {
            var tab = _ref2.tab;

            if (tab.callback) {
                tab.callback();
            } else {
                this.loadTabData(tab.search_query, tab.id);
            }
        }
    }, {
        key: 'onTabMenuItemClick',
        value: function onTabMenuItemClick(_ref3) {
            var item = _ref3.item;

            this.loadTabData(item.search_query, item.id);
        }
    }, {
        key: 'currentTabIndex',
        get: function get() {
            var tabIndex = this.findTabIndexByItemId(this.tabId);
            return tabIndex < 0 ? DEFAULT_TAB_INDEX : tabIndex;
        }

        /**
         * Intentionally empty setter since we use purely computed value
         * @param tabIndex
         */
        ,
        set: function set(tabIndex) {} // eslint-disable-line

    }, {
        key: 'defaultNavigationItems',
        get: function get() {
            var _this3 = this;

            return [{
                title: 'Overview',
                search_query: ''
            }, {
                title: 'Folders',
                id: 'folders',
                icon: 'folder_open',
                callback: function callback() {
                    return _this3.DialogService.show({
                        controller: _controller2.default,
                        controllerAs: '$ctrl',
                        template: folderBrowserTemplate,
                        parent: document.body,
                        openFrom: 'top',
                        closeTo: 'top',
                        clickOutsideToClose: true,
                        escapeToClose: true,
                        fullscreen: true,
                        locals: {
                            folderChangedCallback: function folderChangedCallback(folderId) {
                                if (folderId) {
                                    _this3.loadTabData(_lucene2.default.convertFoldersToLuceneCompatible([folderId]), 'folders');
                                }
                            }
                        }
                    });
                }
            }];
        }
    }], [{
        key: 'processNavigationData',
        value: function processNavigationData(data) {
            return data.map(function (item) {
                item.title = item.name;

                if (item.children) {
                    item.items = item.children.map(function (view) {
                        view.title = view.name;
                        return view;
                    });

                    var queries = item.items.map(function (view) {
                        return view.search_query;
                    });
                    item.search_query = '(' + queries.join(') OR (') + ')';
                }

                if (!item.search_query) {
                    item.disabled = true;
                }

                return item;
            });
        }
    }]);

    return SensorTabsController;
}();

exports.default = SensorTabsController;

/***/ }),

/***/ "uK+v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


rolesRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rolesRouter;

var _usersAndAccess = __webpack_require__("flzX");

/** @ngInject */
function rolesRouter($stateProvider) {
    var rolesState = {
        url: '/roles',
        views: {
            contentBody: {
                component: _usersAndAccess.Roles.Component.selector
            }
        }
    };

    $stateProvider.state('main.users-and-access.roles', rolesState);
}

/***/ }),

/***/ "uMxi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SendMailController = function () {
    /** @ngInject */
    SendMailController.$inject = ["EventEmitter"];
    function SendMailController(EventEmitter) {
        _classCallCheck(this, SendMailController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(SendMailController, [{
        key: "$onInit",
        value: function $onInit() {
            if (!this.action) {
                this.action = false;
            }
        }
    }, {
        key: "close",
        value: function close() {
            this.onClose(this.eventEmitter({
                action: this.action
            }));
        }
    }]);

    return SendMailController;
}();

exports.default = SendMailController;

/***/ }),

/***/ "uNYU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function responseDataExtractor(response) {
    return response.data;
}

var FoldersApi = function () {
    /** @ngInject */
    FoldersApi.$inject = ["$http"];
    function FoldersApi($http) {
        _classCallCheck(this, FoldersApi);

        this.$http = $http;
        this.listUrl = _utils2.default.buildApiUrl('folders.list');
    }

    _createClass(FoldersApi, [{
        key: 'fetch',
        value: function fetch(params) {
            return this.$http.get(this.listUrl, { params: params }).then(responseDataExtractor);
        }
    }, {
        key: 'create',
        value: function create(data) {
            return this.$http.post(this.listUrl, data).then(responseDataExtractor);
        }
    }, {
        key: 'update',
        value: function update(folderId, data) {
            var url = _utils2.default.buildApiUrl('folders.entity', { folderId: folderId });
            return this.$http.patch(url, data).then(responseDataExtractor);
        }
    }, {
        key: 'remove',
        value: function remove(folderId) {
            var url = _utils2.default.buildApiUrl('folders.entity', { folderId: folderId });
            return this.$http.delete(url).then(responseDataExtractor);
        }
    }, {
        key: 'move',
        value: function move(folderId, data) {
            var url = _utils2.default.buildApiUrl('folders.move', { folderId: folderId });
            return this.$http.post(url, data).then(responseDataExtractor);
        }
    }]);

    return FoldersApi;
}();

exports.default = FoldersApi;

/***/ }),

/***/ "uPUl":
/***/ (function(module, exports) {

module.exports = "<h3>{{ ::$ctrl.stateTitle }}</h3> <span flex></span> <md-button class=\"md-icon-button effect-rollover\" ng-class=\"{'is-active': $ctrl.isActive}\" ng-click=$ctrl.showHelpMenu($event); aria-label=\"Open help menu\"> <i md-menu-origin class=material-icons>help</i> <md-tooltip md-direction=left class=dt-theme>Help & Support</md-tooltip> </md-button> ";

/***/ }),

/***/ "uRgF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _add = __webpack_require__("gDsE");

var _add2 = _interopRequireDefault(_add);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtFolderTreeAddFolder',
    options: _add2.default
};

/***/ }),

/***/ "uTXi":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "uWoC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUCKET_NAME = 'state.starred';

var ThingStarController = function () {
    /** @ngInject */
    ThingStarController.$inject = ["EventEmitter"];
    function ThingStarController(EventEmitter) {
        _classCallCheck(this, ThingStarController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingStarController, [{
        key: '$onInit',
        value: function $onInit() {
            this.thingStarred = false;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            if (changes.reset) {
                if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                    this.resetValues();
                }
            }
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            if (this.thingStarred) {
                this.fillBucket();

                this.pushUpdate(this.eventEmitter({
                    value: this.thingStarred
                }));
            } else {
                this.clearBucket();
            }
        }
    }, {
        key: 'fillBucket',
        value: function fillBucket() {
            this.addItemToBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingStarred
                }
            }));
        }
    }, {
        key: 'clearBucket',
        value: function clearBucket() {
            this.removeItemFromBucket(this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            }));
        }
    }, {
        key: 'resetValues',
        value: function resetValues() {
            this.thingStarred = false;

            this.clearBucket();
        }
    }]);

    return ThingStarController;
}();

exports.default = ThingStarController;

/***/ }),

/***/ "uccH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _radioStatus = __webpack_require__("u1r9");

var _radioStatus2 = _interopRequireDefault(_radioStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("mpcD");

exports.default = {
    bindings: {
        radio: '<'
    },
    template: template,
    controller: _radioStatus2.default
};

/***/ }),

/***/ "v7S/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alertBox = __webpack_require__("OOZJ");

var _alertBox2 = _interopRequireDefault(_alertBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtAlertBox',
    options: _alertBox2.default
};

/***/ }),

/***/ "vNKU":
/***/ (function(module, exports) {

module.exports = "<md-content class=dt-layout-content__container flex> <div layout=column flex> <div layout=column layout-align=\"top stretch\" layout-fill ui-view=content></div> </div> </md-content>";

/***/ }),

/***/ "vYb2":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("lW7l"),
    baseUniq = __webpack_require__("N+h1");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ "vkwR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _local = __webpack_require__("JwvL");

var _local2 = _interopRequireDefault(_local);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// noinspection JSUnresolvedVariable,Eslint
if (!"production" || ['development', 'test'].indexOf("production")) {
    __webpack_require__("i017"); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * MenuApi class.
 */

var MenuApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    MenuApi.$inject = ["$http"];
    function MenuApi($http) {
        _classCallCheck(this, MenuApi);

        this.$http = $http;
        this.config = _local2.default.api.menu;
    }

    /**
     * Get Application menu config
     * @returns {promise}
     */


    _createClass(MenuApi, [{
        key: 'getAppMenu',
        value: function getAppMenu() {
            return this.$http.get(this.config.appMenuUrl).then(responseDataExtractor);
        }
    }]);

    return MenuApi;
}();

exports.default = MenuApi;

/***/ }),

/***/ "vmFd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


folderPathEditDirectiveConfig.$inject = ["DialogService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = folderPathEditDirectiveConfig;

var _dialog = __webpack_require__("lqki");

var _dialog2 = _interopRequireDefault(_dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dialogTemplate = __webpack_require__("TpVu");

/** @ngInject */
function folderPathEditDirectiveConfig(DialogService) {
    function link($scope, $element) {
        function showDialog(event) {
            DialogService.show({
                controller: _dialog2.default,
                controllerAs: '$ctrl',
                template: dialogTemplate,
                parent: document.body,
                targetEvent: event,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    folderChangedCallback: $scope.dtFolderPathEditCallback,
                    folderId: $scope.dtFolderPathEdit
                }
            });
        }

        $element.on('click', showDialog);

        $element.on('$destroy', function () {
            $element.off('click', showDialog);
        });
    }

    return {
        restrict: 'A',
        scope: {
            dtFolderPathEdit: '<',
            dtFolderPathEditCallback: '&'
        },
        link: link
    };
}

/***/ }),

/***/ "voNC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabs = __webpack_require__("bvol");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtTabs',
    options: _tabs2.default
};

/***/ }),

/***/ "vuy0":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Alerts & Actions'\"></dt-content-header> <div layout=row layout-align=\"start start\" flex layout-margin ng-if=$ctrl.isSupported> <div flex=30> <dt-alerts-actions-nav class=\"box md-block layout-padding\" on-push-current=$ctrl.getCurrentRule($event) alerts-actions=$ctrl.alertsActions> </dt-alerts-actions-nav> </div> <div flex=45> <dt-alerts-actions-content class=\"box md-block layout-padding\" ng-if=$ctrl.currentAlertsActions on-remove=$ctrl.removeAlertsActions($event) on-cancel=$ctrl.resetAlertsActionsCurrent($event) rule=$ctrl.currentAlertsActions> </dt-alerts-actions-content> </div> <div flex=25> <div class=\"box layout-padding\" ng-if=$ctrl.currentAlertsActions> <ul class=custom-list layout=column> <li layout=row layout-align=\"start center\"> <dt-icon class=\"space-m-r-m space-m-r-l\"> <span class=\"icons icons--alert\"> <span class=\"fa fa-exclamation\"></span> <md-icon md-svg-icon=touch aria-label=Touch></md-icon> </span> </dt-icon> <div class=custom-list__text> <div class=md-caption> 0 sensors currently meet rule conditions </div> <a href=#> <i class=\"material-icons material-icons--s\">search</i> Show sensors </a> </div> </li> <li layout=row layout-align=\"start center\"> <dt-icon class=\"space-m-r-m space-m-r-l\"> <span class=icons> <md-icon md-svg-icon=touch aria-label=Touch></md-icon> </span> </dt-icon> <div class=custom-list__text> <div class=md-caption> 0 sensors use this rule </div> <a href=#> <i class=\"material-icons material-icons--s\">search</i> Show sensors </a> </div> </li> </ul> </div> </div> </div> <div layout=row layout-align=\"start start\" flex ng-if=!$ctrl.isSupported> <div class=placeholder-block layout-margin> <div class=placeholder-block__label> <h3>Functionality not supported</h3> <p>This feature is not available in the beta version</p> </div> <div class=placeholder-block__content> <img src=/assets/images/alerts-actions.png class=placeholder-block__image alt=\"This functionality don't supported\"> </div> </div> </div> ";

/***/ }),

/***/ "w+pj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    chart: {
        type: 'line'
    },
    yAxis: {
        labels: {
            format: '{value} °C'
        }
    },
    tooltip: {
        valueSuffix: '°C'
    }
};

/***/ }),

/***/ "w1+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


accountSettingsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = accountSettingsRouter;

var _accountSettings = __webpack_require__("ffSu");

/** @ngInject */
function accountSettingsRouter($stateProvider) {
    var baseState = {
        url: '/account-settings',
        views: {
            content: {
                component: _accountSettings.Component.selector
            }
        }
    };

    $stateProvider.state('main.account-settings', baseState);
}

/***/ }),

/***/ "w3xc":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-grid__row space-m-b-n\"> <div class=form-grid__col> <i class=\"fa fa-signal\" aria-hidden=true></i> <label class=form-grid__label>Signal strength</label> <dt-help-icon message-key=help_icon_advanced_search_signal></dt-help-icon> </div> </div> <div class=\"form-grid__row space-m-l-m\"> <div class=form-grid__col> <label class=md-caption for=signal-start>between</label> <md-input-container class=\"form-element form-element--simple space-m-h-xs\"> <md-select id=signal-start aria-label=\"Signal strength higher than value\" name=signal-start ng-model=$ctrl.aboveValue ng-change=$ctrl.onChange() ng-model-options=\"{\n                            'updateOn': 'default blur',\n                            'debounce': {\n                                'default': 350,\n                                'blur': 0\n                            }\n                        }\"> <md-option>{{ ::$ctrl.anyText }}</md-option> <md-option ng-repeat=\"signal in $ctrl.signals\" ng-value=signal> <dt-radio-status radio=signal></dt-radio-status> </md-option> </md-select> </md-input-container> </div> <div class=form-grid__col> <label class=\"md-caption space-m-r-m\" for=signal-end>and</label> <md-input-container class=\"form-element form-element--simple space-m-h-xs\"> <md-select id=signal-end aria-label=\"Signal strength lower than value\" name=signal-end ng-model=$ctrl.belowValue ng-change=$ctrl.onChange() ng-model-options=\"{\n                            'updateOn': 'default blur',\n                            'debounce': {\n                                'default': 350,\n                                'blur': 0\n                            }\n                        }\"> <md-option>{{ ::$ctrl.anyText }}</md-option> <md-option ng-repeat=\"signal in $ctrl.signals\" ng-value=signal> <dt-radio-status radio=signal></dt-radio-status> </md-option> </md-select> </md-input-container> </div> </div>";

/***/ }),

/***/ "wJTK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingDetailsFolder = __webpack_require__("Pnd4");

var _thingDetailsFolder2 = _interopRequireDefault(_thingDetailsFolder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtThingDetailsFolder',
    options: _thingDetailsFolder2.default
};

/***/ }),

/***/ "wJzk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _recentEvents = __webpack_require__("XEyd");

var _recentEvents2 = _interopRequireDefault(_recentEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtRecentEvents',
    options: _recentEvents2.default
};

/***/ }),

/***/ "wL9e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = undefined;

var _customers = __webpack_require__("xv0h");

var _customers2 = _interopRequireDefault(_customers);

var _customers3 = __webpack_require__("Gwh9");

var _customers4 = _interopRequireDefault(_customers3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Component = {
    selector: 'dtCustomersView',
    options: _customers4.default
};

exports.Config = _customers2.default;
exports.Component = Component;

/***/ }),

/***/ "wiYI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateNotificationController = function () {
    /** @ngInject */
    CreateNotificationController.$inject = ["EventEmitter"];
    function CreateNotificationController(EventEmitter) {
        _classCallCheck(this, CreateNotificationController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(CreateNotificationController, [{
        key: "$onInit",
        value: function $onInit() {
            if (!this.action) {
                this.action = false;
            }
        }
    }, {
        key: "close",
        value: function close() {
            this.onClose(this.eventEmitter({
                action: this.action
            }));
        }
    }]);

    return CreateNotificationController;
}();

exports.default = CreateNotificationController;

/***/ }),

/***/ "wyRe":
/***/ (function(module, exports) {

module.exports = "<md-checkbox class=\"md-default-theme md-checkbox--icon\" ng-model=$ctrl.thingStarred ng-change=$ctrl.onChange() aria-label=checkbox> <md-icon md-svg-icon=star aria-label=star></md-icon> <span class=\"form-grid__label form-grid__col__label form-grid__col__label--long\"> Starred things <dt-help-icon message-key=help_icon_advanced_search_starred></dt-help-icon> </span> </md-checkbox> ";

/***/ }),

/***/ "x2ce":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


getFocusDirectiveConfig.$inject = ["$timeout"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getFocusDirectiveConfig;
/** @ngInject */
function getFocusDirectiveConfig($timeout) {
    function link($scope, $element) {
        $scope.$watch('getFocus', function (value) {
            if (value) {
                $timeout(function () {
                    $element[0].focus();
                }, 1);
            }
        });
    }

    return {
        restrict: 'A',
        scope: {
            getFocus: '<'
        },
        link: link
    };
}

/***/ }),

/***/ "xGfM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsersController = function () {
    /** @ngInject */
    UsersController.$inject = ["UsersApi", "RolesApi", "Loader", "DialogService", "$timeout"];
    function UsersController(UsersApi, RolesApi, Loader, DialogService, $timeout) {
        _classCallCheck(this, UsersController);

        this.UsersApi = UsersApi;
        this.RolesApi = RolesApi;
        this.Loader = Loader;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
    }

    _createClass(UsersController, [{
        key: '$onInit',
        value: function $onInit() {
            this.users = [];
            this.roles = [];
            this.selectedUsers = [];
            this.selectedRole = null;

            this.query = '';

            this.hasRoles = false;
            this.inProgress = false;
            this.showAddUser = false;

            this.loadUsers();
            this.loadRoles();
        }
    }, {
        key: 'startProgress',
        value: function startProgress() {
            this.inProgress = true;
            this.Loader.show();
        }
    }, {
        key: 'stopProgress',
        value: function stopProgress() {
            this.inProgress = false;
            this.Loader.hide();
        }
    }, {
        key: 'loadUsers',
        value: function loadUsers(query) {
            var _this = this;

            this.startProgress();

            var promise = void 0;
            if (query && query.length) {
                promise = this.UsersApi.search(query);
            } else {
                promise = this.UsersApi.getList();
            }

            return promise.then(function (data) {
                _this.users = data.users || [];

                _this.stopProgress();

                return _this.users;
            }, function () {
                _this.users = [];

                _this.stopProgress();

                return _this.users;
            });
        }
    }, {
        key: 'loadRoles',
        value: function loadRoles() {
            var _this2 = this;

            return this.RolesApi.getList().then(function (data) {
                _this2.roles = data.roles || [];
                _this2.hasRoles = _this2.roles.length;

                return _this2.roles;
            }, function () {
                _this2.roles = [];
                _this2.hasRoles = false;

                return _this2.roles;
            });
        }
    }, {
        key: 'onCreateNewUserClick',
        value: function onCreateNewUserClick() {
            this.showAddUser = !this.showAddUser;
        }
    }, {
        key: 'onSearchInputActivate',
        value: function onSearchInputActivate() {
            this.showAddUser = false;
        }
    }, {
        key: 'onSearchInputDeactivate',
        value: function onSearchInputDeactivate() {
            this.showAddUser = false;
        }
    }, {
        key: 'onSearch',
        value: function onSearch(_ref) {
            var query = _ref.query;

            this.query = query;

            this.loadUsers(query);
        }
    }, {
        key: 'resetSearch',
        value: function resetSearch() {
            this.query = '';

            this.loadUsers();
        }
    }, {
        key: 'onUserCreate',
        value: function onUserCreate(_ref2) {
            var _this3 = this;

            var user = _ref2.user;

            this.startProgress();

            this.UsersApi.createUser(user).then(function () {
                _this3.loadUsers();

                _this3.showAddUser = false;
            }, function () {
                _this3.stopProgress();
            });
            // TODO: add toast for error
        }
    }, {
        key: 'onCancelUserCreate',
        value: function onCancelUserCreate() {
            this.showAddUser = false;
        }
    }, {
        key: 'onUserDelete',
        value: function onUserDelete(user) {
            var _this4 = this;

            this.startProgress();

            this.showAddUser = false;

            this.UsersApi.deleteUser(user.id).then(function () {
                _this4.users = _this4.users.filter(function (localUser) {
                    return localUser.id !== user.id;
                });
                _this4.stopProgress();
                // TODO: refactor when elastic will work correctly with cache
                // this.loadUsers();
            }, function () {
                _this4.stopProgress();
            });
            // TODO: add toast for error
        }
    }, {
        key: 'onUserResetPassword',
        value: function onUserResetPassword(user) {
            var _this5 = this;

            this.startProgress();

            this.showAddUser = false;

            this.UsersApi.resetPassword(user.id).then(function () {
                _this5.stopProgress();
                // TODO: refactor when elastic will work correctly with cache
                // this.loadUsers();
            }, function () {
                _this5.stopProgress();
            });
            // TODO: add toast for error
        }
    }, {
        key: 'onAssignRole',
        value: function onAssignRole($event) {
            var _this6 = this;

            if (!this.selectedRole || !this.selectedUsers || !this.selectedUsers.length) return;

            this.DialogService.confirm({
                title: 'Assign Role',
                textContent: 'Would you like to assign role "' + this.selectedRole.name + '" to selected users?',
                ariaLabel: 'assign-role',
                targetEvent: $event,
                ok: 'Assign',
                cancel: 'Cancel'
            }).then(function () {
                _this6.startProgress();

                _this6.showAddUser = false;

                _this6.RolesApi.addUsersToRole(_this6.selectedRole.id, _this6.selectedUsers.map(function (user) {
                    return user.id;
                })).then(function () {
                    // TODO: refactor when elastic will work correctly with cache
                    _this6.$timeout(function () {
                        _this6.loadUsers();
                    }, 1000);
                }, function () {
                    _this6.stopProgress();
                });
                // TODO: add toast for error
            });
        }
    }]);

    return UsersController;
}();

exports.default = UsersController;

/***/ }),

/***/ "xK5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


labelsRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = labelsRouter;

var _foldersAndLabels = __webpack_require__("VByS");

/** @ngInject */
function labelsRouter($stateProvider) {
    var labelsState = {
        url: '/labels',
        views: {
            contentBody: {
                component: _foldersAndLabels.Labels.Component.selector
            }
        }
    };

    $stateProvider.state('main.folders-and-labels.labels', labelsState).state('main.folders-and-labels.labels.label', {
        url: '/{labelId}',
        resolve: {
            /** @ngInject */
            label: ["LabelsApi", "$stateParams", function label(LabelsApi, $stateParams) {
                return LabelsApi.entity($stateParams.labelId).catch(function () {
                    return null;
                });
            }]
        },
        /** @ngInject */
        onEnter: ["label", "$state", function onEnter(label, $state) {
            // eslint-disable-line consistent-return
            if (!label) {
                return $state.target('main.folders-and-labels.labels');
            }
        }],

        component: _foldersAndLabels.Labels.LabelDetails.selector
    });
}

/***/ }),

/***/ "xcRF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Component = exports.Config = exports.apiAccess = undefined;

var _apiAccess = __webpack_require__("H10Z");

var apiAccess = _interopRequireWildcard(_apiAccess);

var _developerSettings = __webpack_require__("H2Td");

var _developerSettings2 = _interopRequireDefault(_developerSettings);

var _developerSettings3 = __webpack_require__("aIVg");

var _developerSettings4 = _interopRequireDefault(_developerSettings3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Component = {
    selector: 'dtDeveloperSettings',
    options: _developerSettings4.default
};

exports.apiAccess = apiAccess;
exports.Config = _developerSettings2.default;
exports.Component = Component;

/***/ }),

/***/ "xggF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThingNameController = function () {
    /** @ngInject */
    ThingNameController.$inject = ["EventEmitter"];
    function ThingNameController(EventEmitter) {
        _classCallCheck(this, ThingNameController);

        this.eventEmitter = EventEmitter;
    }

    _createClass(ThingNameController, [{
        key: "$onChanges",
        value: function $onChanges(_ref) {
            var name = _ref.name;

            this.originalName = name.currentValue;
        }
    }, {
        key: "save",
        value: function save() {
            if (this.name !== this.originalName) {
                this.onUpdate(this.eventEmitter({
                    patch: {
                        name: this.name
                    }
                }));
            }
        }
    }]);

    return ThingNameController;
}();

exports.default = ThingNameController;

/***/ }),

/***/ "xowN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThingNotesController = function ThingNotesController() {
  _classCallCheck(this, ThingNotesController);
};

exports.default = ThingNotesController;

/***/ }),

/***/ "xpNK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingBattery = __webpack_require__("Uiye");

var _thingBattery2 = _interopRequireDefault(_thingBattery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("MjS9");

exports.default = {
    bindings: {
        reset: '<',
        pushUpdate: '&',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingBattery2.default
};

/***/ }),

/***/ "xpeM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/cloud-connector.svg";

/***/ }),

/***/ "xv0h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


customersRouter.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = customersRouter;

var _usersAndAccess = __webpack_require__("flzX");

/** @ngInject */
function customersRouter($stateProvider) {
    var customersState = {
        url: '/customers',
        views: {
            contentBody: {
                component: _usersAndAccess.Customers.Component.selector
            }
        }
    };

    $stateProvider.state('main.users-and-access.customers', customersState);
}

/***/ }),

/***/ "y4pL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Service = undefined;

var _errors = __webpack_require__("zucC");

var _errors2 = _interopRequireDefault(_errors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ErrorsService settings
 * @type {{name: string, definition: ErrorsService}}
 */
var Service = {
    name: 'ErrorsService',
    definition: _errors2.default
};

exports.Service = Service;

/***/ }),

/***/ "y9gm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("dZZq");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * CategoriesApi class.
 */

var CategoriesApi = function () {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    CategoriesApi.$inject = ["$http"];
    function CategoriesApi($http) {
        _classCallCheck(this, CategoriesApi);

        this.$http = $http;
        this.listUrl = _utils2.default.buildApiUrl('categories.list');
    }

    /**
     * Get Categories
     * @returns {promise}
     */


    _createClass(CategoriesApi, [{
        key: 'getList',
        value: function getList() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.$http.get(this.listUrl, { params: params }).then(responseDataExtractor);
        }

        /**
         * Search Categories by query
         * @param {string} query - Search pattern
         * @param {Object} metadata - Request settings, like: limit, ofset etc.
         * @returns {promise}
         */

    }, {
        key: 'search',
        value: function search(query) {
            var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this.$http.get(this.listUrl, {
                params: _extends({
                    query: query + '*'
                }, metadata)
            }).then(responseDataExtractor);
        }

        /**
         * Create Category
         * @param {Object} category - Category object
         * @returns {*}
         */

    }, {
        key: 'createCategory',
        value: function createCategory(category) {
            return this.$http.post(this.listUrl, category).then(responseDataExtractor);
        }

        /**
         * Get Category by given category id
         * @param {number} categoryId - Category id
         * @returns {promise}
         */

    }, {
        key: 'getCategory',
        value: function getCategory(categoryId) {
            var url = _utils2.default.buildApiUrl('categories.entity', { categoryId: categoryId });

            return this.$http.get(url).then(responseDataExtractor);
        }
    }, {
        key: 'saveCategory',
        value: function saveCategory(categoryId, data) {
            var url = _utils2.default.buildApiUrl('categories.entity', { categoryId: categoryId });

            return this.$http.put(url, data).then(responseDataExtractor);
        }

        /**
         * Delete Category by given category id
         * @param {number} categoryId - Category id
         * @returns {promise}
         */

    }, {
        key: 'deleteCategory',
        value: function deleteCategory(categoryId) {
            var url = _utils2.default.buildApiUrl('categories.entity', { categoryId: categoryId });

            return this.$http.delete(url).then(responseDataExtractor);
        }
    }]);

    return CategoriesApi;
}();

exports.default = CategoriesApi;

/***/ }),

/***/ "yBwX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _left = __webpack_require__("IQvl");

var _left2 = _interopRequireDefault(_left);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    selector: 'dtNavbarLeft',
    options: _left2.default
};

/***/ }),

/***/ "yEJU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DeveloperSettingsController = function () {
    /** @ngInject */
    DeveloperSettingsController.$inject = ["$state"];
    function DeveloperSettingsController($state) {
        _classCallCheck(this, DeveloperSettingsController);

        this.$state = $state;
    }

    _createClass(DeveloperSettingsController, [{
        key: '$onInit',
        value: function $onInit() {
            this.tabs = [{
                title: 'Api Access',
                state: 'main.developer-settings.api-access'
            }];
        }
    }, {
        key: 'onTabClick',
        value: function onTabClick(_ref) {
            var tab = _ref.tab;

            this.$state.go(tab.state);
        }
    }]);

    return DeveloperSettingsController;
}();

exports.default = DeveloperSettingsController;

/***/ }),

/***/ "yH9N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


editNavbarDirectiveConfig.$inject = ["DialogService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = editNavbarDirectiveConfig;

var _popup = __webpack_require__("8B5C");

var _popup2 = _interopRequireDefault(_popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popupTemplate = __webpack_require__("Nm+6");

/** @ngInject */
function editNavbarDirectiveConfig(DialogService) {
    function link($scope, $element) {
        function showDialog(event) {
            event.preventDefault();

            DialogService.show({
                controller: _popup2.default,
                controllerAs: 'ctrl',
                template: popupTemplate,
                parent: document.body,
                targetEvent: event,
                openFrom: 'top',
                closeTo: 'top',
                clickOutsideToClose: true,
                escapeToClose: true,
                fullscreen: true,
                locals: {
                    onDone: $scope.dtEditNavbar || null
                }
            });
        }

        $element.on('click', showDialog);

        $element.on('$destroy', function () {
            $element.off('click', showDialog);
        });
    }

    return {
        restrict: 'A',
        scope: {
            dtEditNavbar: '&'
        },
        link: link
    };
}

/***/ }),

/***/ "yR4c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomersController = function () {
    /** @ngInject */
    CustomersController.$inject = ["CustomersApi", "Loader", "DialogService", "$timeout"];
    function CustomersController(CustomersApi, Loader, DialogService, $timeout) {
        _classCallCheck(this, CustomersController);

        this.CustomersApi = CustomersApi;
        this.Loader = Loader;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
    }

    _createClass(CustomersController, [{
        key: '$onInit',
        value: function $onInit() {
            this.customers = [];
            this.selectedCustomers = [];

            this.query = '';

            this.inProgress = false;

            this.loadCustomers();
        }
    }, {
        key: 'startProgress',
        value: function startProgress() {
            this.inProgress = true;
            this.Loader.show();
        }
    }, {
        key: 'stopProgress',
        value: function stopProgress() {
            this.inProgress = false;
            this.Loader.hide();
        }
    }, {
        key: 'loadCustomers',
        value: function loadCustomers(query) {
            var _this = this;

            this.startProgress();

            var promise = void 0;
            if (query && query.length) {
                promise = this.CustomersApi.search(query);
            } else {
                promise = this.CustomersApi.getList();
            }

            return promise.then(function (data) {
                _this.customers = data.customers || [];

                _this.stopProgress();

                return _this.customers;
            }, function () {
                _this.customers = [];

                _this.stopProgress();

                return _this.customers;
            });
        }
    }, {
        key: 'onSearch',
        value: function onSearch(_ref) {
            var query = _ref.query;

            this.query = query;

            this.loadCustomers(query);
        }
    }, {
        key: 'resetSearch',
        value: function resetSearch() {
            this.query = '';

            this.loadCustomers();
        }
    }, {
        key: 'onCustomerDelete',
        value: function onCustomerDelete(customer) {
            var _this2 = this;

            this.startProgress();

            this.CustomersApi.deactivateCustomer(customer.id).then(function () {
                _this2.customers = _this2.customers.filter(function (localCustomer) {
                    return localCustomer.id !== customer.id;
                });
                _this2.stopProgress();
                // TODO: refactor when elastic will work correctly with cache
                // this.loadCustomers();
            }, function () {
                _this2.stopProgress();
            });
            // TODO: add toast for error
        }
    }, {
        key: 'onCustomerResetPassword',
        value: function onCustomerResetPassword(customer) {
            var _this3 = this;

            this.startProgress();

            this.CustomersApi.resetPasswordForCustomer(customer.id).then(function () {
                _this3.stopProgress();
                // TODO: refactor when elastic will work correctly with cache
                // this.loadCustomers(); // should we?
            }, function () {
                _this3.stopProgress();
            });
            // TODO: add toast for error
        }
    }, {
        key: 'onRequestAccess',
        value: function onRequestAccess($event, customer) {
            var _this4 = this;

            this.DialogService.prompt({
                title: 'Request access to view customer info',
                htmlContent: 'This will send a message to ' + customer.email + '<br />\n                            asking them to click a link to allow you full access to<br />\n                            their account and sensors for 72 hours.<br /><br />\n                            \n                            You will be notified when you have access or if they<br />\n                            deny your request.<br /><br />\n                            \n                            You can add a personalized message below<br />\n                            (optional).',
                placeholder: 'Personal message',
                ariaLabel: 'request-access-to-view-info',
                targetEvent: $event,
                ok: 'Request access',
                cancel: 'Cancel'
            }).then(function () {
                var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                _this4.startProgress();

                _this4.CustomersApi.requestAccessToCustomer({ customer_id: customer.id, message: message }).then(function () {
                    // TODO: refactor when elastic will work correctly with cache
                    _this4.$timeout(function () {
                        _this4.loadCustomers();
                    }, 1000);
                }, function () {
                    _this4.stopProgress();
                });
                // TODO: add toast for error
            });
        }
    }]);

    return CustomersController;
}();

exports.default = CustomersController;

/***/ }),

/***/ "yZX0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/icons/icon_signal5.svg";

/***/ }),

/***/ "yjGC":
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-align=\"start center\" ng-if=!$ctrl.isEditing> <img src=https://placehold.it/50x50 alt=\"\"/> <div class=\"md-caption space-m-l-s\"> {{ $ctrl.location.description }} </div> </div> <div layout=row layout-align=\"start start\" ng-if=$ctrl.isEditing> <label for=uploadFile class=\"is-editable-block space-m-r-s\"> <input type=file name=uploadFile id=uploadFile /> <img src=https://placehold.it/50x50 alt=image /> </label> <div flex> <textarea class=operations-textarea>{{ $ctrl.location.description }}</textarea> </div> </div> ";

/***/ }),

/***/ "ykX9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppRoutes.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AppRoutes;

var _app = __webpack_require__("5GsZ");

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTHORIZATION_REPEAT_DELAY = 5000; // 5 seconds

/**
 * App specific routes and state configuration
 * @param {$stateProvider} $stateProvider ui-router state provider
 * @param {$urlRouterProvider} $urlRouterProvider ui-router provider
 * @param {$locationProvider} $locationProvider location provider
 * @constructor
 * @ngInject
 */
function AppRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    var mainState = {
        abstract: true,
        component: _app2.default.selector,
        resolve: {
            /** @ngInject */
            storedUser: ["AuthService", function storedUser(AuthService) {
                return AuthService.getUser();
            }],
            /** @ngInject */
            authorizedUser: ["storedUser", "AuthService", function authorizedUser(storedUser, AuthService) {
                if (storedUser && !storedUser.expired) {
                    return storedUser;
                }

                return AuthService.silentLogin().catch(function () {
                    return null;
                });
            }],
            /**
             * This resolve is used only to initialize remote configuration loader and load config
             * @ngInject
             */
            remoteConfig: ["RemoteConfigService", function remoteConfig(RemoteConfigService) {
                return RemoteConfigService.loadConfig();
            }],
            /** @ngInject */
            folders: ["authorizedUser", "FolderService", function folders(authorizedUser, FolderService) {
                if (authorizedUser) {
                    return FolderService.loadFolders().catch(function () {
                        return null;
                    });
                }
                return null;
            }]
        },
        /** @ngInject */
        onEnter: ["authorizedUser", "$state", function onEnter(authorizedUser, $state) {
            // eslint-disable-line consistent-return
            if (!authorizedUser) {
                return $state.target('auth');
            }
        }]
    };

    $stateProvider.state('auth', {
        url: '/auth',
        /** @ngInject */
        onEnter: ["AuthService", function onEnter(AuthService) {
            AuthService.login();
        }]
    });

    $stateProvider.state('auth-process', {
        url: '/auth/process',
        resolve: {
            /** @ngInject */
            authorizedUser: ["AuthService", function authorizedUser(AuthService) {
                return AuthService.authorize().catch(function () {
                    return null;
                });
            }]
        },
        /** @ngInject */
        onEnter: ["authorizedUser", "$state", function onEnter(authorizedUser, $state) {
            // eslint-disable-line consistent-return
            if (authorizedUser) {
                return $state.target('main.sensors.list');
            }

            setTimeout(function () {
                location.href = '/sensors-and-connectors';
            }, AUTHORIZATION_REPEAT_DELAY);
        }]
    });

    $stateProvider.state('main', mainState);

    $urlRouterProvider.otherwise('/sensors-and-connectors');
}

/***/ }),

/***/ "ylAY":
/***/ (function(module, exports) {

module.exports = "<md-dialog class=\"dialog dialog--middle\" layout=column layout-align=space-between> <md-dialog-content class=space-p-h-m> <section layout=row layout-align=\"start center\"> <h2>Save to dashboard</h2> <span flex></span> <md-button class=md-icon-button ng-click=vm.close()> <md-icon class=\"text-primary material-icons--m\">clear</md-icon> </md-button> </section> <div layout=column> <div layout=row> <div class=\"space-p-r-m flex-50\"> <md-input-container class=md-block> <label>Name</label> <input type=text> <div class=md-input-hint>Used for the link in the navbar</div> </md-input-container> </div> <div class=\"space-p-l-m flex-50\"> <md-input-container class=md-block> <label>Category</label> <md-select ng-model=categoty> <md-option ng-value=1>Temperature</md-option> <md-option ng-value=2>Door</md-option> <md-option ng-value=3>Window</md-option> <md-option ng-value=4>Theft</md-option> </md-select> <div class=md-input-hint>Used for organizing navbar links</div> </md-input-container> </div> </div> <section> <h4 class=block-title> Sensor selection <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </h4> <div layout=row> <md-radio-group layout=row flex ng-model=sensor_selection> <div class=flex-40> <md-radio-button class=dt-theme value=sensor_selection.radio1 name=radio1 aria-label=label> <span class=text-truncate>These specific sensors</span> </md-radio-button> </div> <div class=\"u-context flex-60 space-m-b-l\"> <md-radio-button class=dt-theme value=sensor_selection.radio2 name=radio2 aria-label=label1> <span class=text-truncate>All sensors matching there search parameters</span> </md-radio-button> <div class=\"md-input-hint space-m-l-l space-p-l-xs\"> 2 sensors are currently unchecked. There will be included on the dashboard if you choose this option. </div> </div> </md-radio-group> </div> </section> <section> <h4 class=block-title> Date range <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </h4> <div class=space-m-v-s> <md-radio-group layout=row ng-model=date_range> <md-radio-button class=\"dt-theme flex\" value=date_range.radio1 name=radio1 aria-label=\"last day\"> <span>Last 24 hrs</span> </md-radio-button> <md-radio-button class=\"dt-theme flex\" value=date_range.radio2 name=radio2 aria-label=\"last week\"> <span>Last 7 days</span> </md-radio-button> <md-radio-button class=\"dt-theme flex\" value=date_range.radio3 name=radio3 aria-label=\"last mounth\"> <span>Last 30 days</span> </md-radio-button> </md-radio-group> </div> <div> <md-checkbox class=dt-theme ng-model=checkbox.showNavigation aria-label=checkbox> Show date navigation </md-checkbox> </div> </section> <section> <h4 class=block-title> Graphs <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </h4> <ul class=\"custom-list custom-list--simple\"> <li layout=row layout-align=\"start center\"> <div flex=40> <md-checkbox class=\"dt-theme space-m-b-s\" ng-model=checkbox.alertsWarnings aria-label=checkbox> Alerts and warnings </md-checkbox> </div> <div flex=60> <md-checkbox class=\"dt-theme space-m-b-s\" ng-model=checkbox.averageTemperature aria-label=checkbox> Average temperature with highs and lows </md-checkbox> </div> </li> <li layout=row layout-align=\"start center\"> <div flex=40> <md-checkbox class=\"dt-theme space-m-b-s\" ng-model=checkbox.doorOpenings aria-label=checkbox> Door openings </md-checkbox> </div> <div flex=60> <md-checkbox class=\"dt-theme space-m-b-s\" ng-model=checkbox.windowOpenings aria-label=checkbox> Window openings </md-checkbox> </div> </li> <li layout=row layout-align=\"start center\"> <div flex=40> <md-checkbox class=\"dt-theme space-m-b-s\" ng-model=checkbox.objectRemovals aria-label=checkbox> Object removals </md-checkbox> </div> <div flex=60> <md-checkbox class=\"dt-theme space-m-b-s\" ng-model=checkbox.buttonTaps aria-label=checkbox> Button taps </md-checkbox> </div> </li> </ul> </section> </div> </md-dialog-content> <md-dialog-actions class=\"space-p-h-l space-p-b-m\"> <div layout=row layout-align=\"end center\"> <md-button class=md-primary ng-click=vm.close()> Cancel </md-button> <md-button class=md-primary> Save </md-button> </div> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "yqDe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingLocation = __webpack_require__("1EOf");

var _thingLocation2 = _interopRequireDefault(_thingLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("g7I2");

exports.default = {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingLocation2.default
};

/***/ }),

/***/ "z1Cy":
/***/ (function(module, exports) {

module.exports = "<div class=\"box box--grey space-m-v-m\" layout-padding> <md-button class=\"md-primary md-icon-button box__btn-close\" ng-click=$ctrl.close();> <i class=material-icons>add_circle_outline</i> </md-button> <div class=content-title layout=row layout-align=\"start center\"> <span>Create Notification</span> <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </div> <div layout=row layout-align=space-between> <div> <md-input-container class=md-block style=width:210px> <label>Severity *</label> <md-select ng-model=test> <md-option value=warning>Warning</md-option> <md-option value=alert>Alert</md-option> <md-option value=info>Info</md-option> </md-select> <div class=\"md-input-hint md-caption-1\">Determines how notification is displayed</div> </md-input-container> </div> <div layout=column> <div class=text-label-active>Dismiss notification</div> <div layout=row layout-align=\"start center\" class=space-m-b-s> <md-checkbox class=\"md-primary space-m-b-n\"></md-checkbox> <div layout=row layout-align=\"start center\"> <div class=md-body-1>After</div> <md-input-container class=input-container--short style=width:30px> <input type=text maxlength=3 class=text-center> </md-input-container> <div class=md-body-1>hrs</div> <md-input-container class=input-container--short style=width:30px> <input type=text maxlength=2 class=text-center> </md-input-container> <div class=md-body-1>min</div> <md-input-container class=input-container--short style=width:30px> <input type=text maxlength=2 class=text-center> </md-input-container> <div class=md-body-1>sec</div> </div> </div> <div> <md-checkbox class=md-primary> <div class=md-body-1>Clear when rule no longer applies</div> </md-checkbox> </div> <div> <md-checkbox class=md-primary> <div class=md-body-1>Dismiss manually</div> </md-checkbox> </div> </div> </div> <div> <md-input-container class=md-block> <label>Notification message</label> <input type=text> <div class=\"md-input-hint md-caption-1\">Seen in sensor details when rule is triggered</div> </md-input-container> </div> </div> ";

/***/ }),

/***/ "zF9l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TabsComponent = exports.LeftNavigationComponent = undefined;

var _left = __webpack_require__("yBwX");

var _left2 = _interopRequireDefault(_left);

var _tabs = __webpack_require__("voNC");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.LeftNavigationComponent = _left2.default;
exports.TabsComponent = _tabs2.default;

/***/ }),

/***/ "zFAJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _thingLabels = __webpack_require__("Ihv8");

var _thingLabels2 = _interopRequireDefault(_thingLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("70dX");

exports.default = {
    bindings: {
        reset: '<',
        labels: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template: template,
    controller: _thingLabels2.default
};

/***/ }),

/***/ "zQTU":
/***/ (function(module, exports) {

module.exports = "<div layout=column> <h3 class=\"box-title space-m-t-n\">Rules</h3> <dt-entities-filter entities-filtered=$ctrl.getFilterRules($event) input-placeholder=\"Search rules\"></dt-entities-filter> <section class=space-m-v-l> <div layout=row layout-align=\"start center\"> <div class=content-title>Proximity</div> <span flex></span> <md-icon class=svg-icon aria-label=Door md-svg-icon=door> <md-tooltip class=dt-theme md-direction=top> Door </md-tooltip> </md-icon> <md-icon class=svg-icon aria-label=Window md-svg-icon=window> <md-tooltip class=dt-theme md-direction=top> Window </md-tooltip> </md-icon> <md-icon class=svg-icon aria-label=Theft md-svg-icon=theft> <md-tooltip class=dt-theme md-direction=top> Theft </md-tooltip> </md-icon> </div> <ul class=\"custom-list custom-list--rules\"> <li ng-repeat=\"rule in $ctrl.alertsActions\n            | filter:{type: 'proximity'}\n            | filter:$ctrl.filterRule\" ng-click=$ctrl.onSelect(rule)> <dt-rule class=dtRule rule=rule data-ng-class=\"{'dtRule--active': rule.id == $ctrl.currentRule.id}\"></dt-rule> </li> </ul> <a href=# class=md-caption ng-click=\"$ctrl.create($event, 'proximity'); $event.preventDefault();\">+ Create new rule</a> </section> <section class=space-m-v-l> <div layout=row layout-align=\"start center\"> <div class=content-title>Temperature</div> <span flex></span> <md-icon class=svg-icon aria-label=Temperature md-svg-icon=temperature> <md-tooltip class=dt-theme md-direction=top> Temperature </md-tooltip> </md-icon> </div> <ul class=\"custom-list custom-list--rules\"> <li ng-repeat=\"rule in $ctrl.alertsActions\n            | filter:{type: 'temperature'}\n            | filter:$ctrl.filterRule\" ng-click=$ctrl.onSelect(rule)> <dt-rule class=dtRule rule=rule data-ng-class=\"{'dtRule--active': rule.id == $ctrl.currentRule.id}\"></dt-rule> </li> </ul> <a href=# ng-click=\"$ctrl.create($event, 'temperature'); $event.preventDefault();\" class=md-caption>+ Create new rule</a> </section> <section class=space-m-v-l> <div layout=row layout-align=\"start center\"> <div class=content-title>Touch</div> <span flex></span> <md-icon class=svg-icon aria-label=Touch md-svg-icon=touch> <md-tooltip class=dt-theme md-direction=top> Touch </md-tooltip> </md-icon> </div> <ul class=\"custom-list custom-list--rules\"> <li ng-repeat=\"rule in $ctrl.alertsActions\n            | filter:{type: 'touch'}\n            | filter:$ctrl.filterRule\" ng-click=$ctrl.onSelect(rule)> <dt-rule class=dtRule rule=rule data-ng-class=\"{'dtRule--active': rule.id == $ctrl.currentRule.id}\"></dt-rule> </li> </ul> <a href=# class=md-caption ng-click=\"$ctrl.create($event, 'touch'); $event.preventDefault();\">+ Create new rule</a> </section> </div> ";

/***/ }),

/***/ "zUGe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _accountSettings = __webpack_require__("neeV");

var _accountSettings2 = _interopRequireDefault(_accountSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__("LMEn");

exports.default = {
    controller: _accountSettings2.default,
    template: template
};

/***/ }),

/***/ "zZQo":
/***/ (function(module, exports) {

module.exports = "<md-dialog style=width:490px> <md-dialog-content class=\"md-dialog-content space-p-b-s\"> <h2 class=\"md-dialog-title space-m-b-xl\">Save link to view in navbar</h2> <form name=ctrl.saveViewForm ng-submit=ctrl.save()> <div class=\"block-title space-m-b-l\"> Link location in navbar <i class=\"material-icons material-icons--help space-m-h-s\">help</i> </div> <md-radio-group layout=column ng-model=ctrl.viewPlacement> <md-radio-button class=dt-theme value=top aria-label=\"single item\"> Single menu item </md-radio-button> <div layout=row layout-align=\"start center\" style=height:40px> <md-radio-button class=\"dt-theme space-m-r-xl space-m-b-n\" value=dropdown> Within a category </md-radio-button> <dt-search-autocomplete ng-if=ctrl.showDropdown flex placeholder=\"Enter category\" text-key=name on-change=ctrl.onCategoryQueryChanged($event) on-selected=ctrl.onCategoryFound($event) on-search=ctrl.onSearch($event)></dt-search-autocomplete> </div> </md-radio-group> <md-input-container class=\"md-block input-emphases space-m-b-n\"> <label>Link title</label> <input name=viewName type=text ng-model=ctrl.viewName required> <div class=md-input-hint> Give your view a descriptive name to easily find it later </div> <div ng-messages=ctrl.saveViewForm.viewName.$error> <div ng-message=required>You did not enter a link title</div> </div> </md-input-container> </form> </md-dialog-content> <md-dialog-actions class=space-p-h-l> <div layout=column layout-align=\"start none\" flex> <section layout=row layout-align=\"end center\"> <md-button class=md-primary ng-click=ctrl.cancel()> Cancel </md-button> <md-button class=md-primary ng-click=ctrl.save() ng-disabled=ctrl.saveViewForm.$invalid> Save link in navbar </md-button> </section> </div> </md-dialog-actions> </md-dialog> ";

/***/ }),

/***/ "zucC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * ErrorsService class.
 * Use this service to manage errors configuration, like translations, error messages etc.
 */
var ErrorsService = function () {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    ErrorsService.$inject = ["RemoteConfigService"];
    function ErrorsService(RemoteConfigService) {
        _classCallCheck(this, ErrorsService);

        this.RemoteConfigService = RemoteConfigService;

        this.config = (0, _cloneDeep3.default)(this.RemoteConfigService.getErrorsConfig());
        if (!this.config) {
            this.config = {};
        }
    }

    /**
     * Get generic errors config
     * @returns {Array} Return list of generic error configs
     */


    _createClass(ErrorsService, [{
        key: 'getGenericErrors',
        value: function getGenericErrors() {
            return this.config.generic || [];
        }

        /**
         * Get error configs by component name
         * @param {string} componentName - Component name
         * @returns {Object|Array<Object>} Return component error configs
         */

    }, {
        key: 'getComponentErrors',
        value: function getComponentErrors(componentName) {
            return this.config[componentName] || {};
        }
    }]);

    return ErrorsService;
}();

exports.default = ErrorsService;

/***/ }),

/***/ "zwEQ":
/***/ (function(module, exports) {

module.exports = "<dt-content-header state-title=\"'Sensors & Connectors'\"></dt-content-header> <dt-sensor-tabs tab-id=$ctrl.tabId search-query=$ctrl.q></dt-sensor-tabs> <ui-view search-query=$ctrl.q></ui-view>";

/***/ }),

/***/ "zxh4":
/***/ (function(module, exports) {

module.exports = "<div class=form-grid__row> <label class=md-caption>Registered</label> <md-input-container class=\"form-element form-element--simple space-m-h-s\" style=width:74px> <md-select aria-label=Registered ng-model=$ctrl.selectedOption ng-change=$ctrl.onChange()> <md-option>{{ ::$ctrl.anyText }}</md-option> <md-option ng-repeat=\"(label, value) in ::$ctrl.values\" ng-value=value> {{::label}} </md-option> <md-option ng-value=$ctrl.customText>{{ ::$ctrl.customText }}</md-option> </md-select> </md-input-container> <md-icon class=\"material-icons material-icons--help\">help</md-icon> </div> <div ng-if=$ctrl.isCustomSelected() layout=column style=margin-top:15px> <md-datepicker ng-model=$ctrl.customAfter md-placeholder=\"From Date\" md-hide-icons=calendar></md-datepicker> <span style=\"margin:10px 0\">to</span> <md-datepicker ng-model=$ctrl.customBefore md-placeholder=\"To Date\" md-hide-icons=calendar></md-datepicker> </div>";

/***/ }),

/***/ "zzTv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cloneDeep2 = __webpack_require__("Y0zI");

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * NotificationsService class.
 * Use this service to manage notifications by configuration.
 */
var NotificationsService = function () {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    NotificationsService.$inject = ["RemoteConfigService"];
    function NotificationsService(RemoteConfigService) {
        _classCallCheck(this, NotificationsService);

        this.RemoteConfigService = RemoteConfigService;

        this.config = (0, _cloneDeep3.default)(this.RemoteConfigService.getNotificationsConfig());

        this.items = this.config.items || [];
        this.itemsMapByStatus = {};

        this.defaultNotification = {
            exclamation: false,
            color: ''
        };

        this.createNotificationsMapByStatus();
    }

    /**
     * Parse config items and create map for notifications by notification.status
     * @returns {Object} Return object with notifications linked to notification.status inside that object}
     */


    _createClass(NotificationsService, [{
        key: 'createNotificationsMapByStatus',
        value: function createNotificationsMapByStatus() {
            var _this = this;

            if (!this.items || !Array.isArray(this.items) || !this.items.length) return {};

            this.items.forEach(function (notification) {
                _this.itemsMapByStatus[notification.status] = notification;
            });

            this.sortNotificationsMap();

            return this.getNotificationsMapByStatus();
        }

        /**
         * Sort notifications map by notification.status
         * @returns {Object} Map of notifications
         */

    }, {
        key: 'sortNotificationsMap',
        value: function sortNotificationsMap() {
            var _this2 = this;

            this.itemsMapByStatus = Object.keys(this.itemsMapByStatus).sort().reduce(function (result, item) {
                result[item] = _this2.itemsMapByStatus[item];

                return result;
            }, {});

            return this.itemsMapByStatus;
        }

        /**
         * Get default notification
         * @returns {{exclamation: boolean, color: string}} Return default object for notification
         */

    }, {
        key: 'getDefaultNotification',
        value: function getDefaultNotification() {
            return this.defaultNotification;
        }

        /**
         * Get notification by status
         * @param {string} status - Status name
         * @returns {{exclamation: boolean, color: string}} Return found notification by status from map or default
         * notification
         */

    }, {
        key: 'getNotificationByStatus',
        value: function getNotificationByStatus(status) {
            return this.itemsMapByStatus[status] || this.getDefaultNotification();
        }

        /**
         * Get all notifications (NOTICE: Original notifications configs from API/Server)
         * @returns {Array} Return list of notification configs
         */

    }, {
        key: 'getAllNotifications',
        value: function getAllNotifications() {
            return this.items;
        }

        /**
         * Get notification by status from map
         * @returns {{}} Return map of notifications by status
         */

    }, {
        key: 'getNotificationsMapByStatus',
        value: function getNotificationsMapByStatus() {
            return this.itemsMapByStatus;
        }
    }]);

    return NotificationsService;
}();

exports.default = NotificationsService;

/***/ })

},["2twT"]);


// WEBPACK FOOTER //
// app.a48d6e8cb925ed324a34.js